export const locationData = [
  {
    East: [
      {
        Bugesera: [
          {
            Gashora: [
              {
                Biryogo: [
                  "Bidudu",
                  "Biryogo",
                  "Buhoro",
                  "Gihanama",
                  "Kagarama",
                  "Kanyonyomba",
                  "Karutete",
                  "Kivugiza",
                  "Rugunga",
                ],
              },
              {
                Kabuye: [
                  "Bidudu",
                  "Kabuye",
                  "Karizinge",
                  "Rwagasiga",
                  "Rweteto",
                ],
              },
              {
                Kagomasi: [
                  "Akagako",
                  "Kagomasi",
                  "Kiruhura",
                  "Kuruganda",
                  "Runzenze",
                  "Rushubi",
                ],
              },
              {
                Mwendo: [
                  "Gaharwa",
                  "Gisenyi",
                  "Kayovu",
                  "Ruhanga",
                  "Ruhanura",
                  "Rutanga",
                ],
              },
              {
                Ramiro: [
                  "Dihiro",
                  "Kagasa I",
                  "Kagasa II",
                  "Karusine I",
                  "Karusine II",
                  "Migina",
                  "Munyinya",
                  "Rweru I",
                  "Rweru II",
                ],
              },
            ],
          },
          {
            Juru: [
              {
                Juru: [
                  "Ayabakiza",
                  "Bisagara",
                  "Nyamigende",
                  "Rugarama",
                  "Rwamakara",
                  "Twabagarama",
                ],
              },
              {
                Kabukuba: [
                  "Gikana",
                  "Gikurazo",
                  "Kabukuba",
                  "Kamatongo",
                  "Majanja",
                  "Mbuye",
                  "Rushubi",
                ],
              },
              {
                Mugorore: [
                  "Cyirabo",
                  "Gatora",
                  "Kajevuba",
                  "Mugorore",
                  "Murambi",
                  "Rebero",
                  "Rwamurama",
                  "Tabarari",
                ],
              },
              {
                Musovu: [
                  "Bitega",
                  "Cyabasonga",
                  "Cyingaju",
                  "Kabeza",
                  "Nyaruhuru",
                ],
              },
              {
                Rwinume: [
                  "Gisororo",
                  "Kabeza",
                  "Katarara",
                  "Kinihira",
                  "Rwimpyisi",
                  "Uwimpunga",
                ],
              },
            ],
          },
          {
            Kamabuye: [
              {
                Biharagu: [
                  "Akanigo",
                  "Biharagu",
                  "Kanyonyera",
                  "Munazi",
                  "Muyigi",
                  "Nyarurama",
                  "Rubugu",
                ],
              },
              {
                Burenge: [
                  "Akabazeyi",
                  "Kagenge",
                  "Murambo",
                  "Nyabyondo",
                  "Nyakariba",
                  "Rebero",
                  "Senga",
                ],
              },
              {
                Kampeka: [
                  "Byimana",
                  "Kampeka",
                  "Mabuye",
                  "Masangano",
                  "Mbuganzeri",
                  "Mparo",
                  "Ndama",
                  "Pamba I",
                  "Pamba II",
                ],
              },
              {
                Nyakayaga: [
                  "Akaje",
                  "Fatinkanda",
                  "Murago",
                  "Murambi",
                  "Ntungamo I",
                  "Ntungamo II",
                  "Nyakayaga",
                ],
              },
              {
                Tunda: [
                  "Cyogamuyaga",
                  "Mububa I",
                  "Mububaya II",
                  "Rubirizi",
                  "Rusibya",
                  "Tunda",
                  "Twuruziramire",
                  "Uwibiraro I",
                  "Uwibiraro II",
                  "Uwumusave",
                ],
              },
            ],
          },
          {
            Mareba: [
              {
                Bushenyi: [
                  "Bigaga",
                  "Bukumba",
                  "Cyantwari",
                  "Gasagara",
                  "Gitega",
                  "Kabeza",
                  "Kagese",
                  "Kagogo",
                  "Kamasonga",
                  "Mareba",
                  "Muyange",
                  "Rukoyoyo",
                  "Runyonza",
                  "Rususa",
                ],
              },
              {
                Gakomeye: [
                  "Gatanga",
                  "Gitwa",
                  "Kabere",
                  "Kajevuba",
                  "Kamudeberi",
                  "Kamunana",
                  "Kanka",
                  "Kaziranyenzi",
                  "Rwintare",
                ],
              },
              {
                Nyamigina: [
                  "Gafunzo",
                  "Kabeza",
                  "Kabingo",
                  "Kabuye",
                  "Karwana",
                  "Ngugu",
                  "Nyamigisha",
                  "Ruhina",
                  "Rusenyi",
                  "Ruyenzi",
                ],
              },
              {
                Rango: [
                  "Gatare",
                  "Gatinza",
                  "Gihoko",
                  "Kabuga",
                  "Kagarama",
                  "Matinza",
                  "Mbuga",
                  "Rango",
                  "Rusagara",
                  "Rwabikwano",
                ],
              },
              {
                Rugarama: [
                  "Gasagara",
                  "Gatare",
                  "Kayonza",
                  "Keza",
                  "Kururama",
                  "Muyenzi",
                  "Ruduha",
                  "Rugarama",
                  "Rutaka",
                ],
              },
            ],
          },
          {
            Mayange: [
              {
                Gakamba: [
                  "Gacucu",
                  "Gakamba",
                  "Gisenyi",
                  "Kamugenzi",
                  "Karambo",
                  "Kavumu",
                  "Rukora",
                ],
              },
              {
                Kagenge: [
                  "Biryogo",
                  "Gakindo",
                  "Gitaramuka",
                  "Karama",
                  "Kiruhura",
                  "Remera",
                  "Rukindo",
                  "Taba",
                  "Tetero",
                ],
              },
              {
                Kibenga: [
                  "Gahwiji I",
                  "Gahwiji II",
                  "Kindonyi",
                  "Murambi",
                  "Ruhorobero",
                  "Rwakaramira",
                  "Rwarusaku",
                ],
              },
              {
                Kibirizi: [
                  "Gacyamo",
                  "Gahinga",
                  "Gisenyi",
                  "Gitera",
                  "Kibirizi",
                  "Rugazi",
                  "Rwakibirizi",
                ],
              },
              {
                Mbyo: [
                  "Cyaruhiririra",
                  "Kabyo",
                  "Rugarama",
                  "Rwimikoni I",
                  "Rwimikoni II",
                ],
              },
            ],
          },
          {
            Musenyi: [
              {
                Gicaca: [
                  "Bidudu",
                  "Cyanika",
                  "Cyarubazi",
                  "Gatare",
                  "Gihari",
                  "Kagusa",
                  "Kamahango",
                  "Kavumu",
                  "Kidudu",
                  "Migina",
                  "Ngarama",
                  "Remera",
                  "Rusagara",
                ],
              },
              {
                Musenyi: [
                  "Bidudu",
                  "Bishinge",
                  "Bizenga",
                  "Cyeru",
                  "Gakomeye",
                  "Gakurazo",
                  "Kigarama",
                  "Kijuri",
                  "Kiringa",
                  "Muhanga",
                  "Nunga",
                  "Nyagasagara",
                  "Rugando",
                  "Rugeyo",
                ],
              },
              {
                Nyagihunika: [
                  "Gatoki",
                  "Gitagata",
                  "Kigusa",
                  "Kiruhura",
                  "Mbonwa",
                  "Nyakajuri",
                  "Rugarama",
                  "Rushubi",
                  "Rwankeri",
                ],
              },
              {
                Rulindo: [
                  "Kabeza",
                  "Kabuye",
                  "Kagunga",
                  "Kanyamata",
                  "Karambo",
                  "Karubanzangabo",
                  "Kinyovi",
                  "Nyamuri",
                  "Rulindo",
                  "Runyonza",
                ],
              },
            ],
          },
          {
            Mwogo: [
              {
                Bitaba: [
                  "Bitaba",
                  "Gatwe",
                  "Gisasa",
                  "Misatsi",
                  "Rebero",
                  "Rukoronko",
                ],
              },
              {
                Kagasa: [
                  "Gatare",
                  "Gisenyi",
                  "Karutabana",
                  "Ngando",
                  "Rubumba",
                  "Rwintenderi",
                ],
              },
              {
                Rugunga: [
                  "Kagerero",
                  "Nyamabuye",
                  "Nyarukombe",
                  "Rugazi",
                  "Rukira",
                  "Rukore",
                  "Rusagara",
                ],
              },
              {
                Rurenge: [
                  "Gatoki",
                  "Gitaraga",
                  "Kaboshya",
                  "Kaziramire",
                  "Rurenge",
                  "Rwabashenyi",
                ],
              },
            ],
          },
          {
            Ngeruka: [
              {
                Gihembe: [
                  "Buhara",
                  "Kabaya",
                  "Kabuye",
                  "Kadebu",
                  "Kagasa",
                  "Karambo",
                  "Kirasaniro",
                  "Kururama",
                  "Nyakariba",
                  "Nyarubande",
                  "Rusagara",
                  "Rutare",
                  "Ruzinge",
                  "Shitwe",
                ],
              },
              {
                Murama: [
                  "Agashyamba",
                  "Bishenyi",
                  "Fatinkanda",
                  "Gakurazo",
                  "Gatanga",
                  "Ikoni",
                  "Kagege",
                  "Kankuriyingoma",
                  "Kigandu",
                  "Kinamba",
                  "Murama",
                  "Muyange",
                  "Nyakagarama",
                  "Rusamaza",
                  "Rwabisheshe",
                  "Shami",
                ],
              },
              {
                Ngeruka: [
                  "Binyonzwe",
                  "Kamajeri",
                  "Kamasonga",
                  "Karugondo",
                  "Kivugiza",
                  "Muyange",
                  "Ngeruka",
                ],
              },
              {
                Nyakayenzi: [
                  "Heru",
                  "Kabuye",
                  "Karama",
                  "Kavumu",
                  "Kibaya",
                  "Kibungo",
                  "Kimiduha",
                  "Murambi",
                  "Nyakayenzi",
                  "Twimpara",
                ],
              },
              {
                Rutonde: [
                  "Akajuri",
                  "Kabare",
                  "Kabumbwe",
                  "Kagano",
                  "Kamugera",
                  "Kamugore",
                  "Kigarama",
                  "Rubirizi",
                  "Rugazi",
                  "Runyonza",
                  "Rusibya",
                ],
              },
            ],
          },
          {
            Ntarama: [
              {
                Cyugaro: [
                  "Gatoro",
                  "Kayenzi",
                  "Kidudu",
                  "Kingabo",
                  "Rubomborana",
                  "Rugarama",
                  "Rugunga",
                ],
              },
              {
                Kanzenze: [
                  "Cyeru",
                  "Gasagara",
                  "Kabaha",
                  "Kabeza",
                  "Karumuna",
                  "Kurugenge",
                  "Nyamabuye",
                  "Rwangara",
                ],
              },
              {
                Kibungo: [
                  "Kagoma I",
                  "Kagoma II",
                  "Kiganwa",
                  "Nganwa",
                  "Nyarunazi",
                  "Ruhengeri",
                  "Rusekera",
                ],
              },
            ],
          },
          {
            Nyamata: [
              {
                Kanazi: [
                  "Bihari",
                  "Cyeru",
                  "Gitovu",
                  "Kagirazina",
                  "Musagara",
                  "Nyarugati I",
                  "Nyarugati II",
                  "Rugando",
                  "Sumbure",
                ],
              },
              {
                Kayumba: [
                  "Gatare",
                  "Karambi",
                  "Kayenzi",
                  "Murambi",
                  "Nyagatovu",
                  "Nyakwibereka",
                  "Nyiramatuntu",
                  "Rwanza",
                ],
              },
              {
                Maranyundo: [
                  "Gahembe",
                  "Gisunzu",
                  "Mukoma",
                  "Muyange",
                  "Rugarama",
                  "Rusagara",
                ],
              },
              {
                Murama: [
                  "Bishweshwe",
                  "Gataraga",
                  "Gatare",
                  "Kasebigege",
                  "Kivugiza",
                  "Kiyogoma",
                  "Mwesa",
                  "Rucucu",
                  "Ruhanga",
                  "Rutobotobo",
                  "Rutukura",
                ],
              },
              {
                "Nyamata y' Umujyi": [
                  "Gasenga I",
                  "Gasenga II",
                  "Gatare I",
                  "Gatare II",
                  "Gatare III",
                  "Nyabivumu",
                  "Nyamata I",
                  "Nyamata II",
                  "Rugarama I",
                  "Rugarama II",
                  "Rugarama III",
                  "Rwakibirizi I",
                  "Rwakibirizi II",
                ],
              },
            ],
          },
          {
            Nyarugenge: [
              {
                Gihinga: [
                  "Mabanga",
                  "Mwoshya",
                  "Ntungamo",
                  "Nyabuhoro",
                  "Nyagasozi",
                  "Nyarubande",
                  "Rwabusoro",
                ],
              },
              {
                Kabuye: [
                  "Cyahafi",
                  "Gateko",
                  "Gatoki",
                  "Karubagazi",
                  "Nyakabingo",
                  "Nyakabuye",
                  "Nyarusambu",
                ],
              },
              {
                Murambi: [
                  "Cundaminega",
                  "Cyeru",
                  "Kadogori",
                  "Kanombe",
                  "Kayitanga",
                  "Nyagakombe",
                  "Rugandara",
                  "Rurama",
                  "Rushorezo",
                ],
              },
              {
                Ngenda: [
                  "Bushonyi",
                  "Kamabare",
                  "Kamugera",
                  "Kiyovu",
                  "Muyange",
                  "Nyagisenyi",
                  "Rubona",
                  "Rugasa",
                  "Rwashangwe",
                  "Tubumba",
                ],
              },
              {
                Rugando: [
                  "Bushenyi",
                  "Gako",
                  "Kamahirwe",
                  "Nsoro",
                  "Rebero",
                  "Rugero",
                ],
              },
            ],
          },
          {
            Rilima: [
              {
                Kabeza: [
                  "Bidenge",
                  "Biraro",
                  "Bwiza",
                  "Gako",
                  "Gasarwe",
                  "Gasave",
                  "Gitega",
                  "Kabeza",
                  "Kagarama",
                  "Karambi",
                  "Karambo",
                  "Karirisi",
                  "Marembo",
                  "Nyamisagara",
                ],
              },
              {
                Karera: [
                  "Gakurazo",
                  "Gatare",
                  "Kamahoro",
                  "Mutarama",
                  "Ruyenzi",
                  "Rwankomati",
                  "Rwavuningoma",
                  "Rwimirama",
                ],
              },
              {
                Kimaranzara: [
                  "Akintwari",
                  "Akumunezero",
                  "Amizero",
                  "Buhoro",
                  "Byimana",
                  "Gasabo",
                  "Gihushi",
                  "Akabahaya",
                  "Kidogo",
                  "Kimaranzara",
                  "Kivumu",
                ],
              },
              {
                Ntarama: [
                  "Akabeza",
                  "Gasave",
                  "Gaseke",
                  "Gasenyi",
                  "Gitovu",
                  "Kagugu",
                  "Kamashya",
                  "Kavumu",
                  "Ntarama",
                  "Nyamure",
                  "Rurambo",
                  "Saruduha",
                ],
              },
              {
                Nyabagendwa: [
                  "Cyoma",
                  "Gicaca",
                  "Kamabuye",
                  "Karama",
                  "Mataba",
                  "Mubuga",
                  "Mukoma",
                  "Murambi",
                  "Nyabagendwa",
                  "Nyamizi",
                  "Rwibikara",
                ],
              },
            ],
          },
          {
            Ruhuha: [
              {
                Bihari: [
                  "Bihari",
                  "Busasamana",
                  "Masenga I",
                  "Masenga II",
                  "Mukoma",
                  "Nyagafunzo",
                  "Rugarama",
                  "Rwanzunga",
                ],
              },
              {
                Gatanga: [
                  "Butereri",
                  "Kayigi",
                  "Kibaza",
                  "Nyaburiba",
                  "Nyakagarama",
                  "Rwanika",
                ],
              },
              {
                Gikundamvura: [
                  "Gikundamvura",
                  "Kanombe",
                  "Kazabagarura",
                  "Kiyovu",
                  "Rukurazo",
                  "Rusenyi",
                ],
              },
              {
                Kindama: [
                  "Gatare",
                  "Gatovu",
                  "Kagasera",
                  "Kamweru",
                  "Kibaza",
                  "Kindama",
                  "Rebero",
                  "Ruramba",
                  "Rutare",
                  "Saruduha",
                ],
              },
              {
                Ruhuha: [
                  "Kimikamba",
                  "Mubano",
                  "Nyabaranga",
                  "Ruhuha I",
                  "Ruhuha II",
                ],
              },
            ],
          },
          {
            Rweru: [
              {
                Batima: [
                  "Agahonnyo",
                  "Batima",
                  "Gasororo",
                  "Gikoma",
                  "Ihara",
                  "Kamudusi",
                  "Mbuganzeri",
                  "Rubira",
                  "Ruhehe",
                  "Twinyange",
                ],
              },
              {
                Kintambwe: [
                  "Gakindo",
                  "Gasenyi",
                  "Maburane",
                  "Mugina",
                  "Nyiragiseke",
                  "Nyirakanemba",
                  "Nyirarubomboza",
                  "Nzangwa",
                  "Ubukoroco",
                ],
              },
              {
                Mazane: ["Gasasa", "Rukira", "Rusenyi"],
              },
              {
                Nemba: [
                  "Kigina",
                  "Kimpara",
                  "Kimvubu",
                  "Muyoboro",
                  "Nemba",
                  "Nyakabingo",
                  "Rutete",
                  "Rwibinyogote",
                  "Rwiminazi",
                ],
              },
              {
                Nkanga: [
                  "Agashoro",
                  "Kivusha",
                  "Mujwiri",
                  "Mushyoroti",
                  "Nkanga",
                  "Ruzo",
                ],
              },
              {
                Sharita: ["Karizinge", "Sharita"],
              },
            ],
          },
          {
            Shyara: [
              {
                Kabagugu: ["Kabagugu", "Kinteko", "Ngaruye", "Rwamanyoni"],
              },
              {
                Kamabuye: ["Gakoni", "Nyabaguma", "Rubwirwa"],
              },
              {
                Nziranziza: ["Gahosha", "Kagarama", "Nziranziza", "Ruli"],
              },
              {
                Rebero: ["Gateko", "Nyamirama", "Rebero", "Rutebe"],
              },
              {
                Rutare: ["Gaseke", "Kamweru", "Ruhanga", "Rutare", "Shyara"],
              },
            ],
          },
        ],
      },
      {
        Gatsibo: [
          {
            Gasange: [
              {
                Kigabiro: ["Kabuye", "Kigabiro", "Maya", "Munini", "Rugarama"],
              },
              {
                Kimana: ["Byahi", "Kagarama", "Kimana", "Rugarama"],
              },
              {
                Teme: ["Buburankwi", "Giheta", "Kinunga", "Teme"],
              },
              {
                Viro: ["Gahara I", "Gahara II", "Kagogo", "Viro"],
              },
            ],
          },
          {
            Gatsibo: [
              {
                Gatsibo: [
                  "Gatare",
                  "Gatsibo",
                  "Hanika",
                  "Mukwiza",
                  "Munini",
                  "Nyakagarama",
                  "Nyamuduha",
                  "Nyarukoni",
                  "Rwimbogo",
                ],
              },
              {
                Manishya: [
                  "Manishya",
                  "Nyagahandagaza",
                  "Nyaruhanga",
                  "Nyarukoni",
                  "Rugarama",
                ],
              },
              {
                Mugera: [
                  "Kabuga",
                  "Kamasapfu",
                  "Karambo I",
                  "Kavumu",
                  "Kayisha",
                  "Kiraritsi",
                  "Mugera",
                  "Nyarukoni I",
                  "Rurama",
                ],
              },
              {
                Nyabicwamba: [
                  "Agakenyeri",
                  "Agakomeye",
                  "Agatoma",
                  "Gatungu",
                  "Kabashenda",
                  "Kaduha",
                  "Kigarama",
                  "Nyabiheke",
                  "Nyamuduha",
                  "Rucumbo",
                  "Rutovu",
                  "Ryabakame",
                  "Ryebare",
                ],
              },
              {
                Nyagahanga: [
                  "Gitega",
                  "Karama",
                  "Kizinga",
                  "Mangarama",
                  "Nyagahanga",
                  "Nyakibande",
                  "Rugarama",
                  "Rusenge",
                ],
              },
            ],
          },
          {
            Gitoki: [
              {
                Bukomane: [
                  "Bukomane",
                  "Muburembo",
                  "Gakiri",
                  "Gisaka",
                  "Kigomero",
                  "Mungaju",
                  "Nyakayaga",
                  "Mururema",
                  "Rwagitima",
                  "Ryarukaza",
                ],
              },
              {
                Cyabusheshe: [
                  "Binunga",
                  "Cyabusheshe",
                  "Cyoto",
                  "Kigabiro",
                  "Kivuba",
                  "Nyarunazi",
                  "Rushashi",
                ],
              },
              {
                Karubungo: [
                  "Gisharara",
                  "Isangano",
                  "Kagugu",
                  "Kamuhenda",
                  "Karubungo",
                  "Kinyange",
                  "Nyagacyamo",
                  "Nyarugarama",
                  "Rugarama",
                  "Rwamuhinga",
                  "Sata",
                ],
              },
              {
                Mpondwa: [
                  "Akibiraro",
                  "Akuruganda",
                  "Bukira",
                  "Bwiza",
                  "Gahama",
                  "Nyakabungo",
                  "Nyaruhanga",
                  "Ryabugenge",
                  "Tsima",
                ],
              },
              {
                Nyamirama: [
                  "Gahabo",
                  "Kagarama",
                  "Kinteko",
                  "Kwishaba",
                  "Minago",
                  "Mwanama",
                  "Nyabikenke",
                  "Nyamuraza",
                  "Nyarukombe",
                  "Rukiri",
                  "Rwinsanga",
                ],
              },
              {
                Rubira: [
                  "Gakiri",
                  "Gikuyu",
                  "Kavumu",
                  "Nyakabota",
                  "Nyakagarama",
                  "Nyamengo",
                  "Rugarama",
                  "Rurehe",
                  "Rwintama",
                ],
              },
            ],
          },
          {
            Kabarore: [
              {
                Kabarore: ["Bihinga", "Kabarore I", "Kabaroreii", "Kabingo"],
              },
              {
                Kabeza: ["Gatoki", "Kabeza", "Mishenyi", "Ryanjeru"],
              },
              {
                Karenge: ["Karenge", "Mutarama", "Nyarubuye"],
              },
              {
                Marimba: [
                  "Kabare",
                  "Kanteri",
                  "Marimba",
                  "Nyarwanya",
                  "Rebero",
                  "Rutenderi",
                  "Rwimbogo",
                ],
              },
              {
                Nyabikiri: ["Kabeza", "Ngarama", "Nyabikiri"],
              },
              {
                Simbwa: ["Kibondo I", "Kibondo II", "Ruhuha", "Simbwa"],
              },
            ],
          },
          {
            Kageyo: [
              {
                Busetsa: [
                  "Busetsa",
                  "Cyabuhimbiri",
                  "Cyatoko",
                  "Gitebwe",
                  "Kaninga",
                  "Kayenzi",
                  "Kivugiza",
                  "Nyarubuye",
                  "Nyarusange",
                  "Rugarama",
                  "Rwikubo",
                  "Tsima",
                ],
              },
              {
                Gituza: [
                  "Bugarama",
                  "Gisiza",
                  "Kabacuzi",
                  "Kigara",
                  "Mpama",
                  "Nyakabare",
                  "Rwabihumbi",
                ],
              },
              {
                Kintu: [
                  "Gakeri",
                  "Jabiro",
                  "Kigando",
                  "Kirara",
                  "Nyakabungo",
                  "Rutoma",
                  "Ryabushogoro",
                ],
              },
              {
                Nyagisozi: [
                  "Agatare",
                  "Kageyo",
                  "Kashango",
                  "Kinyana",
                  "Nyabukobero",
                  "Nyagisozi",
                  "Rukira",
                ],
              },
            ],
          },
          {
            Kiramuruzi: [
              {
                Akabuga: [
                  "Akagarama",
                  "Akarambo",
                  "Amataba",
                  "Bushenyi",
                  "Businde",
                  "Kiramuruzi",
                  "Kiyogori",
                  "Nduba",
                  "Ubuhoro",
                ],
              },
              {
                Gakenke: [
                  "Akabingo",
                  "Akamasine",
                  "Akurusizi",
                  "Bwunyu",
                  "Gatugunda",
                  "Gipangu",
                  "Kayita",
                  "Nyakagarama",
                  "Nyamarebe",
                  "Rwagashyaba",
                  "Umurehe",
                ],
              },
              {
                Gakoni: [
                  "Karuhura",
                  "Kiyovu",
                  "Kumana",
                  "Kumunini",
                  "Kumwiga",
                  "Rwajembe",
                ],
              },
              {
                Nyabisindu: [
                  "Akabare",
                  "Akabuga",
                  "Akantunga",
                  "Bushenyi",
                  "Gahoko",
                  "Gasave",
                  "Gitunginka",
                  "Itaba",
                  "Karaba",
                  "Nyagasambu",
                  "Nyagashenyi",
                  "Nyarusambu",
                  "Rugenge",
                ],
              },
            ],
          },
          {
            Kiziguro: [
              {
                Agakomeye: [
                  "Agatovu",
                  "Akabingo",
                  "Akingondo",
                  "Bishenyi",
                  "Bwiza",
                  "Isangano",
                  "Ishanti",
                  "Munanira",
                  "Muringa",
                  "Nyungwe",
                  "Ubutatu",
                ],
              },
              {
                Mbogo: [
                  "Akabuye",
                  "Akavumu",
                  "Nyakabungo",
                  "Nyakagarama",
                  "Rebero",
                  "Ryabihura",
                  "Ryamuhuzi",
                ],
              },
              {
                Ndatemwa: [
                  "Akabagendo",
                  "Akamamesa",
                  "Akarambo",
                  "Bidudu",
                  "Gakunyu",
                  "Gihinga",
                  "Gorora",
                  "Kabukungu",
                  "Kanyonyomba",
                  "Kigarama",
                  "Kinunga",
                  "Mataba",
                  "Mishunzi",
                  "Murehe",
                  "Nyagashenyi",
                  "Rubungo",
                  "Rukungu",
                  "Ryarugema",
                ],
              },
              {
                Rubona: [
                  "Agatare",
                  "Akagarama",
                  "Amarende",
                  "Bwiza",
                  "Cyarutabira",
                  "Ihema",
                  "Iramba",
                  "Kigabiro",
                  "Kigoroba",
                  "Kinimba",
                  "Nyagasambu",
                  "Nyarurembo",
                  "Rubaya",
                  "Rubira",
                  "Ryakabucye",
                  "Ryanyiranyana",
                  "Tubindi",
                ],
              },
            ],
          },
          {
            Muhura: [
              {
                Bibare: [
                  "Agasharu",
                  "Akabuga",
                  "Akagasaro",
                  "Cyahafi",
                  "Cyarugira",
                  "Cyaruhagazi",
                  "Gasigati",
                  "Kinyaga",
                  "Maryohe",
                  "Mugogo",
                  "Musasa",
                  "Rutoma",
                  "Rwangendo",
                ],
              },
              {
                Gakorokombe: [
                  "Agahama",
                  "Agasharu",
                  "Biniga",
                  "Kinihira",
                  "Nyarubuye",
                  "Umunini",
                  "Urubiri",
                  "Urugarama",
                  "Uwakibungo",
                ],
              },
              {
                Mamfu: [
                  "Agatagara",
                  "Akabirizi",
                  "Akamamana",
                  "Akamatamu",
                  "Akarengo",
                  "Kamugenge",
                  "Kaziga",
                  "Ruhinga",
                  "Rwanama",
                  "Umunanira",
                ],
              },
              {
                Rumuli: [
                  "Gihembe",
                  "Juga",
                  "Kabeza",
                  "Karama",
                  "Kigarama",
                  "Ntungamo",
                  "Nyange",
                  "Rwasama",
                  "Rweza",
                  "Umurambi",
                ],
              },
              {
                Taba: [
                  "Cyoga I",
                  "Cyoga II",
                  "Gahanga",
                  "Gatare",
                  "Kanyinya",
                  "Karenge",
                  "Matyazo",
                  "Mayora",
                  "Mwambaro",
                  "Nshoro",
                  "Rugarama",
                  "Ruhenda",
                  "Rususa",
                  "Rwangendo",
                  "Taba",
                ],
              },
            ],
          },
          {
            Murambi: [
              {
                Murambi: [
                  "Agacyamo",
                  "Agasharu",
                  "Agatagara",
                  "Akamashya",
                  "Byimana",
                  "Kabarondo",
                  "Kabuga",
                  "Kigote",
                  "Kimironko",
                  "Kiniga",
                  "Mataba",
                  "Ryampunga",
                  "Urugarama",
                ],
              },
              {
                Nyamiyaga: [
                  "Bweranyange",
                  "Kabeza",
                  "Kagenge",
                  "Kiniga",
                  "Runyinya",
                ],
              },
              {
                Rwankuba: [
                  "Akarambo",
                  "Akayenzi",
                  "Ikinyaga",
                  "Impanzi",
                  "Nyagasambu",
                  "Nyagatovu",
                  "Umwiga",
                  "Urugarama",
                ],
              },
              {
                Rwimitereri: [
                  "Bushenyi",
                  "Bweya",
                  "Byimana",
                  "Kibumba",
                  "Kigote",
                  "Kimondo",
                  "Kinunga",
                  "Nyakabanda",
                  "Rugarama",
                ],
              },
            ],
          },
          {
            Ngarama: [
              {
                Bugamba: [
                  "Akagerero",
                  "Cyamuganga",
                  "Kajevuba",
                  "Kinihira",
                  "Kinyinya",
                ],
              },
              {
                Karambi: [
                  "Cyankondo",
                  "Kamuri",
                  "Karambi",
                  "Kimbugu",
                  "Mishenyi",
                  "Ruhuha",
                  "Rurama",
                  "Rushenyi",
                  "Ruziranyenzi",
                  "Rwagakara",
                ],
              },
              {
                Kigasha: [
                  "Akabuga",
                  "Akabuye",
                  "Akagarama",
                  "Akajevuba",
                  "Byimana",
                  "Cyabahima",
                  "Cyahafi",
                  "Gikundamvura",
                  "Ikirongo",
                  "Iperu",
                  "Kinunga",
                  "Kiyovu",
                  "Kizunguruko",
                  "Mbogo",
                  "Nyagisa",
                  "Nyantojo",
                  "Rukombe",
                  "Rurama",
                  "Ruyonza",
                  "Rwangingo",
                ],
              },
              {
                Ngarama: [
                  "Amahoro",
                  "Gatungo",
                  "Ibare",
                  "Intsinzi",
                  "Kabeho",
                  "Kiyovu",
                  "Rugarama",
                  "Urukundo",
                ],
              },
              {
                Nyarubungo: [
                  "Burambira",
                  "Kintarama",
                  "Kivumu",
                  "Murama",
                  "Rugarama",
                  "Ruhengeri",
                  "Rutovu",
                  "Rwiri",
                ],
              },
            ],
          },
          {
            Nyagihanga: [
              {
                Gitinda: [
                  "Gatungo",
                  "Isangano",
                  "Kibimbiri",
                  "Kintarama",
                  "Kirehe",
                  "Kiziba",
                  "Nyabukingi",
                  "Rushenyi",
                  "Twegerane",
                ],
              },
              {
                Kibare: [
                  "Bitaba",
                  "Bushashari",
                  "Bwicaro",
                  "Gashure",
                  "Gatyazo",
                  "Kagera",
                  "Kigarama",
                  "Kukabare",
                  "Murambi",
                  "Rugaragara",
                ],
              },
              {
                Mayange: [
                  "Kabuye",
                  "Kajevuba",
                  "Kamatamu",
                  "Mpangare I",
                  "Mpangare II",
                  "Neke",
                  "Nyarubuye",
                  "Rweza",
                ],
              },
              {
                Murambi: [
                  "Gishikiri",
                  "Kabeza",
                  "Kagarama",
                  "Kanyinya",
                  "Mubirembo",
                  "Munanira",
                  "Rukoma",
                  "Rusenge",
                  "Umugamba",
                ],
              },
              {
                Nyagitabire: [
                  "Byimana",
                  "Kabudogo",
                  "Kamiseke",
                  "Kamurara",
                  "Kibatsi",
                  "Kuwingeri",
                  "Mataba",
                  "Mpashani",
                  "Nyamikamba",
                  "Par-chance",
                  "Rwintare",
                ],
              },
              {
                Nyamirama: [
                  "Burembo",
                  "Butumba",
                  "Cyanyanoga",
                  "Kabuga",
                  "Nyakabungo",
                  "Nyamiyaga",
                  "Rugarama",
                  "Rugogwe",
                ],
              },
            ],
          },
          {
            Remera: [
              {
                Bushobora: [
                  "Abanyangeyo",
                  "Agasenga",
                  "Akagarama I",
                  "Akagarama II",
                  "Akamabuye",
                  "Akankusi",
                  "Gumino",
                  "Nyagatabire",
                  "Rwagitima",
                ],
              },
              {
                Butiruka: ["Akabuga", "Gasabo", "Icyerekezo", "Urushenyi"],
              },
              {
                Kigabiro: [
                  "Akabuga",
                  "Amataba",
                  "Byimana",
                  "Kanyinya",
                  "Kigabiro",
                  "Runyinya",
                  "Rwamusaro",
                  "Rwikubo",
                  "Ryarutsinzi",
                ],
              },
              {
                Nyagakombe: [
                  "Akababito",
                  "Karufuri",
                  "Nyakanga",
                  "Nyamarebe",
                  "Nyaruhoko",
                ],
              },
              {
                Rurenge: [
                  "Akagarama",
                  "Butinza",
                  "Kagunga",
                  "Kibenga",
                  "Nyagasozi",
                  "Rubare",
                  "Rugarama",
                  "Rurenge",
                ],
              },
              {
                Rwarenga: [
                  "Cyeru",
                  "Kabuye",
                  "Kagasha",
                  "Kigarama",
                  "Nyamugari",
                  "Nyarubuye",
                  "Rushenyi",
                  "Umunini",
                ],
              },
            ],
          },
          {
            Rugarama: [
              {
                Bugarama: ["Akenene", "Kabare", "Nyagasiga", "Rebero"],
              },
              {
                Gihuta: [
                  "Agatare",
                  "Gashenyi I",
                  "Gashenyi II",
                  "Ibare",
                  "Ntende I",
                  "Ntende II",
                  "Nyagahanga",
                ],
              },
              {
                Kanyangese: [
                  "Agakiri",
                  "Akazinga",
                  "Amahoro",
                  "Cyampirita",
                  "Kabeza",
                  "Kanyangese",
                  "Munini",
                  "Nyabubare",
                  "Nyakariro",
                  "Rebero",
                  "Remera",
                  "Rugarama",
                  "Rugazi",
                  "Rwagitima",
                  "Rwunyu",
                  "Tetero",
                ],
              },
              {
                Matare: [
                  "Agakenyeri",
                  "Akabare",
                  "Bujumo",
                  "Gitsimba I",
                  "Gitsimba II",
                  "Kabana",
                  "Matare",
                  "Nyagatare",
                  "Nyarusambu",
                  "Rebero",
                  "Rwankuba",
                ],
              },
              {
                Matunguru: [
                  "Akabasanza",
                  "Gatovu",
                  "Kabeza",
                  "Ngoma",
                  "Nyabagendwa",
                  "Nyamata",
                  "Nyamirambo",
                  "Nyenyeri",
                  "Rambura",
                  "Rushenyi",
                  "Tungiro",
                ],
              },
              {
                Remera: [
                  "Akajevuba",
                  "Gikoma",
                  "Kanyiranzage",
                  "Miko",
                  "Rwamivu",
                ],
              },
            ],
          },
          {
            Rwimbogo: [
              {
                Kiburara: [
                  "Isangano",
                  "Kiburara",
                  "Nyacyonga",
                  "Rebero",
                  "Rubirizi",
                  "Rugando",
                ],
              },
              {
                Munini: [
                  "Gikobwa",
                  "Humure",
                  "Kabeza",
                  "Marembo",
                  "Mucucu",
                  "Munini",
                  "Nyamwiza",
                  "Rweza",
                  "Rwinyana",
                ],
              },
              {
                Nyamatete: [
                  "Akajevuba",
                  "Gashenyi",
                  "Gihunika",
                  "Gitega",
                  "Kabeza",
                  "Kagugu",
                  "Kidugudu",
                  "Kiyovu",
                  "Nyamatete",
                  "Rurembo",
                  "Rwimbogo",
                  "Rwiminazi",
                  "Umurego",
                ],
              },
              {
                Rwikiniro: [
                  "Akamahoro",
                  "Byimana",
                  "Isangano",
                  "Kabusunzu",
                  "Karambi",
                  "Kinunga",
                  "Ndama I",
                  "Ndama II",
                  "Nyamabuye",
                  "Rukomo",
                  "Rwikiniro I",
                  "Rwikiniro II",
                ],
              },
            ],
          },
        ],
      },
      {
        Kayonza: [
          {
            Gahini: [
              {
                Juru: [
                  "Gisenga",
                  "Juru",
                  "Kamudongo",
                  "Kimana",
                  "Kwisoko",
                  "Mikinga",
                  "Miyaga",
                  "Musimbi",
                  "Nyabombe",
                  "Nyabugogo",
                  "Nyakabungo",
                  "Rubariro",
                ],
              },
              {
                Kahi: ["Akabare", "Nyamiyaga", "Rukore", "Tsima", "Uruhuha"],
              },
              {
                Kiyenzi: [
                  "Kabuye",
                  "Kinyinya",
                  "Kiyenzi",
                  "Nyagahandagaza",
                  "Nyirampaca",
                ],
              },
              {
                Urugarama: [
                  "Akabahizi",
                  "Akabeza",
                  "Akamuyenzi",
                  "Akimpara",
                  "Buyanja",
                  "Ibiza",
                  "Myatano",
                  "Nyagitabire",
                  "Rwinkuba",
                  "Umwiga",
                  "Urugarama",
                  "Videwo",
                ],
              },
            ],
          },
          {
            Kabare: [
              {
                Cyarubare: [
                  "Kabeza",
                  "Kacyiru",
                  "Kanyetonga",
                  "Kibimba",
                  "Kiburara",
                  "Mahumbezi",
                  "Nyagakonji",
                  "Rukagati",
                  "Rwabarema",
                  "Rwakavuna",
                  "Umunini",
                  "Umuremampango",
                  "Umuyenzi",
                ],
              },
              {
                Gitara: [
                  "Gahombya",
                  "Kagumiro",
                  "Kajevuba",
                  "Kazeneza",
                  "Mubuga",
                  "Rugunga",
                ],
              },
              {
                Kirehe: [
                  "Duterimbere",
                  "Gahama",
                  "Gikombe",
                  "Kabatinya",
                  "Kabuhome",
                  "Kanyirabuki",
                  "Matahiro",
                  "Nyabiyenzi",
                  "Rompuwe",
                  "Rushenyi",
                  "Rwagatera",
                ],
              },
              {
                Rubimba: [
                  "Bara",
                  "Buhabwa",
                  "Kabarungu",
                  "Kabeza",
                  "Kamuhabura",
                  "Nyarusange",
                  "Rwamushoma",
                ],
              },
              {
                Rubumba: [
                  "Bwatampama",
                  "Gakenyeri",
                  "Gakoma",
                  "Gishyoza",
                  "Kibimba",
                  "Kibuye",
                  "Ntungamo",
                  "Nyabugogo",
                ],
              },
            ],
          },
          {
            Kabarondo: [
              {
                Cyabajwa: [
                  "Busindu",
                  "Cyabajwa",
                  "Kabarondo",
                  "Murenge",
                  "Nkuba I",
                  "Nkuba II",
                  "Rugwagwa",
                  "Rutagara",
                ],
              },
              {
                Cyinzovu: [
                  "Agashikiri",
                  "Akinyenyeri",
                  "Bitoma",
                  "Cyinzovu",
                  "Gihuke",
                  "Munini",
                  "Nyabisenga",
                  "Nyakabungo",
                  "Rugarama",
                  "Rugazi",
                  "Rurenge",
                  "Rwakigeri",
                ],
              },
              {
                Kabura: [
                  "Agasharu",
                  "Agatare",
                  "Akagarama",
                  "Gashonyi",
                  "Gisoro",
                  "Kabeza",
                  "Kabuye",
                  "Kanyegenyege",
                  "Murambi",
                  "Nyabikenke I",
                  "Nyabikenke II",
                  "Rubira",
                ],
              },
              {
                Rusera: [
                  "Butobagire",
                  "Rurama",
                  "Rusera",
                  "Rutagara Centre",
                  "Umucyo",
                ],
              },
            ],
          },
          {
            Mukarange: [
              {
                Bwiza: [
                  "Abemeramahoro",
                  "Abisunganye",
                  "Amizero",
                  "Karambarara",
                  "Kinyemera",
                ],
              },
              {
                Kayonza: [
                  "Akabuga",
                  "Buhonde",
                  "Cyeru",
                  "Gakurazo",
                  "Gasogororo",
                  "Gatebe",
                  "Kabungo",
                  "Kayonza Centre",
                  "Kivugiza",
                  "Miyange",
                  "Munazi",
                ],
              },
              {
                Mburabuturo: [
                  "Akabuga",
                  "Akarugangare",
                  "Bwingeyo",
                  "Gihima",
                  "Kinunga",
                  "Mburabuturo",
                ],
              },
              {
                Nyagatovu: [
                  "Akabeza",
                  "Akamarara",
                  "Akamayange",
                  "Akanyinya",
                  "Gatagara",
                  "Iragwe",
                  "Irebero",
                  "Nyagatovu",
                ],
              },
              {
                Rugendabari: [
                  "Gikumba",
                  "Kanyamasha",
                  "Karambo I",
                  "Karambo II",
                  "Nyakagarama",
                  "Rugendabari",
                  "Rutare",
                ],
              },
            ],
          },
          {
            Murama: [
              {
                Bunyentongo: [
                  "Bweramvura",
                  "Gahengeri",
                  "Gisunzu",
                  "Kabeza",
                  "Kagarama",
                  "Mpilindi",
                  "Nyamabuye",
                  "Shyanda",
                ],
              },
              {
                Muko: ["Gihazo", "Karama", "Ngoma", "Rebezo", "Rugarama"],
              },
              {
                Murama: [
                  "Bubindi",
                  "Kajevuba",
                  "Murama",
                  "Rusaro",
                  "Rwabugengeri",
                ],
              },
              {
                Nyakanazi: [
                  "Busasamana",
                  "Nyagahinga",
                  "Nyakanazi",
                  "Rugazi",
                  "Rurenge",
                ],
              },
              {
                Rusave: [
                  "Bicumbi",
                  "Bwinyana",
                  "Byimana",
                  "Gasutamo",
                  "Kinyinya",
                  "Seresi",
                ],
              },
            ],
          },
          {
            Murundi: [
              {
                Buhabwa: [
                  "Buhabwa",
                  "Cyamburara",
                  "Gakoma",
                  "Miyaga",
                  "Mucucu",
                  "Murundi",
                ],
              },
              {
                Karambi: [
                  "Akamina",
                  "Bugarura",
                  "Gafunzo",
                  "Kabana",
                  "Kabuga",
                  "Karambi",
                  "Kiyovu",
                  "Ngumeri I",
                  "Ngumeri II",
                  "Nyagashanga",
                  "Nyamirama",
                  "Rugunga",
                  "Rukoyoyo",
                  "Rumuri",
                  "Rushenyi",
                  "Rwasama",
                  "Rwinsheke I",
                  "Rwinsheke II",
                ],
              },
              {
                Murundi: [
                  "Kayongo",
                  "Kibari",
                  "Kinyana",
                  "Macuba",
                  "Nyanga",
                  "Rucaca",
                ],
              },
              {
                Ryamanyoni: [
                  "Akanyerezo",
                  "Cyandorimana",
                  "Kabingo",
                  "Kaneke",
                  "Kanyegera",
                  "Ngarama",
                  "Nyabugando",
                  "Rwakabanda",
                  "Rwinyambo",
                  "Ryakirenzi I",
                  "Ryakirenzi II",
                  "Ryamanyoni",
                  "Ubwiza",
                ],
              },
            ],
          },
          {
            Mwiri: [
              {
                Kageyo: [
                  "Gisunzu",
                  "Kiyonza",
                  "Ndago",
                  "Rugeyo",
                  "Rwisirabo I",
                  "Rwisirabo II",
                  "Sebasengo",
                ],
              },
              {
                Migera: [
                  "Agahiza",
                  "Murori",
                  "Mwiri",
                  "Nyakagarama",
                  "Umutekano",
                ],
              },
              {
                Nyamugari: [
                  "Gasarabwayi",
                  "Kabeza",
                  "Kabukeye",
                  "Kigarama",
                  "Ruhoroba",
                  "Rwazana",
                  "Ryamutumo",
                ],
              },
              {
                Nyawera: [
                  "Gitega",
                  "Muhozi",
                  "Murehe",
                  "Nyakabungo",
                  "Ryakibanda",
                ],
              },
            ],
          },
          {
            Ndego: [
              {
                Byimana: [
                  "Busasamana",
                  "Irebero",
                  "Kabeza",
                  "Kururembo",
                  "Nyakabingo",
                  "Nyamata",
                ],
              },
              {
                Isangano: [
                  "Gafunzo",
                  "Gashonga",
                  "Kabusunzu",
                  "Kagese",
                  "Kagoma",
                  "Kamahoro",
                  "Kanyinya",
                  "Kibare",
                ],
              },
              {
                Karambi: [
                  "Gasenyi",
                  "Ihema",
                  "Kagasa",
                  "Kamabuye",
                  "Kumunini",
                  "Murambi",
                  "Musenyi",
                  "Remera",
                ],
              },
              {
                Kiyovu: ["Gasabo", "Humure", "Iramiro", "Mwurire", "Nyamugali"],
              },
            ],
          },
          {
            Nyamirama: [
              {
                Gikaya: [
                  "Gasharu",
                  "Gasogi",
                  "Gasura",
                  "Kabuye",
                  "Kamonyi",
                  "Karambi",
                  "Kinkoronko",
                  "Kiyanja",
                ],
              },
              {
                Musumba: [
                  "Karama",
                  "Kiyovu",
                  "Musenyi",
                  "Nyabisindu",
                  "Nyagasambu",
                  "Nyarunazi",
                  "Rusera",
                ],
              },
              {
                Rurambi: [
                  "Amashinge",
                  "Bwiza",
                  "Kabeza",
                  "Kabuya I",
                  "Kabuya II",
                  "Kabuye",
                  "Ntintyi",
                  "Rugarama",
                  "Ruvumu",
                  "Shirinyota",
                ],
              },
              {
                Shyogo: [
                  "Agasharu",
                  "Gatoki",
                  "Kacyiru",
                  "Nyacyonga",
                  "Nyakagarama",
                  "Rugagi",
                  "Rwangabarezi",
                  "Rwinyana",
                ],
              },
            ],
          },
          {
            Rukara: [
              {
                Kawangire: [
                  "Butimba I",
                  "Butimba II",
                  "Gakenyeri",
                  "Gitega",
                  "Karama",
                  "Kidogo",
                  "Kinunga",
                  "Rwempasha",
                ],
              },
              {
                Rukara: [
                  "Butimba",
                  "Buyonza",
                  "Gitarama",
                  "Ibiza",
                  "Kabuga",
                  "Kamajigija",
                  "Karambo I",
                  "Karambo II",
                  "Karubamba",
                  "Kinunga I",
                  "Kinunga II",
                  "Mitungo",
                  "Mumuri",
                  "Munyinya",
                  "Muzizi",
                  "Nyagaharabuge",
                  "Nyirarukara",
                  "Uruyenzi",
                ],
              },
              {
                Rwimishinya: [
                  "Akabare I",
                  "Akabare II",
                  "Karagari I",
                  "Karagari II",
                  "Kigwene I",
                  "Kigwene II",
                  "Kinunga I",
                  "Kinunga II",
                  "Mirambi I",
                  "Mirambi II",
                  "Mirambi III",
                  "Nyarutunga I",
                  "Nyarutunga II",
                ],
              },
            ],
          },
          {
            Ruramira: [
              {
                Bugambira: [
                  "Agasharu",
                  "Agatare",
                  "Amashya",
                  "Buhoro",
                  "Murambi",
                ],
              },
              {
                Nkamba: [
                  "Akabarima",
                  "Akarambo",
                  "Cyabitana",
                  "Gitega",
                  "Nyagacyamu",
                  "Sabununga",
                  "Umubuga",
                ],
              },
              {
                Ruyonza: [
                  "Gisenga",
                  "Gitoki",
                  "Gitwa",
                  "Kabeza",
                  "Kacyiru",
                  "Rukoma",
                  "Taba",
                ],
              },
              {
                Umubuga: [
                  "Agasharu",
                  "Akarugina",
                  "Amazinga",
                  "Gitesannyi",
                  "Kabukara",
                  "Kabuye",
                  "Kajembe",
                  "Kamukire",
                ],
              },
            ],
          },
          {
            Rwinkwavu: [
              {
                Gihinga: [
                  "Akajevuba",
                  "Akayebe",
                  "Gihinga",
                  "Karuhambo",
                  "Migera",
                  "Nyabimuri",
                  "Rubirizi",
                  "Rugunga",
                  "Rusera",
                  "Uburembo",
                ],
              },
              {
                Mbarara: [
                  "Gacaca",
                  "Gahushyi",
                  "Kingogo",
                  "Mbarara I",
                  "Mbarara II",
                  "Mutembo",
                ],
              },
              {
                Mukoyoyo: [
                  "Bishenyi",
                  "Busasamana",
                  "Bwiza",
                  "Dusabane",
                  "Kazeneza",
                  "Kiyovu",
                  "Mahumbezi",
                  "Mutembo",
                  "Nyamabuye",
                  "Nyankora",
                  "Nyarwashama I",
                  "Nyarwashama II",
                  "Rebero",
                  "Twibanire",
                  "Twiyunge",
                  "Vungiro",
                ],
              },
              {
                Nkondo: [
                  "Burigade",
                  "Byimana",
                  "Gasabo",
                  "Gisozi",
                  "Kinihira",
                  "Matinza",
                  "Muganza",
                  "Nkondo I",
                  "Nkondo II",
                  "Nyabihare",
                  "Rebero",
                  "Rurama",
                  "Rwinkwavu",
                  "Seka",
                ],
              },
            ],
          },
        ],
      },
      {
        Kirehe: [
          {
            Gahara: [
              {
                Butezi: [
                  "Cyamabuye",
                  "Cyasusa I",
                  "Cyasusa II",
                  "Irama Centre",
                  "Kabeza",
                  "Kijumbura I",
                  "Kijumbura II",
                  "Kijumbura III",
                  "Kivogera",
                  "Rwabarimba",
                  "Rwabiyombe",
                  "Rwamabenga",
                  "Rwamuzima",
                  "Samuko",
                  "Umubano I",
                  "Umubano II",
                ],
              },
              {
                Muhamba: [
                  "Bukorasi",
                  "Cyobaharaye",
                  "Gacaca",
                  "Gasaka",
                  "Gasasa",
                  "Kabeza",
                  "Muhero",
                  "Murama",
                  "Muyange",
                  "Ntaruka",
                  "Nyabitare",
                  "Rusisiro",
                ],
              },
              {
                Murehe: [
                  "Cyasemakamba",
                  "Cyumbati",
                  "Isangano",
                  "Mugogo",
                  "Murama I",
                  "Murama II",
                  "Nyakarambi",
                  "Nyamahuna",
                  "Nyamirondogoro",
                  "Nyamugari",
                  "Nyankurazo",
                  "Nyombe",
                  "Village Dagaza",
                ],
              },
              {
                Nyagasenyi: [
                  "Cyabihama I",
                  "Cyabihama II",
                  "Gakurungo",
                  "Gasarabwayi",
                  "Gashongora",
                  "Iribagiza",
                  "Kabagera",
                  "Kagarama",
                  "Mugatare",
                  "Nyakabimba",
                  "Nyamisagara",
                  "Rugando",
                  "Rugina",
                  "Rusave",
                  "Rwabaseka",
                  "Rwambanda",
                ],
              },
              {
                Nyakagezi: [
                  "Kivogo",
                  "Muguruka I",
                  "Muguruka II",
                  "Mukundanya",
                  "Nyagasozi",
                  "Rubira",
                  "Rubumba",
                  "Rurama",
                  "Susuruka",
                ],
              },
              {
                Rubimba: [
                  "Agatangaza",
                  "Byimana",
                  "Kanteyamanga",
                  "Kinyonzo I",
                  "Kinyonzo II",
                  "Nyagasozi",
                  "Nyakarambi",
                  "Rubira",
                  "Rununga",
                  "Rwakajonge",
                  "Rwamaranga I",
                  "Rwamaranga II",
                  "Rwamurema",
                  "Umubogora",
                ],
              },
            ],
          },
          {
            Gatore: [
              {
                Curazo: [
                  "Gatenga",
                  "Kigarama",
                  "Mugeruko",
                  "Nyarwogo",
                  "Rugari",
                  "Runyinya",
                  "Rutoma",
                ],
              },
              {
                Cyunuzi: [
                  "Cyunuzi I",
                  "Cyunuzi II",
                  "Gakuyo",
                  "Kabeza",
                  "Kabungo",
                  "Nyagashyanga",
                  "Rurenge",
                ],
              },
              {
                Muganza: [
                  "Kamomo",
                  "Karenge",
                  "Ntungamo",
                  "Nyarusange",
                  "Rebero",
                  "Rwabigaro",
                ],
              },
              {
                Nyamiryango: [
                  "Bwiza",
                  "Gashanga",
                  "Gasharu",
                  "Karambi",
                  "Nyagitongo",
                  "Rubuye",
                  "Rwanyabigaba",
                ],
              },
              {
                Rwabutazi: [
                  "Bitoma I",
                  "Bitoma II",
                  "Muyange",
                  "Rugina",
                  "Rurembo I",
                  "Samuko",
                  "Ururembo II",
                ],
              },
              {
                Rwantonde: [
                  "Cyiha",
                  "Karehero",
                  "Karembo",
                  "Kavomo",
                  "Kigarama",
                  "Mitoyi",
                  "Mumeya",
                  "Rubona",
                  "Rusenyi",
                  "Rutare",
                ],
              },
            ],
          },
          {
            Kigarama: [
              {
                Cyanya: [
                  "Cyanya",
                  "Gakoni",
                  "Kabimba I",
                  "Kabimba II",
                  "Kigende",
                  "Nyakavogo",
                  "Nyamikoni",
                  "Nyamirambo I",
                  "Nyamirambo II",
                  "Nyarutovu",
                  "Rubare",
                ],
              },
              {
                Kigarama: [
                  "Gahindu",
                  "Humure",
                  "Kigarama",
                  "Kiravunga",
                  "Nyakazinga",
                  "Nyamiyaga",
                  "Nyarutojo",
                  "Rugari",
                  "Rurenge",
                  "Samuko",
                ],
              },
              {
                Kiremera: [
                  "Bweranka I",
                  "Bweranka II",
                  "Cyanika",
                  "Irama",
                  "Kagane",
                  "Kagorogoro",
                  "Kaguriro",
                  "Karenge I",
                  "Karenge II",
                  "Kayirarye",
                  "Kimesho",
                  "Kiremera",
                  "Nyaryenge",
                  "Rwesinge",
                  "Umunezero",
                ],
              },
              {
                Nyakerera: [
                  "Gasenyi",
                  "Gatari",
                  "Kabare",
                  "Kabuga",
                  "Kiyovu",
                  "Nyabubare",
                  "Ruhandagazi",
                  "Rukiri",
                  "Ryamukaza",
                ],
              },
              {
                Nyankurazo: [
                  "Kabeza",
                  "Kivu",
                  "Marembo",
                  "Nshungerezi",
                  "Nyagahanga",
                  "Nyakabungo",
                  "Nyakigera",
                  "Nyakwisi",
                  "Rama",
                  "Ruhuha",
                  "Rusumo",
                ],
              },
            ],
          },
          {
            Kigina: [
              {
                Gatarama: [
                  "Efemu",
                  "Gitaba",
                  "Kabimba",
                  "Kabugwe",
                  "Kanogo",
                  "Kanyabihara",
                  "Nyakizu",
                  "Ruhama",
                ],
              },
              {
                Rugarama: [
                  "Isangano",
                  "Kabeza",
                  "Kagega",
                  "Kimeya",
                  "Kubwinteko",
                  "Kabuga",
                  "Kundengo",
                  "Byimana",
                  "Muganza",
                  "Nyagisozi",
                  "Rugando",
                  "Rugarama",
                  "Rujambara",
                  "Rwakanyambo",
                ],
              },
              {
                Ruhanga: [
                  "Buhwaga",
                  "Kavuzo",
                  "Ku Murenge",
                  "Nyagasozi",
                  "Nyakarambi I",
                  "Nyakarambi II",
                  "Nyakibande",
                  "Rebezo",
                  "Rubare",
                  "Rwagasare I",
                  "Rwagasare II",
                  "Rwakarinda",
                  "Rwamabare",
                  "Rwamakara",
                  "Rwanyamutara",
                ],
              },
              {
                Rwanteru: [
                  "Bugarura",
                  "Gasarasi",
                  "Mugisenyi I",
                  "Mugisenyi II",
                  "Nyakayaga",
                  "Rusororo",
                  "Rwanteru I",
                  "Rwanteru II",
                ],
              },
            ],
          },
          {
            Kirehe: [
              {
                Gahama: [
                  "Byimana",
                  "Kabeza",
                  "Kaziba",
                  "Kiyovu",
                  "Muhweza",
                  "Murugarama",
                  "Ntungamo",
                  "Nyakatsi",
                  "Nyamazi",
                  "Rebero",
                ],
              },
              {
                Kirehe: [
                  "Agatwa",
                  "Byimana",
                  "Kamasaro",
                  "Kirehe",
                  "Mirambi",
                  "Runyinya",
                ],
              },
              {
                Nyabigega: [
                  "Bugarura",
                  "Duterimbere",
                  "Gahuzamiryango",
                  "Kabeza",
                  "Kamuhoza",
                  "Mushirarungu",
                  "Nyarurembo",
                  "Rurenge",
                  "Twizerane",
                  "Vatikani",
                ],
              },
              {
                Nyabikokora: [
                  "Bwiza",
                  "Byimana",
                  "Kaduha",
                  "Karenge",
                  "Kiyovu",
                  "Kwihanika",
                  "Kwirebero",
                  "Mumpinga",
                  "Nyarurembo",
                  "Nyarusange",
                  "Rugenge",
                  "Rugero",
                  "Rurama",
                  "Rusamaza",
                  "Rutonde",
                ],
              },
              {
                Rwesero: [
                  "Bengazi",
                  "Byimana",
                  "Gahama",
                  "Kabeza",
                  "Karuhura",
                  "Munini",
                  "Rwabikweto",
                  "Rwesero",
                ],
              },
            ],
          },
          {
            Mahama: [
              {
                Kamombo: [
                  "Amahoro",
                  "Bwiza",
                  "Byimana",
                  "Kabuga",
                  "Kamabuye",
                  "Kamato",
                  "Kamombo",
                  "Kigongi",
                  "Kigufi",
                  "Rumuri",
                  "Terimbere",
                  "Umubano",
                ],
              },
              {
                Munini: [
                  "Kabeza",
                  "Kagera",
                  "Karambi",
                  "Munini",
                  "Nyenyeri",
                  "Rebero",
                  "Remanyundo",
                  "Rugarama",
                  "Ruhondo",
                ],
              },
              {
                Mwoga: [
                  "Buhaga",
                  "Cyanika",
                  "Gisanze",
                  "Isangano",
                  "Kwisha",
                  "Mwoga",
                  "Nyarusange",
                ],
              },
              {
                Saruhembe: [
                  "Gisenyi",
                  "Kanombe",
                  "Karebezo",
                  "Muride",
                  "Nyagahanga",
                  "Nyamiyumbo",
                  "Rushonga",
                  "Saruhembe",
                ],
              },
              {
                Umunini: ["Ihuriro"],
              },
            ],
          },
          {
            Mpanga: [
              {
                Bwiyorere: [
                  "Bihembe",
                  "Cyimparage",
                  "Gisenyi",
                  "Kacyiru",
                  "Kamarashavu",
                  "Kangarame",
                  "Nyagasenyi",
                  "Nyakabande",
                  "Ruhama",
                ],
              },
              {
                Kankobwa: [
                  "Kankobwa",
                  "Murundi",
                  "Nyamiyaga",
                  "Remera",
                  "Rusha",
                ],
              },
              {
                Mpanga: [
                  "Kabuye I",
                  "Kabuye II",
                  "Mpanga",
                  "Nyagatovu",
                  "Rurambi I",
                  "Rurambi II",
                ],
              },
              {
                Mushongi: [
                  "Gitoma",
                  "Kayanga",
                  "Mishenyi",
                  "Mushongi",
                  "Ngugu I",
                  "Ngugu II",
                ],
              },
              {
                Nasho: [
                  "Agasasa",
                  "Busasamana I",
                  "Busasamana II",
                  "Ibanda",
                  "Mutwe",
                  "Nyabubare I",
                  "Nyabubare II",
                  "Nyawera I",
                  "Nyawera II",
                  "Pilote",
                ],
              },
              {
                Nyakabungo: [
                  "Cyamuhabura",
                  "Gikushya",
                  "Gitega",
                  "Isenga",
                  "Kabuga",
                  "Nyagatovu",
                  "Nyakabungo",
                  "Rudandi",
                  "Rushenyi",
                ],
              },
              {
                Rubaya: [
                  "Akinzuki",
                  "Byimana",
                  "Gacenshero",
                  "Kabeza",
                  "Mumpinga",
                  "Murambi",
                  "Rubaya",
                  "Rukonji",
                  "Rushonga",
                ],
              },
            ],
          },
          {
            Musaza: [
              {
                Gasarabwayi: [
                  "Gasarabwayi",
                  "Gicuma",
                  "Kanyosha",
                  "Nyakariba I",
                  "Nyakariba II",
                  "Nyakiriba",
                  "Rukumba",
                  "Rwinyundo",
                ],
              },
              {
                Kabuga: [
                  "Gikenke",
                  "Kabuga",
                  "Kagasa",
                  "Kambwire",
                  "Kimeya",
                  "Nyamugari",
                  "Rubuye I",
                  "Rubuye II",
                  "Rugango",
                  "Rwamurema",
                ],
              },
              {
                Mubuga: [
                  "Kanogo",
                  "Kanombe",
                  "Kiyovu",
                  "Mubuga",
                  "Runyinya",
                  "Rwamuhazi",
                  "Ryabega",
                  "Ryarugazi",
                ],
              },
              {
                Musaza: [
                  "Gatwe I",
                  "Gatwe II",
                  "Kanyinya I",
                  "Kanyinya II",
                  "Musaza",
                  "Muyoka",
                  "Nyakariba",
                ],
              },
              {
                Nganda: [
                  "Gacuba I",
                  "Gacuba II",
                  "Kamagare",
                  "Kaziba",
                  "Murura",
                  "Nganda",
                  "Nganda Ville I",
                  "Nganda Ville II",
                  "Nyamiyaga",
                  "Ruseke",
                  "Rwabugagara",
                  "Rwamushongore",
                ],
              },
            ],
          },
          {
            Mushikiri: [
              {
                Bisagara: [
                  "Bingaro",
                  "Bisagara",
                  "Isangano",
                  "Kampara",
                  "Nkoyoyo",
                  "Nyabubare",
                  "Nyakabande",
                  "Ruturamigina",
                  "Umunini",
                  "Umutuzo",
                  "Umuyange",
                ],
              },
              {
                Cyamigurwa: [
                  "Bwiza",
                  "Impara",
                  "Isangano",
                  "Kamasare",
                  "Karenge",
                  "Kigarama",
                  "Nyamabuye",
                  "Rusenyi",
                ],
              },
              {
                Rugarama: [
                  "Birengero",
                  "Bugarura",
                  "Cyanjuna",
                  "Cyanyamisa",
                  "Gahushyi",
                  "Kacyiru",
                  "Kamarashavu",
                  "Kamunyana",
                  "Karambi",
                  "Nyagatugunda",
                  "Nyagitongo",
                  "Rutare",
                  "Rwamunana",
                  "Ryogire",
                  "Tomi",
                ],
              },
              {
                Rwanyamuhanga: [
                  "Bweramana",
                  "Cyaka",
                  "Cyeru",
                  "Humure",
                  "Mugina",
                  "Munini",
                  "Nterere",
                  "Nyagateme",
                  "Nyaruhanga",
                  "Rubimba",
                  "Rutare",
                  "Rutoma",
                  "Sake",
                ],
              },
              {
                Rwayikona: [
                  "Barisuka",
                  "Birembo",
                  "Isangano",
                  "Kabeza",
                  "Kabuga",
                  "Nyakabande",
                  "Nyungwe",
                  "Rukira",
                  "Rusumo",
                  "Rwahenge",
                  "Rwakabandama",
                  "Rwayikona",
                  "Tonero",
                ],
              },
            ],
          },
          {
            Nasho: [
              {
                Cyambwe: [
                  "Gicaca",
                  "Kagamba",
                  "Kagese I",
                  "Nyakazinga",
                  "Rugwiro",
                  "Rukono",
                  "Rushoka",
                  "Rwinyange",
                ],
              },
              {
                Kagese: [
                  "Gatunguru",
                  "Kagese II",
                  "Kanamira",
                  "Kibimba",
                  "Mitsindo",
                  "Murehe",
                  "Nyabimuri",
                ],
              },
              {
                Ntaruka: [
                  "Gashasha",
                  "Kabusunzu",
                  "Karenge II",
                  "Nyabihara",
                  "Nyagasozi",
                  "Nyamurindira",
                  "Ruhema",
                  "Ruseke",
                  "Rwamuhigi",
                ],
              },
              {
                Rubirizi: [
                  "Kabigembe I",
                  "Kabigembe II",
                  "Kadamu",
                  "Karenge I",
                  "Masizi",
                  "Mulindi",
                  "Nyabiyenzi",
                  "Rwandarushya I",
                  "Rwandarushya II",
                ],
              },
              {
                Rugoma: [
                  "Gashiru",
                  "Gatarama",
                  "Gatare",
                  "Kabigembe",
                  "Kageyo",
                  "Karama",
                  "Karubare",
                  "Rebezo",
                  "Rugoma",
                ],
              },
            ],
          },
          {
            Nyamugari: [
              {
                Bukora: [
                  "Bukinanyana",
                  "Bukora",
                  "Busasamana",
                  "Bweramana",
                  "Kabuga",
                  "Maranyundo",
                  "Mudahunga",
                  "Mumararungu",
                  "Mushirarungu",
                  "Mwima",
                  "Nyabiyenzi",
                  "Remanyundo",
                ],
              },
              {
                Kagasa: [
                  "Bwiza",
                  "Ituze",
                  "Kagasa",
                  "Kamabuye",
                  "Kameya",
                  "Mataba",
                  "Nyabayama",
                  "Nyakariba",
                  "Nyamirama",
                  "Nyarurembo",
                  "Rebero",
                  "Urugwiro",
                ],
              },
              {
                Kazizi: [
                  "Amahoro",
                  "Byimana",
                  "Gahomvu",
                  "Gasabo",
                  "Gasetsa",
                  "Gashanga",
                  "Jyambere",
                  "Kabwayi",
                  "Mucyo",
                  "Nyenyeri",
                  "Tetero",
                  "Ururembo",
                ],
              },
              {
                Kiyanzi: [
                  "Kabungeri",
                  "Kabuye",
                  "Kacyiru",
                  "Kagera",
                  "Kamarashavu",
                  "Karambi",
                  "Karehe",
                  "Karembo",
                  "Kinamba",
                  "Matare",
                  "Mitako",
                  "Murambi",
                  "Muyinza",
                  "Nyarwamura",
                  "Remera",
                  "Rusumo",
                ],
              },
              {
                Nyamugari: [
                  "Amahoro",
                  "Gasenyi",
                  "Ihuriro",
                  "Isangano",
                  "Kabeza",
                  "Kamugarura",
                  "Kimigisha",
                  "Munini",
                  "Muramba",
                  "Nyagahama",
                  "Nyamugari Centre",
                  "Rama",
                  "Rebero",
                  "Rurembo",
                  "Rusozi",
                  "Ubumwe",
                  "Umubano",
                  "Umunezero",
                ],
              },
            ],
          },
          {
            Nyarubuye: [
              {
                Mareba: [
                  "Burembo",
                  "Kaziba I",
                  "Kaziba II",
                  "Nyacyonga I",
                  "Nyacyonga II",
                  "Nyamateke",
                  "Rurenge I",
                  "Rurenge II",
                ],
              },
              {
                Nyabitare: [
                  "Bicumbi",
                  "Kazizi",
                  "Kazizi II",
                  "Mpanguhe",
                  "Ndabarekuye",
                  "Nyabayama",
                  "Nyabitare",
                  "Nyamisagara",
                  "Nyamugari",
                  "Rugarama",
                  "Rwamagana",
                ],
              },
              {
                Nyarutunga: [
                  "Bugarura",
                  "Kagabiro",
                  "Kagorogoro",
                  "Nkakwa",
                  "Nyakanazi",
                  "Nyarubuye I",
                  "Nyarubuye II",
                  "Nyarutunga",
                  "Remera",
                  "Rubare",
                  "Rutunga",
                ],
              },
            ],
          },
        ],
      },
      {
        Ngoma: [
          {
            Gashanda: [
              {
                Cyerwa: [
                  "Cyerwa",
                  "Gako",
                  "Mizibiri",
                  "Muyange",
                  "Nyamugali",
                  "Ruyema I",
                  "Ruyema II",
                ],
              },
              {
                Giseri: [
                  "Kibimba",
                  "Murambi",
                  "Nyagitabire",
                  "Rubambantare",
                  "Rwambohero",
                  "Rwanyamigono",
                ],
              },
              {
                Munege: ["Gakuto", "Kanege", "Nyagasenga", "Rugarama"],
              },
              {
                Mutsindo: [
                  "Cyanama",
                  "Gisenyi",
                  "Kanyinya",
                  "Kirundo",
                  "Nyakarambo",
                  "Nyamasare",
                  "Rwakavuna",
                  "Rwinkuba",
                  "Ryangiriye",
                ],
              },
            ],
          },
          {
            Jarama: [
              {
                Ihanika: [
                  "Irebero",
                  "Kabonero",
                  "Kamapfizi",
                  "Kivugiza",
                  "Nyamugari",
                  "Umuka",
                ],
              },
              {
                Jarama: [
                  "Abiyunze",
                  "Akabeza",
                  "Dufatanye",
                  "Duterimbere",
                  "Irarire",
                  "Twizerane",
                  "Ubumwe",
                ],
              },
              {
                Karenge: [
                  "Akabuga",
                  "Akagoma",
                  "Akajevuba",
                  "Gisoko",
                  "Kanombe",
                  "Karenge",
                  "Kavumu",
                  "Korandebe",
                  "Nyamirambo",
                  "Nyarurembo",
                  "Rusenyi",
                  "Shirinyota",
                ],
              },
              {
                Kibimba: [
                  "Akabira",
                  "Akaziba",
                  "Cyahafi",
                  "Ibabiri",
                  "Murama",
                  "Uruhuha",
                  "Urukomo",
                ],
              },
              {
                Kigoma: [
                  "Icyurusambu",
                  "Iramiro",
                  "Kigoma",
                  "Meraneza",
                  "Mubaha",
                  "Ramba",
                  "Remera",
                  "Vunga",
                ],
              },
            ],
          },
          {
            Karembo: [
              {
                Akaziba: [
                  "Impinga",
                  "Kwiperu",
                  "Kukabeza",
                  "Ngara",
                  "Nyagasozi",
                  "Rubumba",
                  "Rukizi",
                  "Rurenge",
                  "Rwamuhimbura",
                  "Umusebeya",
                  "Umuyange",
                ],
              },
              {
                Karaba: [
                  "Kigobe",
                  "Mungoro",
                  "Rusumbantwari",
                  "Umurehe",
                  "Urutare",
                ],
              },
              {
                Nyamirambo: [
                  "Gashekasheke I",
                  "Gashekasheke II",
                  "Gitaraga",
                  "Kanama",
                  "Karibu",
                  "Kivugangoma I",
                  "Kivugangoma II",
                  "Mumahoro",
                  "Murambi",
                  "Rwakayango",
                ],
              },
            ],
          },
          {
            Kazo: [
              {
                Birenga: [
                  "Gahondo",
                  "Karisizo",
                  "Murindwa",
                  "Murusenyi",
                  "Nyakagezi",
                ],
              },
              {
                Gahurire: ["Itambiro", "Rebero", "Rugenge", "Umuyange"],
              },
              {
                Karama: ["Kabimba", "Kagusa", "Karenge", "Mpandu", "Rango"],
              },
              {
                Kinyonzo: ["Amabumba", "Kibimba", "Rugarama", "Tunduti"],
              },
              {
                Umukamba: ["Akabaya", "Kagarama", "Kazo", "Umukamba"],
              },
            ],
          },
          {
            Kibungo: [
              {
                Cyasemakamba: [
                  "Amarembo",
                  "Bwiza",
                  "Gatoro",
                  "Kabeza",
                  "Kiruhura",
                  "Rubimba",
                ],
              },
              {
                Gahima: [
                  "Gasoro",
                  "Karenge",
                  "Kazeneza",
                  "Nyamigina",
                  "Rutovu",
                  "Rwamihuro",
                ],
              },
              {
                Gatonde: [
                  "Karungu",
                  "Misange",
                  "Nyagakizi",
                  "Nyagatovu",
                  "Nyakabungo",
                  "Rubona",
                ],
              },
              {
                Karenge: [
                  "Amahoro",
                  "Gatare",
                  "Ihuriro",
                  "Isangano",
                  "Kabeza",
                  "Musamvu",
                  "Ubumwe",
                ],
              },
              {
                Mahango: [
                  "Gisaka",
                  "Kabimba",
                  "Kacyiru",
                  "Karambi",
                  "Rebezo",
                  "Ruhinga",
                ],
              },
            ],
          },
          {
            Mugesera: [
              {
                Akabungo: [
                  "Agakindo",
                  "Akabingo",
                  "Kinihira",
                  "Nyamirambo",
                  "Rugarama",
                  "Rurenge",
                  "Rwinkwavu",
                ],
              },
              {
                Mugatare: [
                  "Icocorero",
                  "Ikibinge",
                  "Isangano",
                  "Kampara",
                  "Kumunini",
                  "Kumuyange",
                  "Mumurenge",
                  "Rwamenyo",
                ],
              },
              {
                Ntanga: [
                  "Akabande",
                  "Akabeza",
                  "Akinteko",
                  "Ikiyovu",
                  "Murambi",
                  "Rugaju",
                  "Urukoki",
                ],
              },
              {
                Nyamugari: [
                  "Gisenyi",
                  "Gishandaro",
                  "Kimanama",
                  "Nyamabuye",
                  "Rwarutare",
                  "Ubuhanira",
                ],
              },
              {
                Nyange: [
                  "Agatare",
                  "Gomezo",
                  "Ntarama",
                  "Nunga",
                  "Rugazi",
                  "Rusave",
                  "Rwamibari",
                ],
              },
            ],
          },
          {
            Murama: [
              {
                Gitaraga: [
                  "Gitaraga",
                  "Kizenga",
                  "Ntara",
                  "Nyagahura",
                  "Nyakabanga",
                  "Rukizi",
                  "Tonero",
                ],
              },
              {
                Kigabiro: [
                  "Cyeru",
                  "Kaboza",
                  "Kigabiro",
                  "Murutare",
                  "Mutara",
                  "Nyagasozi",
                ],
              },
              {
                Mvumba: [
                  "Gitesanyi",
                  "Kibimba",
                  "Kiyagara",
                  "Mvumba",
                  "Nyakagezi",
                  "Nyarwanya",
                  "Rugarama",
                ],
              },
              {
                Rurenge: [
                  "Gashanda",
                  "Gasibya",
                  "Gatoma",
                  "Gitaba",
                  "Kabeza",
                  "Kambuto",
                  "Kanyinya",
                  "Kaziba",
                  "Kurutare",
                  "Muguruka",
                  "Murambi",
                  "Ruvuzi",
                  "Ruzinga",
                ],
              },
              {
                Sakara: [
                  "Agatonde",
                  "Kabahushi",
                  "Kakahi",
                  "Kavumu",
                  "Kukarenge",
                  "Mukibara",
                  "Nyagataba",
                  "Nyamirembe",
                  "Rwabuconco",
                  "Sagatare",
                  "Urubare",
                ],
              },
            ],
          },
          {
            Mutenderi: [
              {
                Karwema: ["Cyanamo", "Gitesanyi", "Meraneza", "Musenyi"],
              },
              {
                Kibare: [
                  "Kabombo",
                  "Mutukura",
                  "Ndarage",
                  "Rwakaza",
                  "Rwankamba",
                ],
              },
              {
                Mutenderi: [
                  "Agatonde",
                  "Akarimbu",
                  "Cyanyunga",
                  "Kibaya",
                  "Tonero",
                ],
              },
              {
                Muzingira: [
                  "Gatonde",
                  "Rusave",
                  "Rwakandari",
                  "Shyagashya",
                  "Umuyange",
                ],
              },
              {
                Nyagasozi: ["Nyagasozi", "Nyamirindi", "Nyamugari"],
              },
            ],
          },
          {
            Remera: [
              {
                Bugera: [
                  "Gasebeya",
                  "Gatare",
                  "Gisunzu",
                  "Kabeza",
                  "Kiyovu",
                  "Kumukiza",
                  "Munini I",
                  "Munini II",
                  "Nkenke",
                  "Rubumba",
                  "Rwesero",
                ],
              },
              {
                Kinunga: [
                  "Kabeza",
                  "Kamvumba",
                  "Kigaga",
                  "Murambi",
                  "Nyarugenge",
                  "Urusagara",
                ],
              },
              {
                Ndekwe: [
                  "Gikomero",
                  "Icyakabiri",
                  "Rugando",
                  "Ruhuha",
                  "Rukore",
                  "Rwamutabazi",
                ],
              },
              {
                Nyamagana: [
                  "Bukiranzuki",
                  "Kabuye",
                  "Kaguruka",
                  "Kinanira",
                  "Nyakabingo",
                  "Rebero",
                  "Rubimba",
                  "Ruhama",
                  "Ryinteko",
                  "Tonero",
                ],
              },
            ],
          },
          {
            Rukira: [
              {
                Buliba: [
                  "Dagaza",
                  "Gatare",
                  "Kabeza",
                  "Kanzenze",
                  "Kibande",
                  "Kibimba",
                  "Rugaragara",
                  "Rurama",
                  "Rwakimanzi",
                  "Rwavuguta",
                  "Sangano",
                ],
              },
              {
                Kibatsi: [
                  "Agatare",
                  "Bweranka",
                  "Gahushyi",
                  "Gituku",
                  "Kagarama",
                  "Kibimba",
                  "Korandebe",
                  "Munezero",
                  "Nyamabuye",
                  "Rubagabaga",
                  "Rusenyi",
                  "Rwanyineka",
                  "Terimbere",
                ],
              },
              {
                Nyaruvumu: [
                  "Amahoro",
                  "Cyamahehe",
                  "Gafunzo",
                  "Gatare",
                  "Isangano",
                  "Nyagataba",
                  "Rugenge",
                  "Terimbere",
                ],
              },
              {
                Nyinya: [
                  "Cyabayagara",
                  "Kabimba",
                  "Karuruma",
                  "Kibimba",
                  "Mirambi",
                  "Rugarama",
                  "Ruhama",
                  "Rwagakobe",
                  "Rwagishanga",
                  "Rwamukobwa",
                ],
              },
            ],
          },
          {
            Rukumberi: [
              {
                Gituza: ["Gitesanyi", "Gituza", "Mfune", "Ruyenzi"],
              },
              {
                Ntovi: [
                  "Iyantende",
                  "Kigese",
                  "Mugwato",
                  "Ntovi",
                  "Rukumberi",
                  "Rwamibabi",
                ],
              },
              {
                Rubago: [
                  "Akabungo",
                  "Kavumve",
                  "Nyagakizi",
                  "Nyagitabire",
                  "Rubago",
                ],
              },
              {
                Rubona: [
                  "Kagarama",
                  "Maswa I",
                  "Maswa II",
                  "Rugenda I",
                  "Rugenda II",
                  "Ruyenzi I",
                ],
              },
              {
                Rwintashya: [
                  "Bare",
                  "Karokora",
                  "Rwimpongo I",
                  "Rwimpongo II",
                  "Shyembe",
                ],
              },
            ],
          },
          {
            Rurenge: [
              {
                Akagarama: [
                  "Kuwimana",
                  "Mukibimba",
                  "Rwanyamuhinda",
                  "Umurambi",
                  "Rugazi",
                  "Uruyenzi",
                ],
              },
              {
                Muhurire: [
                  "Agatonero",
                  "Gashinya",
                  "Gisunzu",
                  "Gitobe",
                  "Nyamata",
                ],
              },
              {
                Musya: [
                  "Inteko",
                  "Kabimba",
                  "Kamugundu",
                  "Karama",
                  "Runazi",
                  "Rwasaburo",
                ],
              },
              {
                Rugese: [
                  "Kajevuba",
                  "Kamwiru",
                  "Kiyanja",
                  "Kumunini",
                  "Nyamigende",
                  "Rugarika",
                  "Rwakanuma",
                ],
              },
              {
                Rujambara: [
                  "Akarambaraye",
                  "Kabeza",
                  "Mashyoza",
                  "Mbonwa",
                  "Nyabagaza",
                  "Urusagara",
                ],
              },
              {
                Rwikubo: [
                  "Akabakanda",
                  "Amashya",
                  "Kabashumba",
                  "Kigarama",
                  "Kivugangoma",
                  "Ruhuha",
                  "Rwaromba",
                ],
              },
            ],
          },
          {
            Sake: [
              {
                Gafunzo: [
                  "Cyanika",
                  "Gatare",
                  "Icyizanye",
                  "Isovu",
                  "Kiriko",
                  "Kumurenge",
                  "Mabuga I",
                  "Mabuga II",
                  "Nyakagezi",
                  "Rwanyabiranga",
                  "Rwumba",
                ],
              },
              {
                Kibonde: [
                  "Kabare",
                  "Karenge",
                  "Kidakama",
                  "Murama",
                  "Nkingi",
                  "Nyagasani",
                  "Umucyo",
                ],
              },
              {
                Nkanga: [
                  "Agatare",
                  "Akabira",
                  "Bukokoza",
                  "Gisera",
                  "Iryarurengo",
                  "Kanazi",
                  "Mizibiri",
                ],
              },
              {
                Rukoma: [
                  "Akagoma",
                  "Irebero",
                  "Isangano",
                  "Muminoga",
                  "Musenyi",
                  "Nyagasozi",
                  "Nyakariba",
                  "Nyarurembo",
                  "Umukoni",
                ],
              },
            ],
          },
          {
            Zaza: [
              {
                Nyagasozi: [
                  "Agatare",
                  "Akabeza",
                  "Akabuga",
                  "Igifurere",
                  "Ikiyovu",
                  "Rebero",
                  "Isanganiro",
                  "Rubati",
                  "Rwanshuro",
                  "Rwimbirwa",
                  "Sugira",
                ],
              },
              {
                Nyagatugunda: [
                  "Akanyinya",
                  "Amahoro",
                  "Cyerwa",
                  "Cyizihira",
                  "Itonero",
                  "Jyambere",
                  "Kabonero",
                  "Kirira",
                  "Kizenga",
                  "Kumuyange",
                  "Nyagatugunda",
                  "Nyakabanda",
                  "Nyakabande",
                  "Nyarurembo",
                  "Rebero",
                  "Rugarama",
                  "Rushubi",
                  "Rwezibamba",
                ],
              },
              {
                Ruhembe: [
                  "Agasave",
                  "Ituze",
                  "Kabeza",
                  "Kacyiru",
                  "Karenge",
                  "Kumunini",
                  "Makoma",
                  "Mpembwe",
                  "Nyagahinga",
                  "Nyaruteja",
                  "Rugarama",
                  "Rushubi",
                  "Urutare",
                ],
              },
              {
                Ruhinga: [
                  "Agataba",
                  "Akabungo",
                  "Busasamana",
                  "Gasebeya",
                  "Isangano",
                  "Kagarama",
                  "Nyagahandagazi",
                  "Nyakariba",
                  "Rwakagina",
                  "Sangaza",
                  "Ubumwe",
                  "Umukoma",
                  "Umuvugangoma",
                ],
              },
            ],
          },
        ],
      },
      {
        Nyagatare: [
          {
            Gatunda: [
              {
                Cyagaju: [
                  "Hanganyundo",
                  "Iramiro",
                  "Isangano",
                  "Kabeza",
                  "Kibisabo",
                ],
              },
              {
                Kabeza: [
                  "Huriro",
                  "Kabeza",
                  "Muvumba",
                  "Muyenzi",
                  "Nyamirambo",
                  "Rebero",
                ],
              },
              {
                Nyamikamba: [
                  "Byimana",
                  "Gikunyu",
                  "Gitega",
                  "Gitovu",
                  "Kaburimbo",
                  "Kibuye",
                  "Nyamikamba",
                  "Rwebare",
                  "Ryabuvara",
                  "Ryarukabura",
                ],
              },
              {
                Nyamirembe: [
                  "Byimana",
                  "Huriro",
                  "Kajevuba",
                  "Kirindimure",
                  "Mabare",
                ],
              },
              {
                Nyangara: [
                  "Bugarama",
                  "Kabeza",
                  "Mugomero",
                  "Muhambo",
                  "Mutumba",
                  "Rwimbogo",
                  "Ryanyabugwende",
                ],
              },
              {
                Nyarurema: [
                  "Bubare",
                  "Buguma",
                  "Butimba",
                  "Kabeza",
                  "Muhabura",
                  "Nyarurema",
                  "Shabana",
                ],
              },
              {
                Rwensheke: ["Kabuye", "Kamate", "Nyiraburunga", "Rwensheke"],
              },
            ],
          },
          {
            Karama: [
              {
                Bushara: [
                  "Bushara Centre",
                  "Ihuriro",
                  "Isangano",
                  "Kadendegeri",
                  "Meshero",
                  "Rurembo",
                  "Uruyenzi",
                ],
              },
              {
                Cyenkwanzi: [
                  "Cyenkwanzi Centre",
                  "Kabeza",
                  "Kiyovu",
                  "Rurembo",
                ],
              },
              {
                Gikagati: [
                  "Bigega",
                  "Gataba",
                  "Gikagati Centre",
                  "Gishenyi",
                  "Kanunga",
                  "Nyabitare",
                  "Nyakibande",
                  "Rurembo",
                  "Rutegamatwi",
                ],
              },
              {
                Gikundamvura: [
                  "Fene",
                  "Gikundamvura I",
                  "Gikundamvura II",
                  "Irebero",
                  "Isangano",
                  "Kukibuye",
                  "Kukimpundu",
                  "Musenyi",
                  "Nyabitare",
                  "Nyagasharara",
                  "Umutara",
                  "Urugwiro",
                ],
              },
              {
                Kabuga: [
                  "Gakukuru",
                  "Kabeza",
                  "Kabuga",
                  "Kizunguruko",
                  "Nyakibande",
                  "Nyamirama",
                  "Rukamba",
                  "Rwebishirira",
                  "Rwubuzizi",
                ],
              },
              {
                Ndego: [
                  "Gakirage",
                  "Kababanda",
                  "Kanyami",
                  "Matereza",
                  "Mishasha",
                  "Murambi",
                  "Mutete",
                  "Ndego",
                  "Rubanda",
                  "Rusoroza",
                  "Rutoma",
                ],
              },
              {
                Nyakiga: [
                  "Humure",
                  "Kabeza",
                  "Kanunga",
                  "Karama Centre",
                  "Kavumu",
                  "Kentarama",
                  "Mabare",
                ],
              },
            ],
          },
          {
            Karangazi: [
              {
                Kamate: ["Bugarama", "Buhongoro", "Kamate", "Kigazi", "Muzehe"],
              },
              {
                Karama: ["Karama", "Makomo", "Rundiro"],
              },
              {
                Kizirakome: ["Kageyo", "Kahi", "Kizirakome", "Rurebe"],
              },
              {
                Mbare: [
                  "Kabirizi",
                  "Kajumo",
                  "Karohoza",
                  "Mbare",
                  "Rwarucura",
                  "Ryabega",
                ],
              },
              {
                Musenyi: [
                  "Bwanga",
                  "Gacungiro",
                  "Kabeza",
                  "Musenyi I",
                  "Musenyi II",
                  "Rugarama",
                  "Ruziranyenzi",
                ],
              },
              {
                Ndama: ["Akayange", "Ndama", "Rwabiharamba"],
              },
              {
                Nyagashanga: ["Bidudu", "Bwera", "Kabare", "Ruhita"],
              },
              {
                Nyamirama: [
                  "Kayange I",
                  "Kayange II",
                  "Nkoma I",
                  "Nkoma II",
                  "Nyamirama I",
                  "Nyamirama II",
                ],
              },
              {
                Rubagabaga: ["Iraba", "Nkuna", "Nyarutovu", "Rebero"],
              },
              {
                Rwenyemera: [
                  "Bwera",
                  "Imishongi",
                  "Kayishunika",
                  "Kizirakome",
                  "Rwenyana",
                  "Rwenyemera",
                  "Rwimirama",
                ],
              },
              {
                Rwisirabo: [
                  "Gakoma",
                  "Humure",
                  "Karangazi",
                  "Rubona",
                  "Rukundo",
                ],
              },
            ],
          },
          {
            Katabagemu: [
              {
                Bayigaburire: [
                  "Agasasa",
                  "Bingaro",
                  "Byimana",
                  "Gikandura",
                  "Igikorosi",
                  "Kibuye",
                  "Nyagahandagaza",
                ],
              },
              {
                Kaduha: [
                  "Kaduha I",
                  "Kaduha II",
                  "Kanyinya",
                  "Nyabiyonza",
                  "Urumuri",
                ],
              },
              {
                Kanyeganyege: ["Kabaya", "Kabeza", "Kanyeganyege", "Rebero"],
              },
              {
                Katabagemu: [
                  "Gashenyi",
                  "Kagogo",
                  "Kajevuba",
                  "Kigarama",
                  "Nyabwunyu",
                  "Umunanira",
                ],
              },
              {
                Kigarama: [
                  "Kanguka",
                  "Kibuye",
                  "Kigarama",
                  "Rebero",
                  "Shirimpumu",
                ],
              },
              {
                Nyakigando: [
                  "Byimana",
                  "Kabeza",
                  "Kamutara",
                  "Ntoma",
                  "Nyakigando I",
                  "Nyakigando II",
                  "Rebero",
                ],
              },
              {
                Rubira: ["Igitego", "Isangano", "Kanyesunzu", "Rubira"],
              },
              {
                Rugazi: [
                  "Akabira",
                  "Burera",
                  "Ishyirahamwe",
                  "Rwagisangangabo",
                ],
              },
              {
                Rutoma: ["Buyugi", "Kabeza", "Mahoro", "Rutoma", "Ryaruganzu"],
              },
            ],
          },
          {
            Kiyombe: [
              {
                Gataba: [
                  "Cyemiyaga",
                  "Gahama",
                  "Gicuba",
                  "Kwiperu",
                  "Nyakabungo",
                  "Nyamiyaga",
                  "Ruhonwa",
                  "Ruhuha",
                  "Rutete",
                  "Rwabashanja",
                  "Rwakikunengwa",
                  "Rwebare",
                ],
              },
              {
                Gitenga: [
                  "Gitenga",
                  "Izinga",
                  "Kabingo",
                  "Kibuye",
                  "Muhambo",
                  "Mukasha",
                  "Nyabubare",
                  "Rwagakuba",
                ],
              },
              {
                Kabungo: [
                  "Bitare",
                  "Cyondo",
                  "Gatoki",
                  "Gorora",
                  "Kindege",
                  "Manombe",
                  "Mataba",
                  "Murambi",
                  "Nyakabungo",
                  "Rugarama",
                  "Rwamiko",
                  "Rwamushe",
                ],
              },
              {
                Karambo: [
                  "Bureka",
                  "Butehe",
                  "Kakagaju",
                  "Karujanga",
                  "Kinoga",
                  "Kitaburimbi",
                  "Nkana",
                  "Nyakabungo",
                  "Rugarama",
                  "Rwakashande",
                  "Rwemisavu",
                  "Rwengugwe",
                ],
              },
              {
                Karujumba: [
                  "Gishoro",
                  "Kabare",
                  "Kagorogoro",
                  "Kajevuba",
                  "Karujumba Centre",
                  "Katoma",
                  "Kenzizi",
                  "Mushesha",
                  "Mweneno",
                  "Ngangare",
                  "Nyabwongoroka",
                  "Nyange",
                  "Rukongoro",
                ],
              },
              {
                Tovu: [
                  "Cyerero",
                  "Gashuro",
                  "Gasyata",
                  "Gatyazo",
                  "Nyagatete",
                  "Nyakigera",
                  "Nyamirima",
                  "Nyaruziba",
                  "Rugarama",
                  "Rutungo",
                ],
              },
            ],
          },
          {
            Matimba: [
              {
                Bwera: ["Bwera", "Ntoma", "Rugaga"],
              },
              {
                Byimana: [
                  "Byimana I",
                  "Byimana II",
                  "Byimana III",
                  "Kabuga I",
                  "Kabuga II",
                ],
              },
              {
                Cyembogo: ["Byimana", "Kabeza", "Kamahoro", "Kiyovu"],
              },
              {
                Kagitumba: [
                  "Gishara",
                  "Kagera",
                  "Kagitumba",
                  "Kamabuye",
                  "Munini",
                  "Musenyi",
                  "Muvumba",
                  "Nziranziza",
                ],
              },
              {
                Kanyonza: [
                  "Gakoma",
                  "Musebeya",
                  "Musha",
                  "Nyampeke",
                  "Rukundo",
                ],
              },
              {
                Matimba: [
                  "Umudugudu Wa I",
                  "Umudugudu Wa II",
                  "Umudugudu Wa III",
                  "Umudugudu Wa IV",
                  "Umudugudu Wa V",
                  "Umudugudu Wa VI",
                  "Umudugudu Wa VII",
                ],
              },
              {
                Nyabwishongwezi: [
                  "Nyabwishongwezi I",
                  "Nyabwishongwezi II",
                  "Nyabwishongwezi III",
                ],
              },
              {
                Rwentanga: [
                  "Kagezi I",
                  "Kagezi II",
                  "Mitayayo I",
                  "Mitayayo II",
                  "Rwentanga",
                ],
              },
            ],
          },
          {
            Mimuri: [
              {
                Bibare: [
                  "Bibare",
                  "Karukwanzi",
                  "Nyakagenge",
                  "Nyamafura",
                  "Nyaruziba",
                  "Rwimirama",
                  "Urugano",
                  "Urutambi",
                ],
              },
              {
                Gakoma: [
                  "Gakoma",
                  "Gisenyi",
                  "Kanyinya",
                  "Kumusaraba",
                  "Nyagahandagaza",
                  "Nyarwina",
                  "Rusororo",
                ],
              },
              {
                Mahoro: [
                  "Cyabwana",
                  "Gitwe",
                  "Iterambere",
                  "Kabeza",
                  "Mizero",
                  "Nyabugogo",
                  "Nyagahita",
                  "Rebero",
                  "Rubumba",
                  "Shenga",
                ],
              },
              {
                Mimuri: [
                  "Byimana",
                  "Indahemuka",
                  "Isangano",
                  "Karukwanzi",
                  "Rebero",
                  "Rwimirama",
                ],
              },
              {
                Rugari: [
                  "Amahoro",
                  "Isangano",
                  "Nteko",
                  "Rebero",
                  "Ubumwe",
                  "Urumuri",
                ],
              },
            ],
          },
          {
            Mukama: [
              {
                Bufunda: [
                  "Bitabo",
                  "Bufunda",
                  "Kibihanga",
                  "Nyakajeje",
                  "Rebero",
                ],
              },
              {
                Gatete: [
                  "Gatete I",
                  "Gatete II",
                  "Hunga",
                  "Kazinga",
                  "Rutete",
                  "Ryandahuka",
                ],
              },
              {
                Gihengeri: [
                  "Butare",
                  "Butwaro",
                  "Gashahi",
                  "Gihengeri",
                  "Gishoro",
                  "Kabongoya I",
                  "Kabongoya II",
                  "Kigarama",
                  "Nyarubuye",
                ],
              },
              {
                Gishororo: [
                  "Akinyambo",
                  "Byumba",
                  "Kabeza",
                  "Kabukunzi",
                  "Kisaro",
                ],
              },
              {
                Kagina: [
                  "Cyabahurura",
                  "Kagonga",
                  "Kireranyana",
                  "Ngoma",
                  "Nyagatare",
                  "Nyakagarama",
                  "Nyakarama",
                ],
              },
              {
                Rugarama: [
                  "Bukire",
                  "Byimana",
                  "Kibondo",
                  "Kireranyana",
                  "Nyacyonga",
                  "Nyakagarama",
                  "Sipure",
                ],
              },
            ],
          },
          {
            Musheri: [
              {
                Kibirizi: ["Kabungo", "Kibirizi", "Nyamenge", "Nyamisange"],
              },
              {
                Kijojo: ["Kagwegwe", "Kanyinya", "Kijojo", "Rwakabungo"],
              },
              {
                Musheri: ["Gakiri", "Kiyaza", "Mugari", "Musheri"],
              },
              {
                Ntoma: [
                  "Bikonoka",
                  "Murisanga",
                  "Ntoma",
                  "Rukundo",
                  "Rutarama",
                ],
              },
              {
                Nyagatabire: [
                  "Gikunyu",
                  "Mushorerwa",
                  "Nyagatabire",
                  "Rugarama",
                ],
              },
              {
                Nyamiyonga: [
                  "Cyenombe",
                  "Isangano",
                  "Nyamiyonga",
                  "Shirimpumu",
                ],
              },
              {
                "Rugarama I": ["Humure", "Karambi", "Karuca", "Nyabyihura"],
              },
              {
                "Rugarama II": ["Kibitaka", "Rebero", "Rwenyana", "Umunini"],
              },
            ],
          },
          {
            Nyagatare: [
              {
                Barija: ["Barija A", "Barija B", "Burumba", "Kinihira"],
              },
              {
                Bushoga: [
                  "Bushoga",
                  "Cyabahanga",
                  "Cyonyo",
                  "Ruhuha I",
                  "Ruhuha II",
                  "Ryinkuyu",
                ],
              },
              {
                Cyabayaga: [
                  "Akamonyi",
                  "Bihinga",
                  "Cyabayaga",
                  "Nyakabuye",
                  "Urugero",
                ],
              },
              {
                Gakirage: [
                  "Gakirage",
                  "Kiboga I",
                  "Kiboga II",
                  "Mihingo",
                  "Nkongi",
                  "Urumuri",
                ],
              },
              {
                Kamagiri: ["Kamagiri", "Karungi", "Nkerenke"],
              },
              {
                Nsheke: ["Kabare", "Nsheke", "Nyegeza"],
              },
              {
                Nyagatare: [
                  "Mirama I",
                  "Mirama II",
                  "Nyagatare I",
                  "Nyagatare II",
                  "Nyagatare III",
                ],
              },
              {
                Rutaraka: [
                  "Gihorobwa",
                  "Mugari",
                  "Nkonji",
                  "Rutaraka",
                  "Ryabega",
                ],
              },
              {
                Ryabega: ["Marongero", "Rugendo", "Ryabega"],
              },
            ],
          },
          {
            Rukomo: [
              {
                Gahurura: [
                  "Amahoro",
                  "Busasamana",
                  "Isangano",
                  "Nomero I",
                  "Rambura",
                  "Ruyonza",
                  "Ubumwe",
                  "Urugwiro",
                  "Urukundo",
                  "Urumuri",
                ],
              },
              {
                Gashenyi: [
                  "Agasasa",
                  "Bukamba",
                  "Gashenyi",
                  "Gisenyi",
                  "Huriro",
                  "Isangano",
                  "Kiyovu",
                  "Murore",
                  "Nyamirambo",
                  "Rebero",
                  "Rukomo",
                  "Rurembo",
                ],
              },
              {
                Nyakagarama: [
                  "Akamashama",
                  "Akamasheka",
                  "Amahoro",
                  "Amizero",
                  "Gashenyi",
                  "Gashura",
                  "Isangano",
                  "Karugondo",
                  "Kayenzi",
                  "Musenyi",
                  "Nyakagarama",
                  "Nyamworoma",
                ],
              },
              {
                "Rukomo II": [
                  "Amahoro",
                  "Berwa",
                  "Isangano",
                  "Kabeza",
                  "Mwurirwa",
                  "Nyange",
                  "Nyarubuye",
                  "Nyarurama",
                  "Rebero",
                  "Rugabano",
                ],
              },
              {
                Rurenge: [
                  "Akajuka",
                  "Benishyaka",
                  "Biryogo",
                  "Kabeza",
                  "Kabusunzu",
                  "Nyabwunyu",
                  "Nyamirambo",
                  "Rurenge",
                  "Rushashi",
                  "Rwiju",
                ],
              },
            ],
          },
          {
            Rwempasha: [
              {
                Cyenjonjo: ["Cyenjonjo I", "Cyenjonjo II", "Rutare II"],
              },
              {
                Gasinga: ["Gasinga", "Nyendo", "Rwibishorogoto"],
              },
              {
                Kabare: ["Gituro", "Kabare", "Ururimbi"],
              },
              {
                Kazaza: ["Gakindo", "Kazaza", "Rukiri"],
              },
              {
                Mishenyi: ["Gicwamba", "Kinungu", "Mishenyi"],
              },
              {
                Rugarama: ["Bubare", "Rugarama"],
              },
              {
                Rukorota: ["Bukonji", "Rukorota"],
              },
              {
                Rutare: ["Mashaka", "Nshuli", "Rutare"],
              },
              {
                Rwempasha: ["Nyarubare", "Rwahi", "Rwempasha", "Uwinkiko"],
              },
              {
                Ryeru: ["Bweya", "Ryeru"],
              },
            ],
          },
          {
            Rwimiyaga: [
              {
                Gacundezi: [
                  "Bugaragara",
                  "Gacundezi I",
                  "Gacundezi II",
                  "Rukundo I",
                  "Rukundo II",
                  "Rukundo III",
                ],
              },
              {
                Kabeza: [
                  "Gatovu",
                  "Kabeza",
                  "Kabeza Centre",
                  "Kavumu",
                  "Rugarama",
                  "Rukiri I",
                  "Rukiri II",
                ],
              },
              {
                Kirebe: ["Gatebe I", "Gatebe II", "Kirebe", "Rukindo"],
              },
              {
                Ntoma: [
                  "Gashwenu",
                  "Kibuye",
                  "Kimaramu",
                  "Nyampire",
                  "Rwembogo",
                ],
              },
              {
                Nyarupfubire: [
                  "Kamagiri",
                  "Nyakagando I",
                  "Nyakagando II",
                  "Nyarupfubire I",
                  "Nyarupfubire II",
                  "Rwimiyaga I",
                  "Rwimiyaga II",
                ],
              },
              {
                Nyendo: ["Isangano", "Nyamirama", "Rebero", "Remera"],
              },
              {
                Rutungu: [
                  "Bwera",
                  "Cyamunyana",
                  "Gakagati I",
                  "Gakagati II",
                  "Rubira",
                ],
              },
              {
                Rwimiyaga: [
                  "Byimana",
                  "Gakoma",
                  "Kizungu",
                  "Mahoro",
                  "Muyange",
                  "Rebero",
                  "Rwinyange",
                ],
              },
            ],
          },
          {
            Tabagwe: [
              {
                Gishuro: [
                  "Gatoma",
                  "Kaborogota",
                  "Kayanja",
                  "Nyagatare",
                  "Nyasine",
                ],
              },
              {
                Gitengure: [
                  "Bitibyoma",
                  "Gitengure",
                  "Kayigiro",
                  "Nshuri",
                  "Nyagasigati",
                ],
              },
              {
                Nkoma: [
                  "Agafaru",
                  "Ibare",
                  "Kabeza",
                  "Kaduha",
                  "Kigando",
                  "Mutozo",
                  "Nkoma",
                  "Rugabano",
                  "Runyinya",
                ],
              },
              {
                Nyabitekeri: [
                  "Kabeza",
                  "Kabirizi",
                  "Kamate",
                  "Kangoma",
                  "Kiyovu",
                  "Munini",
                ],
              },
              {
                Nyagatoma: [
                  "Agafaro",
                  "Agasongero",
                  "Akajevuba",
                  "Kabusunzu",
                  "Mutungisa",
                  "Runyeri",
                ],
              },
              {
                Shonga: [
                  "Gikoba",
                  "Nyakanoni",
                  "Nyakigando",
                  "Rwubuzizi",
                  "Shonga",
                ],
              },
              {
                Tabagwe: [
                  "Gakamba",
                  "Gasheshe",
                  "Kagarama",
                  "Nyenyeri",
                  "Tabagwe",
                ],
              },
            ],
          },
        ],
      },
      {
        Rwamagana: [
          {
            Fumbwe: [
              {
                Mununu: [
                  "Cyingara",
                  "Janjagiro",
                  "Kabeza",
                  "Kabuga",
                  "Ndinda",
                  "Nyirabiteri",
                ],
              },
              {
                Nyagasambu: [
                  "Mataba",
                  "Rambura",
                  "Rebero",
                  "Rugarama",
                  "Rugenge",
                ],
              },
              {
                Nyakagunga: ["Akabeza", "Kibaza", "Kirehe", "Rugarama"],
              },
              {
                Nyamirama: [
                  "Agatare",
                  "Akagarama",
                  "Bigarama",
                  "Cyarutabana",
                  "Makwandi",
                  "Ntungamo",
                  "Shenga",
                ],
              },
              {
                Nyarubuye: [
                  "Gihima",
                  "Gitwe",
                  "Kabirizi",
                  "Kivugiza",
                  "Murambi",
                  "Rurembo",
                ],
              },
              {
                Sasabirago: [
                  "Birembo",
                  "Byimana",
                  "Irukwaya",
                  "Karambo",
                  "Munini",
                ],
              },
            ],
          },
          {
            Gahengeri: [
              {
                Gihumuza: [
                  "Cyanga",
                  "Gatare",
                  "Kabeza",
                  "Kajevuba",
                  "Nyirabujari",
                  "Rebero",
                ],
              },
              {
                Kagezi: ["Akabuga", "Kabonero", "Rwarugaju", "Samatare"],
              },
              {
                Kanyangese: ["Agakari", "Gatenderi", "Ruhita", "Umunini"],
              },
              {
                Kibare: [
                  "Iramiro",
                  "Kabuye",
                  "Kanserege",
                  "Karutimbo",
                  "Kinyovi",
                  "Rurambi",
                ],
              },
              {
                Mutamwa: [
                  "Agasharu",
                  "Kamugasa",
                  "Nyabagaza",
                  "Nyirarwirungu",
                  "Rubonobono",
                  "Rugagi",
                  "Ryasenteteri",
                ],
              },
              {
                Rugarama: [
                  "Amatafari",
                  "Byimana",
                  "Mataba",
                  "Nyakiri",
                  "Nyarucyamo",
                  "Rebero",
                ],
              },
              {
                Runyinya: [
                  "Akamasasa",
                  "Cyeru",
                  "Gacunshu",
                  "Kabarore",
                  "Karambo",
                  "Kiyovu",
                  "Ruyumba",
                  "Ryamuzuka",
                ],
              },
              {
                Rweri: [
                  "Kabigondo",
                  "Kamurindi",
                  "Akinteko",
                  "Kiruruma",
                  "Mataba",
                  "Nyamugari",
                ],
              },
            ],
          },
          {
            Gishali: [
              {
                Binunga: ["Busharu", "Nyakivomo", "Rurindimura"],
              },
              {
                Bwinsanga: ["Akanogo", "Mugusha", "Nyakabungo", "Shaburondo"],
              },
              {
                Cyinyana: ["Nyagacyamo", "Nyakagarama", "Ururembo"],
              },
              {
                Gati: ["Agatare", "Nyamabuye", "Umunanira", "Uruhuha"],
              },
              {
                Kavumu: ["Akabuga", "Ingeyo", "Kibonde", "Uruyenzi"],
              },
              {
                Ruhimbi: [
                  "Abakina",
                  "Byimana",
                  "Cyiri",
                  "Rwagahaya",
                  "Umunini",
                ],
              },
              {
                Ruhunda: ["Mpungwe", "Nyagahinga", "Nyagakombe"],
              },
            ],
          },
          {
            Karenge: [
              {
                Bicaca: [
                  "Bicaca",
                  "Cyanyirampazi",
                  "Cyarugaju",
                  "Kabeza",
                  "Kajevuba",
                  "Karuyenzi",
                  "Runzenze",
                ],
              },
              {
                Byimana: ["Byimana", "Karambo", "Kiyaya", "Rukori"],
              },
              {
                Kabasore: [
                  "Ipide",
                  "Kabasore",
                  "Migamba",
                  "Nyagatovu",
                  "Ruvomo",
                ],
              },
              {
                Kangamba: [
                  "Byimana",
                  "Kagese",
                  "Kangamba",
                  "Kimarambasa",
                  "Nkongi",
                ],
              },
              {
                Karenge: ["Bwiza", "Karenge", "Ntebe", "Rebero"],
              },
              {
                Nyabubare: [
                  "Feri",
                  "Kanyangese",
                  "Nyabubare",
                  "Rwinka",
                  "Ryamugabo",
                ],
              },
              {
                Nyamatete: [
                  "Cyerwa",
                  "Mutabo",
                  "Ndengo",
                  "Nyagasenyi",
                  "Nyakabuye",
                  "Nyamatete",
                ],
              },
            ],
          },
          {
            Kigabiro: [
              {
                Bwiza: [
                  "Gitega",
                  "Kagererao",
                  "Munini",
                  "Nyakabande",
                  "Rutaka",
                  "Rutonde",
                  "Rweza",
                ],
              },
              {
                Cyanya: [
                  "Bigabiro",
                  "Biraro",
                  "Busanza",
                  "Cyahafi",
                  "Kabeza",
                  "Kabuye",
                  "Kamata",
                  "Karuhayi",
                  "Karutimbo",
                  "Rurembo",
                ],
              },
              {
                Nyagasenyi: [
                  "Gahonogo",
                  "Kavura",
                  "Kayenzi",
                  "Kigega",
                  "Kirehe",
                  "Ramba",
                  "Rusave",
                  "Umuganura",
                ],
              },
              {
                Sibagire: [
                  "Bacyoro",
                  "Bugugu",
                  "Cyimpima",
                  "Gasharu",
                  "Kabuga",
                  "Kamanga",
                  "Miyange",
                ],
              },
              {
                Sovu: [
                  "Cyaruhogo",
                  "Gatare",
                  "Kiruhura",
                  "Nyabishunzi",
                  "Rugobagoba",
                  "Rushangara",
                ],
              },
            ],
          },
          {
            Muhazi: [
              {
                Byeza: ["Gatobotobo", "Kabeza", "Nyarukombe"],
              },
              {
                Kabare: ["Birembo", "Ubwiza", "Umunini", "Uwimanzi"],
              },
              {
                Karambi: ["Gahengeri", "Kayenzi", "Kinunga", "Ragwe"],
              },
              {
                Karitutu: [
                  "Agatare",
                  "Cyeru",
                  "Karambo",
                  "Kingondo",
                  "Nyarugarama",
                ],
              },
              {
                Kitazigurwa: ["Byimana", "Gasharu", "Kabirizi", "Karwiru"],
              },
              {
                Murambi: ["Gasharu", "Kabusunzu", "Nyendo", "Yabaranda"],
              },
              {
                Nsinda: ["Akabeza", "Kibare", "Rubirizi"],
              },
              {
                Ntebe: ["Amagaju", "Urugero", "Urugwiro"],
              },
              {
                Nyarusange: [
                  "Akagarama",
                  "Akatorero",
                  "Gahondo",
                  "Kanywiriri",
                  "Kavura",
                  "Kidogo",
                  "Mpinga",
                  "Plage",
                  "Umubuga",
                ],
              },
            ],
          },
          {
            Munyaga: [
              {
                Kaduha: [
                  "Gishike",
                  "Kababero",
                  "Kabare",
                  "Kamamana",
                  "Kangabo",
                  "Kigabiro",
                  "Rwakigara",
                  "Rwimbogo",
                ],
              },
              {
                Nkungu: [
                  "Kabuye",
                  "Kiryango",
                  "Mataba",
                  "Nyagakombe",
                  "Rudashya",
                  "Rushangara",
                ],
              },
              {
                Rweru: ["Birayi", "Gatare", "Kabingo", "Kanyegera", "Mubuga"],
              },
              {
                Zinga: ["Cyinganzwa", "Kabazeyi", "Karambo", "Rwisange"],
              },
            ],
          },
          {
            Munyiginya: [
              {
                Binunga: [
                  "Irebero",
                  "Isangano",
                  "Kabeza",
                  "Umuhumuro",
                  "Urugwiza",
                ],
              },
              {
                Bwana: [
                  "Kabuye",
                  "Kiruhura",
                  "Rutembo",
                  "Rwagahigi",
                  "Rwamugurusu",
                  "Rweza",
                  "Umurinzi",
                ],
              },
              {
                Cyarukamba: ["Kabenda", "Kagarama", "Ndago", "Rweza"],
              },
              {
                Cyimbazi: ["Agatare", "Akabuye", "Ntunga", "Nyagakombe"],
              },
              {
                Nkomangwa: [
                  "Bakannyi",
                  "Kabuye",
                  "Karubisha",
                  "Nyagahanga",
                  "Ryamirenge",
                ],
              },
              {
                Nyarubuye: [
                  "Babasha",
                  "Buyanja",
                  "Kabeza",
                  "Kimara",
                  "Kiyovu",
                  "Mazinga",
                  "Nkindi",
                ],
              },
            ],
          },
          {
            Musha: [
              {
                Akabare: [
                  "Akabare",
                  "Binunga",
                  "Budahigwa",
                  "Duha",
                  "Gashikiri",
                  "Rugabano",
                  "Rukombe",
                ],
              },
              {
                Budahanda: ["Karambo", "Nyantoki", "Rwabiyange"],
              },
              {
                Kagarama: [
                  "Kagarama",
                  "Kiruhura",
                  "Muhogoto",
                  "Nyagacyamo",
                  "Nyamigano",
                ],
              },
              {
                Musha: [
                  "Gatika",
                  "Kadasumbwa",
                  "Karifuru",
                  "Nyakiriba",
                  "Rugarama",
                ],
              },
              {
                Nyabisindu: [
                  "Agashuhe",
                  "Busanza",
                  "Bwiza",
                  "Nyabisindu",
                  "Rujumbura",
                  "Rwamivu",
                  "Umunini",
                ],
              },
              {
                Nyakabanda: ["Bitsibo", "Ruhita", "Rutoma"],
              },
            ],
          },
          {
            Muyumbu: [
              {
                Akinyambo: [
                  "Akubugingo",
                  "Kampigika",
                  "Rugarama",
                  "Ryabaheshwa",
                ],
              },
              {
                Bujyujyu: [
                  "Gatare",
                  "Gishaka",
                  "Kabeza",
                  "Kagona",
                  "Karama",
                  "Rebero",
                  "Rubaza",
                  "Rusave",
                  "Yeruzalemu",
                ],
              },
              {
                Murehe: [
                  "Bitega",
                  "Kajororo",
                  "Kayigi",
                  "Miyove",
                  "Murehe",
                  "Ruvomo",
                ],
              },
              {
                Ntebe: [
                  "Gakomeye",
                  "Gasave",
                  "Gisenyi",
                  "Kabagabo",
                  "Kajevuba",
                  "Kanyinya",
                  "Nyarubambo",
                  "Samuramba",
                ],
              },
              {
                Nyarukombe: [
                  "Gatuza",
                  "Gitaraga",
                  "Gituza",
                  "Kinunga",
                  "Marembo",
                  "Mugogo",
                  "Mumena",
                  "Rubona",
                ],
              },
            ],
          },
          {
            Mwulire: [
              {
                Bicumbi: [
                  "Bicumbi",
                  "Gasharu",
                  "Karama",
                  "Manene",
                  "Nyagihanga",
                  "Rwimbogo",
                  "Sabusaro",
                ],
              },
              {
                Bushenyi: [
                  "Byange",
                  "Kabahima",
                  "Kangaruye",
                  "Rebero",
                  "Rubiha",
                  "Ruseke",
                ],
              },
              {
                Mwulire: [
                  "Cyome",
                  "Gisanza",
                  "Akagarama",
                  "Kigabiro",
                  "Mpinga",
                  "Munini I",
                  "Munini II",
                  "Rebero",
                ],
              },
              {
                Ntunga: [
                  "Cyimbazi",
                  "Kabacuzi",
                  "Kadasumbwa",
                  "Karuzigura",
                  "Kiyovu",
                  "Nkira",
                  "Ntunga",
                  "Rugarama",
                  "Rugenge",
                ],
              },
            ],
          },
          {
            Nyakaliro: [
              {
                Bihembe: [
                  "Bihembe",
                  "Busimbuzi",
                  "Butare",
                  "Kabere",
                  "Kanyangese",
                  "Mubumbwe",
                  "Ngarama",
                  "Rusheshe",
                ],
              },
              {
                Gatare: ["Gatare", "Karogo", "Kigina", "Runzenze", "Samuduha"],
              },
              {
                Gishore: [
                  "Gishore",
                  "Kagarama",
                  "Matyazo",
                  "Nyirabuhene",
                  "Rugende",
                  "Ruhanika",
                  "Rusagara",
                  "Rusave",
                  "Rususa",
                ],
              },
              {
                Munini: [
                  "Akamasatura",
                  "Munini",
                  "Nyakagarama",
                  "Nyarurembo",
                  "Nyarutovu",
                  "Nyiramitemeri",
                  "Rwamibungo",
                  "Rwankacari",
                ],
              },
              {
                Rwimbogo: [
                  "Cyaruhinda",
                  "Kamashaza",
                  "Kasemanyana",
                  "Kimicanga",
                  "Nduba",
                  "Nduhuye",
                  "Rwimbogo",
                  "Ryarurindo",
                ],
              },
            ],
          },
          {
            Nzige: [
              {
                Akanzu: [
                  "Akanzige",
                  "Akanzu",
                  "Cyahafi",
                  "Cyerwa",
                  "Gikoni",
                  "Gitanu",
                  "Kiyovu",
                  "Nyarugenge",
                ],
              },
              {
                Kigarama: [
                  "Gisenyi",
                  "Kajevuba",
                  "Kamabuye",
                  "Karukannyi",
                  "Mikoni",
                  "Mubuga",
                  "Nyarutovu",
                  "Rugunga",
                ],
              },
              {
                Murama: [
                  "Agasharu",
                  "Gatoki",
                  "Kabeza",
                  "Kamakuka",
                  "Kibabara",
                  "Ndinda",
                  "Nyarusange",
                ],
              },
              {
                Rugarama: [
                  "Bicaca",
                  "Bitega",
                  "Kayibanda",
                  "Nyabugogo",
                  "Ruvomo",
                  "Rwagatsama",
                ],
              },
            ],
          },
          {
            Rubona: [
              {
                Byinza: [
                  "Bidudu",
                  "Gitwa",
                  "Kabayange I",
                  "Kabayange II",
                  "Mumahoro",
                  "Munini",
                  "Umumeyu",
                  "Uwadesa",
                ],
              },
              {
                Kabatasi: [
                  "Agasharu",
                  "Gitaraga",
                  "Kabuye",
                  "Kibabara",
                  "Kiboha",
                  "Midahandwa",
                  "Mitari",
                  "Nyagatare",
                  "Rusenyi",
                  "Umurehe",
                ],
              },
              {
                Kabuye: ["Agatare", "Cyamuyango", "Rubumba", "Rutare"],
              },
              {
                Karambi: ["Bigaga", "Byobo", "Karambi", "Mataba", "Rugarama"],
              },
              {
                Mabare: [
                  "Amarimba",
                  "Bitare",
                  "Gasharu",
                  "Nyamabuye",
                  "Rubirizi",
                  "Rusanza",
                  "Umubuga",
                  "Urugwiro",
                ],
              },
              {
                Nawe: ["Cyiri", "Gaseke", "Rudashya"],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    Kigali: [
      {
        Gasabo: [
          {
            Bumbogo: [
              {
                Kinyaga: [
                  "Akakaza",
                  "Kigarama",
                  "Kingabo",
                  "Muhozi",
                  "Rubungo",
                  "Ryakigogo",
                  "Zindiro",
                ],
              },
              {
                Musave: ["Kagarama", "Kayumba", "Ramba", "Rebero", "Rugando"],
              },
              {
                Mvuzo: [
                  "Kigabiro",
                  "Kiyoro",
                  "Murarambo",
                  "Nkona",
                  "Nyakabingo",
                  "Rukoma",
                ],
              },
              {
                Ngara: ["Birembo", "Gisasa", "Munini", "Ruhinga", "Uwaruraza"],
              },
              {
                Nkuzuzu: [
                  "Akabenejuru",
                  "Akasedogo",
                  "Akimpama",
                  "Burima",
                  "Kityazo",
                ],
              },
              {
                Nyabikenke: [
                  "Bushya",
                  "Gikumba",
                  "Kamutamu",
                  "Karama",
                  "Kayenzi",
                  "Kigara",
                  "Kiriza",
                  "Masizi",
                  "Mbogo",
                  "Nyampamo",
                ],
              },
              {
                Nyagasozi: [
                  "Akanyiramugarura",
                  "Akigabiro",
                  "Gishaka",
                  "Kabuye",
                  "Mpabwa",
                  "Nyagasambu",
                  "Urutarishonga",
                ],
              },
            ],
          },
          {
            Gatsata: [
              {
                Karuruma: [
                  "Akamamana",
                  "Akimihigo",
                  "Bigega",
                  "Busasamana",
                  "Kingasire",
                  "Kumuyange",
                  "Muremera",
                  "Nyagasozi",
                  "Rugoro",
                  "Rwesero",
                  "Tetero",
                ],
              },
              {
                Nyamabuye: [
                  "Agakomeye",
                  "Gashubi",
                  "Gisiza",
                  "Hanika",
                  "Juru",
                  "Kibaya",
                  "Mpakabavu",
                  "Musango",
                  "Ndengo",
                  "Nyakabande",
                  "Nyakanunga",
                  "Rubonobono",
                  "Runyonza",
                  "Rusoro",
                  "Ruvumero",
                  "Uwagatovu",
                ],
              },
              {
                Nyamugari: [
                  "Agataramo",
                  "Akamwunguzi",
                  "Akarubimbura",
                  "Akisoko",
                  "Amarembo",
                  "Amizero",
                  "Bwiza",
                  "Ihuriro",
                  "Isangano",
                  "Kanyonyomba",
                  "Nyakariba",
                  "Rwakarihejuru",
                ],
              },
            ],
          },
          {
            Gikomero: [
              {
                Gasagara: ["Bwimiyange", "Bwingeyo", "Gasagara", "Rugwiza"],
              },
              {
                Gicaca: ["Ntaganzwa", "Nyagasozi", "Nyagisozi", "Ruganda"],
              },
              {
                Kibara: ["Gahinga", "Gasharu", "Kibobo", "Nombe"],
              },
              {
                Munini: ["Munini", "Mutokerezwa", "Rudakabukirwa", "Runyinya"],
              },
              {
                Murambi: ["Kimisebeya", "Kivugiza", "Rugarama", "Twina"],
              },
            ],
          },
          {
            Gisozi: [
              {
                Musezero: [
                  "Amajyambere",
                  "Amarembo",
                  "Byimana",
                  "Gasave",
                  "Gasharu",
                  "Kagara",
                  "Nyakariba",
                  "Rwinyana",
                ],
              },
              {
                Ruhango: [
                  "Kanyinya",
                  "Kumukenke",
                  "Murambi",
                  "Ntora",
                  "Rukeri",
                  "Umurava",
                ],
              },
            ],
          },
          {
            Jabana: [
              {
                Akamatamu: [
                  "Akamatamu",
                  "Cyeyere",
                  "Murehe",
                  "Nyacyonga",
                  "Nyagasozi",
                  "Nyarukurazo",
                ],
              },
              {
                Bweramvura: [
                  "Agakenke",
                  "Agatare",
                  "Akinyana",
                  "Gikingo",
                  "Gitega",
                  "Gitenga",
                  "Nyakabingo",
                  "Nyarurama",
                  "Rugogwe",
                  "Taba",
                ],
              },
              {
                Kabuye: [
                  "Amakawa",
                  "Amasangano",
                  "Buliza",
                  "Ihuriro",
                  "Kabeza",
                  "Karuruma",
                  "Murama",
                  "Nyagasozi",
                  "Rebero",
                  "Rugarama",
                  "Tetero",
                ],
              },
              {
                Kidashya: [
                  "Agasekabuye",
                  "Agatare",
                  "Amasangano",
                  "Mubuga",
                  "Nyamweru",
                ],
              },
              {
                Ngiryi: [
                  "Agahama",
                  "Agasharu",
                  "Akabuga",
                  "Jurwe",
                  "Kiberinka",
                  "Nyakirehe",
                  "Nyarubuye",
                  "Rubona",
                  "Rwanyanza",
                  "Uwanyange",
                ],
              },
            ],
          },
          {
            Jali: [
              {
                Agateko: [
                  "Bugarama",
                  "Bukamba",
                  "Byimana",
                  "Kabizoza",
                  "Kinunga",
                  "Urunyinya",
                  "Rwankuba",
                ],
              },
              {
                Buhiza: ["Kabande", "Gatare", "Nyamugali", "Nyarubuye"],
              },
              {
                Muko: ["Gahinga", "Gatare", "Umunyinya"],
              },
              {
                Nkusi: [
                  "Agatwa",
                  "Kabagina",
                  "Kajevuba",
                  "Kigarama",
                  "Nyagasayo",
                ],
              },
              {
                Nyabuliba: [
                  "Nyaburira",
                  "Kirehe",
                  "Mataba",
                  "Nyarurembo",
                  "Rubona",
                ],
              },
              {
                Nyakabungo: ["Bwocya", "Gitaba", "Karenge", "Rugina", "Ruhihi"],
              },
              {
                Nyamitanga: ["Agasharu", "Agatare", "Kabuga", "Runyinya"],
              },
            ],
          },
          {
            Kacyiru: [
              {
                Kamatamu: [
                  "Amajyambere",
                  "Bukinanyana",
                  "Cyimana",
                  "Gataba",
                  "Itetero",
                  "Kabare",
                  "Kamuhire",
                  "Karukamba",
                  "Nyagacyamo",
                  "Rwinzovu",
                  "Urugwiro",
                  "Uruhongore",
                ],
              },
              {
                Kamutwa: [
                  "Agasaro",
                  "Gasharu",
                  "Inkingi",
                  "Kanserege",
                  "Kigugu",
                  "Ruganwa",
                  "Umuco",
                  "Umutekano",
                  "Urugero",
                  "Urwibutso",
                ],
              },
              {
                Kibaza: [
                  "Amahoro",
                  "Bwiza",
                  "Ihuriro",
                  "Ineza",
                  "Inyange",
                  "Iriba",
                  "Kabagari",
                  "Ubumwe",
                  "Umutako",
                  "Urukundo",
                  "Virunga",
                ],
              },
            ],
          },
          {
            Kimihurura: [
              {
                Kamukina: [
                  "Inyamibwa",
                  "Isangano",
                  "Isano",
                  "Ituze",
                  "Izuba",
                  "Juru",
                  "Nyenyeri",
                  "Umurava",
                  "Urumuri",
                ],
              },
              {
                Kimihurura: [
                  "Amahoro",
                  "Amajyambere",
                  "Imihigo",
                  "Intambwe",
                  "Mutara",
                  "Rugarama",
                  "Ubumwe",
                  "Umutekano",
                  "Urwego",
                ],
              },
              {
                Rugando: ["Gasange", "Gasasa", "Marembo", "Rebero", "Taba"],
              },
            ],
          },
          {
            Kimironko: [
              {
                Bibare: [
                  "Abatuje",
                  "Amariza",
                  "Imanzi",
                  "Imena",
                  "Imitari",
                  "Inganji",
                  "Ingenzi",
                  "Ingeri",
                  "Inshuti",
                  "Intashyo",
                  "Intwari",
                  "Inyamibwa",
                  "Inyange",
                  "Ubwiza",
                  "Umwezi",
                ],
              },
              {
                Kibagabaga: [
                  "Akintwari",
                  "Buranga",
                  "Gasharu",
                  "Ibuhoro",
                  "Kageyo",
                  "Kamahinda",
                  "Karisimbi",
                  "Karongi",
                  "Nyirabwana",
                  "Ramiro",
                  "Rindiro",
                  "Rugero",
                  "Rukurazo",
                  "Urumuri",
                ],
              },
              {
                Nyagatovu: [
                  "Ibukinanyana",
                  "Ibuhoro",
                  "Ijabiro",
                  "Isangano",
                  "Itetero",
                  "Urugwiro",
                ],
              },
            ],
          },
          {
            Kinyinya: [
              {
                Gacuriro: [
                  "Agatare",
                  "Akanyamugabo",
                  "Akarambo",
                  "Akaruvusha",
                  "Bishikiri",
                  "Cyeru",
                  "Estate 2020",
                  "Kabuhunde II",
                  "Kirira",
                  "Urubanda",
                  "Urugarama",
                ],
              },
              {
                Gasharu: ["Agatare", "Gasharu", "Kami", "Rwankuba"],
              },
              {
                Kagugu: [
                  "Dusenyi",
                  "Gicikiza",
                  "Giheka",
                  "Kabuhunde I",
                  "Kadobogo",
                  "Kagarama",
                  "Muhororo",
                  "Nyakabungo",
                  "Rukingu",
                ],
              },
              {
                Murama: ["Binunga", "Ngaruyinka", "Rusenyi", "Taba"],
              },
            ],
          },
          {
            Ndera: [
              {
                Bwiza: [
                  "Akarwasa",
                  "Akasemuromba",
                  "Bucyemba",
                  "Gasharu",
                  "Mukagarama",
                  "Ruhangare",
                ],
              },
              {
                Cyaruzinge: [
                  "Ayabakora",
                  "Cyaruzinge",
                  "Gashure",
                  "Gatare",
                  "Gisura",
                  "Karubibi",
                  "Mulindi",
                ],
              },
              {
                Kibenga: [
                  "Bahoze",
                  "Berwa",
                  "Buhoro",
                  "Burunga",
                  "Gitaraga",
                  "Kira",
                  "Nezerwa",
                  "Rugazi",
                  "Runyonza",
                  "Tumurere",
                  "Ururembo",
                ],
              },
              {
                Masoro: [
                  "Byimana",
                  "Kabeza",
                  "Masoro",
                  "Matwari",
                  "Mubuga",
                  "Munini",
                ],
              },
              {
                Mukuyu: [
                  "Akamusare",
                  "Akimana",
                  "Gasharu",
                  "Jurwe",
                  "Karambo",
                  "Kigabiro",
                  "Ruseno",
                ],
              },
              {
                Rudashya: [
                  "Kacyinyaga",
                  "Kamahoro",
                  "Munini",
                  "Nyakagezi",
                  "Ruhangare",
                  "Ruhogo",
                ],
              },
            ],
          },
          {
            Nduba: [
              {
                Butare: [
                  "Kanani",
                  "Kidahe",
                  "Kigabiro",
                  "Nyamurambi",
                  "Nyarubuye",
                  "Nyura",
                ],
              },
              {
                Gasanze: [
                  "Gatagara",
                  "Kagarama",
                  "Nyabitare",
                  "Nyakabungo",
                  "Nyarubande",
                  "Uruhetse",
                ],
              },
              {
                Gasura: [
                  "Agacyamo",
                  "Gashinya",
                  "Gikombe",
                  "Kazi",
                  "Kigufi",
                  "Nyirakibehe",
                  "Uruhahiro",
                ],
              },
              {
                Gatunga: [
                  "Agasharu",
                  "Amataba",
                  "Burungero",
                  "Karama",
                  "Nyange",
                  "Rebero",
                  "Uruyange",
                ],
              },
              {
                Muremure: [
                  "Gatobotobo",
                  "Kibungo",
                  "Musezero",
                  "Nyaburoro",
                  "Taba",
                ],
              },
              {
                Sha: [
                  "Bikumba",
                  "Gakizi",
                  "Gatare",
                  "Kamuyange",
                  "Kigarama",
                  "Ngara",
                ],
              },
              {
                Shango: [
                  "Akazi",
                  "Kaduha",
                  "Kamuhoza",
                  "Mirambi",
                  "Munini",
                  "Ndanyoye",
                  "Nyamigina",
                  "Rugarama",
                ],
              },
            ],
          },
          {
            Remera: [
              {
                Nyabisindu: [
                  "Amarembo I",
                  "Amarembo II",
                  "Gihogere",
                  "Kagara",
                  "Kinunga",
                  "Nyabisindu",
                  "Rugarama",
                ],
              },
              {
                Nyarutarama: [
                  "Gishushu",
                  "Juru",
                  "Kamahwa",
                  "Kangondo I",
                  "Kangondo II",
                  "Kibiraro I",
                  "Kibiraro II",
                ],
              },
              {
                "Rukiri I": [
                  "Agashyitsi",
                  "Amajyambere",
                  "Izuba",
                  "Gisimenti",
                  "Ubumwe",
                  "Ukwezi",
                  "Urumuri",
                ],
              },
              {
                "Rukiri II": [
                  "Amahoro",
                  "Rebero",
                  "Ruturusu I",
                  "Ruturusu II",
                  "Ubumwe",
                ],
              },
            ],
          },
          {
            Rusororo: [
              {
                Bisenga: ["Bisenga", "Gakenyeri", "Gasiza", "Kidogo"],
              },
              {
                Gasagara: [
                  "Agatare",
                  "Gasagara",
                  "Kamasasa",
                  "Rugagi",
                  "Ryabazana",
                ],
              },
              {
                "Kabuga I": [
                  "Abatangampundu",
                  "Amahoro",
                  "Isangano",
                  "Kabeza",
                  "Kalisimbi",
                  "Masango",
                ],
              },
              {
                "Kabuga II": [
                  "Bwiza",
                  "Cyanamo",
                  "Gatare",
                  "Kamashashi",
                  "Mataba",
                  "Nyagakombe",
                  "Ruhangare",
                ],
              },
              {
                Kinyana: ["Busenyi", "Kigabiro", "Kinyana", "Nyagisozi"],
              },
              {
                Mbandazi: [
                  "Cyeru",
                  "Karambo",
                  "Kataruha",
                  "Mugeyo",
                  "Rugarama",
                  "Samuduha",
                ],
              },
              {
                Nyagahinga: [
                  "Gisharara",
                  "Kabutare",
                  "Kanyinya",
                  "Kigarama",
                  "Nyarucundura",
                  "Runyonza",
                  "Urumuri",
                ],
              },
              {
                Ruhanga: [
                  "Kinyaga",
                  "Mirama",
                  "Nyagacyamo",
                  "Rugende",
                  "Ruhanga",
                ],
              },
            ],
          },
          {
            Rutunga: [
              {
                Gasabo: ["Gasharu", "Mulindi", "Vugavuge"],
              },
              {
                Indatemwa: [
                  "Kabarera",
                  "Kamusengo",
                  "Karekare",
                  "Karuranga",
                  "Nyakabande",
                ],
              },
              {
                Kabaliza: ["Kabaliza", "Nyamise", "Rwanyanza"],
              },
              {
                Kacyatwa: [
                  "Cyili",
                  "Kacyatwa",
                  "Kandamira",
                  "Kantabana",
                  "Munini",
                ],
              },
              {
                Kibenga: ["Abanyangeyo", "Kibenga", "Nyamvumvu"],
              },
              {
                Kigabiro: [
                  "Kamusare",
                  "Karwiru",
                  "Kigabiro",
                  "Rukerereza",
                  "Rwintare",
                ],
              },
            ],
          },
        ],
      },
      {
        Kicukiro: [
          {
            Gahanga: [
              {
                Gahanga: [
                  "Gahanga",
                  "Gatare",
                  "Gatovu",
                  "Rinini",
                  "Rwinanka",
                  "Ubumwe",
                ],
              },
              {
                Kagasa: [
                  "Kabeza",
                  "Kabidandi",
                  "Kiyanja",
                  "Nyacyonga",
                  "Nyagafunzo",
                  "Nyakuguma",
                  "Rugando II",
                ],
              },
              {
                Karembure: [
                  "Amahoro",
                  "Bigo",
                  "Kabeza",
                  "Kamuyinga",
                  "Karembure",
                  "Kimena",
                  "Mubuga",
                  "Rwamaya",
                ],
              },
              {
                Murinja: [
                  "Kampuro",
                  "Kigasa",
                  "Mashyiga",
                  "Nyabigugu",
                  "Nyamuharaza",
                  "Rukore",
                  "Runyoni",
                  "Sabununga",
                ],
              },
              {
                Nunga: [
                  "Kigarama",
                  "Kinyana",
                  "Mugendo",
                  "Nunga I",
                  "Nunga II",
                  "Rugasa",
                ],
              },
              {
                Rwabutenge: [
                  "Gahosha",
                  "Gashubi",
                  "Kaboshya",
                  "Karambo",
                  "Rebero",
                  "Rugando I",
                ],
              },
            ],
          },
          {
            Gatenga: [
              {
                Gatenga: [
                  "Amahoro",
                  "Gakoki",
                  "Gatenga",
                  "Ihuriro",
                  "Isangano",
                  "Rugari",
                ],
              },
              {
                Karambo: [
                  "Gwiza",
                  "Ihuriro",
                  "Jyambere",
                  "Kamabuye",
                  "Mahoro",
                  "Ramiro",
                  "Rebero",
                  "Rugwiro",
                  "Ruhuka",
                  "Sangwa",
                ],
              },
              {
                Nyanza: [
                  "Bwiza",
                  "Cyeza",
                  "Gasabo",
                  "Ihuriro",
                  "Isonga",
                  "Juru",
                  "Marembo",
                  "Murambi",
                  "Nyanza",
                  "Rebero",
                  "Rusororo",
                  "Sabaganga",
                  "Taba",
                ],
              },
              {
                Nyarurama: ["Bigo", "Bisambu", "Kabeza", "Nyabikenke"],
              },
            ],
          },
          {
            Gikondo: [
              {
                Kagunga: [
                  "Gatare",
                  "Kabuye I",
                  "Kabuye II",
                  "Kagunga I",
                  "Kagunga II",
                  "Rebero",
                ],
              },
              {
                Kanserege: [
                  "Kanserege I",
                  "Kanserege II",
                  "Kanserege III",
                  "Marembo I",
                  "Marembo II",
                  "Marembo III",
                ],
              },
              {
                Kinunga: [
                  "Kigugu I",
                  "Kigugu II",
                  "Kigugu III",
                  "Kinunga",
                  "Ruganwa I",
                  "Ruganwa II",
                  "Ruganwa III",
                ],
              },
            ],
          },
          {
            Kagarama: [
              {
                Kanserege: [
                  "Bwiza",
                  "Byimana",
                  "Ituze",
                  "Kanserege",
                  "Kinunga",
                ],
              },
              {
                Muyange: ["Kamuna", "Mugeyo", "Muyange", "Rugunga"],
              },
              {
                Rukatsa: [
                  "Inshuti",
                  "Mpingayanyanza",
                  "Nyacyonga",
                  "Nyanza",
                  "Rukatsa",
                  "Taba",
                ],
              },
            ],
          },
          {
            Kanombe: [
              {
                Busanza: [
                  "Amahoro",
                  "Antene",
                  "Bamporeze I",
                  "Bamporeze II",
                  "Gashyushya",
                  "Gishikiri",
                  "Hope",
                  "Kariyeri",
                  "Nyarugugu",
                  "Radari",
                  "Rukore",
                ],
              },
              {
                Kabeza: [
                  "Akagera",
                  "Bwiza",
                  "Gasabo",
                  "Giporoso I",
                  "Giporoso II",
                  "Juru",
                  "Kabeza",
                  "Karisimbi",
                  "Muhabura",
                  "Mulindi",
                  "Nyarurembo",
                  "Nyenyeri",
                  "Rebero",
                ],
              },
              {
                Karama: [
                  "Bitare",
                  "Byimana",
                  "Cyurusagara",
                  "Gakorokombe",
                  "Gikundiro",
                  "Gitarama",
                  "Karama",
                  "Nyabyunyu",
                  "Nyarutovu",
                  "Urukundo",
                ],
              },
              {
                Rubirizi: [
                  "Beninka",
                  "Bukunzi",
                  "Cyeru",
                  "Intwari",
                  "Itunda",
                  "Kavumu",
                  "Susuruka",
                  "Ubumwe",
                  "Umunara",
                  "Uwabarezi",
                  "Zirakamwa",
                ],
              },
            ],
          },
          {
            Kicukiro: [
              {
                Gasharu: ["Amajyambere", "Gasharu", "Sakirwa", "Umunyinya"],
              },
              {
                Kagina: [
                  "Gashiha",
                  "Iriba",
                  "Multimedia",
                  "Umunyinya",
                  "Umuremure",
                  "Urugero",
                ],
              },
              {
                Kicukiro: [
                  "Gasave",
                  "Isoko",
                  "Karisimbi",
                  "Kicukiro",
                  "Triangle",
                  "Ubumwe",
                ],
              },
              {
                Ngoma: ["Ahitegeye", "Intaho", "Iriba", "Isangano", "Urugero"],
              },
            ],
          },
          {
            Kigarama: [
              {
                Bwerankori: [
                  "Gakokobe",
                  "Gatare",
                  "Imena",
                  "Ituze",
                  "Kabutare",
                  "Kimisange",
                  "Nyenyeri",
                  "Ubumenyi",
                ],
              },
              {
                Karugira: [
                  "Ibuga",
                  "Ihuriro",
                  "Murambi",
                  "Rutoki",
                  "Taba",
                  "Terimbere",
                  "Ubutare",
                  "Umurimo",
                ],
              },
              {
                Kigarama: [
                  "Akimana",
                  "Amahoro",
                  "Byimana",
                  "Indatwa",
                  "Ingenzi",
                  "Kabeza",
                  "Karurayi",
                  "Mataba",
                  "Umucyo",
                ],
              },
              {
                Nyarurama: [
                  "Kamabuye",
                  "Karuyenzi",
                  "Kivu",
                  "Rebero",
                  "Twishorezo",
                  "Zuba",
                ],
              },
              {
                Rwampara: [
                  "Amajyambere",
                  "Bwiza",
                  "Nyarurembo",
                  "Ubumwe",
                  "Umutekano",
                  "Urumuri",
                  "Uwateke",
                ],
              },
            ],
          },
          {
            Masaka: [
              {
                Ayabaraya: [
                  "Kababyeyi",
                  "Ayabaraya",
                  "Nyamico",
                  "Nyamyijima",
                  "Nyirakavomo",
                  "Rususa",
                ],
              },
              {
                Cyimo: [
                  "Biryogo",
                  "Bwiza",
                  "Cyimo",
                  "Kabeza",
                  "Kiyovu",
                  "Masaka",
                  "Murambi",
                  "Nyakagunga",
                  "Urugwiro",
                ],
              },
              {
                Gako: [
                  "Bamporeze",
                  "Butangampundu",
                  "Butare",
                  "Cyugamo",
                  "Gicaca",
                  "Gihuke",
                  "Kabeza",
                  "Kibande",
                  "Rebero",
                  "Rugende",
                  "Ruyaga",
                ],
              },
              {
                Gitaraga: [
                  "Gitaraga",
                  "Kabeza",
                  "Kajevuba",
                  "Nyakarambi",
                  "Nyange",
                  "Ruhanga",
                  "Rwintare",
                ],
              },
              {
                Mbabe: [
                  "Kabeza",
                  "Kamashashi",
                  "Mbabe",
                  "Murambi",
                  "Ngarama",
                  "Sangano",
                ],
              },
              {
                Rusheshe: [
                  "Cyankongi",
                  "Cyeru",
                  "Gatare",
                  "Kagese",
                  "Kanyetabi",
                  "Mubano",
                  "Ruhosha",
                ],
              },
            ],
          },
          {
            Niboye: [
              {
                Gatare: [
                  "Byimana",
                  "Gatare",
                  "Imena",
                  "Kamahoro",
                  "Kigarama",
                  "Rugunga",
                  "Rurembo",
                  "Taba",
                ],
              },
              {
                Niboye: [
                  "Buhoro",
                  "Gaseke",
                  "Gateke",
                  "Gorora",
                  "Kigabiro",
                  "Kinunga",
                  "Kiruhura",
                  "Munini",
                  "Murehe",
                  "Mwijabo",
                  "Mwijuto",
                  "Nyarubande",
                  "Rwezamenyo",
                  "Sovu",
                  "Taba",
                ],
              },
              {
                Nyakabanda: [
                  "Amahoro",
                  "Amarebe",
                  "Amarembo",
                  "Bigabiro",
                  "Bukinanyana",
                  "Bumanzi",
                  "Bwiza",
                  "Gatsibo",
                  "Gikundiro",
                  "Indakemwa",
                  "Indamutsa",
                  "Indatwa",
                  "Inyarurembo",
                  "Isangano",
                  "Karama",
                  "Kinyana",
                  "Rugwiro",
                  "Umurava",
                ],
              },
            ],
          },
          {
            Nyarugunga: [
              {
                Kamashashi: [
                  "Akindege",
                  "Indatwa",
                  "Intwari",
                  "Kabagendwa",
                  "Kibaya",
                  "Mukoni",
                  "Mulindi",
                  "Umucyo",
                  "Uruhongore",
                ],
              },
              {
                Nonko: [
                  "Gasaraba",
                  "Gihanga",
                  "Gitara",
                  "Kavumu",
                  "Mahoro",
                  "Nyarutovu",
                  "Rugali",
                  "Runyonza",
                ],
              },
              {
                Rwimbogo: [
                  "Gabiro",
                  "Kabaya",
                  "Kanogo",
                  "Marembo",
                  "Umushumba Mwiza",
                  "Nyandungu",
                  "Ruragendwa",
                  "Rwinyana",
                  "Rwinyange",
                  "Rwiza",
                  "Urwibutso",
                ],
              },
            ],
          },
        ],
      },
      {
        Nyarugenge: [
          {
            Gitega: [
              {
                Akabahizi: [
                  "Gihanga",
                  "Iterambere",
                  "Izuba",
                  "Nyaburanga",
                  "Nyenyeri",
                  "Ubukorikori",
                  "Ubumwe",
                  "Ubwiyunge",
                  "Umucyo",
                  "Umurabyo",
                  "Umuseke",
                  "Vugizo",
                ],
              },
              {
                Akabeza: ["Akinyambo", "Amayaga", "Gitwa", "Ituze", "Mpazi"],
              },
              {
                Gacyamo: [
                  "Amahoro",
                  "Impuhwe",
                  "Intsinzi",
                  "Kivumu",
                  "Ubumwe",
                  "Urukundo",
                  "Ururembo",
                ],
              },
              {
                Kigarama: [
                  "Ingenzi",
                  "Sangwa",
                  "Umubano",
                  "Umucyo",
                  "Umuhoza",
                  "Umurava",
                ],
              },
              {
                Kinyange: [
                  "Akabugenewe",
                  "Ihuriro",
                  "Isangano",
                  "Isano",
                  "Karitasi",
                  "Ubumanzi",
                  "Uburezi",
                  "Ubwiza",
                  "Umucyo",
                  "Umwembe",
                  "Urugano",
                ],
              },
              {
                Kora: [
                  "Isangano",
                  "Kanunga",
                  "Kinyambo",
                  "Kivumu",
                  "Kora",
                  "Mpazi",
                  "Rugano",
                  "Rugari",
                  "Ubumwe",
                ],
              },
            ],
          },
          {
            Kanyinya: [
              {
                Nyamweru: [
                  "Bwimo",
                  "Gatare",
                  "Mubuga",
                  "Nyakirambi",
                  "Nyamweru",
                  "Ruhengeri",
                ],
              },
              {
                Nzove: [
                  "Bibungo",
                  "Bwiza",
                  "Gateko",
                  "Kagasa",
                  "Nyabihu",
                  "Rutagara I",
                  "Rutagara II",
                  "Ruyenzi",
                ],
              },
              {
                Taba: [
                  "Kagaramira",
                  "Ngendo",
                  "Nyarurama",
                  "Nyarusange",
                  "Rwakivumu",
                  "Taba",
                ],
              },
            ],
          },
          {
            Kigali: [
              {
                Kigali: [
                  "Akirwanda",
                  "Gisenga",
                  "Kadobogo",
                  "Kagarama",
                  "Kibisogi",
                  "Muganza",
                  "Murama",
                  "Rubuye",
                  "Ruhango",
                  "Ryasharangabo",
                ],
              },
              {
                Mwendo: [
                  "Agakomeye",
                  "Akagugu",
                  "Amahoro",
                  "Amajyambere",
                  "Birambo",
                  "Isangano",
                  "Kanyabami",
                  "Karambo",
                  "Mwendo",
                  "Ruhuha",
                  "Ubuzima",
                  "Umutekano",
                ],
              },
              {
                Nyabugogo: [
                  "Gakoni",
                  "Gatare",
                  "Giticyinyoni",
                  "Kadobogo",
                  "Kamenge",
                  "Karama",
                  "Kiruhura",
                  "Nyabikoni",
                  "Nyabugogo",
                  "Ruhondo",
                ],
              },
              {
                Ruriba: [
                  "Misibya",
                  "Nyabitare",
                  "Ruhango",
                  "Ruharabuge",
                  "Ruriba",
                  "Ruzigimbogo",
                  "Ryamakomari",
                  "Tubungo",
                ],
              },
              {
                Rwesero: [
                  "Akanyamirambo",
                  "Akinama",
                  "Makaga",
                  "Musimba",
                  "Ruhogo",
                  "Rwesero",
                  "Rweza",
                  "Vuganyana",
                ],
              },
            ],
          },
          {
            Kimisagara: [
              {
                Kamuhoza: [
                  "Buhoro",
                  "Busasamana",
                  "Isimbi",
                  "Ituze",
                  "Karama",
                  "Karwarugabo",
                  "Kigabiro",
                  "Mataba",
                  "Munini",
                  "Ntaraga",
                  "Nunga",
                  "Rurama",
                  "Rutunga",
                  "Tetero",
                ],
              },
              {
                Katabaro: [
                  "Akamahoro",
                  "Akishinge",
                  "Akishuri",
                  "Amahumbezi",
                  "Inganzo",
                  "Kigarama",
                  "Mpazi",
                  "Mugina",
                  "Ubumwe",
                  "Ubusabane",
                  "Umubano",
                  "Umurinzi",
                  "Uruyange",
                ],
              },
              {
                Kimisagara: [
                  "Akabeza",
                  "Amahoro",
                  "Birama",
                  "Buhoro",
                  "Bwiza",
                  "Byimana",
                  "Gakaraza",
                  "Gaseke",
                  "Ihuriro",
                  "Inkurunziza",
                  "Karambi",
                  "Kigina",
                  "Kimisagara",
                  "Kove",
                  "Muganza",
                  "Nyabugogo",
                  "Nyagakoki",
                  "Nyakabingo",
                  "Nyamabuye",
                  "Sangwa",
                  "Sano",
                ],
              },
            ],
          },
          {
            Mageregere: [
              {
                Kankuba: [
                  "Kamatamu",
                  "Kankuba",
                  "Karukina",
                  "Musave",
                  "Nyarumanga",
                  "Rugendabari",
                ],
              },
              {
                Kavumu: [
                  "Ayabatanga",
                  "Kankurimba",
                  "Kavumu",
                  "Mubura",
                  "Murondo",
                  "Nyakabingo",
                  "Nyarubuye",
                ],
              },
              {
                Mataba: [
                  "Burema",
                  "Gahombo",
                  "Kabeza",
                  "Karambi",
                  "Kwisanga",
                  "Mageragere",
                  "Mataba",
                  "Rushubi",
                ],
              },
              {
                Ntungamo: [
                  "Akanakamageragere",
                  "Gatovu",
                  "Nyabitare",
                  "Nyarubande",
                  "Rubungo",
                  "Rwindonyi",
                ],
              },
              {
                Nyarufunzo: [
                  "Akabungo",
                  "Akamashinge",
                  "Maya",
                  "Nyarufunzo",
                  "Nyarurama",
                  "Rubete",
                ],
              },
              {
                Nyarurenzi: [
                  "Amahoro",
                  "Ayabaramba",
                  "Gikuyu",
                  "Iterambere",
                  "Nyabirondo",
                  "Nyarurenzi",
                ],
              },
              {
                Runzenze: [
                  "Gisunzu",
                  "Mpanga",
                  "Nkomero",
                  "Runzenze",
                  "Uwurugenge",
                ],
              },
            ],
          },
          {
            Muhima: [
              {
                Amahoro: [
                  "Amahoro",
                  "Amizero",
                  "Inyarurembo",
                  "Kabirizi",
                  "Ubuzima",
                  "Uruhimbi",
                ],
              },
              {
                Kabasengerezi: ["Icyeza", "Ikana", "Intwari", "Kabasengerezi"],
              },
              {
                Kabeza: [
                  "Hirwa",
                  "Ikaze",
                  "Imanzi",
                  "Ingenzi",
                  "Ituze",
                  "Sangwa",
                  "Umwezi",
                ],
              },
              {
                Nyabugogo: [
                  "Abeza",
                  "Icyerekezo",
                  "Indatwa",
                  "Rwezangoro",
                  "Ubucuruzi",
                  "Umutekano",
                ],
              },
              {
                Rugenge: ["Imihigo", "Impala", "Rugenge", "Ubumanzi"],
              },
              {
                Tetero: [
                  "Indamutsa",
                  "Ingoro",
                  "Inkingi",
                  "Intiganda",
                  "Iwacu",
                  "Tetero",
                ],
              },
              {
                Ubumwe: [
                  "Bwahirimba",
                  "Duterimbere",
                  "Isangano",
                  "Nyanza",
                  "Urugwiro",
                  "Urwego",
                ],
              },
            ],
          },
          {
            Nyakabanda: [
              {
                "Munanira I": [
                  "Kabusunzu",
                  "Munanira",
                  "Ntaraga",
                  "Nyagasozi",
                  "Rurembo",
                ],
              },
              {
                "Munanira II": [
                  "Gasiza",
                  "Kamwiza",
                  "Kanyange",
                  "Karudandi",
                  "Kigabiro",
                  "Kokobe",
                  "Mucyuranyana",
                  "Nkundumurimbo",
                ],
              },
              {
                "Nyakabanda I": [
                  "Akinkware",
                  "Gapfupfu",
                  "Gasiza",
                  "Kariyeri",
                  "Kokobe",
                  "Munini",
                  "Nyakabanda",
                  "Rwagitanga",
                ],
              },
              {
                "Nyakabanda II": [
                  "Ibuhoro",
                  "Kabeza",
                  "Kanyiranganji",
                  "Karujongi",
                  "Kigarama",
                  "Kirwa",
                ],
              },
            ],
          },
          {
            Nyamirambo: [
              {
                Cyivugiza: [
                  "Amizero",
                  "Gabiro",
                  "Imanzi",
                  "Ingenzi",
                  "Intwari",
                  "Karisimbi",
                  "Mahoro",
                  "Mpano",
                  "Muhabura",
                  "Muhoza",
                  "Munini",
                  "Rugero",
                  "Shema",
                ],
              },
              {
                Gasharu: ["Kagunga", "Karukoro", "Rwintare"],
              },
              {
                Mumena: [
                  "Akanyana",
                  "Akanyirazaninka",
                  "Akarekare",
                  "Akatabaro",
                  "Irembo",
                  "Itaba",
                  "Kiberinka",
                  "Mumena",
                  "Rwampara",
                ],
              },
              {
                Rugarama: [
                  "Gatare",
                  "Kiberinka",
                  "Munanira",
                  "Riba",
                  "Rubona",
                  "Rugarama",
                  "Runyinya",
                  "Rusisiro",
                  "Tetero",
                ],
              },
            ],
          },
          {
            Nyarugenge: [
              {
                Agatare: [
                  "Agatare",
                  "Amajyambere",
                  "Inyambo",
                  "Meraneza",
                  "Uburezi",
                  "Umucyo",
                  "Umurava",
                ],
              },
              {
                Biryogo: ["Biryogo", "Gabiro", "Isoko", "Nyiranuma", "Umurimo"],
              },
              {
                Kiyovu: [
                  "Amizero",
                  "Cercle Sportif",
                  "Ganza",
                  "Imena",
                  "Indangamirwa",
                  "Ingenzi",
                  "Inyarurembo",
                  "Ishema",
                  "Isibo",
                  "Muhabura",
                  "Rugunga",
                  "Sugira",
                ],
              },
              {
                Rwampara: [
                  "Amahoro",
                  "Gacaca",
                  "Intwari",
                  "Rwampara",
                  "Umucyo",
                  "Umuganda",
                ],
              },
            ],
          },
          {
            Rwezamenyo: [
              {
                "Kabuguru I": ["Muhoza", "Muhuza", "Mumararungu", "Murambi"],
              },
              {
                "Kabuguru II": ["Buhoro", "Gasabo", "Mutara", "Ubusabane"],
              },
              {
                "Rwezamenyo I": [
                  "Abatarushwa",
                  "Indatwa",
                  "Inkerakubanza",
                  "Intwari",
                ],
              },
              {
                "Rwezamenyo II": ["Amahoro", "Umucyo", "Urumuri"],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    North: [
      {
        Burera: [
          {
            Bungwe: [
              {
                Bungwe: [
                  "Bungwe",
                  "Gakeri",
                  "Gatenga",
                  "Kinihira",
                  "Nyabyondo",
                  "Rweru",
                  "Zaneza",
                ],
              },
              {
                Bushenya: [
                  "Buhinga",
                  "Bushenya",
                  "Gifumba",
                  "Mbuga",
                  "Ryamayaya",
                ],
              },
              {
                Mudugari: [
                  "Buzaniro",
                  "Kivumo",
                  "Mubuga",
                  "Rubayo",
                  "Sangabuzi",
                  "Vunga",
                ],
              },
              {
                Tumba: [
                  "Byorera",
                  "Karwema",
                  "Mubuga",
                  "Murambo",
                  "Mutungo",
                  "Nama",
                  "Nyarukore",
                  "Tumba",
                ],
              },
            ],
          },
          {
            Butaro: [
              {
                Gatsibo: [
                  "Gafumba",
                  "Gahuye",
                  "Gasebeya",
                  "Gatare",
                  "Gatovu",
                  "Kadehero",
                  "Kagano",
                  "Kaniga",
                  "Kanyoni",
                  "Kindoyi",
                  "Murambi",
                  "Rubonobono",
                  "Rwabutama",
                  "Rweru",
                ],
              },
              {
                Mubuga: [
                  "Biyove",
                  "Bugeme",
                  "Gacyamo",
                  "Kirwa",
                  "Mulindi",
                  "Murambi",
                  "Musenyi",
                  "Nyanamo",
                  "Rupangu",
                  "Ryakagundu",
                  "Ryanturege",
                ],
              },
              {
                Muhotora: [
                  "Bukaragata",
                  "Cyahera",
                  "Gahunge",
                  "Kabere",
                  "Karambi",
                  "Kibande",
                  "Kindege",
                  "Murambo",
                  "Murwa",
                  "Rugandu",
                  "Taba",
                ],
              },
              {
                Nyamicucu: [
                  "Burambira",
                  "Gacereri",
                  "Gahira",
                  "Gari",
                  "Gasiza",
                  "Gitovu",
                  "Karingorera",
                  "Kibingo",
                  "Kiringa",
                  "Murwa",
                  "Musama",
                  "Nkururo",
                  "Nyamiyaga",
                  "Rubaya",
                  "Rugeshi",
                  "Rwemikore",
                ],
              },
              {
                Rusumo: [
                  "Budogoro",
                  "Butaro",
                  "Buyanga",
                  "Cyasenge",
                  "Gitanda",
                  "Kabahura",
                  "Kabaya",
                  "Kabingo",
                  "Kamonyi",
                  "Kanyesogo",
                  "Mugari",
                  "Mugera",
                  "Mukeri",
                  "Musongati",
                  "Nyamiyaga",
                  "Runaba",
                ],
              },
            ],
          },
          {
            Cyanika: [
              {
                Gasiza: [
                  "Bahimba",
                  "Gahirikiro",
                  "Gashunguru",
                  "Kabona",
                  "Karisimbi",
                  "Kaziguro",
                  "Nyamiyaga",
                  "Rwankongi",
                ],
              },
              {
                Gisovu: [
                  "Gisovu",
                  "Hanika",
                  "Kamegeri",
                  "Mataba",
                  "Ruhimbi",
                  "Rusenyi",
                  "Rutango",
                  "Samiro",
                ],
              },
              {
                Kabyiniro: [
                  "Butete",
                  "Kabadari",
                  "Mbonabose",
                  "Mugarama",
                  "Mugeshi",
                  "Nkiriza",
                  "Nyagisenyi",
                  "Zindiro",
                ],
              },
              {
                Kagitega: [
                  "Gasebeya",
                  "Kabaya",
                  "Kagerero",
                  "Karambo",
                  "Kidaho",
                  "Munini",
                  "Ntarama",
                  "Sirwa",
                ],
              },
              {
                Kamanyana: [
                  "Gasiza",
                  "Gasovu",
                  "Kabira",
                  "Kavunda",
                  "Kibaya",
                  "Majyambere",
                  "Nyarutosho",
                  "Runyenkanda",
                  "Ryabiteyi",
                ],
              },
              {
                Nyagahinga: [
                  "Bisura",
                  "Gahama",
                  "Gahonga",
                  "Gakenke",
                  "Kabande",
                  "Kabyimana",
                  "Kanyabaranzi",
                  "Kebero",
                  "Mashango",
                  "Musave",
                  "Ruko",
                ],
              },
            ],
          },
          {
            Cyeru: [
              {
                Butare: [
                  "Butare",
                  "Gatare",
                  "Kamata",
                  "Kamonyi",
                  "Musama",
                  "Nyaruyove",
                  "Ryandahagaze",
                ],
              },
              {
                Ndongozi: [
                  "Kabagenza",
                  "Ntazi",
                  "Nterura",
                  "Nyagisozi",
                  "Nyamusanze",
                  "Rujanja",
                  "Ryaruhirima",
                ],
              },
              {
                Ruyange: [
                  "Bitagara",
                  "Burabwa",
                  "Gatagara-jite",
                  "Kabaya",
                  "Ngambi",
                  "Rihiro",
                  "Rugarama",
                  "Runyenyeri",
                  "Susa",
                ],
              },
            ],
          },
          {
            Gahunga: [
              {
                Buramba: [
                  "Buramba",
                  "Gafatangwe",
                  "Gasenyi",
                  "Kagoma",
                  "Karuheshyi",
                  "Murambi",
                  "Musanzu",
                ],
              },
              {
                Gisizi: [
                  "Gisizi",
                  "Kabagabo",
                  "Kanaba",
                  "Kigote",
                  "Nyagasozi",
                  "Ruri",
                ],
              },
              {
                Kidakama: [
                  "Bahenga",
                  "Kabarima",
                  "Kabindi",
                  "Kajevuba",
                  "Kangoma",
                  "Kanyendara",
                  "Kidakama",
                  "Mubuga",
                  "Nangimbibi",
                  "Rusenyi",
                  "Songa",
                ],
              },
              {
                Nyangwe: [
                  "Bihanga",
                  "Gasagara",
                  "Gikoro",
                  "Kamatanda",
                  "Mubibi",
                  "Ntenyo",
                  "Nyangwe",
                  "Remera",
                ],
              },
              {
                Rwasa: [
                  "Gitagata",
                  "Kabanga",
                  "Kangoboka",
                  "Kanyiramusengo",
                  "Mirigari",
                  "Mutara",
                  "Nyangezi",
                ],
              },
            ],
          },
          {
            Gatebe: [
              {
                Gabiro: [
                  "Gatebe",
                  "Ginga",
                  "Kabuga",
                  "Kagano",
                  "Kajerijeri",
                  "Nyakabungo",
                  "Rugarama",
                  "Ryaruyumbu",
                  "Zihare",
                ],
              },
              {
                Musenda: [
                  "Bikumba",
                  "Cyankaranka",
                  "Kabayoboke",
                  "Kabuga",
                  "Muremure",
                  "Nyamahunge",
                  "Rushaki",
                  "Sabukima",
                  "Sunzu",
                ],
              },
              {
                Rwambogo: [
                  "Cyili",
                  "Mubuga",
                  "Murambo",
                  "Ruhinga",
                  "Rutete",
                  "Taba",
                ],
              },
              {
                Rwasa: [
                  "Karambi",
                  "Kiyogera",
                  "Murambo",
                  "Nganzo",
                  "Rugarama",
                  "Rutovu",
                ],
              },
            ],
          },
          {
            Gitovu: [
              {
                Mariba: [
                  "Buhembe",
                  "Cyogo",
                  "Kiboga",
                  "Mariba",
                  "Musekera",
                  "Mwungura",
                  "Rusuzuma",
                ],
              },
              {
                Musasa: [
                  "Butanga",
                  "Gashiru",
                  "Gicura",
                  "Kamusaba",
                  "Kibumbiro",
                  "Murore",
                  "Mutara",
                  "Ruhombo",
                  "Shyamba",
                  "Sina",
                ],
              },
              {
                Runoga: [
                  "Gitwe",
                  "Kiraro",
                  "Mubuga",
                  "Musekera",
                  "Mutungu",
                  "Siganiro",
                ],
              },
            ],
          },
          {
            Kagogo: [
              {
                Kabaya: ["Bihanga", "Butare", "Kanaba", "Murambi", "Rukenke"],
              },
              {
                Kayenzi: [
                  "Gatare",
                  "Kaguriro",
                  "Kiyira",
                  "Mubaya",
                  "Ngobori",
                  "Rukoro",
                  "Rusisiro",
                  "Rwitongo",
                ],
              },
              {
                Kiringa: [
                  "Gisanze",
                  "Karambi",
                  "Kariba",
                  "Karombero",
                  "Kigote",
                  "Kirigari",
                  "Musangabo",
                  "Nyamuha",
                  "Rusenyi",
                  "Rwabageni",
                  "Ryangarama",
                ],
              },
              {
                Nyamabuye: [
                  "Gitare",
                  "Kabana",
                  "Kabashotsi",
                  "Kikubo",
                  "Mfashe",
                  "Musarara",
                  "Nyamabuye",
                  "Nyarubuye",
                  "Nyarugina",
                ],
              },
            ],
          },
          {
            Kinoni: [
              {
                Gafuka: [
                  "Basumba",
                  "Bugeyo",
                  "Buharo",
                  "Kabeza",
                  "Kanoni",
                  "Ntwana",
                  "Nyagafunzo",
                ],
              },
              {
                Nkenke: ["Birwa", "Kigina", "Kigugu", "Nyagatoki", "Sunzu"],
              },
              {
                Nkumba: [
                  "Cyanya",
                  "Cyivugiza",
                  "Kabaguma",
                  "Karambo",
                  "Mbaya",
                  "Mubuga",
                  "Mutabo",
                ],
              },
              {
                Ntaruka: [
                  "Cyamabuye",
                  "Gikoro",
                  "Kabaya",
                  "Karuganda",
                  "Nyabagenzi",
                  "Nyarubuye",
                  "Nyarurembo",
                  "Ryamakoro",
                  "Shenyi",
                ],
              },
            ],
          },
          {
            Kinyababa: [
              {
                Bugamba: [
                  "Cyogo",
                  "Gacaca",
                  "Gako",
                  "Gatare",
                  "Kabingo",
                  "Kirwa",
                  "Matyazo",
                  "Ndabizi",
                  "Rukore",
                ],
              },
              {
                Kaganda: [
                  "Gisirwe",
                  "Kiraro",
                  "Mariko",
                  "Murambo",
                  "Ruhinga",
                  "Rusebeya",
                  "Rwahondo",
                ],
              },
              {
                Musasa: [
                  "Gitoma",
                  "Kabarore",
                  "Kanyaminyinya",
                  "Murambo",
                  "Rukaya",
                ],
              },
              {
                Rutovu: [
                  "Gisiriri",
                  "Gitenge",
                  "Karambo",
                  "Kavumu",
                  "Musaga",
                  "Nyabizi I",
                  "Nyabizi II",
                  "Nyabizi III",
                  "Rubayu",
                  "Ryatamba",
                  "Shaga",
                ],
              },
            ],
          },
          {
            Kivuye: [
              {
                Bukwashuri: [
                  "Buhita",
                  "Gitovu",
                  "Murambo",
                  "Nyakira",
                  "Nyamisare",
                  "Nyarutovu",
                ],
              },
              {
                Gashanje: [
                  "Bitukura",
                  "Burango",
                  "Gafumba",
                  "Gashiru",
                  "Karambo",
                  "Nyakabungo",
                  "Rugarambiro",
                ],
              },
              {
                Murwa: [
                  "Gasiza",
                  "Gatare",
                  "Kabaya",
                  "Muhambo",
                  "Rubara",
                  "Rucyamo",
                  "Rusasa",
                  "Vumage",
                ],
              },
              {
                Nyirataba: [
                  "Buganza",
                  "Bukumbi",
                  "Kabasha",
                  "Kanyenzugi",
                  "Kivumo",
                  "Mushunga",
                  "Shanja",
                ],
              },
            ],
          },
          {
            Nemba: [
              {
                Kivumu: [
                  "Gashushura",
                  "Kigeyo",
                  "Mugano",
                  "Nyamusanze",
                  "Songorero",
                ],
              },
              {
                Nyamugari: [
                  "Cyabami",
                  "Kagihanga",
                  "Karyango",
                  "Muhondo",
                  "Nyagahondo",
                  "Nyiraruhuha",
                  "Ryaruhirima",
                  "Shorezo",
                ],
              },
              {
                Rubona: [
                  "Bugarigari",
                  "Bukenyeye",
                  "Butunda",
                  "Cyabarenge",
                  "Kadehero",
                  "Kanyaru",
                  "Murandamo",
                  "Ngongwe",
                  "Nyantweri",
                  "Rebero",
                ],
              },
              {
                Rushara: [
                  "Bishingwe",
                  "Bugondo",
                  "Cyave",
                  "Kagesera",
                  "Mugomero",
                  "Nyabitare",
                ],
              },
            ],
          },
          {
            Rugarama: [
              {
                Cyahi: [
                  "Busura",
                  "Gakore",
                  "Hanika",
                  "Karutwe",
                  "Nguri",
                  "Nyabiho",
                  "Rubeja",
                  "Ruganda",
                  "Tatiro",
                ],
              },
              {
                Gafumba: [
                  "Bambiro",
                  "Basumba",
                  "Gacyogo",
                  "Gahunga",
                  "Kabaya",
                  "Kanyangezi",
                  "Muturirwa",
                  "Nyarwondo",
                  "Rugarama",
                  "Rutamba",
                ],
              },
              {
                Karangara: [
                  "Gahama",
                  "Gasiza",
                  "Kabaya",
                  "Kanyamugezi",
                  "Maya",
                  "Muhabura",
                  "Rugwiro",
                  "Rukiko",
                  "Sasa",
                ],
              },
              {
                Rurembo: [
                  "Birwa",
                  "Gashore",
                  "Mpinga",
                  "Nyakiriba",
                  "Rwambeho",
                  "Rwinkuba",
                ],
              },
            ],
          },
          {
            Rugengabari: [
              {
                Kilibata: [
                  "Bushima",
                  "Cyogo",
                  "Murungu",
                  "Musheke",
                  "Remera",
                  "Taba",
                ],
              },
              {
                Mucaca: [
                  "Burago",
                  "Burande",
                  "Gahinga",
                  "Kamonyi",
                  "Karubamba",
                  "Mugina",
                  "Nkoto",
                  "Nyabikungu",
                  "Rihiro",
                ],
              },
              {
                Nyanamo: [
                  "Bwenjeli",
                  "Kabira",
                  "Kabukoko",
                  "Kabuyenge",
                  "Kamonyi",
                  "Kiziba",
                  "Murambo",
                  "Taba",
                ],
              },
              {
                Rukandabyuma: [
                  "Gatenga",
                  "Kinyefurwe",
                  "Mubuga",
                  "Murambo",
                  "Ngoma",
                  "Nyansyo",
                  "Remya",
                  "Rugandu",
                  "Seta",
                ],
              },
            ],
          },
          {
            Ruhunde: [
              {
                Gaseke: [
                  "Gahe",
                  "Gatare",
                  "Kanyoni",
                  "Kintobo",
                  "Mukaka",
                  "Murambo",
                  "Rugaragara",
                  "Rukiniro",
                  "Rukwavu",
                ],
              },
              {
                Gatare: [
                  "Gashinge",
                  "Gashishori",
                  "Gatete",
                  "Gitwe",
                  "Nganzo",
                  "Ruganda",
                  "Rukingu",
                  "Terimbere",
                ],
              },
              {
                Gitovu: [
                  "Cyasuri",
                  "Genda",
                  "Kaberano",
                  "Kamonyi",
                  "Muremure",
                  "Mweru",
                  "Ngoma",
                  "Tetero",
                ],
              },
              {
                Rusekera: [
                  "Bugambanyoni",
                  "Gasura",
                  "Gatokezo",
                  "Matyazo",
                  "Rubyiniro",
                  "Rusenge",
                  "Tarasi",
                ],
              },
            ],
          },
          {
            Rusarabuye: [
              {
                Kabona: [
                  "Bucyaba",
                  "Busutamo",
                  "Buzamuye",
                  "Gahinga",
                  "Gasongati",
                  "Gikore",
                  "Karambo",
                  "Muharuro",
                  "Munanira",
                  "Murambo",
                  "Musebeya",
                  "Ntagara",
                  "Rutuku",
                ],
              },
              {
                Ndago: [
                  "Burehe",
                  "Gacaca",
                  "Gaseke",
                  "Gitovu",
                  "Kajerijeri",
                  "Karorero",
                  "Kirambo",
                  "Ndago",
                  "Nyarungu",
                ],
              },
              {
                Ruhanga: [
                  "Bisayu I",
                  "Bisayu II",
                  "Bumba",
                  "Kamukondo",
                  "Kanigo",
                  "Karuhanga",
                  "Kibuye",
                  "Ngundu",
                  "Ruhanga",
                  "Ruhurura I",
                  "Ruhurura II",
                  "Rutoro",
                ],
              },
            ],
          },
          {
            Rwerere: [
              {
                Gacundura: [
                  "Burindwa",
                  "Gacundura",
                  "Kanigo",
                  "Karegamazi",
                  "Moma",
                  "Rugaragara",
                  "Rugarambiro",
                  "Sarambwe",
                ],
              },
              {
                Gashoro: [
                  "Bisaga",
                  "Cyapa",
                  "Gashoro",
                  "Kibuye",
                  "Ngonya",
                  "Rugezi",
                  "Rwerere",
                ],
              },
              {
                Ruconsho: [
                  "Buhore",
                  "Gakenke",
                  "Kamatengu",
                  "Kinkware",
                  "Mugera",
                  "Ngoma",
                  "Ruconsho",
                ],
              },
              {
                Rugari: [
                  "Gacyamu",
                  "Gatovu",
                  "Mucaca",
                  "Murambo",
                  "Mushubi",
                  "Tangata",
                ],
              },
            ],
          },
        ],
      },
      {
        Gakenke: [
          {
            Busengo: [
              {
                Birambo: ["Birambo", "Gitwa", "Kirwa", "Nyarubande"],
              },
              {
                Butereri: [
                  "Buhuga",
                  "Butereri",
                  "Gasakuza",
                  "Kirwa",
                  "Rubaga",
                  "Rugendabari",
                  "Rwinkuba",
                ],
              },
              {
                Byibuhiro: [
                  "Gatoke",
                  "Kamina",
                  "Karambi",
                  "Nyagasozi",
                  "Ruboza",
                ],
              },
              {
                Kamina: [
                  "Bunyangezi",
                  "Kajereri",
                  "Kamina",
                  "Mwendo",
                  "Nyarubuye",
                  "Rwankuba",
                ],
              },
              {
                Kirabo: [
                  "Gasaso",
                  "Kirabo",
                  "Munyinya",
                  "Ngezi",
                  "Rusebeya",
                  "Wimfizi",
                ],
              },
              {
                Mwumba: ["Kabuga", "Kamonyi", "Karaba", "Mugunga", "Rutenga"],
              },
              {
                Ruhanga: [
                  "Bukinga",
                  "Gashirwe",
                  "Kabaya",
                  "Kabugiri",
                  "Rurangara",
                ],
              },
            ],
          },
          {
            Coko: [
              {
                Kiruku: [
                  "Buhuri",
                  "Bukamba",
                  "Bushagashi",
                  "Gatare",
                  "Mucumazo",
                  "Ntarabana",
                  "Nyamasuka",
                  "Rubuguma",
                ],
              },
              {
                Mbirima: [
                  "Akanduga",
                  "Burengo",
                  "Bushyama",
                  "Matovu",
                  "Mbogo",
                  "Murambi",
                  "Rwahi",
                  "Shyunga",
                ],
              },
              {
                Nyange: [
                  "Buhara",
                  "Gaseke",
                  "Karambo",
                  "Karoli",
                  "Musasa",
                  "Ntobwe",
                  "Vumandi",
                ],
              },
              {
                Nyanza: ["Baramba", "Gikamba", "Gitaba", "Kavumu", "Tumba"],
              },
            ],
          },
          {
            Cyabingo: [
              {
                Muhaza: [
                  "Buraza",
                  "Busoga",
                  "Karombero",
                  "Muhaza",
                  "Mushirarungu",
                  "Ntaraga",
                  "Rutaramiro",
                ],
              },
              {
                Muhororo: [
                  "Butaraga",
                  "Gatoki",
                  "Gatorero",
                  "Kabungwe",
                  "Karenge",
                  "Muhororo",
                  "Musebeya",
                  "Tongoburo",
                ],
              },
              {
                Muramba: [
                  "Bukuba",
                  "Gahama",
                  "Gatare",
                  "Musebeya",
                  "Rugaragara",
                  "Rwobe",
                ],
              },
              {
                Mutanda: [
                  "Cyabingo",
                  "Gishubi",
                  "Kambare",
                  "Kanyamukenke",
                  "Mucaca",
                  "Mutanda",
                ],
              },
              {
                Rukore: [
                  "Kigote",
                  "Muramba",
                  "Murehe",
                  "Nyabisika",
                  "Nyamugali",
                  "Rugendabare",
                  "Rukore",
                ],
              },
            ],
          },
          {
            Gakenke: [
              {
                Buheta: [
                  "Buyagiro",
                  "Gatwa",
                  "Gihemba",
                  "Gikerera",
                  "Karambi",
                  "Karorero",
                  "Mucuro",
                  "Murambi",
                  "Ndora",
                  "Rusebeya",
                ],
              },
              {
                Kagoma: [
                  "Bukanka",
                  "Cyandago",
                  "Gitenga",
                  "Kamatare",
                  "Murama",
                  "Murambi",
                  "Musave",
                  "Ntobwe",
                  "Rurambi",
                  "Rusuri",
                ],
              },
              {
                Nganzo: [
                  "Bwimba",
                  "Gahondo",
                  "Gashigwe",
                  "Gishyinguro",
                  "Kaniga",
                  "Kanyiramanyana",
                  "Karambi",
                  "Karehe",
                  "Karuganda",
                  "Mbizi",
                  "Mbogo",
                  "Muyira",
                  "Ryabazungu",
                ],
              },
              {
                Rusagara: [
                  "Akarugamba",
                  "Busingiryi",
                  "Kabaya",
                  "Kageyo",
                  "Kakinungu",
                  "Kivumu",
                  "Mazinga",
                  "Murambi",
                  "Museke",
                  "Nyamabuye",
                  "Ruberano",
                  "Sitwe",
                  "Umujyi Wa Gakenke",
                ],
              },
            ],
          },
          {
            Gashenyi: [
              {
                Nyacyina: [
                  "Bwiyando",
                  "Gashinge",
                  "Kadehero",
                  "Masoro",
                  "Mukira",
                  "Nyamure",
                  "Rugarama",
                  "Rugendabari",
                  "Ruhore",
                ],
              },
              {
                Rukura: [
                  "Gahihi",
                  "Gikoro",
                  "Kara",
                  "Kirambo",
                  "Murandi",
                  "Nyamataha",
                ],
              },
              {
                Rutabo: [
                  "Buhira",
                  "Buturuba",
                  "Gasanzwe",
                  "Kabwika",
                  "Kamurambo",
                  "Kanwa",
                  "Rubuga",
                ],
              },
              {
                Rutenderi: [
                  "Gaseke",
                  "Gatwa",
                  "Gitaba",
                  "Kabere",
                  "Kabugomba",
                  "Kibara",
                  "Murambo",
                ],
              },
              {
                Taba: [
                  "Busaro",
                  "Bushita",
                  "Gasharu",
                  "Gihanga",
                  "Kangomba",
                  "Kanteko",
                  "Murambi",
                  "Mwisha",
                  "Rutenderi",
                ],
              },
            ],
          },
          {
            Janja: [
              {
                Gakindo: [
                  "Bukerera",
                  "Bunyironko",
                  "Kabusoro",
                  "Kibonwa",
                  "Rubona",
                  "Rurumbya",
                ],
              },
              {
                Gashyamba: [
                  "Burega",
                  "Gatongo",
                  "Gitovu",
                  "Nyabikenke",
                  "Rwampali",
                ],
              },
              {
                Gatwa: [
                  "Buhanga",
                  "Gitega",
                  "Kinoko",
                  "Murambi",
                  "Mwanza",
                  "Nyabushishiri",
                  "Nyagisozi",
                ],
              },
              {
                Karukungu: [
                  "Buhimbi",
                  "Cyifuzo",
                  "Gitaba",
                  "Karama",
                  "Mugandu",
                  "Rugeshi",
                  "Rusasa",
                  "Rutake",
                ],
              },
            ],
          },
          {
            Kamubuga: [
              {
                Kamubuga: [
                  "Gasebeya",
                  "Gashishi",
                  "Gitwe",
                  "Kabuye",
                  "Kanshenge",
                  "Kanyirantege",
                  "Marira",
                  "Nyarungu",
                  "Raro",
                  "Rugari",
                  "Ruhehe",
                  "Runeka",
                ],
              },
              {
                Kidomo: [
                  "Bucyaba",
                  "Bugogo",
                  "Kidomo",
                  "Kintobo",
                  "Njugi",
                  "Nyamusongati",
                  "Rugeshi",
                  "Rutagara",
                ],
              },
              {
                Mbatabata: [
                  "Buhinda",
                  "Gatare",
                  "Horero",
                  "Kabyaza",
                  "Karingorera",
                  "Mbatabata",
                  "Mwasha",
                  "Ryabirere",
                ],
              },
              {
                Rukore: [
                  "Kabutwa",
                  "Karangara",
                  "Kinyababa",
                  "Rungu",
                  "Rusasa",
                  "Rusumo",
                  "Rwata",
                  "Taba",
                ],
              },
            ],
          },
          {
            Karambo: [
              {
                Kanyanza: [
                  "Gatembe",
                  "Kabuhunu",
                  "Kabutare",
                  "Karambi",
                  "Karenge",
                  "Marembo",
                  "Nyiramisabike",
                ],
              },
              {
                Karambo: [
                  "Bataga",
                  "Bumbeja",
                  "Bushumba",
                  "Cyumba",
                  "Gasovu",
                  "Gatare",
                  "Gatorero",
                  "Gishingo",
                  "Kigarama",
                  "Mugamba",
                  "Nyiramuhimba",
                  "Rwamiko",
                  "Ryarurimbura",
                ],
              },
              {
                Kirebe: [
                  "Bukondo",
                  "Bukunga",
                  "Bukweto",
                  "Kabuye",
                  "Kavumu",
                  "Mubuga",
                  "Mwiyanike",
                  "Nyabigugu",
                ],
              },
            ],
          },
          {
            Kivuruga: [
              {
                Cyintare: ["Bigogwe", "Buhuga", "Cyintare", "Nyarubuye"],
              },
              {
                Gasiza: [
                  "Bushoka",
                  "Kabuhoma",
                  "Kamwumba",
                  "Nturo",
                  "Nyarungu",
                ],
              },
              {
                Rugimbu: [
                  "Gasave",
                  "Karuhunge",
                  "Mugali",
                  "Rurambo",
                  "Rutamba",
                  "Rwamabare",
                ],
              },
              {
                Ruhinga: [
                  "Buranga",
                  "Kamomo",
                  "Kavumu",
                  "Kintarure",
                  "Munyege",
                  "Rugeshi",
                  "Rwakirari",
                ],
              },
              {
                Sereri: [
                  "Buhayo",
                  "Kabara",
                  "Kivuruga",
                  "Masoro",
                  "Musekera",
                  "Ngarama",
                ],
              },
            ],
          },
          {
            Mataba: [
              {
                Buyange: [
                  "Gabiro",
                  "Gashingiro",
                  "Kabeza",
                  "Kanamo",
                  "Karambi",
                  "Mubuga",
                  "Nyamiyaga",
                  "Rugendabari",
                  "Ryarugema",
                ],
              },
              {
                Gikombe: [
                  "Bugari",
                  "Bweramana",
                  "Gashyushya",
                  "Gatovu",
                  "Muhororo",
                  "Munini",
                  "Muyaga",
                  "Nyangoma",
                  "Ruganda",
                  "Ruhanga",
                ],
              },
              {
                Nyundo: [
                  "Gihita",
                  "Gitaba",
                  "Kabuyora",
                  "Kagando",
                  "Karambi",
                  "Mataba",
                  "Mwanza",
                  "Nkurazo",
                ],
              },
            ],
          },
          {
            Minazi: [
              {
                Gasiho: [
                  "Gahombo",
                  "Gahunda",
                  "Gasangwa",
                  "Gihinga",
                  "Kabarima",
                  "Kigeyo",
                  "Mbogo",
                ],
              },
              {
                Munyana: ["Gihororo", "Gitwa", "Kanka", "Kivuba", "Nyabitare"],
              },
              {
                Murambi: ["Gisovu", "Kabuga", "Musave", "Nyanza", "Nyarubuye"],
              },
              {
                Raba: [
                  "Bukonde",
                  "Gaharo",
                  "Gitaragwe",
                  "Munihi",
                  "Mutara",
                  "Ndegamire",
                  "Sarabuye",
                ],
              },
            ],
          },
          {
            Mugunga: [
              {
                Gahinga: [
                  "Cyinama",
                  "Giheta",
                  "Nyagahondo",
                  "Nyakagezi",
                  "Rwimpiri",
                ],
              },
              {
                Munyana: [
                  "Cyarubayi",
                  "Karambi",
                  "Muhororo",
                  "Nturo",
                  "Rwezamenyo",
                ],
              },
              {
                Mutego: [
                  "Kamasanze",
                  "Kamunyana",
                  "Karambo",
                  "Nganzo",
                  "Rutaraga",
                ],
              },
              {
                Nkomane: ["Kabuga", "Kanaba", "Nemba", "Nyagasozi", "Rusebeya"],
              },
              {
                Rutabo: [
                  "Gacemeri",
                  "Gasovu",
                  "Gatonde",
                  "Kabuhoro",
                  "Muhororo",
                ],
              },
              {
                Rutenderi: ["Kiraro", "Nyakazenga", "Nyundo", "Rubona"],
              },
              {
                Rwamambe: [
                  "Biraro",
                  "Bushoka",
                  "Gashubi",
                  "Kabiganda",
                  "Kanyinya",
                ],
              },
            ],
          },
          {
            Muhondo: [
              {
                Busake: ["Busake", "Gikikira", "Kibirizi", "Nyakabanda"],
              },
              {
                Bwenda: ["Gahama", "Gatare", "Gitaba", "Kimanama", "Nketsi"],
              },
              {
                Gasiza: ["Gahabwa", "Gahinga", "Gahondo", "Gasiza", "Kabeza"],
              },
              {
                Gihinga: ["Base", "Gihinga", "Karehe", "Samuduha", "Taba"],
              },
              {
                Huro: ["Cura", "Gitwa", "Huro", "Kabuga", "Rubona"],
              },
              {
                Musagara: ["Akara", "Cyenda", "Giteme", "Karobagire"],
              },
              {
                Musenyi: ["Buhinya", "Gakuyu", "Kigali", "Musenyi"],
              },
              {
                Ruganda: ["Gisozi", "Kinyonzo", "Mubuga", "Ranzi", "Ruganda"],
              },
              {
                Rwinkuba: ["Cyimbogo", "Kanyana", "Ruhorobero"],
              },
            ],
          },
          {
            Muyongwe: [
              {
                Bumba: [
                  "Bumba",
                  "Buzu",
                  "Gikoro",
                  "Gitovu",
                  "Gitwe",
                  "Mataba",
                  "Shiru",
                ],
              },
              {
                Gisiza: [
                  "Gitanda",
                  "Kabingo",
                  "Kiyebe",
                  "Muramba",
                  "Ruhoko",
                  "Sanzare",
                ],
              },
              {
                Karyango: ["Gikombe", "Kibingo", "Mahaha", "Mugera"],
              },
              {
                Nganzo: [
                  "Muhororo",
                  "Nganzo",
                  "Ngoma",
                  "Nyarubuye",
                  "Vugangoma",
                ],
              },
              {
                Va: ["Bukwera", "Businde", "Gikombe", "Mutoyi", "Ranzi"],
              },
            ],
          },
          {
            Muzo: [
              {
                Kabatezi: [
                  "Curugusi",
                  "Gasave",
                  "Gitabi",
                  "Kabatezi",
                  "Kasheshe",
                  "Runyinya",
                  "Rusororo",
                ],
              },
              {
                Kiryamo: [
                  "Akamagaju",
                  "Gahondo",
                  "Munyinya",
                  "Murambi",
                  "Rugarama",
                  "Rugege",
                  "Sezuku",
                ],
              },
              {
                Mubuga: [
                  "Butambwe",
                  "Kanini",
                  "Kavuza",
                  "Mubuga",
                  "Mwirika",
                  "Mwurire",
                ],
              },
              {
                Mwiyando: [
                  "Gitabi",
                  "Gitoke",
                  "Kagano",
                  "Muguguri",
                  "Nyagasozi",
                  "Rubayo",
                  "Ruhondo",
                ],
              },
              {
                Rwa: [
                  "Bitaba",
                  "Cyinturo",
                  "Gacaca",
                  "Gihororo",
                  "Kabere",
                  "Mafubo",
                  "Nyagahondo",
                  "Nyarubande",
                ],
              },
            ],
          },
          {
            Nemba: [
              {
                Buranga: [
                  "Buranga",
                  "Burego",
                  "Butare",
                  "Kanyansyo",
                  "Muganwa",
                  "Mukaka",
                  "Rukoji",
                ],
              },
              {
                Gahinga: ["Bitare", "Bukurura", "Kabaya", "Kilimbi"],
              },
              {
                Gisozi: [
                  "Gisagara",
                  "Kabushara",
                  "Kamatete",
                  "Kanama",
                  "Kanunga",
                  "Kanzoka",
                  "Karukara",
                  "Kirehe",
                  "Mushubi",
                  "Nyamyumba",
                ],
              },
              {
                Mucaca: [
                  "Cyahafi",
                  "Gatare",
                  "Kabingo",
                  "Kabuye",
                  "Kamuvunyi",
                  "Kiruhura",
                  "Kiryamo",
                  "Munyege",
                  "Musange",
                  "Ntakabavu",
                  "Nyamiyaga",
                ],
              },
            ],
          },
          {
            Ruli: [
              {
                Busoro: [
                  "Congoli",
                  "Cyoganyoni",
                  "Gitaba",
                  "Kabare",
                  "Kibirizi",
                  "Nkoto",
                  "Rugaragara",
                ],
              },
              {
                Gikingo: [
                  "Bushoka",
                  "Gatwa",
                  "Kabingo",
                  "Karango",
                  "Nyamugari",
                  "Rumasa",
                ],
              },
              {
                Jango: [
                  "Gatagara",
                  "Gihura",
                  "Gitonde",
                  "Kinyonzo",
                  "Mubuga",
                  "Murehe",
                ],
              },
              {
                Ruli: [
                  "Bariza",
                  "Gahondo",
                  "Gataba",
                  "Mugambazi",
                  "Ngayake",
                  "Nyakarambi",
                ],
              },
              {
                Rwesero: [
                  "Gatare",
                  "Gisizi",
                  "Mabago",
                  "Mugwato",
                  "Nyarunyinya",
                ],
              },
            ],
          },
          {
            Rusasa: [
              {
                Gataba: ["Bumonyo A", "Gahama", "Gataba", "Kebero", "Kibaya"],
              },
              {
                Kamonyi: [
                  "Burinda",
                  "Gakindo",
                  "Gapfura",
                  "Gitwe",
                  "Kidomo",
                  "Nyagahama",
                  "Rurambi",
                ],
              },
              {
                Murambi: ["Buharabuye", "Karuhunge", "Kirehe", "Nyange"],
              },
              {
                Nyundo: ["Bukingo", "Bumonyo B", "Gisovu", "Nyundo", "Tane"],
              },
              {
                Rumbi: ["Bukiza", "Buyora", "Bwanamo", "Ninda"],
              },
              {
                Rurembo: [
                  "Bushoka",
                  "Mazinga",
                  "Murori",
                  "Nyakabungo",
                  "Rugamba",
                ],
              },
            ],
          },
          {
            Rushashi: [
              {
                Burimba: ["Kabuye", "Kara", "Kivumu"],
              },
              {
                Busanane: ["Gisenyi", "Gisiza", "Kanzuki", "Nyakagezi"],
              },
              {
                Joma: ["Kineza", "Mataba", "Mwifuzo", "Nyagasozi", "Rugarama"],
              },
              {
                Kageyo: ["Kabeza", "Kabona", "Karambi", "Murambi", "Nganzo"],
              },
              {
                Mbogo: ["Bushoka", "Buzoza", "Gisanze", "Gitongo", "Nyabitare"],
              },
              {
                Razi: ["Gahinga", "Gikongoro", "Kirwa", "Nkoto", "Nyangoyi"],
              },
              {
                Rwankuba: [
                  "Giheta",
                  "Karushashi",
                  "Ngambi",
                  "Ruganda",
                  "Rwamabega",
                ],
              },
              {
                Shyombwe: ["Gatare", "Gatwa", "Gihororo", "Murara"],
              },
            ],
          },
        ],
      },
      {
        Gicumbi: [
          {
            Bukure: [
              {
                Karenge: [
                  "Gasharu",
                  "Kabuga",
                  "Kagarama",
                  "Karenge",
                  "Muguruka",
                  "Nyarutovu",
                  "Rebero",
                ],
              },
              {
                Kigabiro: [
                  "Gabiro",
                  "Kanyogote",
                  "Rugogwe",
                  "Rurama",
                  "Rwarenga",
                ],
              },
              {
                Kivumu: [
                  "Butare",
                  "Karambo",
                  "Karushya",
                  "Kivugiza",
                  "Kivumu",
                  "Ruyange",
                ],
              },
              {
                Rwesero: [
                  "Gicaca",
                  "Karagari",
                  "Mugorore",
                  "Ntarama",
                  "Nyarubira",
                ],
              },
            ],
          },
          {
            Bwisige: [
              {
                Bwisige: [
                  "Kabuye",
                  "Kavuruga",
                  "Kidandali",
                  "Ndoha",
                  "Nyakabungo",
                  "Nyarubuye",
                  "Nyarwina",
                  "Rutoma",
                  "Rwarurema",
                ],
              },
              {
                Gihuke: [
                  "Cyamukanya",
                  "Kumana",
                  "Kumunini",
                  "Kuwindenge",
                  "Muneke",
                  "Murehe",
                  "Nyagakizi",
                  "Nyakagera",
                  "Nyamugari",
                  "Rurenge",
                ],
              },
              {
                Mukono: [
                  "Akavuza",
                  "Murambi",
                  "Nyarumba",
                  "Nyirantungu",
                  "Rwebisheke",
                  "Rwondo",
                  "Ryakirayi",
                ],
              },
              {
                Nyabushingitwa: [
                  "Gahondo",
                  "Musayo",
                  "Ndayabana",
                  "Nyagatoma",
                  "Ruhuha",
                  "Warufu",
                ],
              },
            ],
          },
          {
            Byumba: [
              {
                Gacurabwenge: [
                  "Gacurabwenge",
                  "Gasharu",
                  "Gashirwe",
                  "Rubyiniro",
                  "Ruyaga",
                  "Rwasama",
                ],
              },
              {
                Gisuna: [
                  "Bereshi",
                  "Gatare",
                  "Gisuna",
                  "Kinihira I",
                  "Kinihira II",
                  "Rebero",
                  "Ruhashya",
                  "Rwiri",
                ],
              },
              {
                Kibali: ["Gakenke", "Mugorore", "Rugarama", "Ruzo"],
              },
              {
                Kivugiza: ["Kabingo", "Karambi", "Kivugiza", "Mugandu"],
              },
              {
                Murama: ["Gacaca", "Rukereza", "Rurambi", "Taba"],
              },
              {
                Ngondore: ["Bukamba", "Gitovu", "Karambo", "Kimirimo"],
              },
              {
                Nyakabungo: ["Gacyamo", "Kabuga", "Kanunga", "Rugaragara"],
              },
              {
                Nyamabuye: [
                  "Gasiza",
                  "Gatete",
                  "Kumana",
                  "Mugomero",
                  "Nyiragasuruba",
                  "Rwabukoko",
                  "Umurara",
                ],
              },
              {
                Nyarutarama: [
                  "Kagarama",
                  "Mukeri",
                  "Muriza",
                  "Nyamiyaga",
                  "Nyamugali",
                  "Nyande",
                  "Nyarubande",
                  "Rugandu",
                  "Rugarama",
                  "Rwamuhuba",
                ],
              },
            ],
          },
          {
            Cyumba: [
              {
                Gasunzu: ["Mubuga", "Mugera", "Ryamuromba", "Zihare"],
              },
              {
                Muhambo: ["Kiliba", "Nyamabare", "Rugerero"],
              },
              {
                Nyakabungo: [
                  "Burambira",
                  "Gashija",
                  "Gatoki",
                  "Kabare",
                  "Kigombe",
                  "Remera",
                  "Ryaruhumba",
                ],
              },
              {
                Nyambare: ["Burambira", "Gipandi", "Remera", "Rusebeya"],
              },
              {
                Nyaruka: ["Burindi", "Humura", "Maya", "Murore", "Rusambya"],
              },
              {
                Rwankonjo: ["Gatuna", "Kagera", "Keyebe", "Kivuruga", "Rukizi"],
              },
            ],
          },
          {
            Giti: [
              {
                Gatobotobo: [
                  "Kababito",
                  "Kabacuzi",
                  "Kagahumbi",
                  "Matyazo",
                  "Nyamirambo",
                  "Rugarama",
                ],
              },
              {
                Murehe: [
                  "Bisika",
                  "Bushiranyota",
                  "Butare",
                  "Cyamabano",
                  "Gatare",
                  "Kabeza",
                  "Kigabiro",
                ],
              },
              {
                Tanda: [
                  "Gasharu",
                  "Mashyoza",
                  "Nganwa",
                  "Nyakabungo",
                  "Ruzizi",
                  "Tanda",
                ],
              },
            ],
          },
          {
            Kageyo: [
              {
                Gihembe: [
                  "Gitaba",
                  "Karihira",
                  "Munini",
                  "Muyange",
                  "Nyaruvumu",
                  "Nyirabadugu",
                ],
              },
              {
                Horezo: ["Kigoma", "Musetsa", "Nyirangoga", "Rukongi"],
              },
              {
                Kabuga: ["Gatobotobo", "Gicumbi", "Maya", "Mukenke", "Murama"],
              },
              {
                Muhondo: ["Kagwa", "Kamanyundo", "Kamwumba", "Mwange"],
              },
              {
                Nyamiyaga: [
                  "Gatare",
                  "Gatiba",
                  "Kabare",
                  "Kageyo",
                  "Mugomero",
                  "Musura",
                  "Mutobo",
                  "Rukomo",
                ],
              },
            ],
          },
          {
            Kaniga: [
              {
                Bugomba: [
                  "Gatare",
                  "Kabungo",
                  "Kajevuba",
                  "Nyaruhanga",
                  "Rugarama",
                  "Rugari",
                  "Ryakabanda",
                ],
              },
              {
                Gatoma: [
                  "Gashiru",
                  "Kamabare",
                  "Nyakagera",
                  "Nyakara",
                  "Nyakibande",
                  "Rugarama",
                ],
              },
              {
                Mulindi: [
                  "Centre Mulindi",
                  "Gisunzu",
                  "Kagorogoro",
                  "Kigwene",
                  "Nyakabungo",
                  "Rugenda",
                  "Ruhita",
                  "Rukizi",
                  "Runyinya",
                  "Taba",
                ],
              },
              {
                Nyarwambu: [
                  "Cyasaku",
                  "Kabeza",
                  "Kanyaruyonga",
                  "Kinnyogo",
                  "Mushunga",
                  "Nyamabare",
                ],
              },
              {
                Rukurura: [
                  "Kabare",
                  "Kamushure",
                  "Karambo",
                  "Ngabira",
                  "Nyagatare",
                ],
              },
            ],
          },
          {
            Manyagiro: [
              {
                Kabuga: [
                  "Gabiro",
                  "Kigarama",
                  "Mugera",
                  "Murehe",
                  "Mutara",
                  "Rubindi",
                ],
              },
              {
                Nyiragifumba: [
                  "Gacyamo",
                  "Kiyovu",
                  "Murambo",
                  "Rurambi",
                  "Rwamazi",
                ],
              },
              {
                Nyiravugiza: ["Bugibwa", "Kajevuba", "Rurembo", "Rusebeya"],
              },
              {
                Remera: [
                  "Busa",
                  "Bushinga",
                  "Gasiza",
                  "Gitaba",
                  "Kabeza",
                  "Rugasa",
                  "Sangano",
                  "Shyigura",
                ],
              },
              {
                Rusekera: ["Gakubo", "Kavure", "Kiyovu", "Nyamyumba", "Rebero"],
              },
              {
                Ryaruyumba: [
                  "Gatsyata",
                  "Gatungo",
                  "Muturirwa",
                  "Nyantarure",
                  "Nyarukombe",
                  "Rugasa",
                  "Rusabira",
                  "Taba",
                ],
              },
            ],
          },
          {
            Miyove: [
              {
                Gakenke: [
                  "Gisiza",
                  "Karwanira",
                  "Kirwa",
                  "Kivomo",
                  "Museke",
                  "Nyarurambi",
                  "Rugandu",
                ],
              },
              {
                Miyove: [
                  "Kamonyi",
                  "Karambo",
                  "Mpinga",
                  "Mukaka",
                  "Murambo",
                  "Murehe",
                  "Nyamiyaga",
                  "Nyarubuye",
                  "Rebero",
                  "Remera",
                ],
              },
              {
                Mubuga: [
                  "Gatare",
                  "Gitsimbura",
                  "Kabuga",
                  "Kacyiru",
                  "Kagote",
                  "Kaje",
                  "Kirwa",
                  "Kivumu",
                  "Mubuga",
                  "Murambo",
                  "Rutovu",
                  "Tetero",
                ],
              },
            ],
          },
          {
            Mukarange: [
              {
                Cyamuganga: ["Burambira", "Ndarama", "Nyakabungo", "Rugarama"],
              },
              {
                Gatenga: [
                  "Ibereshi",
                  "Kagunga",
                  "Kiyorwa",
                  "Mugina",
                  "Nyacyoroma",
                  "Nyange",
                ],
              },
              {
                Kiruhura: ["Burembo", "Gacwamba", "Kariba", "Nyamutoko"],
              },
              {
                Mutarama: [
                  "Gikore",
                  "Kaziba",
                  "Mafumirwa",
                  "Murara",
                  "Rugeshi",
                ],
              },
              {
                Rugerero: [
                  "Gakizi",
                  "Kagarama",
                  "Kinnyogo",
                  "Munyege",
                  "Rurembo",
                  "Rushasha",
                  "Ruziku",
                ],
              },
              {
                Rusambya: ["Kabungo", "Kagane", "Nyagakizi", "Rusambya"],
              },
            ],
          },
          {
            Muko: [
              {
                Cyamuhinda: [
                  "Gicuregenya",
                  "Ntonyanga",
                  "Rugaragara",
                  "Rukazire",
                  "Rwamitembe",
                ],
              },
              {
                Kigoma: [
                  "Cyerere",
                  "Gatobotobo",
                  "Karambi",
                  "Karumuli",
                  "Ryarwoga",
                ],
              },
              {
                Mwendo: ["Gikumba", "Kabuye", "Kagogo", "Kirengo"],
              },
              {
                Ngange: ["Gasharu", "Kabare", "Kimpongo", "Mayora", "Rudogo"],
              },
              {
                Rebero: [
                  "Gasizi",
                  "Karundi",
                  "Kirara",
                  "Kirwanirwa",
                  "Mayogi",
                  "Nyampundu",
                  "Ryagashaka",
                ],
              },
            ],
          },
          {
            Mutete: [
              {
                Gaseke: [
                  "Gasharu",
                  "Gihira",
                  "Irasaniro",
                  "Ngando",
                  "Nyamabuye",
                  "Nyamiryango",
                  "Nyamugari",
                  "Runyinya",
                ],
              },
              {
                Kabeza: [
                  "Busabira",
                  "Kabasega",
                  "Kagarama",
                  "Merezo",
                  "Minanire",
                  "Nyagasozi",
                  "Rusebeya",
                ],
              },
              {
                Musenyi: [
                  "Gataba",
                  "Karambi",
                  "Kimisugi",
                  "Muhororo",
                  "Rukondo",
                  "Rurama",
                  "Rutongo",
                ],
              },
              {
                Mutandi: [
                  "Gatare",
                  "Gihangara",
                  "Kamaganga",
                  "Karama",
                  "Karambi",
                  "Kariku",
                  "Muhengeri",
                  "Nyarubande",
                ],
              },
              {
                Nyarubuye: [
                  "Gitega",
                  "Kajwejwe",
                  "Kavumu",
                  "Mataba",
                  "Nkenzi",
                  "Rugarama",
                  "Ruhondo",
                  "Rusumo",
                ],
              },
            ],
          },
          {
            Nyamiyaga: [
              {
                Gahumuliza: ["Majyambere", "Maya", "Ruhango"],
              },
              {
                Jamba: ["Byimana", "Kamabuye", "Kumuremure", "Rugarama"],
              },
              {
                Kabeza: ["Karambo", "Mataba", "Mugorore", "Rugari"],
              },
              {
                Kabuga: ["Kabeza", "Kaduha", "Mubuga", "Nyarubuye"],
              },
              {
                Karambo: ["Gaseke", "Gatare", "Kinyinya", "Murama"],
              },
              {
                Kiziba: ["Gasave", "Karambi", "Nyirakagamba", "Rwingwe"],
              },
              {
                Mataba: ["Mataba", "Miyange", "Rugarama", "Ruyaga"],
              },
            ],
          },
          {
            Nyankenke: [
              {
                Butare: [
                  "Gikombe",
                  "Kabere",
                  "Rwambeho",
                  "Rwirute",
                  "Ryabishanga",
                ],
              },
              {
                Kigogo: [
                  "Gakoma",
                  "Gasake",
                  "Gatare",
                  "Kiyovu",
                  "Ntabangira",
                  "Rusayu",
                ],
              },
              {
                Kinishya: [
                  "Gashiru",
                  "Kabuga",
                  "Nyagafunzo",
                  "Nyirantarengwa",
                  "Rwata",
                ],
              },
              {
                Rusasa: [
                  "Birumba",
                  "Mashyiga",
                  "Nyangezi",
                  "Rembero",
                  "Ruhoho",
                ],
              },
              {
                Rutete: [
                  "Kabingo",
                  "Kageje",
                  "Nyamugali",
                  "Ruhinga",
                  "Ryanterura",
                  "Shokero",
                ],
              },
              {
                Rwagihura: [
                  "Gacaca",
                  "Kabahura",
                  "Kagogo",
                  "Mwendo",
                  "Rwagihura",
                ],
              },
              {
                Yaramba: [
                  "Cyankaranka",
                  "Mwenyi",
                  "Nturo",
                  "Nyarubuye",
                  "Nyirakazo",
                ],
              },
            ],
          },
          {
            Rubaya: [
              {
                Gihanga: ["Gomba", "Kirimbi", "Nkurura", "Runaba", "Rusambya"],
              },
              {
                Gishambashayo: ["Gashiru", "Karambo"],
              },
              {
                Gishari: ["Kabaya", "Kagugo", "Mugote", "Nyakesha"],
              },
              {
                Muguramo: ["Centre Rubaya", "Gasheke", "Mabare", "Ngange"],
              },
              {
                Nyamiyaga: ["Kabeza", "Kiriba", "Mariba"],
              },
            ],
          },
          {
            Rukomo: [
              {
                Cyeya: [
                  "Birambo",
                  "Bisika",
                  "Bwuhira",
                  "Gateke",
                  "Kanombe",
                  "Rwambungo",
                ],
              },
              {
                Cyuru: [
                  "Bukamba",
                  "Kabuga",
                  "Karengo",
                  "Kimiko",
                  "Muhama",
                  "Nyamutezi",
                  "Sabiro",
                ],
              },
              {
                Gisiza: [
                  "Gatare",
                  "Gitaba",
                  "Karambi",
                  "Nyarubuye",
                  "Rushubi",
                  "Rusumo",
                ],
              },
              {
                Kinyami: [
                  "Gahondo",
                  "Gasharara",
                  "Kariba",
                  "Kivugiza",
                  "Meshero",
                  "Rukomo",
                  "Ryarubanza",
                ],
              },
              {
                Mabare: [
                  "Cyingoma",
                  "Kanyiramana",
                  "Kararama",
                  "Kayungwe",
                  "Mburamazi",
                  "Murambo",
                  "Ryandinda",
                ],
              },
              {
                Munyinya: [
                  "Kabeza",
                  "Kabuga",
                  "Mataba",
                  "Munyinya",
                  "Nyankokoma",
                  "Rwamushumba",
                ],
              },
            ],
          },
          {
            Rushaki: [
              {
                Gitega: [
                  "Bugwe",
                  "Gisiza",
                  "Gitega",
                  "Kabo",
                  "Karambi",
                  "Karambo",
                  "Rubyiro",
                  "Ryaruganzu",
                ],
              },
              {
                Kamutora: [
                  "Gashinge",
                  "Kabuga",
                  "Kamutora",
                  "Karwoga",
                  "Mabare",
                  "Nkamba",
                  "Nyamyumba",
                  "Remera",
                ],
              },
              {
                Karurama: [
                  "C. Rushaki",
                  "Gatonde",
                  "Izinga",
                  "Mbuga",
                  "Ngabira",
                  "Nyaruhanga",
                  "Rumuri",
                  "Rwaranda",
                ],
              },
            ],
          },
          {
            Rutare: [
              {
                Bikumba: [
                  "Karugeyo",
                  "Kintaganirwa",
                  "Marembo",
                  "Matyazo",
                  "Nyabisindu",
                ],
              },
              {
                Gasharu: [
                  "Buyegero",
                  "Kabagabo",
                  "Kabusunzu",
                  "Kagarama",
                  "Rwimbogo",
                  "Yogi",
                ],
              },
              {
                Gatwaro: ["Bureranyana", "Gashinya", "Kabira", "Kanaba"],
              },
              {
                Kigabiro: [
                  "Kabuye",
                  "Munini",
                  "Nyakabingo",
                  "Nyakavunga",
                  "Rugarama",
                ],
              },
              {
                Munanira: [
                  "Bushokanyambo",
                  "Gasharu",
                  "Kirwa",
                  "Mataba",
                  "Ruti",
                ],
              },
              {
                Nkoto: [
                  "Bariza",
                  "Bwangamwanda",
                  "Murehe",
                  "Nyagatoma",
                  "Nyansenge",
                ],
              },
            ],
          },
          {
            Ruvune: [
              {
                Cyandaro: [
                  "Karambo",
                  "Kigarama",
                  "Mushesho",
                  "Nyankokoma",
                  "Rugarama",
                ],
              },
              {
                Gasambya: [
                  "Karambi",
                  "Kirara",
                  "Mataba",
                  "Nyamirama",
                  "Ruhete",
                  "Ryasunzu",
                ],
              },
              {
                Gashirira: [
                  "Kagasha",
                  "Nyarubuye",
                  "Nyarurama",
                  "Nyarwina",
                  "Remera",
                  "Rugerero",
                ],
              },
              {
                Kabare: ["Buyanja", "Murehe", "Nyarusange", "Taba"],
              },
              {
                Rebero: [
                  "Bitoma",
                  "Burambo",
                  "Gatare",
                  "Kirwa",
                  "Mwanza",
                  "Rwaburegeya",
                  "Rwamiko",
                  "Sunzu",
                ],
              },
              {
                Ruhondo: [
                  "Gatoki",
                  "Karambo",
                  "Kirwa",
                  "Mugorore",
                  "Nyagakizi",
                  "Nyakaju",
                  "Rwinyana",
                ],
              },
            ],
          },
          {
            Rwamiko: [
              {
                Cyeru: [
                  "Bugarura",
                  "Gabiro",
                  "Kamurenzi",
                  "Karika",
                  "Mukuyu",
                  "Murambi",
                  "Nyagasozi",
                  "Rugarama",
                ],
              },
              {
                Kigabiro: [
                  "Cyiri",
                  "Kabira",
                  "Kanyove",
                  "Karangara",
                  "Mutambiko",
                  "Rubuye",
                ],
              },
              {
                Nyagahinga: [
                  "Kabusunzu",
                  "Kibiraro",
                  "Kigaga",
                  "Ntaremba",
                  "Rugarama",
                ],
              },
            ],
          },
          {
            Shangasha: [
              {
                Bushara: ["Bushara", "Gasura", "Gatare", "Nganzo"],
              },
              {
                Kitazigurwa: [
                  "Gacyamo",
                  "Iharama",
                  "Mubuga",
                  "Ntomvu",
                  "Rugarama",
                ],
              },
              {
                Nyabishambi: [
                  "Gasiza",
                  "Kagali",
                  "Karambo",
                  "Matyazo",
                  "Murambo",
                  "Rukiniro",
                  "Rutete",
                ],
              },
              {
                Nyabubare: [
                  "Bikumba",
                  "Irembo",
                  "Karuhanga",
                  "Nyakabingo",
                  "Nyamiyaga",
                ],
              },
              {
                Shangasha: [
                  "Ituze",
                  "Kabeza",
                  "Kajyanjyali",
                  "Rugali",
                  "Runaba",
                  "Ryamatebura",
                ],
              },
            ],
          },
        ],
      },
      {
        Musanze: [
          {
            Busogo: [
              {
                Gisesero: ["Gahanga", "Jabiro", "Kabaya", "Nengo"],
              },
              {
                Kavumu: [
                  "Gatovu",
                  "Karema",
                  "Karuriza",
                  "Mutaboneka",
                  "Rugeshi",
                ],
              },
              {
                Nyagisozi: ["Cyasure", "Gora", "Kabwenge", "Kirezi", "Rurembo"],
              },
              {
                Sahara: ["Nyarubuye", "Nyiragaju", "Rubaya", "Ryamukutsi"],
              },
            ],
          },
          {
            Cyuve: [
              {
                Bukinanyana: [
                  "Bubandu",
                  "Mubwiza",
                  "Murambi",
                  "Mwidagaduro",
                  "Mwirongi",
                  "Rugeshi",
                ],
              },
              {
                Buruba: [
                  "Bazizana",
                  "Kabahama",
                  "Kamenantare",
                  "Ruhindinka",
                  "Rutemba",
                  "Ruvumu",
                ],
              },
              {
                Cyanya: [
                  "Kabaya",
                  "Karugabanya",
                  "Kayange",
                  "Kibande",
                  "Mubari",
                  "Mubuga",
                  "Mugarama",
                  "Rebero",
                  "Ruhehe",
                ],
              },
              {
                Kabeza: [
                  "Bucuzi",
                  "Gashangiro",
                  "Kareba",
                  "Karinzi",
                  "Karunyura",
                  "Kungo",
                ],
              },
              {
                Migeshi: [
                  "Buremu",
                  "Gakenke",
                  "Kabaya",
                  "Kamanga",
                  "Kiviriza",
                  "Mugari",
                  "Nyaruyaga",
                  "Rabika",
                ],
              },
              {
                Rwebeya: [
                  "Marantima",
                  "Mubuga",
                  "Nganzo",
                  "Nyarubande",
                  "Nyiraruhengeri",
                ],
              },
            ],
          },
          {
            Gacaca: [
              {
                Gakoro: [
                  "Butunda",
                  "Cyiri",
                  "Gahama",
                  "Murora",
                  "Murundo",
                  "Nkomero",
                ],
              },
              {
                Gasakuza: [
                  "Gasenyi",
                  "Gataba",
                  "Karushenyi",
                  "Nyamugari",
                  "Ruhasa",
                  "Rurambo",
                ],
              },
              {
                Kabirizi: [
                  "Gitovu",
                  "Kabushanda",
                  "Kanama",
                  "Karama",
                  "Mata",
                  "Mukungwa",
                  "Rungu",
                ],
              },
              {
                Karwasa: [
                  "Burengo",
                  "Kabukende",
                  "Karambi",
                  "Kavumu",
                  "Sarazi",
                ],
              },
            ],
          },
          {
            Gashaki: [
              {
                Kigabiro: [
                  "Birwa",
                  "Butate",
                  "Buzoza",
                  "Kavumu",
                  "Musekera",
                  "Shanga",
                ],
              },
              {
                Kivumu: [
                  "Burango",
                  "Kamatete",
                  "Makara",
                  "Nyakariba",
                  "Ruhehe",
                ],
              },
              {
                Mbwe: ["Budiho", "Gatete", "Kamato", "Kanzo", "Ngambi", "Raro"],
              },
              {
                Muharuro: [
                  "Bugabo",
                  "Karuganda",
                  "Kibinyogote",
                  "Mucaca",
                  "Murandi",
                ],
              },
            ],
          },
          {
            Gataraga: [
              {
                Mudakama: ["Gakuku", "Kagongo", "Kararo", "Mikingo", "Rubaka"],
              },
              {
                Murago: [
                  "Karurambi",
                  "Manjari",
                  "Rukingo",
                  "Rusambu",
                  "Rwinzovu",
                ],
              },
              {
                Rubindi: [
                  "Butakanyundo",
                  "Gacondo",
                  "Gataraga",
                  "Kabaya",
                  "Kaberege",
                ],
              },
              {
                Rungu: [
                  "Gahira",
                  "Gatondori",
                  "Gatovu",
                  "Kampande",
                  "Nyarubande",
                ],
              },
            ],
          },
          {
            Kimonyi: [
              {
                Birira: [
                  "Gakoro",
                  "Kabagoyi",
                  "Kadahenda",
                  "Mbugayera",
                  "Rurembo",
                ],
              },
              {
                Buramira: [
                  "Kabaya",
                  "Kagwene",
                  "Kamugeni",
                  "Nyiramuyenzi",
                  "Ruhinga",
                ],
              },
              {
                Kivumu: [
                  "Masoro",
                  "Muregeya",
                  "Musezero",
                  "Ndorahe",
                  "Nyamugari",
                ],
              },
              {
                Mbizi: ["Buhuma", "Bushubi", "Gatumo", "Rugondo"],
              },
            ],
          },
          {
            Kinigi: [
              {
                Bisoke: [
                  "Bunyenyeri",
                  "Kamata",
                  "Karambi",
                  "Kazi",
                  "Kumazi",
                  "Shonero",
                  "Susa",
                ],
              },
              {
                Kaguhu: [
                  "Kabeza",
                  "Kaniga",
                  "Impano",
                  "Musingi",
                  "Myase",
                  "Nyarusizi",
                  "Nyundo",
                  "Rugeshi",
                  "Ruginga",
                  "Rurembo",
                ],
              },
              {
                Kampanga: [
                  "Kamakara",
                  "Muhe",
                  "Nyarubande",
                  "Nyejoro",
                  "Rubara",
                  "Rugi",
                  "Rutindo",
                ],
              },
              {
                Nyabigoma: [
                  "Cyabirego",
                  "Gahura",
                  "Gasizi",
                  "Kabatwa",
                  "Karyasenge",
                  "Mitobo",
                  "Nyakagezi",
                  "Nyakigina",
                  "Rebero",
                ],
              },
              {
                Nyonirima: [
                  "Bazizana",
                  "Butorwa I",
                  "Butorwa II",
                  "Gahisi",
                  "Gasura",
                  "Kansoro",
                  "Kanyampereri",
                  "Nyagisenyi",
                ],
              },
            ],
          },
          {
            Muhoza: [
              {
                Cyabararika: [
                  "Buhuye",
                  "Bwuzuri",
                  "Gasanze",
                  "Gatare",
                  "Gatorwa",
                  "Kabogobogo",
                  "Yorodani",
                ],
              },
              {
                Kigombe: [
                  "Kavumu",
                  "Kiryi",
                  "Mugara",
                  "Nduruma",
                  "Nyamagumba",
                  "Nyamuremure",
                  "Rukereza",
                ],
              },
              {
                Mpenge: [
                  "Gikwege",
                  "Giramahoro",
                  "Mpenge",
                  "Rukoro",
                  "Rusagara",
                ],
              },
              {
                Ruhengeri: [
                  "Buhoro",
                  "Burera",
                  "Bushozi",
                  "Byimana",
                  "Kabaya",
                  "Muhe",
                  "Susa",
                ],
              },
            ],
          },
          {
            Muko: [
              {
                Cyivugiza: [
                  "Gakoro",
                  "Kabudundu",
                  "Kamutara",
                  "Karebero",
                  "Karwabigwi",
                  "Nyagahondo",
                  "Nyakanama",
                  "Nyiramuko",
                  "Sangano",
                  "Susa",
                ],
              },
              {
                Cyogo: [
                  "Kabere",
                  "Kadahenda",
                  "Karabiro",
                  "Karuyege",
                  "Nyagasambu",
                  "Rubanga",
                ],
              },
              {
                Mburabuturo: [
                  "Bugese",
                  "Kabindi",
                  "Kigasa",
                  "Musenyi",
                  "Mwanganzara",
                  "Ngabane",
                  "Ntindo",
                ],
              },
              {
                Songa: [
                  "Buhano",
                  "Butare",
                  "Kamaheke",
                  "Karambo",
                  "Kavumu",
                  "Kibuye",
                  "Mubago",
                ],
              },
            ],
          },
          {
            Musanze: [
              {
                Cyabagarura: [
                  "Bitare",
                  "Bukane",
                  "Gaturo",
                  "Gikeri",
                  "Kabaya",
                  "Kageyo",
                  "Kanyabirayi",
                  "Kiroba",
                  "Rugeyo",
                  "Ruvumu",
                ],
              },
              {
                Garuka: [
                  "Cyanturo",
                  "Gacinyiro",
                  "Gapfuro",
                  "Kanganwa",
                  "Kanyaminaba",
                ],
              },
              {
                Kabazungu: [
                  "Bihinga",
                  "Kidendezi",
                  "Mufukuro",
                  "Nyabageni",
                  "Rucumu",
                  "Rwunga",
                ],
              },
              {
                Nyarubuye: [
                  "Bannyisuka",
                  "Kareba",
                  "Kavumbu",
                  "Murenzi",
                  "Nturo",
                  "Tero",
                ],
              },
              {
                Rwambogo: [
                  "Buhunge",
                  "Gakoro",
                  "Kirerema",
                  "Nyarubande",
                  "Runyangwe",
                  "Rwunga",
                ],
              },
            ],
          },
          {
            Nkotsi: [
              {
                Bikara: [
                  "Barizo",
                  "Kabaya",
                  "Karambi",
                  "Kindiki",
                  "Kinkware",
                  "Kiruhura",
                  "Nyakinama",
                  "Rubindi",
                ],
              },
              {
                Gashinga: ["Buhanga", "Gitaraga", "Kabasaza", "Musebeya"],
              },
              {
                Mubago: [
                  "Bugugu",
                  "Buhamo",
                  "Musembe",
                  "Nyagahondo",
                  "Nyarubingo",
                ],
              },
              {
                Rugeshi: [
                  "Bigabiro",
                  "Gahanga",
                  "Gasebeya",
                  "Karambo",
                  "Mucyamo",
                  "Mutuzo",
                ],
              },
              {
                Ruyumba: [
                  "Cyivugiza",
                  "Gasiza",
                  "Kamusheshe",
                  "Murindi",
                  "Nyakigezi",
                ],
              },
            ],
          },
          {
            Nyange: [
              {
                Cyivugiza: [
                  "Gasoroza",
                  "Kagano",
                  "Kageshi",
                  "Mugwati",
                  "Muhe",
                  "Nyabitare",
                  "Rugarama",
                  "Rusenge",
                  "Terimbere",
                ],
              },
              {
                Kabeza: [
                  "Gahama",
                  "Kansoro",
                  "Kibingo",
                  "Ntamiziro",
                  "Nyarubuye",
                  "Riboneye",
                  "Rwebeya",
                ],
              },
              {
                Kamwumba: [
                  "Kabaya",
                  "Kamajaga",
                  "Kamicaca",
                  "Musenyi",
                  "Ntarama",
                  "Rugari",
                ],
              },
              {
                Muhabura: [
                  "Bazizana",
                  "Bihinga",
                  "Bukingo",
                  "Buramba",
                  "Jite",
                  "Micaca",
                  "Nkogote",
                  "Ntarama",
                  "Ntebe",
                  "Rugwiro",
                ],
              },
              {
                Ninda: [
                  "Garuka",
                  "Gisigwa",
                  "Kabagorozi",
                  "Kabara",
                  "Kabari",
                  "Kareba",
                  "Nkiriza",
                  "Nyabutaka",
                  "Nyakagezi",
                  "Nyamiyaga",
                  "Nyarubande",
                ],
              },
            ],
          },
          {
            Remera: [
              {
                Gasongero: [
                  "Bukara",
                  "Gitega",
                  "Mugogo",
                  "Nyakibande",
                  "Rususa",
                ],
              },
              {
                Kamisave: [
                  "Kabara",
                  "Kamurera",
                  "Mikamo",
                  "Mukinga",
                  "Rugari",
                  "Ryampunga",
                ],
              },
              {
                Murandi: [
                  "Buhogo",
                  "Kabagora",
                  "Karuruma",
                  "Muganda",
                  "Nyirabisekuro",
                  "Nyundo",
                ],
              },
              {
                Murwa: [
                  "Giseke",
                  "Gitwa",
                  "Kabashima",
                  "Kamanga",
                  "Mwiyandiro",
                  "Ngenzi",
                ],
              },
              {
                Rurambo: [
                  "Bitsibo",
                  "Gatare",
                  "Kabusozo",
                  "Kintashya",
                  "Mugeshi",
                  "Nyanza",
                ],
              },
            ],
          },
          {
            Rwaza: [
              {
                Bumara: [
                  "Gisorora",
                  "Kabuye",
                  "Kavumu",
                  "Muheta",
                  "Nyakarambi II",
                ],
              },
              {
                Kabushinge: [
                  "Busana",
                  "Gihango",
                  "Kabuga",
                  "Murambi",
                  "Nyagisozi",
                  "Nyarugando",
                  "Ramba",
                  "Rwamigimbu",
                ],
              },
              {
                Musezero: [
                  "Kamabuye",
                  "Kansenda",
                  "Kibingo",
                  "Kiganda",
                  "Mataba",
                  "Mutara",
                  "Nyakarambi I",
                ],
              },
              {
                Nturo: [
                  "Gakenke",
                  "Mugogo",
                  "Rubabi",
                  "Rugari",
                  "Rugogwe",
                  "Ruvumu",
                ],
              },
              {
                Nyarubuye: [
                  "Buhama",
                  "Bukoro",
                  "Kanama",
                  "Murambi",
                  "Ngege",
                  "Rusaki",
                  "Sayo",
                ],
              },
            ],
          },
          {
            Shingiro: [
              {
                Gakingo: [
                  "Burengo",
                  "Bwamazi",
                  "Gasura",
                  "Kabeza",
                  "Kadahenda",
                  "Karwesero",
                  "Mutuzo",
                  "Ryambungira",
                ],
              },
              {
                Kibuguzo: [
                  "Bikereri",
                  "Byimana",
                  "Cyimbazi",
                  "Mutuzo",
                  "Nyundo",
                  "Rwinuma",
                ],
              },
              {
                Mudende: [
                  "Budasubira",
                  "Nyamiyaga",
                  "Nyarutembe",
                  "Rubagara",
                  "Rutagara",
                  "Vubiro",
                ],
              },
              {
                Mugari: [
                  "Kabagabo",
                  "Kabeza",
                  "Kimanzi",
                  "Nyakagezi",
                  "Rebero",
                  "Terimbere",
                ],
              },
            ],
          },
        ],
      },
      {
        Rulindo: [
          {
            Base: [
              {
                Cyohoha: [
                  "Bukangano",
                  "Buramba",
                  "Gihemba",
                  "Gitwa",
                  "Kabingo",
                  "Kabuga",
                  "Musenyi",
                  "Mushongi",
                  "Nyangoyi",
                  "Rubanda",
                ],
              },
              {
                Gitare: [
                  "Bushyiga",
                  "Gatete",
                  "Gihora",
                  "Gisiza",
                  "Kirwa",
                  "Mugenda I",
                  "Mugenda II",
                  "Nyamugali",
                  "Rugaragara",
                  "Rugerero",
                ],
              },
              {
                Rwamahwa: [
                  "Base",
                  "Cyondo",
                  "Gitovu",
                  "Kabahama",
                  "Kabeza",
                  "Karambi",
                  "Kiruli",
                  "Mutima",
                ],
              },
            ],
          },
          {
            Burega: [
              {
                Butangampundu: [
                  "Gacyamo",
                  "Gashinge",
                  "Karambi",
                  "Karugaju",
                  "Kerera",
                  "Kibiraro",
                  "Kigabiro",
                  "Kigarama",
                  "Kisigiro",
                  "Mayaga",
                  "Muduha",
                  "Muhondo",
                  "Nyamiyaga",
                  "Runyinya",
                ],
              },
              {
                Karengeri: [
                  "Bugoboka",
                  "Byerwa",
                  "Gasare",
                  "Gasharu",
                  "Gashinge",
                  "Gatete",
                  "Kantabo",
                  "Kanunga",
                  "Kizenga",
                  "Kiziba",
                  "Mataba",
                  "Mitabi",
                  "Mukarange",
                  "Rwamiko",
                ],
              },
              {
                Taba: [
                  "Bugarama",
                  "Cyinzuzi",
                  "Gasango",
                  "Kiboha",
                  "Kivomo",
                  "Mwenene",
                  "Mwite",
                  "Ngange",
                  "Nyagisozi",
                  "Rubara",
                  "Rusine",
                  "Ryinzovu",
                ],
              },
            ],
          },
          {
            Bushoki: [
              {
                Gasiza: [
                  "Budaha",
                  "Buhande",
                  "Gitwa",
                  "Karambi",
                  "Remera",
                  "Ruhanga",
                  "Rulindo",
                ],
              },
              {
                Giko: [
                  "Buramira",
                  "Cyiri",
                  "Gashiru",
                  "Karambo",
                  "Kigamba",
                  "Kivomo",
                  "Ngarama",
                  "Rugote",
                ],
              },
              {
                Kayenzi: ["Gitaba", "Muduha", "Murambo", "Rebero", "Rwanzu"],
              },
              {
                Mukoto: [
                  "Buvumo",
                  "Buyogoma",
                  "Gatare",
                  "Marembo",
                  "Muko",
                  "Mukoto",
                  "Rusave",
                ],
              },
              {
                Nyirangarama: [
                  "Bubiro",
                  "Byimana",
                  "Gatenga",
                  "Gifuba",
                  "Karambi",
                  "Nyenyeri",
                  "Nyirangarama",
                  "Remera",
                  "Tare",
                  "Terambere",
                ],
              },
            ],
          },
          {
            Buyoga: [
              {
                Busoro: ["Gashana", "Gatwa", "Karambo", "Kibanda", "Rugarama"],
              },
              {
                Butare: [
                  "Gasave",
                  "Giko",
                  "Kankanga",
                  "Karambi",
                  "Ryanyirakayobe",
                ],
              },
              {
                Gahororo: [
                  "Bunyana",
                  "Gatare",
                  "Gatenderi",
                  "Gipfundo",
                  "Gitabura",
                  "Shagasha",
                ],
              },
              {
                Gitumba: ["Gitaba", "Munini", "Nyarubuye", "Remera", "Rutabo"],
              },
              {
                Karama: [
                  "Cyasenge",
                  "Kajeneni",
                  "Karambi",
                  "Karambo",
                  "Kavumo",
                  "Kigarama",
                ],
              },
              {
                Mwumba: [
                  "Gakoma",
                  "Mataba",
                  "Murambo",
                  "Nyamwiza",
                  "Nyarubuye",
                ],
              },
              {
                Ndarage: [
                  "Gahondo",
                  "Gikingo",
                  "Kagozi",
                  "Karambi",
                  "Kimagali",
                ],
              },
            ],
          },
          {
            Cyinzuzi: [
              {
                Budakiranya: [
                  "Gatagara",
                  "Gihinga",
                  "Kamatongo",
                  "Kanyoni",
                  "Kavumu",
                  "Kigarama",
                  "Nyakabanga",
                  "Rugaragara",
                ],
              },
              {
                Migendezo: [
                  "Cyanya",
                  "Gitabage",
                  "Karambo",
                  "Marembo",
                  "Ngabitsinze",
                  "Nyamugali",
                  "Remera",
                  "Rusagara",
                ],
              },
              {
                Rudogo: [
                  "Gasekabuye",
                  "Gaseke",
                  "Gasizi",
                  "Gihuke",
                  "Kirambo",
                  "Munini",
                  "Munoga",
                  "Musenyi",
                ],
              },
            ],
          },
          {
            Cyungo: [
              {
                Burehe: [
                  "Gitandi",
                  "Karambo",
                  "Karengeri",
                  "Kibande",
                  "Kibogora",
                  "Nyagatovu",
                  "Sove",
                ],
              },
              {
                Marembo: [
                  "Buyaga",
                  "Gahinga",
                  "Kibuye",
                  "Kidomo",
                  "Murambo",
                  "Nganzo",
                  "Rugaragara",
                  "Rusayu",
                ],
              },
              {
                Rwili: [
                  "Kabanda",
                  "Karambi",
                  "Kirwa",
                  "Kivumu",
                  "Nturo",
                  "Nyabisasa",
                  "Sakara",
                ],
              },
            ],
          },
          {
            Kinihira: [
              {
                Butunzi: [
                  "Akamiyove",
                  "Barayi",
                  "Bunahi",
                  "Gisekuru",
                  "Kinihira",
                  "Ndorandi",
                ],
              },
              {
                Karegamazi: [
                  "Buhita",
                  "Bwishya",
                  "Gatembe",
                  "Magezi",
                  "Mutoyi",
                  "Ntunguru",
                ],
              },
              {
                Marembo: ["Buhunde", "Cyogo", "Gatare", "Kigali", "Kiyebe"],
              },
              {
                Rebero: [
                  "Kabuga",
                  "Karambi",
                  "Kirwa",
                  "Ndusu",
                  "Rugundu",
                  "Taba",
                ],
              },
            ],
          },
          {
            Kisaro: [
              {
                Gitatsa: ["Kabere", "Ndago", "Ruberano", "Rwili"],
              },
              {
                Kamushenyi: [
                  "Gakenke",
                  "Gatete",
                  "Gatovu",
                  "Kabeza",
                  "Karambi",
                  "Songa",
                  "Wamahoro",
                ],
              },
              {
                Kigarama: [
                  "Gaseke",
                  "Gasharu",
                  "Nyantabo",
                  "Runyinya",
                  "Rwintare",
                ],
              },
              {
                Mubuga: [
                  "Gako",
                  "Kibuye",
                  "Kirenge",
                  "Murambi",
                  "Nyakarekare",
                  "Rutabo",
                ],
              },
              {
                Murama: [
                  "Akamanama",
                  "Gishinge",
                  "Karambi",
                  "Kibingwe",
                  "Mugomero",
                  "Ryarubuguza",
                ],
              },
              {
                Sayo: [
                  "Cyasuri",
                  "Kibanda",
                  "Nyamiyaga",
                  "Rugarama",
                  "Rusongati",
                  "Rusumo",
                ],
              },
            ],
          },
          {
            Masoro: [
              {
                Kabuga: [
                  "Gisiza",
                  "Kanunga",
                  "Karambi",
                  "Kigarama",
                  "Nyakibande",
                  "Nyakizu",
                  "Rubaya",
                ],
              },
              {
                Kigarama: ["Gacyamo", "Marenge", "Nyakabungo", "Rukurazo"],
              },
              {
                Kivugiza: ["Gasenga", "Musega", "Nyarurembo", "Rebero"],
              },
              {
                Nyamyumba: [
                  "Kabeza",
                  "Kabuga",
                  "Kigomwa",
                  "Marembo",
                  "Rusenyi",
                ],
              },
              {
                Shengampuli: [
                  "Agasharu",
                  "Amataba",
                  "Nyabinyana",
                  "Rusine",
                  "Umubuga",
                  "Umutagata",
                ],
              },
            ],
          },
          {
            Mbogo: [
              {
                Bukoro: [
                  "Buhira",
                  "Bukoro",
                  "Gasama",
                  "Gihonga",
                  "Kalindi",
                  "Kibamba",
                  "Kibaya",
                  "Kinini Ya Mbogo",
                  "Ruhanya",
                  "Rwambogo",
                ],
              },
              {
                Mushari: [
                  "Bukongi",
                  "Buraro",
                  "Buyanja",
                  "Gitaba",
                  "Nkurura",
                  "Nyakabuye",
                  "Rwambogo",
                ],
              },
              {
                Ngiramazi: [
                  "Gasovu",
                  "Gikombe",
                  "Gisha",
                  "Kibungo",
                  "Muhora",
                  "Nyakabembe",
                  "Yaramba",
                ],
              },
              {
                Rurenge: [
                  "Gakoma",
                  "Gicumbi",
                  "Gitaba",
                  "Karehe",
                  "Munini",
                  "Ruhondo",
                  "Rurenge",
                  "Rutonde",
                ],
              },
            ],
          },
          {
            Murambi: [
              {
                Bubangu: [
                  "Gashubi",
                  "Karambo",
                  "Karwa",
                  "Mayange",
                  "Nyagisozi",
                  "Rebero",
                  "Ruhunga",
                  "Taba",
                ],
              },
              {
                Gatwa: [
                  "Agatare",
                  "Akarambi",
                  "Amataba",
                  "Gisiza",
                  "Kabeza",
                  "Karambo",
                  "Kigarama",
                ],
              },
              {
                Mugambazi: [
                  "Amahoro",
                  "Buliza",
                  "Gahama",
                  "Gashinge",
                  "Kigarama",
                  "Nyarurembo",
                  "Ruri",
                ],
              },
              {
                Mvuzo: [
                  "Iraro",
                  "Kabeza",
                  "Kabuga",
                  "Munyinya",
                  "Mutabo",
                  "Ntyaba",
                  "Rurama",
                ],
              },
            ],
          },
          {
            Ngoma: [
              {
                Kabuga: [
                  "Gatete",
                  "Kagarama",
                  "Kirambo",
                  "Kiruli",
                  "Nyabuko",
                  "Rubona",
                ],
              },
              {
                Karambo: [
                  "Butare",
                  "Jyambere",
                  "Kagwa",
                  "Karambi",
                  "Marebe",
                  "Nyakagezi",
                ],
              },
              {
                Mugote: [
                  "Cyabasigi",
                  "Kiboha",
                  "Kigina",
                  "Mwishya",
                  "Nyakibyeyi",
                  "Riryi",
                  "Rukoma",
                  "Sakara",
                ],
              },
              {
                Munyarwanda: [
                  "Busizi",
                  "Gaseke",
                  "Kirungu",
                  "Muyange",
                  "Ngaru",
                  "Nyaruvumu",
                  "Rushayu",
                  "Rushubi",
                ],
              },
            ],
          },
          {
            Ntarabana: [
              {
                Kajevuba: [
                  "Bikamba",
                  "Cyamutara",
                  "Gitambi",
                  "Kazi",
                  "Nyakambu",
                  "Nyarubuye",
                  "Rukore",
                  "Rusasa",
                ],
              },
              {
                Kiyanza: [
                  "Gatobotobo",
                  "Kabirizi",
                  "Kivubwe",
                  "Kiyanza I",
                  "Nombe",
                  "Nyagisozi",
                  "Nyamurema",
                  "Nyarurama",
                ],
              },
              {
                Mahaza: [
                  "Burambi",
                  "Gitwa",
                  "Kamuhororo",
                  "Karera",
                  "Kayenzi",
                  "Kibeho",
                  "Rugogwe",
                  "Rusekabuye",
                ],
              },
            ],
          },
          {
            Rukozo: [
              {
                Buraro: [
                  "Kabgayi",
                  "Kabingo",
                  "Kamiyove",
                  "Kivomo",
                  "Murwa",
                  "Nyenyeri",
                  "Rukingu",
                  "Shyondwe",
                ],
              },
              {
                Bwimo: [
                  "Bushyana",
                  "Gatiba",
                  "Gatwa",
                  "Kadendegeri",
                  "Kavumo",
                  "Mwana",
                ],
              },
              {
                Mberuka: ["Gahwazi", "Gakubo", "Kabera", "Mataba", "Mutungo"],
              },
              {
                Mbuye: ["Kibare", "Mujebe", "Musave", "Nyarusebeya", "Ruhanga"],
              },
            ],
          },
          {
            Rusiga: [
              {
                Gako: [
                  "Gifumba",
                  "Kabunigu",
                  "Kabuye",
                  "Nkanga",
                  "Ntakara",
                  "Rwintare",
                ],
              },
              {
                Kirenge: ["Kigarama", "Kinini-rusiga", "Ntaruka", "Rebero"],
              },
              {
                Taba: [
                  "Bitare",
                  "Gahondo",
                  "Karambi",
                  "Karenge",
                  "Kingazi",
                  "Nyakarama",
                ],
              },
            ],
          },
          {
            Shyorongi: [
              {
                Bugaragara: [
                  "Gatimba",
                  "Gatwa",
                  "Gisiza",
                  "Kabaraza",
                  "Kigarama",
                  "Kiziranyenzi",
                  "Nyakaruri",
                  "Nyarushinya",
                ],
              },
              {
                Kijabagwe: [
                  "Gaseke",
                  "Kabagabaga",
                  "Kabakene",
                  "Nyamugari",
                  "Rimwe",
                  "Rugendabari",
                ],
              },
              {
                Muvumu: [
                  "Cyikera",
                  "Kagunda",
                  "Karama",
                  "Kavoma",
                  "Kirurumo",
                  "Kivili",
                  "Mukumba",
                  "Muvumu",
                  "Nyabubare",
                  "Ruhanga",
                ],
              },
              {
                Rubona: [
                  "Bwimo",
                  "Gishyita",
                  "Kigali",
                  "Ngona",
                  "Nyabitare",
                  "Nyarunyinya",
                  "Nyarusange",
                  "Rwahi",
                ],
              },
              {
                Rutonde: [
                  "Bugarura",
                  "Mwagiro",
                  "Ngendo",
                  "Nyabisindu",
                  "Nyabyondo",
                  "Nyamirembe",
                  "Rutonde",
                  "Rweya",
                ],
              },
            ],
          },
          {
            Tumba: [
              {
                Barari: ["Gaseke", "Gashoro", "Karambi", "Kigarama", "Rukore"],
              },
              {
                Gahabwa: ["Kabuga", "Kagusa", "Mafene", "Munyinya", "Rushaki"],
              },
              {
                Misezero: [
                  "Kanaba",
                  "Karambi",
                  "Kavumu",
                  "Marembo",
                  "Misezero",
                  "Rurambo",
                  "Taba",
                ],
              },
              {
                Nyirabirori: [
                  "Bukinga",
                  "Gatare",
                  "Gatsinde",
                  "Gihanga",
                  "Murambi",
                  "Rugando",
                  "Rusura",
                ],
              },
              {
                Taba: [
                  "Kamuragi",
                  "Mwili",
                  "Nkinda",
                  "Nyirambuga",
                  "Nyirataba",
                  "Ruvumba",
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    South: [
      {
        Gisagara: [
          {
            Gikonko: [
              {
                Cyiri: [
                  "Curusi",
                  "Cyendajuru",
                  "Cyimpuga",
                  "Katiro",
                  "Kigitega",
                  "Kinyana",
                  "Murambi",
                  "Musambi",
                  "Sanzu",
                ],
              },
              {
                Gasagara: [
                  "Agasenyi",
                  "Karukambira",
                  "Bibungo",
                  "Gasagara",
                  "Karehe",
                  "Mugusa",
                  "Remera",
                  "Mubezi",
                ],
              },
              {
                Gikonko: [
                  "Gahabwa",
                  "Karubondo",
                  "Manyinya",
                  "Rugarama",
                  "Runyinya",
                ],
              },
              {
                Mbogo: [
                  "Bukorota",
                  "Buremera",
                  "Kirivuga",
                  "Mbogo",
                  "Nyakabuye",
                  "Nyiramageni",
                  "Rwatano",
                  "Rwintare",
                ],
              },
            ],
          },
          {
            Gishubi: [
              {
                Gabiro: [
                  "Busave",
                  "Kigozi",
                  "Kivugiza",
                  "Kurugogwe",
                  "Nyamure",
                  "Nyundo",
                  "Ruhina",
                  "Kurutare",
                  "Rweza",
                  "Tamba",
                  "Zamwe",
                ],
              },
              {
                Nyabitare: [
                  "Hemba",
                  "Kabuga",
                  "Kanombe",
                  "Mutobo",
                  "Mwiba",
                  "Ndaro",
                  "Nyabisindu",
                  "Nyirakanywero",
                  "Rwinkwavu",
                  "Ryarugaju",
                ],
              },
              {
                Nyakibungo: [
                  "Banga",
                  "Gicaca",
                  "Kavumu",
                  "Kibindyi",
                  "Munyinya",
                  "Nkunamo",
                  "Nyakibungo",
                  "Nyarurama",
                  "Rebero",
                  "Rugarama",
                  "Rusasa",
                ],
              },
              {
                Nyeranzi: [
                  "Cyamanyeri",
                  "Gikuyo",
                  "Gishya",
                  "Gitekateke",
                  "Kabungo",
                  "Kagoma",
                  "Kavumu",
                  "Kigarama",
                  "Muduha",
                  "Muyinza",
                  "Nyabyunyu",
                  "Rebero",
                  "Rugogwe",
                  "Rwanza",
                  "Rwegura",
                  "Sakara",
                ],
              },
            ],
          },
          {
            Kansi: [
              {
                Akaboti: [
                  "Agacyamu",
                  "Agataba",
                  "Akabuga",
                  "Akayenzi",
                  "Gatare",
                  "Impinga",
                  "Rugarama",
                  "Ruhuha",
                ],
              },
              {
                Bwiza: [
                  "Akakinka",
                  "Akambogo",
                  "Gitwa",
                  "Kimanama",
                  "Mbeho",
                  "Nyakibungo",
                  "Nyaruhengeri",
                ],
              },
              {
                Sabusaro: [
                  "Akayenzi",
                  "Gikore",
                  "Muhororo",
                  "Nyamure",
                  "Nyarunazi",
                  "Ruhangaye",
                ],
              },
              {
                Umunini: [
                  "Agatare",
                  "Akabagari",
                  "Gisororo",
                  "Kaburanjwiri",
                  "Kaduha",
                  "Kamugani",
                  "Kigarama",
                  "Nyange",
                ],
              },
            ],
          },
          {
            Kibirizi: [
              {
                Duwani: [
                  "Buhoro",
                  "Burashi",
                  "Cyahafi",
                  "Duwani",
                  "Karambo",
                  "Kinteko",
                  "Kivumu",
                  "Mubuga",
                  "Murambi",
                  "Rwuya",
                  "Taba",
                ],
              },
              {
                Kibirizi: [
                  "Burashi",
                  "Gasagara",
                  "Kabakobwa",
                  "Kigarama",
                  "Mareba",
                  "Mbeho",
                  "Ruhuha",
                  "Shenyeri",
                  "Torero",
                ],
              },
              {
                Muyira: [
                  "Agahumiro",
                  "Agasharu",
                  "Akagarama",
                  "Akayohani",
                  "Akirasaniro",
                  "Impinga",
                  "Nyagasozi",
                  "Nyagisasa",
                  "Rwinzuki",
                  "Itaba",
                  "Zihare",
                ],
              },
              {
                Ruturo: [
                  "Agatongati",
                  "Akabuhuzu",
                  "Akamuzenga",
                  "Akarugaju",
                  "Impinga",
                  "Kabagoti",
                  "Karengera",
                  "Kigarama",
                  "Ntobo",
                  "Nyabununi",
                  "Rubazi",
                ],
              },
            ],
          },
          {
            Kigembe: [
              {
                Agahabwa: [
                  "Agahehe",
                  "Kabacuzi",
                  "Kamutozo",
                  "Kamweko",
                  "Nyamabuye",
                  "Ruhuha",
                  "Taba",
                ],
              },
              {
                Gatovu: [
                  "Agasharu",
                  "Agatare",
                  "Akamana",
                  "Gitozo",
                  "Janja",
                  "Kigarama",
                  "Taba",
                ],
              },
              {
                Impinga: [
                  "Akadogo",
                  "Akakijugujugu",
                  "Ikidashya",
                  "Icyijana",
                  "Nyamirama",
                  "Rugeragere",
                ],
              },
              {
                Nyabikenke: [
                  "Akabahizi",
                  "Akimbaka",
                  "Impinga",
                  "Rutare",
                  "Rutaza",
                  "Shyombo",
                  "Umurangara",
                  "Ruyenzi",
                ],
              },
              {
                Rubona: [
                  "Akadogo",
                  "Kashyaga",
                  "Gaharanyonga",
                  "Gatongati",
                  "Murehe",
                  "Nyakabuye",
                ],
              },
              {
                Rusagara: [
                  "Agasharu",
                  "Akajwiga",
                  "Akatera",
                  "Kigarama",
                  "Nyarukurazo",
                  "Nyarunyinya",
                ],
              },
            ],
          },
          {
            Mamba: [
              {
                Gakoma: [
                  "Gakomeye",
                  "Gatare",
                  "Kinamba",
                  "Kivomo",
                  "Kizenga",
                  "Rebero",
                  "Rugenge",
                  "Rugwiza",
                  "Ruhuha",
                  "Sokofi",
                ],
              },
              {
                Kabumbwe: [
                  "Buye",
                  "Gahararo",
                  "Kabuga",
                  "Kirwa",
                  "Muhabura",
                  "Munopfu",
                  "Nunga",
                  "Nyarugenge",
                ],
              },
              {
                Mamba: [
                  "Buhima",
                  "Gakoma",
                  "Gatovu",
                  "Kamudogo",
                  "Karama",
                  "Kirase",
                  "Mashenyi",
                  "Nyarugenge",
                  "Rugunga",
                ],
              },
              {
                Muyaga: [
                  "Butezi",
                  "Cadi",
                  "Cyarwa",
                  "Kabeza",
                  "Kibumba",
                  "Mutori",
                  "Nyamirama",
                  "Ruhamagariro",
                  "Shyembe",
                ],
              },
              {
                Ramba: [
                  "Gatare",
                  "Gatoke",
                  "Kayenzi",
                  "Kigangazi",
                  "Murama",
                  "Murambi",
                  "Nyiramageni",
                  "Runazi",
                  "Rurama",
                  "Rusave",
                  "Rwimvubu",
                ],
              },
            ],
          },
          {
            Muganza: [
              {
                Cyumba: [
                  "Byiza",
                  "Cyumba",
                  "Gitwa",
                  "Kabacuzi",
                  "Kamabango",
                  "Musatsi",
                  "Mutorerwa",
                  "Nyagatovu",
                  "Nyiraburiba",
                  "Rugantete",
                  "Rutare",
                  "Rwimisambi",
                ],
              },
              {
                Muganza: [
                  "Agasharu",
                  "Agatongati",
                  "Amajuri",
                  "Cyanamo",
                  "Gitisi",
                  "Rwamugoyi",
                  "Rwinkuba",
                  "Ubusenyi",
                  "Urusaro",
                ],
              },
              {
                Remera: [
                  "Agakurwe",
                  "Agaseke",
                  "Akarambo",
                  "Butare",
                  "Akajyanama",
                  "Taba",
                ],
              },
              {
                Rwamiko: [
                  "Agasharu",
                  "Agatovu",
                  "Akarubumba",
                  "Akimirama",
                  "Ubuseruka",
                  "Gako",
                  "Impinga",
                  "Kabahongo",
                  "Kiberengeri",
                  "Kidaturwa",
                  "Kigina",
                  "Kiyogoro",
                  "Mbehe",
                  "Nyagatovu",
                  "Nyamagana",
                  "Ryarumenangiga",
                  "Umunazi",
                ],
              },
              {
                Saga: [
                  "Akabacuzi",
                  "Bucaya",
                  "Buhiza",
                  "Duwane",
                  "Impinga",
                  "Isangano",
                  "Kanto I",
                  "Kanto II",
                  "Nyabigugu",
                  "Nyagafumberi",
                  "Nyakagezi",
                  "Nyamiheto I",
                  "Nyamiheto II",
                  "Rwinkuba",
                ],
              },
            ],
          },
          {
            Mugombwa: [
              {
                Baziro: [
                  "Banzankuru",
                  "Gitungwa",
                  "Nyabinyenga",
                  "Nyagatovu",
                  "Nyamirama",
                  "Nyarukeri",
                  "Nyesumo",
                ],
              },
              {
                Kibayi: [
                  "Agakanka",
                  "Akarutsibuka",
                  "Akashyamba",
                  "Akabuga",
                  "Rinda",
                  "Rwahambi",
                  "Udukoni",
                ],
              },
              {
                Kibu: [
                  "Agasharu",
                  "Akabugabo",
                  "Akagashuma",
                  "Mushongi",
                  "Rurenge",
                ],
              },
              {
                Mugombwa: [
                  "Agasharu",
                  "Akagarama",
                  "Akarambo",
                  "Bishya",
                  "Impinga",
                  "Migina",
                ],
              },
              {
                Mukomacara: [
                  "Agakomansyo",
                  "Akanyamirama",
                  "Akarangabo",
                  "Akatare",
                  "Gitarama",
                  "Kabuye",
                  "Nyabisonga",
                  "Nyarusange",
                  "Umukungu",
                ],
              },
            ],
          },
          {
            Mukindo: [
              {
                Gitega: [
                  "Agasharu",
                  "Akazenga",
                  "Gatunda",
                  "Joma",
                  "Akabati",
                  "Magi",
                  "Nyabikoni",
                  "Nyamabuye",
                  "Rebero",
                  "Ruko",
                ],
              },
              {
                Mukiza: [
                  "Akagarama",
                  "Bukamba",
                  "Cyimana",
                  "Gitwa",
                  "Kigoyi",
                  "Mukiza",
                  "Nyabiryo",
                  "Nyakazana",
                  "Nyarutovu",
                  "Rusumba",
                ],
              },
              {
                Nyabisagara: [
                  "Agatare",
                  "Kabuga",
                  "Akanage",
                  "Butare",
                  "Kamasiga",
                  "Makwaza",
                  "Mihigo",
                  "Mutondo",
                  "Nkurubuye",
                  "Nyabihama",
                  "Rurimbi",
                  "Rususa",
                ],
              },
              {
                Runyinya: [
                  "Agakomeye",
                  "Agasharu",
                  "Akakarinda",
                  "Akamaranga",
                  "Akarugina",
                  "Akayenzi",
                  "Cyumusave",
                  "Impinga",
                  "Itaba",
                  "Mpungwe",
                  "Munyegera",
                  "Nyiranguri",
                ],
              },
            ],
          },
          {
            Musha: [
              {
                Bukinanyana: [
                  "Agatega",
                  "Akagarama",
                  "Bukinanyana",
                  "Gihinga",
                  "Karishyira",
                  "Kigoma",
                  "Mugejuru",
                  "Munyegera",
                  "Rugarama",
                  "Rukoni",
                  "Rwabuhanga",
                  "Rwatano",
                ],
              },
              {
                Gatovu: [
                  "Cyayi",
                  "Gaseke",
                  "Gasura",
                  "Gitega",
                  "Kagunda",
                  "Kigarama",
                  "Mutarama",
                  "Nyabitare",
                  "Nyagasambu",
                  "Ryamugunga",
                ],
              },
              {
                Kigarama: [
                  "Bugagiro",
                  "Buremera",
                  "Kabusenda",
                  "Kagunga",
                  "Karugumya",
                  "Kigarama",
                  "Murama",
                  "Nyesonga",
                  "Rugara",
                  "Rugarama",
                ],
              },
              {
                Kimana: [
                  "Akabanga",
                  "Kamabuye",
                  "Kamutabazi",
                  "Kibirizi",
                  "Murambi",
                  "Nyabiduha",
                  "Nyamiyaga",
                  "Ramba",
                  "Rurama",
                  "Rusenyi",
                ],
              },
            ],
          },
          {
            Ndora: [
              {
                Bweya: [
                  "Akiminazi",
                  "Gatobotobo",
                  "Kamahembe",
                  "Kantabana",
                  "Mirayi",
                  "Sabudari",
                ],
              },
              {
                Cyamukuza: [
                  "Giseke",
                  "Nyaburondwe",
                  "Nyarubari",
                  "Ryabiyaga",
                  "Sagahungu",
                  "Urusenyi",
                ],
              },
              {
                Dahwe: [
                  "Agasharu",
                  "Gahondo",
                  "Gitwa",
                  "Kigarama",
                  "Ndatemwa",
                  "Twarubona",
                ],
              },
              {
                Gisagara: [
                  "Gisagara",
                  "Kabuga",
                  "Kabuye",
                  "Ndora",
                  "Nyabitare",
                  "Nyamigango",
                  "Nyarunazi",
                  "Rugara",
                  "Rutonde",
                ],
              },
              {
                Mukande: [
                  "Bugarama",
                  "Kidwange",
                  "Nkinda I",
                  "Nkinda II",
                  "Nyarunyinya",
                  "Nyarusange",
                ],
              },
            ],
          },
          {
            Nyanza: [
              {
                Higiro: [
                  "Agatare",
                  "Kabakene",
                  "Akagarama",
                  "Amashya",
                  "Impinga II",
                  "Rama",
                  "Ruvugizo",
                  "Uruvumvuti",
                ],
              },
              {
                Nyamugari: [
                  "Akayange",
                  "Cyumba",
                  "Gatarinzira",
                  "Kigali",
                  "Rwamiko",
                  "Sare",
                  "Urugogwe",
                  "Urutoyi",
                ],
              },
              {
                Nyaruteja: [
                  "Agahehe",
                  "Akamerwe",
                  "Akasemabondi",
                  "Marambya",
                  "Gisunzu",
                  "Impinga I",
                  "Intuntu",
                  "Rugayantete",
                  "Rugomero",
                ],
              },
              {
                Umubanga: [
                  "Akamabuye",
                  "Akarwishyura",
                  "Akinyana",
                  "Maheresho",
                  "Manyoni",
                  "Remera",
                  "Tundiro",
                  "Urukeri",
                ],
              },
            ],
          },
          {
            Save: [
              {
                Gatoki: [
                  "Gasambu",
                  "Gashubi",
                  "Kampuro",
                  "Kaneke",
                  "Kavumu",
                  "Nyarigina",
                  "Rugarama",
                ],
              },
              {
                Munazi: [
                  "Kadurumba",
                  "Gakombe",
                  "Gitwa",
                  "Kabitoki",
                  "Kigwa",
                  "Nyarure",
                  "Rwoserezo",
                  "Zihare",
                ],
              },
              {
                Rwanza: [
                  "Akarambo",
                  "Bazenga",
                  "Bitabire",
                  "Bwinyambo",
                  "Cyezuburo",
                  "Gahora",
                  "Kamudahunga",
                  "Kigarama",
                  "Kivumu",
                  "Nyabitare",
                  "Nyagacyamu",
                  "Ryamaguri",
                ],
              },
              {
                Shyanda: [
                  "Gahora",
                  "Kagende",
                  "Kirehe",
                  "Kirira",
                  "Mpinga",
                  "Mukoni",
                  "Rugori",
                  "Ryakabuye",
                  "Ryamutabazi",
                  "Taba",
                ],
              },
              {
                Zivu: [
                  "Kinyonzwe",
                  "Musekera",
                  "Nyagasozi",
                  "Rugogwe",
                  "Rwanzana",
                  "Ryamurongo",
                  "Ryarubayi",
                ],
              },
            ],
          },
        ],
      },
      {
        Huye: [
          {
            Gishamvu: [
              {
                Nyakibanda: ["Byimana", "Kamabuye", "Karambo", "Kigarama"],
              },
              {
                Nyumba: [
                  "Akagahaya",
                  "Busoro",
                  "Gasyankingi",
                  "Gishamvu",
                  "Mirambi",
                  "Nyagatama",
                ],
              },
              {
                Ryakibogo: [
                  "Gakombe",
                  "Gasekebuye",
                  "Gitwa",
                  "Impinga",
                  "Kadahokwa",
                  "Kidahire",
                  "Kiduha",
                ],
              },
              {
                Shori: [
                  "Akabere",
                  "Cyambwe",
                  "Kabeza",
                  "Karubare",
                  "Kinyovi",
                  "Rebero",
                  "Rusasa",
                  "Umunyinya",
                ],
              },
            ],
          },
          {
            Huye: [
              {
                Muyogoro: [
                  "Agacyamu",
                  "Agasharu",
                  "Akagarama",
                  "Akaruzi",
                  "Kigarama",
                  "Munini",
                  "Nkamatira",
                  "Nyarutovu",
                  "Nyarwumba",
                  "Rugerero",
                  "Rwankoni",
                  "Rwaza",
                  "Shuni",
                ],
              },
              {
                Nyakagezi: [
                  "Gatongati",
                  "Kamutima",
                  "Karuhinda",
                  "Kigarama",
                  "Kinyana",
                  "Kinyinya",
                  "Mbuba",
                  "Munanira",
                  "Nyarunazi",
                  "Rugarama",
                ],
              },
              {
                Rukira: [
                  "Agacyamu",
                  "Agahenerezo",
                  "Agakombe",
                  "Agasharu",
                  "Gitwa",
                  "Kanazi",
                  "Kaseramba",
                  "Kubutare",
                  "Magonde",
                  "Nyagasambu",
                  "Nyanza",
                  "Rugarama",
                  "Sabaderi",
                ],
              },
              {
                Sovu: [
                  "Gako",
                  "Gasongati",
                  "Gikombe",
                  "Kabagendera",
                  "Karambo",
                  "Karuhayi",
                  "Kigarama",
                  "Ngobagoba",
                  "Rwezamenyo",
                ],
              },
            ],
          },
          {
            Karama: [
              {
                Buhoro: [
                  "Kibingo",
                  "Mataba",
                  "Mitsinda",
                  "Nyamapfunda",
                  "Nyamikaba",
                ],
              },
              {
                Bunazi: [
                  "Agatenderi",
                  "Akarehe",
                  "Ikigarama",
                  "Kinani",
                  "Rwezamenyo",
                ],
              },
              {
                Gahororo: [
                  "Akarambo",
                  "Mavumba",
                  "Mukongoro",
                  "Nyarusange",
                  "Sangano",
                  "Umuyange",
                  "Uwarugondo",
                ],
              },
              {
                Kibingo: [
                  "Agasharu",
                  "Agatovu",
                  "Mukimba",
                  "Nkoto",
                  "Nyesonga",
                  "Zaga",
                ],
              },
              {
                Muhembe: [
                  "Butare",
                  "Cyetete",
                  "Kaburemera",
                  "Rugege",
                  "Uwimpundu",
                ],
              },
            ],
          },
          {
            Kigoma: [
              {
                Gishihe: [
                  "Birambo",
                  "Gihanda",
                  "Gishihe",
                  "Kababaji",
                  "Kabingo",
                  "Kamyuga",
                  "Karambi",
                  "Kavumu",
                ],
              },
              {
                Kabatwa: [
                  "Bande",
                  "Buremera",
                  "Kamihuro",
                  "Karuhimbana",
                  "Kinyata",
                  "Mahwa",
                  "Mbogo",
                  "Sekera",
                ],
              },
              {
                Kabuga: [
                  "Kabingo",
                  "Kagina",
                  "Kanyamugira",
                  "Nyarunazi",
                  "Ruhungu",
                  "Rwabuye",
                  "Sanzu",
                ],
              },
              {
                Karambi: [
                  "Gasura",
                  "Gituntu",
                  "Gitwa",
                  "Kagarama",
                  "Kigarama",
                  "Nyarunyinya",
                  "Rebo",
                ],
              },
              {
                Musebeya: [
                  "Gatovu",
                  "Kabacuzi",
                  "Kabakobwa",
                  "Nyagasozi",
                  "Nyarurembo",
                  "Rusenyi",
                ],
              },
              {
                Nyabisindu: [
                  "Kabugabo",
                  "Kabumba",
                  "Karambi",
                  "Mubuga",
                  "Nkenke",
                  "Nyanzamura",
                  "Rugarama",
                  "Shaba",
                ],
              },
              {
                Rugarama: [
                  "Birembo",
                  "Birinjo",
                  "Gasharu",
                  "Kabumba",
                  "Kakarusho",
                  "Kanyurapfundo",
                  "Nyagahinga",
                  "Ruhinga",
                  "Ryaruhimbya",
                ],
              },
              {
                Shanga: [
                  "Gasharu",
                  "Akaderege",
                  "Gaseke",
                  "Kabicuki",
                  "Ntuntu",
                  "Nyamirama",
                  "Serugenzi",
                ],
              },
            ],
          },
          {
            Kinazi: [
              {
                Byinza: ["Buremera", "Gakoni", "Nyarurama", "Rwerinka"],
              },
              {
                Gahana: ["Cyegera", "Gasaka", "Gihana", "Rugarama", "Sogwe"],
              },
              {
                Gitovu: [
                  "Hanika",
                  "Karambo",
                  "Kinazi",
                  "Muti",
                  "Nyarugunga",
                  "Nyarusange",
                  "Rubona",
                  "Ruvugizo",
                ],
              },
              {
                Kabona: [
                  "Kibiraro",
                  "Mujyejuru",
                  "Munyu",
                  "Remera",
                  "Rwambariro",
                ],
              },
              {
                Sazange: [
                  "Butare",
                  "Gahondo",
                  "Giseke",
                  "Kigarama",
                  "Mukuzanyana",
                  "Nyabisindu",
                ],
              },
            ],
          },
          {
            Maraba: [
              {
                Buremera: ["Buremera", "Gasarabuye", "Kinazi", "Nkorwe"],
              },
              {
                Gasumba: ["Gitabure", "Gitwa", "Kinombe", "Taba"],
              },
              {
                Kabuye: [
                  "Gasharu",
                  "Murama",
                  "Nyamvumba",
                  "Nyarusange",
                  "Rukeri",
                ],
              },
              {
                Kanyinya: ["Bwegera", "Gikomero", "Kabirombe", "Kayeye"],
              },
              {
                Shanga: [
                  "Gasororo",
                  "Gatyazo",
                  "Kabirizi",
                  "Mpinga",
                  "Nyamiyaga",
                  "Nyantende",
                  "Rutontwe",
                  "Shyinga",
                ],
              },
              {
                Shyembe: [
                  "Gisagara",
                  "Kagoma",
                  "Karambi",
                  "Karambo",
                  "Kigarama",
                  "Kizi",
                ],
              },
            ],
          },
          {
            Mbazi: [
              {
                Gatobotobo: [
                  "Agasharu",
                  "Akanyinya",
                  "Bigangara",
                  "Kanyaruhinda",
                  "Mpinga",
                  "Rubona",
                  "Rwabuye",
                ],
              },
              {
                Kabuga: [
                  "Gakombe",
                  "Gasharu",
                  "Gicubuka",
                  "Mpinga",
                  "Ndobogo",
                  "Rwezamenyo",
                ],
              },
              {
                Mutunda: [
                  "Kagera",
                  "Kigusa",
                  "Kimuna",
                  "Kinyana",
                  "Rugarama",
                  "Ruryango",
                ],
              },
              {
                Mwulire: [
                  "Bumbogo",
                  "Cyayove",
                  "Gitwa",
                  "Kaburuba",
                  "Murambi",
                  "Taba",
                ],
              },
              {
                Rugango: [
                  "Gahanga",
                  "Kabakono",
                  "Kamunyinya",
                  "Kanzeyi",
                  "Kibiraro",
                  "Kigarama",
                  "Mpinga",
                  "Ngeri",
                  "Nyabisindu",
                  "Nyamirundi",
                ],
              },
              {
                Rusagara: ["Buhoro", "Gitwa", "Kibirizi", "Cyingoma", "Ruhuha"],
              },
              {
                Tare: [
                  "Cyahafi",
                  "Gashikiri",
                  "Kagarama",
                  "Kavumu",
                  "Kigwene",
                  "Rupango",
                ],
              },
            ],
          },
          {
            Mukura: [
              {
                Bukomeye: [
                  "Bweramana",
                  "Cyiri",
                  "Gahanga",
                  "Gasunzwe",
                  "Kigarama",
                  "Kizenga",
                  "Nyagakingi",
                  "Sata",
                  "Shingangabo",
                  "Taba",
                ],
              },
              {
                Buvumu: [
                  "Akagarama",
                  "Akayenzi",
                  "Akogo",
                  "Amasanganzira",
                  "Kabeza",
                  "Akabutora",
                  "Mpinga",
                  "Nyagasambu",
                  "Remera",
                  "Rujumbura",
                  "Rusenyi",
                  "Taba",
                ],
              },
              {
                Icyeru: [
                  "Akabuga",
                  "Akamahinda",
                  "Gakombe",
                  "Nyagisenyi",
                  "Nyarusambu",
                ],
              },
              {
                "Rango A": [
                  "Agakera",
                  "Agakombe",
                  "Gaseke",
                  "Kabahora",
                  "Mpaza",
                  "Nyamata",
                  "Rwinuma",
                ],
              },
            ],
          },
          {
            Ngoma: [
              {
                Butare: [
                  "Akabuye",
                  "Bukinanyana",
                  "Buye",
                  "Gasoro",
                  "Kabutare",
                  "Karubanda",
                  "Mamba",
                  "Busenyi",
                  "Taba",
                ],
              },
              {
                Kaburemera: [
                  "Gatoki",
                  "Kaguhu",
                  "Karambi",
                  "Nyabubare",
                  "Nyagapfizi",
                  "Rugarama",
                  "Runga",
                ],
              },
              {
                Matyazo: [
                  "Gafurwe",
                  "Kabeza",
                  "Kamucuzi",
                  "Nyabitare",
                  "Rurenda",
                  "Rusisiro",
                  "Ruvuzo",
                ],
              },
              {
                Ngoma: [
                  "Ngoma V",
                  "Ngoma I",
                  "Ngoma III",
                  "Ngoma IV",
                  "Ngoma VI",
                  "Ngoma II",
                ],
              },
            ],
          },
          {
            Ruhashya: [
              {
                Busheshi: [
                  "Kamuhoza",
                  "Kibyagira",
                  "Nyabijyo",
                  "Nyagatovu",
                  "Umuyange",
                ],
              },
              {
                Gatovu: ["Dutare", "Karambo", "Kigoma", "Kiyanza", "Murama"],
              },
              {
                Karama: [
                  "Gakoni",
                  "Kampogo",
                  "Nyakigezi",
                  "Rukubiro",
                  "Umuyinza",
                ],
              },
              {
                Mara: ["Bwankusi", "Gashikiri", "Gitwa", "Karambo", "Rwamara"],
              },
              {
                Muhororo: [
                  "Agasharu",
                  "Kinziramuhindo",
                  "Nyakabingo",
                  "Shyara",
                  "Taba",
                ],
              },
              {
                Rugogwe: ["Agasharu", "Akanyana", "Umurambi"],
              },
              {
                Ruhashya: [
                  "Igerero",
                  "Kigarama",
                  "Mbagabaga",
                  "Muginga",
                  "Rugarama",
                  "Rwamabare",
                ],
              },
            ],
          },
          {
            Rusatira: [
              {
                Buhimba: [
                  "Gasaka",
                  "Agasharu",
                  "Impinga",
                  "Kanyirankuba",
                  "Karubona",
                  "Kinkanga",
                  "Mucunda",
                  "Rugarama",
                ],
              },
              {
                Gafumba: ["Kabuga", "Kigarama", "Kigari", "Mubuga", "Ruvugizo"],
              },
              {
                Kimirehe: [
                  "Gakomeye",
                  "Kagasa",
                  "Kavumu",
                  "Kigarama",
                  "Ndyome",
                  "Nyakabuye",
                  "Nyarutovu",
                  "Rubanga",
                ],
              },
              {
                Kimuna: [
                  "Kamabuye",
                  "Kimigo",
                  "Murambi",
                  "Nyabusunzu",
                  "Rushikiri",
                  "Rwamuganda",
                ],
              },
              {
                Kiruhura: [
                  "Agasharu",
                  "Impinga",
                  "Nyagasozi",
                  "Nyamuko",
                  "Nyarucyamu",
                  "Nyarugenge",
                  "Rubona",
                  "Rugarama",
                  "Tumba",
                  "Umuremera",
                ],
              },
              {
                Mugogwe: [
                  "Gicubuka",
                  "Kabeza",
                  "Kibiraro",
                  "Mubuga",
                  "Murambi",
                ],
              },
            ],
          },
          {
            Rwaniro: [
              {
                Gatwaro: ["Amarongi", "Gatwaro", "Nyakabuye", "Rumana"],
              },
              {
                Kamwambi: [
                  "Gakomeye",
                  "Kamwambi",
                  "Karambo",
                  "Remera",
                  "Rurembo",
                ],
              },
              {
                Kibiraro: ["Murehe", "Nyabisindu", "Nyamivumu", "Nyarunyinya"],
              },
              {
                Mwendo: ["Birambo", "Cyarera", "Murango", "Rugerero"],
              },
              {
                Nyamabuye: [
                  "Bweramana",
                  "Kigarama",
                  "Munanira",
                  "Nyagacyamu",
                  "Nyamabuye",
                ],
              },
              {
                Nyaruhombo: [
                  "Gasharu",
                  "Kibara",
                  "Kigarama",
                  "Murambi",
                  "Mwezi",
                  "Nyabujengwe",
                  "Rugarama",
                ],
              },
              {
                Shyunga: [
                  "Karama",
                  "Karugumya",
                  "Kiboga",
                  "Kigarama",
                  "Rugarama",
                ],
              },
            ],
          },
          {
            Simbi: [
              {
                Cyendajuru: [
                  "Bisambu",
                  "Cyendajuru",
                  "Kigarama",
                  "Matyazo",
                  "Rugarama",
                  "Ruhinga",
                  "Rwatsi",
                ],
              },
              {
                Gisakura: [
                  "Bambiro",
                  "Gasharu",
                  "Kigarama",
                  "Kirarambogo",
                  "Nyabisindu",
                ],
              },
              {
                Kabusanza: [
                  "Bwiza",
                  "Gihinga",
                  "Kigarama",
                  "Maliza",
                  "Muranda",
                  "Ndago",
                  "Ntobwe",
                  "Rusuma",
                  "Umurera",
                ],
              },
              {
                Mugobore: [
                  "Kigarama",
                  "Mugobore",
                  "Nyagasozi",
                  "Nyamirama",
                  "Nyamiyaga",
                  "Nyarurembo",
                  "Rugarama",
                  "Ryasebiganza",
                ],
              },
              {
                Nyangazi: [
                  "Igonde",
                  "Kabakobwa",
                  "Kanyiramana",
                  "Karebero",
                  "Kinyambo",
                  "Ngororero",
                  "Nyarukurazo",
                  "Remera",
                  "Shunga",
                  "Umuyange",
                ],
              },
            ],
          },
          {
            Tumba: [
              {
                Cyarwa: [
                  "Agahora",
                  "Agasengasenge",
                  "Agasharu",
                  "Agateme",
                  "Icyiri",
                  "Kabeza",
                  "Kigarama",
                  "Mukoni",
                  "Taba",
                ],
              },
              {
                Cyimana: [
                  "Abizerwa",
                  "Akamuhoza",
                  "Amahoro",
                  "Ubumwe",
                  "Ubwiyunge",
                ],
              },
              {
                Gitwa: ["Gasenyi", "Berwa", "Nyarurembo", "Rebero", "Rimba"],
              },
              {
                Mpare: [
                  "Agasharu",
                  "Akabuga",
                  "Akarugiranka",
                  "Kigarama",
                  "Musange",
                  "Runyinya",
                  "Rwanyanza",
                ],
              },
              {
                "Rango B": [
                  "Akabeza",
                  "Akakanyamanza",
                  "Byimana",
                  "Impuhwe",
                  "Kigarama",
                  "Ntangarugero",
                  "Urugwiro",
                ],
              },
            ],
          },
        ],
      },
      {
        Kamonyi: [
          {
            Gacurabwenge: [
              {
                Gihinga: [
                  "Kagarama",
                  "Kambyeyi",
                  "Karama",
                  "Nyagasozi",
                  "Nyarunyinya",
                  "Ryabitana",
                ],
              },
              {
                Gihira: [
                  "Bugaba",
                  "Kibanza",
                  "Kidaturwa",
                  "Migina",
                  "Nyabitare",
                ],
              },
              {
                Kigembe: [
                  "Buhoro",
                  "Kabatsi",
                  "Kagarama",
                  "Mushimba",
                  "Nyakabungo",
                  "Rugobagoba",
                ],
              },
              {
                Nkingo: [
                  "Juru",
                  "Kamonyi",
                  "Mataba",
                  "Nyamiryango",
                  "Nyamugari",
                  "Rubona",
                ],
              },
            ],
          },
          {
            Karama: [
              {
                Bitare: ["Gisanze", "Kabuga", "Kajevuba", "Kinkeri", "Kokobe"],
              },
              {
                Bunyonga: ["Bunyonga", "Nyarurembo", "Nyenyeri", "Ryagashaza"],
              },
              {
                Muganza: [
                  "Bitagata",
                  "Gatare",
                  "Ngoma",
                  "Nyamitanga",
                  "Nyaruteja",
                ],
              },
              {
                Nyamirembe: [
                  "Gaji",
                  "Gasharu",
                  "Kavumu",
                  "Kigabiro",
                  "Nyakizu",
                ],
              },
            ],
          },
          {
            Kayenzi: [
              {
                Bugarama: ["Buhurura", "Munyegera", "Nyarurama", "Remera"],
              },
              {
                Cubi: ["Gitwa", "Kamabuye", "Ntwari", "Nyakigezi", "Rwishywa"],
              },
              {
                Kayonza: ["Kigwene", "Muza", "Nyabubare"],
              },
              {
                Kirwa: ["Gasamba", "Gisizi", "Gitwa", "Kigunga", "Ruheka"],
              },
              {
                Mataba: [
                  "Gasasa",
                  "Gikurubuye",
                  "Kabana",
                  "Nyarubaya",
                  "Rugoma",
                ],
              },
              {
                Nyamirama: ["Bushara", "Kibuye", "Rugaragara"],
              },
            ],
          },
          {
            Kayumbu: [
              {
                Busoro: ["Buramba", "Manyana", "Nyabuhoro", "Nyarugenge"],
              },
              {
                Gaseke: ["Gasiza", "Kigarama", "Nyarunyinya"],
              },
              {
                Giko: ["Gasharu", "Mirehe", "Nyarusange", "Ryamanywa"],
              },
              {
                Muyange: ["Kaje", "Kangenzi", "Murambi", "Nyarurembo"],
              },
            ],
          },
          {
            Mugina: [
              {
                Jenda: [
                  "Kigarama",
                  "Kiyonza",
                  "Mataba Nord",
                  "Munini",
                  "Nyamurenga",
                ],
              },
              {
                Kabugondo: ["Bihenga", "Cyeru", "Mataba Sud", "Runzenzi"],
              },
              {
                Mbati: ["Kansoro", "Kigorora", "Mbati", "Mikamba", "Murambi"],
              },
              {
                Mugina: ["Kagasa", "Kireka", "Mparo", "Mugina"],
              },
              {
                Nteko: ["Gishari", "Kona", "Ntasi", "Nyagisozi", "Rusoro"],
              },
            ],
          },
          {
            Musambira: [
              {
                Buhoro: ["Busasamana", "Gihembe", "Gihogwe", "Reramacu"],
              },
              {
                Cyambwe: [
                  "Bimomwe",
                  "Gacaca",
                  "Giheta",
                  "Rugarama",
                  "Ruvumura",
                  "Shaka",
                ],
              },
              {
                Karengera: [
                  "Kamayanja",
                  "Mbari",
                  "Nyarusange",
                  "Nyarutovu",
                  "Rubanga",
                ],
              },
              {
                Kivumu: [
                  "Gahondo",
                  "Gitega",
                  "Munazi",
                  "Nyagisozi",
                  "Nyerenga",
                  "Wimana",
                ],
              },
              {
                Mpushi: [
                  "Gitwiko",
                  "Kabere",
                  "Kamashashi",
                  "Kingoma",
                  "Nyarubuye",
                  "Nyarurama",
                ],
              },
              {
                Rukambura: ["Bitsibo", "Ngoma", "Nkomane", "Nyamirembe"],
              },
            ],
          },
          {
            Ngamba: [
              {
                Kabuga: [
                  "Cyimigenge",
                  "Fukwe",
                  "Musenyi",
                  "Nyagasozi",
                  "Nyamugari",
                  "Raro",
                ],
              },
              {
                Kazirabonde: [
                  "Bigobe",
                  "Gatare",
                  "Gatwa",
                  "Kabande",
                  "Kajevuba",
                  "Munoga",
                ],
              },
              {
                Marembo: [
                  "Gahinga",
                  "Kabagogo",
                  "Kigina",
                  "Nyabitare",
                  "Rugarama",
                ],
              },
            ],
          },
          {
            Nyamiyaga: [
              {
                Bibungo: [
                  "Byenene",
                  "Karubanda",
                  "Murambi",
                  "Nkimbiri",
                  "Nyamabere",
                  "Nyamurasa",
                  "Nyamweru",
                  "Rwabinagu",
                ],
              },
              {
                Kabashumba: [
                  "Bumbogo",
                  "Buye",
                  "Gacumu",
                  "Kigabiro",
                  "Mukuyo",
                  "Murehe",
                  "Nkoto",
                  "Ruvugizo",
                  "Ruyumba",
                  "Umugarama",
                ],
              },
              {
                Kidahwe: [
                  "Kiranzi",
                  "Kirehe",
                  "Magu",
                  "Nyamiyaga",
                  "Nyarubuye",
                  "Rugarama",
                  "Rugwiro",
                  "Rwezamenyo",
                  "Sabununga",
                ],
              },
              {
                Mukinga: [
                  "Birembo",
                  "Kabeza",
                  "Kayenzi",
                  "Mbayaya",
                  "Nyabubare",
                  "Nyamahuru",
                  "Nyarugenge",
                  "Nyaruhengeri",
                  "Wimana",
                ],
              },
              {
                Ngoma: [
                  "Buhoro",
                  "Gitega",
                  "Kabahazi",
                  "Kamabuye",
                  "Kinanira",
                  "Kivugiza",
                  "Munyinya",
                  "Rwankeke",
                ],
              },
            ],
          },
          {
            Nyarubaka: [
              {
                Gitare: [
                  "Karora",
                  "Kibingo",
                  "Mugereke",
                  "Nyabitare",
                  "Remera",
                  "Rwigerero",
                ],
              },
              {
                Kambyeyi: [
                  "Kabungo",
                  "Kigwene",
                  "Kirwa",
                  "Nyagihamba",
                  "Ruhuha",
                  "Ruseke",
                ],
              },
              {
                Kigusa: [
                  "Birembo",
                  "Gaserege",
                  "Kigarama",
                  "Kintama",
                  "Rugarama",
                  "Rwinanka",
                ],
              },
              {
                Nyagishubi: ["Kabere", "Ngendo", "Nombe", "Nyagasozi", "Tare"],
              },
              {
                Ruyanza: [
                  "Buhunga",
                  "Gatagara",
                  "Gitega",
                  "Kanombe",
                  "Kavumu",
                  "Ngarama",
                ],
              },
            ],
          },
          {
            Rugarika: [
              {
                Bihembe: [
                  "Gitwa",
                  "Kadasaya",
                  "Karama",
                  "Rubona",
                  "Rutovu",
                  "Rwabayanga",
                ],
              },
              {
                Kigese: ["Bikamba", "Kigese", "Kirega", "Mibirizi", "Rugarama"],
              },
              {
                Masaka: ["Masaka", "Mpungwe", "Ruramba", "Rwimondo", "Taba"],
              },
              {
                Nyarubuye: [
                  "Kabarama",
                  "Musave",
                  "Nzagwa",
                  "Remera",
                  "Ruhogo",
                  "Samuduha",
                ],
              },
              {
                Sheli: [
                  "Sheli",
                  "Gatovu",
                  "Kagangayire",
                  "Karehe",
                  "Kigarama",
                  "Ntebe",
                ],
              },
            ],
          },
          {
            Rukoma: [
              {
                Bugoba: ["Bugoba", "Gatare", "Kabuga", "Nyarurama", "Nyenge"],
              },
              {
                Buguri: [
                  "Buguri",
                  "Nyabuvomo",
                  "Nyagasozi",
                  "Nyakabande",
                  "Ruzege",
                  "Tunza",
                ],
              },
              {
                Gishyeshye: [
                  "Gahungeri",
                  "Gishyeshye",
                  "Murambi",
                  "Nyamabuye",
                  "Rubare",
                ],
              },
              {
                Murehe: [
                  "Kabagabo",
                  "Kamuzi",
                  "Mubuga",
                  "Rushikiri",
                  "Uwingando",
                ],
              },
              {
                Mwirute: [
                  "Gafonogo",
                  "Mwirute",
                  "Nyarusave",
                  "Rubuye",
                  "Rugarama",
                ],
              },
              {
                Remera: [
                  "Gisenyi",
                  "Kabande",
                  "Kanyinya",
                  "Kigarama",
                  "Mbizi",
                  "Remera",
                ],
              },
              {
                Taba: [
                  "Bukokora",
                  "Karuri",
                  "Nyarusange",
                  "Nyirabihanya",
                  "Taba",
                ],
              },
            ],
          },
          {
            Runda: [
              {
                Gihara: [
                  "Bikimba",
                  "Bimba",
                  "Kabasanza",
                  "Nyagatare",
                  "Rukaragata",
                  "Ruyigi",
                ],
              },
              {
                Kabagesera: [
                  "Bwirabo",
                  "Kabagesera",
                  "Muhambara",
                  "Rubuye",
                  "Rugogwe",
                ],
              },
              {
                Kagina: [
                  "Gasharara",
                  "Kagina",
                  "Kamuhoza",
                  "Kigusa",
                  "Rugarama",
                ],
              },
              {
                Muganza: [
                  "Kigabiro",
                  "Musebeya",
                  "Nyagacyamu",
                  "Nyaruhoko",
                  "Rubona",
                ],
              },
              {
                Ruyenzi: [
                  "Kibaya",
                  "Nyabitare",
                  "Nyagacaca",
                  "Rubumba",
                  "Rugazi",
                ],
              },
            ],
          },
        ],
      },
      {
        Muhanga: [
          {
            Cyeza: [
              {
                Biringaga: [
                  "Gatare",
                  "Karama",
                  "Kuwimana",
                  "Munini",
                  "Nyabisindu",
                ],
              },
              {
                Kigarama: [
                  "Cyanika",
                  "Kajeje",
                  "Mataba",
                  "Mbirizi",
                  "Nyagatovu",
                  "Rwinkuba",
                ],
              },
              {
                Kivumu: [
                  "Buruba",
                  "Busozi",
                  "Bwirika",
                  "Bwiza",
                  "Kamonyi",
                  "Musengo",
                  "Takwe",
                ],
              },
              {
                Makera: [
                  "Binunga",
                  "Kanyanza",
                  "Kigaga",
                  "Nyagatovu",
                  "Rwamugoroba",
                ],
              },
              {
                Nyarunyinya: [
                  "Bishike",
                  "Bucyeye",
                  "Buhoro",
                  "Gasovu",
                  "Gatete",
                  "Rusave",
                ],
              },
              {
                Shori: ["Sholi", "Karehe", "Kibumba", "Nyarubuye", "Rubimba"],
              },
            ],
          },
          {
            Kabacuzi: [
              {
                Buramba: [
                  "Gahembe",
                  "Gahinga",
                  "Kabayaza",
                  "Kirambo",
                  "Musasa",
                ],
              },
              {
                Butare: ["Buyoga", "Gihinga", "Karambo", "Nyirabwayi"],
              },
              {
                Kabuye: ["Kabuga", "Peru"],
              },
              {
                Kavumu: ["Gasave", "Gasiza", "Kabuga", "Rebero", "Rukoma"],
              },
              {
                Kibyimba: ["Gasharu", "Kamiranzogera", "Kanka", "Kibaya"],
              },
              {
                Ngarama: ["Kabuga", "Karambo", "Mpanga", "Nzovi"],
              },
              {
                Ngoma: ["Cyambari", "Gitwa", "Nkegete", "Nyarunyinya", "Peru"],
              },
              {
                Sholi: [
                  "Gakondokondo",
                  "Gitwa",
                  "Jandari",
                  "Kinyoni",
                  "Mucyamo",
                ],
              },
            ],
          },
          {
            Kibangu: [
              {
                Gisharu: [
                  "Buhoro",
                  "Kirehe",
                  "Murandi",
                  "Musezero",
                  "Remera",
                  "Rwesero",
                ],
              },
              {
                Gitega: [
                  "Cyuzu",
                  "Kaziba",
                  "Muhororo",
                  "Musambagiro",
                  "Musarara",
                  "Nkondo",
                ],
              },
              {
                Jurwe: [
                  "Bukiro",
                  "Kimisange",
                  "Murambi",
                  "Nzarwa",
                  "Rubona",
                  "Ruminantege",
                ],
              },
              {
                Mubuga: [
                  "Jarama",
                  "Matoshya",
                  "Mubuga",
                  "Nyarubuye",
                  "Nyaruvumu",
                ],
              },
              {
                Rubyiniro: ["Butare", "Gakurwe", "Mucyamo", "Mugari", "Murehe"],
              },
              {
                Ryakanimba: [
                  "Kinogi",
                  "Musekera",
                  "Mushubaguriko",
                  "Mwumba",
                  "Nyamugari",
                ],
              },
            ],
          },
          {
            Kiyumba: [
              {
                Budende: ["Karambi", "Muduha", "Musenyi", "Ruramba"],
              },
              {
                Ndago: ["Mataba", "Rwezamenyo", "Sovu"],
              },
              {
                Remera: [
                  "Cyakabiri",
                  "Kagahina",
                  "Kagitaba",
                  "Nyanza",
                  "Sabusaro",
                ],
              },
              {
                Ruhina: ["Busumba", "Gatwa", "Kabimbura", "Mubuga", "Nundwe"],
              },
              {
                Rukeri: [
                  "Busindi",
                  "Kabuga",
                  "Matovu",
                  "Munini",
                  "Musagara",
                  "Nyamirambo",
                ],
              },
            ],
          },
          {
            Muhanga: [
              {
                Kanyinya: [
                  "Gakomeye",
                  "Kanyungura",
                  "Mataba",
                  "Nyabugwiza",
                  "Nyamitanga",
                ],
              },
              {
                Nganzo: [
                  "Gasenyi",
                  "Gitongati",
                  "Kabingo",
                  "Kagombero",
                  "Kamazu",
                  "Karama",
                  "Kumukenke",
                  "Masumo",
                ],
              },
              {
                Nyamirama: [
                  "Cyurutare",
                  "Gahabwa",
                  "Kantonganiye",
                  "Namankurwe",
                  "Nyiramarangara",
                  "Rwabagenzi",
                ],
              },
              {
                Remera: [
                  "Gisiza",
                  "Kiyoro",
                  "Muhanga",
                  "Munzereri",
                  "Murama",
                  "Naganiro",
                ],
              },
              {
                Tyazo: ["Gasaka", "Gitima", "Kivomo", "Nyahinda", "Ruhuha"],
              },
            ],
          },
          {
            Mushishiro: [
              {
                Matyazo: [
                  "Cyarubambire",
                  "Gataba",
                  "Gitwa",
                  "Kabeza",
                  "Nyagasozi",
                ],
              },
              {
                Munazi: ["Kabadaha", "Kabare", "Kiyoro", "Rwinkindi"],
              },
              {
                Nyagasozi: [
                  "Bandora",
                  "Gasharu",
                  "Gihara",
                  "Gisovu",
                  "Kanombe",
                  "Kibonwa",
                ],
              },
              {
                Rukaragata: [
                  "Bitsibo",
                  "Hanika",
                  "Kamurekezi",
                  "Kivumu",
                  "Rugerero",
                ],
              },
              {
                Rwasare: ["Bahimba", "Kanyinya", "Karucura", "Rubona"],
              },
              {
                Rwigerero: ["Nyamasheke", "Nyanza", "Rwuki", "Ryaruyange"],
              },
            ],
          },
          {
            Nyabinoni: [
              {
                Gashorera: ["Munyinya", "Muzamuzi", "Ndaragati", "Ryakiyange"],
              },
              {
                Masangano: ["Cyanika", "Murambi", "Ngaru"],
              },
              {
                Mbuga: [
                  "Gitaba",
                  "Karengeri",
                  "Munini",
                  "Murama",
                  "Nyarusange",
                ],
              },
              {
                Muvumba: ["Nyamugari", "Nyamure", "Nyanza"],
              },
              {
                Nyarusozi: [
                  "Gitwa",
                  "Kamahoro",
                  "Kanombe",
                  "Kanyamizo",
                  "Mugeni",
                  "Rusenge",
                ],
              },
            ],
          },
          {
            Nyamabuye: [
              {
                Gahogo: [
                  "Gihuma",
                  "Kamazuru",
                  "Kamugina",
                  "Kavumu",
                  "Nyarucyamu I",
                  "Nyarucyamu II",
                  "Nyarucyamu III",
                  "Rutenga",
                  "Ruvumera",
                ],
              },
              {
                Gifumba: [
                  "Gifumba",
                  "Gisiza",
                  "Kirebe",
                  "Rugarama",
                  "Rutarabana",
                  "Samuduha",
                ],
              },
              {
                Gitarama: [
                  "Gatika",
                  "Kagitarama",
                  "Kavumu",
                  "Nyabisindu",
                  "Nyarusiza",
                  "Nyarutovu",
                ],
              },
              {
                Remera: [
                  "Biti",
                  "Gasenyi",
                  "Gasharu",
                  "Kinyenkanda",
                  "Kirenge",
                  "Munini",
                  "Nete",
                  "Nyakabingo",
                ],
              },
            ],
          },
          {
            Nyarusange: [
              {
                Mbiriri: [
                  "Gasave",
                  "Gasharu",
                  "Gisasa",
                  "Karehe",
                  "Kintobo",
                  "Ntenderi",
                  "Nyarushora",
                ],
              },
              {
                Musongati: [
                  "Cyiciro",
                  "Jabiro",
                  "Kagarama",
                  "Kamanga",
                  "Murambi",
                  "Ngororano",
                ],
              },
              {
                Ngaru: ["Gitega", "Kibirizi", "Remera", "Rukamiro"],
              },
              {
                Rusovu: ["Mututu", "Rukurazo", "Rwambariro", "Vugo"],
              },
            ],
          },
          {
            Rongi: [
              {
                Gasagara: [
                  "Fumbwe",
                  "Gasharu",
                  "Kidahwe",
                  "Murehe",
                  "Musenyi",
                  "Nyabugombe",
                ],
              },
              {
                Gasharu: [
                  "Birehe",
                  "Gituza",
                  "Kabirizi",
                  "Kabuga",
                  "Karama",
                  "Nyamiyaga",
                ],
              },
              {
                Karambo: [
                  "Gifurwe",
                  "Gitwa",
                  "Nyabikenke",
                  "Nyagasozi",
                  "Rushenyi",
                ],
              },
              {
                Nyamirambo: [
                  "Gisoro",
                  "Kabakungu",
                  "Karambi",
                  "Masizi",
                  "Mugwato",
                  "Ntarabana",
                  "Rugogwe",
                  "Rwamure",
                ],
              },
              {
                Ruhango: ["Burerabana", "Kondo", "Muyebe", "Rukoma"],
              },
            ],
          },
          {
            Rugendabari: [
              {
                Gasave: [
                  "Gakoma",
                  "Gasharu",
                  "Giturwa",
                  "Nyagasozi",
                  "Nyakibuye",
                  "Nyamatete",
                ],
              },
              {
                Kanyana: ["Gasovu", "Kabuba", "Muheta", "Ntonde"],
              },
              {
                Kibaga: ["Kiduha", "Mataba", "Njamena"],
              },
              {
                Mpinga: ["Buganda", "Gisiza"],
              },
              {
                Nsanga: ["Mpongo", "Ngando", "Nyundo", "Rugwiza", "Twabumbogo"],
              },
            ],
          },
          {
            Shyogwe: [
              {
                Kinini: [
                  "Gatare",
                  "Kabungo",
                  "Kinyami",
                  "Musezero",
                  "Nyakabingo",
                  "Nyakaguhu",
                ],
              },
              {
                Mbare: [
                  "Buriza",
                  "Muremberi",
                  "Nyabisindu",
                  "Rubugurizo",
                  "Rubuye",
                  "Songa",
                  "Vunga",
                ],
              },
              {
                Mubuga: [
                  "Gakomeye",
                  "Gasharu",
                  "Kigarama",
                  "Mapfundo",
                  "Matsinsi",
                  "Nyamaganda",
                  "Nyarucyamu",
                  "Rwamaraba",
                ],
              },
              {
                Ruli: [
                  "Gakombe",
                  "Kabeza",
                  "Karama",
                  "Kavumu",
                  "Munyinya",
                  "Murambi",
                  "Nyagacyamu",
                  "Ruhina",
                ],
              },
            ],
          },
        ],
      },
      {
        Nyamagabe: [
          {
            Buruhukiro: [
              {
                Bushigishigi: [
                  "Bushigishigi",
                  "Giharayumbu",
                  "Mugote",
                  "Rusekera",
                ],
              },
              {
                Byimana: [
                  "Bishyiga",
                  "Buhoro",
                  "Gakangaga",
                  "Gihumo",
                  "Rukeri",
                ],
              },
              {
                Gifurwe: [
                  "Bitaba",
                  "Gifurwe",
                  "Nganzo",
                  "Nyamaberi",
                  "Ruronzi",
                  "Uwankiriye",
                ],
              },
              {
                Kizimyamuriro: [
                  "Gikungu",
                  "Gishwati",
                  "Kagano",
                  "Kinaba",
                  "Minaga",
                  "Mujerenge",
                  "Tantamara",
                  "Uwinzira",
                ],
              },
              {
                Munini: [
                  "Cyinyonza",
                  "Gitovu",
                  "Magumira",
                  "Matsinda",
                  "Munini",
                  "Rukwandu",
                  "Uwinzovu",
                ],
              },
              {
                Rambya: [
                  "Buruhukiro",
                  "Kibuburo",
                  "Mpanga",
                  "Nkamba",
                  "Ruseke",
                ],
              },
            ],
          },
          {
            Cyanika: [
              {
                Gitega: [
                  "Butare",
                  "Gaseke",
                  "Gasharu",
                  "Gitega",
                  "Kigarama",
                  "Miko",
                  "Munyereri",
                  "Musasa",
                  "Rusarasi",
                  "Rwingoma",
                ],
              },
              {
                Karama: [
                  "Birambo",
                  "Karaba",
                  "Karama",
                  "Mugamba",
                  "Munyinya",
                  "Nyamisave",
                  "Nyanza",
                  "Rwamagana",
                ],
              },
              {
                Kiyumba: [
                  "Gatare",
                  "Gatentwe",
                  "Gikomero",
                  "Gishike",
                  "Kagarama",
                  "Kaviri",
                  "Nyarucyamu",
                ],
              },
              {
                Ngoma: [
                  "Kabarera",
                  "Kamuhirwa",
                  "Kavumu",
                  "Kinga",
                  "Murama",
                  "Nyamirambo",
                ],
              },
              {
                Nyanza: [
                  "Buhiga",
                  "Kibingo",
                  "Mirama",
                  "Mugombwa",
                  "Nyabisindu",
                  "Rugaragara",
                ],
              },
              {
                Nyanzoga: [
                  "Bigazi",
                  "Gafuhisha",
                  "Kagarama",
                  "Karuvenya",
                  "Mbeho",
                  "Mugari",
                  "Nyamirama",
                  "Rusenyi",
                ],
              },
            ],
          },
          {
            Gasaka: [
              {
                Kigeme: ["Gakoma", "Gitaba", "Munombe", "Nyentanga"],
              },
              {
                Ngiryi: [
                  "Karambi",
                  "Kibanda",
                  "Kitazigurwa",
                  "Munyege",
                  "Ngiryi",
                  "Sumba",
                ],
              },
              {
                Nyabivumu: ["Dusego", "Gasharu", "Nyabivumu", "Raro"],
              },
              {
                Nyamugari: [
                  "Kabacuzi",
                  "Kabajogo",
                  "Karama",
                  "Kigarama",
                  "Nyamugari",
                  "Nyarusange",
                ],
              },
              {
                Nzega: ["Gasaka", "Gitantu", "Kadoma", "Nzega"],
              },
              {
                Remera: ["Gitwa", "Kabeza", "Murambi", "Muriro", "Nyamifumba"],
              },
            ],
          },
          {
            Gatare: [
              {
                Bakopfu: ["Karambo", "Karumbi", "Muhingo", "Twiya"],
              },
              {
                Gatare: [
                  "Gashasha",
                  "Kiyovu",
                  "Murembo",
                  "Rwamakara",
                  "Uwisuri",
                ],
              },
              {
                Mukongoro: [
                  "Gikungu",
                  "Kagano",
                  "Kageyo",
                  "Nyakabuye",
                  "Rukereko",
                ],
              },
              {
                Ruganda: [
                  "Gasharu",
                  "Gituntu",
                  "Kamamara",
                  "Masangano",
                  "Runaba",
                  "Rwangambibi",
                ],
              },
              {
                Shyeru: ["Baziro", "Bimba", "Kagusa", "Ruhanga", "Rushyarara"],
              },
            ],
          },
          {
            Kaduha: [
              {
                Kavumu: [
                  "Bamba",
                  "Biziguro",
                  "Gahama",
                  "Gataba",
                  "Gitega",
                  "Joma",
                  "Kabuga",
                  "Kamonyi",
                  "Karehe",
                  "Kavumu",
                ],
              },
              {
                Murambi: ["Kasemanyana", "Kibiraro", "Nyaruryango", "Rebero"],
              },
              {
                Musenyi: [
                  "Burengo",
                  "Gasovu",
                  "Gatoki",
                  "Kirwa",
                  "Munini",
                  "Nganzo",
                  "Nyakirambi",
                  "Ruganda",
                ],
              },
              {
                Nyabisindu: [
                  "Gitabage",
                  "Kabaziro",
                  "Kanyege",
                  "Kasemazi",
                  "Kirehe",
                  "Kivumu",
                  "Muduha",
                  "Mukongoro",
                ],
              },
              {
                Nyamiyaga: [
                  "Cyugaro",
                  "Gashiru",
                  "Nkomero",
                  "Nyakabingo",
                  "Ruhuha",
                  "Rukeri",
                ],
              },
            ],
          },
          {
            Kamegeri: [
              {
                Bwama: ["Gitwa", "Kamiro", "Kigarama"],
              },
              {
                Kamegeri: ["Kinyovu", "Ntaruka", "Rweru", "Sovu"],
              },
              {
                Kirehe: ["Gasharu", "Kigarama", "Ryanyirataba"],
              },
              {
                Kizi: ["Gakomeye", "Kagarama", "Kinyana"],
              },
              {
                Nyarusiza: ["Bande", "Nyarusange", "Nyarusiza", "Rutuna"],
              },
              {
                Rususa: ["Bahina", "Baro", "Kigarama", "Muhembe"],
              },
            ],
          },
          {
            Kibirizi: [
              {
                Bugarama: [
                  "Kabarera",
                  "Kamina",
                  "Karandura",
                  "Kivumu",
                  "Munazi",
                  "Nyabusozi",
                ],
              },
              {
                Bugarura: [
                  "Kasebuturanyi",
                  "Kirwa",
                  "Muyange",
                  "Nyakibyeyi",
                  "Uwinyana",
                ],
              },
              {
                Gashiha: [
                  "Gasharu",
                  "Muduha",
                  "Muganza",
                  "Nyabubare",
                  "Rukamiro",
                ],
              },
              {
                Karambo: [
                  "Gisoro",
                  "Gitwa",
                  "Kavumu",
                  "Nyamirama",
                  "Nyirakiraro",
                ],
              },
              {
                Ruhunga: [
                  "Cyamashya",
                  "Gakoma",
                  "Kabuga",
                  "Munombe",
                  "Nyagishubi",
                  "Ruhurura",
                ],
              },
              {
                Uwindekezi: [
                  "Birembo",
                  "Gatovu",
                  "Karumbi",
                  "Kigarama",
                  "Mugote",
                  "Uwamataba",
                ],
              },
            ],
          },
          {
            Kibumbwe: [
              {
                Bwenda: [
                  "Munyinya",
                  "Murambi",
                  "Murwa",
                  "Nyagatovu",
                  "Nyamirama",
                ],
              },
              {
                Gakanka: [
                  "Cyeru",
                  "Gikomero",
                  "Munini",
                  "Nkurubuye",
                  "Nyarubuye",
                  "Rambya",
                ],
              },
              {
                Kibibi: [
                  "Gatandaganya",
                  "Kabere",
                  "Kanyege",
                  "Kirwa",
                  "Rwezamenyo",
                  "Ryingarura",
                ],
              },
              {
                Nyakiza: [
                  "Dusenyi",
                  "Karambo",
                  "Kinyana",
                  "Murambi",
                  "Nyakizu",
                  "Zigati",
                ],
              },
            ],
          },
          {
            Kitabi: [
              {
                Kagano: [
                  "Bususuruke",
                  "Kintobo",
                  "Turonzi",
                  "Uwabumenyi",
                  "Uwarwubatsi",
                  "Uwintyabire",
                ],
              },
              {
                Mujuga: [
                  "Gahande",
                  "Gasasa",
                  "Mujuga",
                  "Mukaka",
                  "Rwufe",
                  "Uwanyakanyeri",
                  "Uwinka",
                ],
              },
              {
                Mukungu: [
                  "Gahira",
                  "Gatare",
                  "Karambi",
                  "Uwicurangiro",
                  "Uwurunazi",
                ],
              },
              {
                Shaba: [
                  "Bitaba",
                  "Gakoko",
                  "Muganza",
                  "Muyange",
                  "Uwakagoro",
                  "Uwinka",
                ],
              },
              {
                Uwingugu: [
                  "Gisarenda",
                  "Kigari",
                  "Rubuye",
                  "Ruhanga",
                  "Uwimisigati",
                  "Uwurunazi",
                ],
              },
            ],
          },
          {
            Mbazi: [
              {
                Manwari: ["Karambi", "Kibumba", "Kigarama", "Muhororo"],
              },
              {
                Mutiwingoma: [
                  "Gatwa",
                  "Kabere",
                  "Kabuga",
                  "Muduha",
                  "Nyamirama",
                ],
              },
              {
                Ngambi: ["Gaseke", "Kabeza", "Kivomo", "Maheresho", "Munanira"],
              },
              {
                Ngara: [
                  "Butare",
                  "Gasharu",
                  "Gisiza",
                  "Gituntu",
                  "Nyagishumbu",
                  "Ruseke",
                ],
              },
            ],
          },
          {
            Mugano: [
              {
                Gitondorero: [
                  "Gakomeye",
                  "Gitondorero",
                  "Gituntu",
                  "Karambi",
                  "Maso",
                ],
              },
              {
                Gitwa: [
                  "Kabuhoro",
                  "Kirenzi I",
                  "Kirenzi II",
                  "Nyakibingo",
                  "Rutabo",
                  "Ryamigabo",
                ],
              },
              {
                Ruhinga: [
                  "Cyibande",
                  "Gitarama",
                  "Kabuye",
                  "Karambi",
                  "Kinzira",
                  "Runyinya",
                ],
              },
              {
                Sovu: [
                  "Kigarama",
                  "Nziranziza",
                  "Rugarama I",
                  "Rugarama II",
                  "Ruhanga",
                ],
              },
              {
                Suti: ["Cyabute", "Gasiza", "Matyazo", "Rwamiko", "Turyango"],
              },
              {
                Yonde: [
                  "Gisovu",
                  "Kanyegenyege",
                  "Nyarusazi",
                  "Ruhamira I",
                  "Ruhamira II",
                ],
              },
            ],
          },
          {
            Musange: [
              {
                Gasave: [
                  "Gasura",
                  "Kabingo",
                  "Murambi",
                  "Nyabivumu",
                  "Nyakabuye",
                ],
              },
              {
                Jenda: [
                  "Cyabagomba",
                  "Kabakannyi",
                  "Kavumu",
                  "Kayogoro",
                  "Nyakibungo",
                  "Nyakirambi",
                ],
              },
              {
                Masagara: [
                  "Cyabasana",
                  "Cyaruvunge",
                  "Gituntu",
                  "Muhororo",
                  "Mutakara",
                  "Mutuntu",
                  "Nyagihima",
                ],
              },
              {
                Masangano: [
                  "Gasagara",
                  "Kibumba",
                  "Mubuga",
                  "Nyakabuye",
                  "Rutuntu",
                ],
              },
              {
                Masizi: ["Karama", "Munini", "Murehe", "Rwankango", "Rwina"],
              },
              {
                Nyagisozi: [
                  "Dusenyi",
                  "Kibaga",
                  "Remera",
                  "Ruhuga",
                  "Uwabarashi",
                ],
              },
            ],
          },
          {
            Musebeya: [
              {
                Gatovu: [
                  "Bisereganya",
                  "Gatovu",
                  "Gitovu",
                  "Kanyiranzoga",
                  "Nyarubande",
                  "Ryanyakayaga",
                ],
              },
              {
                Nyarurambi: [
                  "Cyabwimba",
                  "Cyarwa",
                  "Gatiti",
                  "Giheta",
                  "Kabere",
                  "Mujyejuru",
                  "Nyarurambi",
                  "Rwabigeyo",
                ],
              },
              {
                Rugano: [
                  "Bugarama",
                  "Busanza",
                  "Gisiza",
                  "Kibandirwa",
                  "Rugano",
                  "Rukungu",
                ],
              },
              {
                Runege: [
                  "Bigugu",
                  "Bitaba",
                  "Gacundura",
                  "Gakereko",
                  "Ndogondwe",
                  "Ruganza",
                  "Rukaranka",
                ],
              },
              {
                Rusekera: ["Karambo", "Ngoma", "Rebero", "Shaki", "Uwimituza"],
              },
              {
                Sekera: [
                  "Masinde",
                  "Mugano",
                  "Nkomero",
                  "Nyaruhura",
                  "Rubumburi",
                  "Rugazi",
                ],
              },
            ],
          },
          {
            Mushubi: [
              {
                Buteteri: [
                  "Gorwe",
                  "Kagorwe",
                  "Kizanganya",
                  "Mugunda",
                  "Murambi",
                  "Ngoma",
                  "Nyakibande",
                  "Remera",
                  "Rusoyo",
                  "Rwamiko",
                ],
              },
              {
                Cyobe: [
                  "Cyobe",
                  "Gaseke",
                  "Gitikirema",
                  "Nyagisumo",
                  "Nyakabingo",
                  "Nyakirambi",
                  "Nyarushike",
                  "Rutoyi",
                ],
              },
              {
                Gashwati: [
                  "Bweramana",
                  "Gashwati",
                  "Muhembe",
                  "Muko",
                  "Mushubi",
                  "Rucunda",
                  "Ruhinga",
                ],
              },
            ],
          },
          {
            Nkomane: [
              {
                Bitandara: [
                  "Bitandara",
                  "Buhanzi",
                  "Munanira",
                  "Muyange",
                  "Rugeyo",
                ],
              },
              {
                Musaraba: [
                  "Gatorove",
                  "Gihunga",
                  "Kimbogo",
                  "Musaraba",
                  "Rusoyo",
                  "Rutare",
                  "Rwimpiri",
                ],
              },
              {
                Mutengeri: [
                  "Cyurwufe",
                  "Gihwahwa",
                  "Kavumu",
                  "Kivumu",
                  "Mutengeri",
                  "Tubuye",
                ],
              },
              {
                Nkomane: ["Banda", "Kagano", "Mugari", "Mutarama", "Ruhinga"],
              },
              {
                Nyarwungo: [
                  "Bisharara",
                  "Bucyero",
                  "Marambo",
                  "Nyaruhombo",
                  "Nyarwungo",
                  "Rangi",
                  "Rutoyi",
                ],
              },
              {
                Twiya: ["Gakomeye", "Gishenge", "Karukoma", "Kibuga", "Twiya"],
              },
            ],
          },
          {
            Tare: [
              {
                Buhoro: [
                  "Gisanze",
                  "Gitovu",
                  "Kanserege",
                  "Kirwa",
                  "Nyabwoma",
                  "Rwufe",
                  "Ryarubondo",
                ],
              },
              {
                Gasarenda: [
                  "Kagarama",
                  "Kiminazi",
                  "Kivuruga",
                  "Murangara",
                  "Muse",
                  "Mwufe",
                  "Uwinkomo",
                ],
              },
              {
                Gatovu: ["Gasenge", "Kigusa", "Kimina", "Muhati", "Ruziba"],
              },
              {
                Kaganza: [
                  "Akanyirandori",
                  "Bivumu",
                  "Buremera",
                  "Cyimicanga",
                  "Ruganza",
                ],
              },
              {
                Nkumbure: [
                  "Biraro",
                  "Bireka",
                  "Gahembe",
                  "Kibwije",
                  "Mubezi",
                  "Muhumo",
                  "Rugeti",
                  "Rukereko",
                  "Uwumugeti",
                  "Vumwe",
                ],
              },
              {
                Nyamigina: [
                  "Gakoma",
                  "Maryohe",
                  "Ngororero",
                  "Nkomero",
                  "Nyarugeti",
                  "Rukoko",
                  "Uwinyana",
                ],
              },
            ],
          },
          {
            Uwinkingi: [
              {
                Bigumira: ["Bigumira", "Cyumuganza", "Gakoko", "Magumira"],
              },
              {
                Gahira: [
                  "Bunyunyu",
                  "Gahira",
                  "Gititi",
                  "Kibugazi",
                  "Kunyu",
                  "Rugeyo",
                  "Uwinkingi",
                ],
              },
              {
                Kibyagira: [
                  "Bishya",
                  "Cyumuganza",
                  "Kabuga",
                  "Kabusekuru",
                  "Kagano",
                  "Sabake",
                  "Sekera",
                ],
              },
              {
                Mudasomwa: [
                  "Gicaca",
                  "Karambo",
                  "Nsinduka",
                  "Rushubi",
                  "Uwanjyogoro",
                ],
              },
              {
                Munyege: [
                  "Bitaba",
                  "Gahango",
                  "Kanyampongo",
                  "Kimina",
                  "Munyege",
                  "Nyarurambi",
                ],
              },
              {
                Rugogwe: [
                  "Mabende",
                  "Munini",
                  "Mwishogwe",
                  "Nyamugari",
                  "Rugeti",
                  "Subukiniro",
                ],
              },
            ],
          },
        ],
      },
      {
        Nyanza: [
          {
            Busasamana: [
              {
                Gahondo: [
                  "Bigega",
                  "Bugura",
                  "Kamatovu",
                  "Karama",
                  "Kavumu",
                  "Kibaga",
                  "Kiberinka",
                  "Nyakwibereka",
                  "Nyarutovu",
                ],
              },
              {
                Kavumu: [
                  "Akirabo",
                  "Gihisi A",
                  "Gihisi B",
                  "Karukoranya A",
                  "Karukoranya B",
                  "Majyambere",
                  "Mugandamure A",
                  "Mugandamure B",
                  "Mukoni",
                  "Nyagatovu",
                  "Nyamagana B",
                  "Rukandiro",
                  "Ruvumera",
                  "Kavumu",
                  "Nyamagana A",
                ],
              },
              {
                Kibinja: [
                  "Kabuzuru",
                  "Kigarama",
                  "Mukindo",
                  "Ngorongari",
                  "Rebero",
                  "Rugarama",
                  "Rugari A",
                  "Rugari B",
                ],
              },
              {
                Nyanza: [
                  "Bunyeshywa",
                  "Gakenyeri A",
                  "Gakenyeri B",
                  "Gatare",
                  "Gatsinsino",
                  "Gatunguru",
                  "Gishike",
                  "Kavumu",
                  "Kigarama",
                  "Kivumu",
                  "Mugonzi",
                  "Nyanza",
                  "Nyarunyinya",
                  "Rubona",
                ],
              },
              {
                Rwesero: [
                  "Bukinankwavu",
                  "Gahanda",
                  "Gisando",
                  "Kabona",
                  "Kidaturwa",
                  "Murambi",
                  "Mwima",
                  "Nyabisindu",
                  "Rugarama",
                  "Rukari",
                  "Rwesero",
                  "Taba",
                ],
              },
            ],
          },
          {
            Busoro: [
              {
                Gitovu: [
                  "Gitega",
                  "Kabeza",
                  "Kayenzi",
                  "Muhindo",
                  "Musumba",
                  "Nazareti",
                  "Nyacyonga",
                  "Nyagasambu",
                  "Rushoka",
                ],
              },
              {
                Kimirama: [
                  "Gitwa",
                  "Kimirama",
                  "Kireranyana",
                  "Ndamira",
                  "Nyamiyonga",
                  "Nyarugenge",
                  "Rugarama",
                ],
              },
              {
                Masangano: [
                  "Busoro",
                  "Bweramana",
                  "Gikombe",
                  "Masangano",
                  "Murambi",
                  "Nyarugunga",
                  "Runyonza",
                  "Shinga",
                ],
              },
              {
                Munyinya: [
                  "Kagarama",
                  "Karambi",
                  "Kigali",
                  "Kivugiza",
                  "Rwara",
                ],
              },
              {
                Rukingiro: [
                  "Cyamugani",
                  "Cyuriro",
                  "Gasambu",
                  "Runazi",
                  "Rwanamiza",
                  "Rwangoga",
                ],
              },
              {
                Shyira: [
                  "Gahogo",
                  "Kinkanga",
                  "Nyamoyaga",
                  "Rucyamo",
                  "Rusharu",
                  "Saruduha",
                ],
              },
            ],
          },
          {
            Cyabakamyi: [
              {
                Kadaho: [
                  "Gahengeri",
                  "Gasenyi",
                  "Gataba",
                  "Gitega",
                  "Kabere",
                  "Kabeza",
                  "Kadaho",
                  "Nyabisazi",
                  "Nyabyiyoni",
                ],
              },
              {
                Karama: [
                  "Butembo",
                  "Cyarera",
                  "Gahondo",
                  "Gatongati",
                  "Kamabuye",
                  "Kamonyi",
                  "Karama",
                  "Nyabinombe",
                ],
              },
              {
                Nyabinyenga: [
                  "Kabuga",
                  "Kandihe",
                  "Karehe",
                  "Kimiyumbu",
                  "Nyabinyenga",
                  "Rugwa",
                  "Rwamagana",
                  "Taba",
                ],
              },
              {
                Nyarurama: [
                  "Kabyuma",
                  "Kigarama",
                  "Kirombozi",
                  "Nyakabingo",
                  "Rugote",
                  "Ruvuzo",
                  "Rwabatwa",
                  "Rwamiko",
                ],
              },
              {
                Rubona: [
                  "Bikombe",
                  "Bugarama",
                  "Gahunga",
                  "Karambo",
                  "Kavumu",
                  "Murambi",
                  "Nyabishike",
                  "Nyaminazi",
                  "Nyarutovu",
                  "Rugendabari",
                ],
              },
            ],
          },
          {
            Kibilizi: [
              {
                Cyeru: [
                  "Gasagara",
                  "Gisika",
                  "Kamatamu",
                  "Karama",
                  "Matara",
                  "Muyebe",
                  "Nyamunini",
                  "Rutete",
                ],
              },
              {
                Mbuye: [
                  "Binyana",
                  "Gako",
                  "Gihama",
                  "Karambi",
                  "Karehe",
                  "Kigarama",
                  "Mukoni",
                  "Rukore",
                ],
              },
              {
                Mututu: [
                  "Gatongati",
                  "Gicumbi",
                  "Kabeza",
                  "Kanyinya",
                  "Kivugiza",
                  "Masangano",
                ],
              },
              {
                Rwotso: [
                  "Bigarama",
                  "Kabuga",
                  "Kibilizi",
                  "Mubano",
                  "Mubuga",
                  "Mutima",
                  "Nyarurama",
                  "Runyonza",
                  "Rusagara",
                  "Saruhembe",
                ],
              },
            ],
          },
          {
            Kigoma: [
              {
                Butansinda: [
                  "Butatsinda",
                  "Gitare",
                  "Shusho",
                  "Karama",
                  "Karambo",
                  "Kayange",
                  "Kibaza",
                  "Kigoma",
                  "Marongi",
                  "Mataba",
                  "Nyesonga",
                ],
              },
              {
                Butara: [
                  "Buruba",
                  "Butara",
                  "Gasharu",
                  "Kavumu",
                  "Kigufi",
                  "Kirundo",
                  "Nyabusheshe",
                  "Runyinya",
                ],
              },
              {
                Gahombo: [
                  "Birembo",
                  "Cyingina",
                  "Gashikiri",
                  "Gicunshu",
                  "Gisore",
                  "Karugando",
                  "Kaziba",
                  "Kirerabana",
                  "Nyagacyamo",
                  "Rugarama",
                  "Serivise",
                ],
              },
              {
                Gasoro: [
                  "Bugarura",
                  "Bwambika",
                  "Gisoro",
                  "Giturwa",
                  "Kabacuzi",
                  "Kajevuba",
                  "Kinene",
                  "Mutende",
                  "Nyabubare",
                  "Nyakabungo",
                  "Runyanzige",
                  "Sholi",
                ],
              },
              {
                Mulinja: [
                  "Akana Ka Mulinja",
                  "Akintare",
                  "Buharankakara",
                  "Buhoro",
                  "Burambi",
                  "Karama",
                  "Kigarama",
                  "Muramba",
                  "Nyarukurazo",
                  "Sabununga",
                ],
              },
            ],
          },
          {
            Mukingo: [
              {
                Cyerezo: [
                  "Birambo",
                  "Bweramana",
                  "Cyerezo",
                  "Cyikirehe",
                  "Cyumba",
                  "Gasharu",
                  "Kamabuye",
                  "Karambi",
                  "Nyarutovu",
                ],
              },
              {
                Gatagara: [
                  "Cyahafi",
                  "Gatagara",
                  "Kamushatsi",
                  "Karama",
                  "Karuhwanya",
                  "Kinyogoto",
                  "Muhororo",
                  "Nyamiyaga",
                  "Nyamuko",
                ],
              },
              {
                Kiruli: [
                  "Gahoko",
                  "Kaganza",
                  "Kiganda",
                  "Kigarama",
                  "Masambu",
                  "Muganza",
                  "Murehe",
                  "Muturirwa",
                  "Nkiko",
                  "Nyabishinge",
                  "Nyankunamirwa",
                ],
              },
              {
                Mpanga: [
                  "Birembo",
                  "Karambi",
                  "Kinyinya",
                  "Mataba",
                  "Nkinda",
                  "Nyakabuye",
                  "Nyamazi",
                  "Remera",
                ],
              },
              {
                Ngwa: [
                  "Bikire",
                  "Biroro",
                  "Gasiza",
                  "Kagwa A",
                  "Karambi A",
                  "Karenge",
                  "Kidaturwa",
                  "Kigarama",
                  "Mwanabiri",
                  "Nyarunyinya A",
                  "Rutete",
                ],
              },
              {
                Nkomero: [
                  "Cyimana",
                  "Gisuma",
                  "Kabarima",
                  "Kibonde",
                  "Kigarama",
                  "Nyacyoma",
                  "Nyakabungo",
                  "Nyankokoma",
                  "Nzuki",
                  "Ruhosha",
                ],
              },
            ],
          },
          {
            Muyira: [
              {
                Gati: ["Buhaza", "Kimfizi", "Kinyoni", "Ruyenzi", "Rwabihanga"],
              },
              {
                Migina: ["Bugina", "Kalilisi", "Kavumu", "Kinyana", "Musenyi"],
              },
              {
                Nyamiyaga: ["Gihama", "Kabuye", "Kiniga", "Nzovi", "Rugese"],
              },
              {
                Nyamure: [
                  "Cyegera",
                  "Gatare",
                  "Gituza",
                  "Kanyundo",
                  "Nyarugunga",
                ],
              },
              {
                Nyundo: ["Jari", "Nyundo", "Mugari", "Muyira", "Nzoga"],
              },
            ],
          },
          {
            Ntyazo: [
              {
                Bugali: [
                  "Gakindo",
                  "Gisayura",
                  "Kabusheja",
                  "Kiruhura",
                  "Marabage",
                  "Ndago",
                  "Nkomane",
                  "Nyabitare",
                  "Rugarama",
                ],
              },
              {
                Cyotamakara: [
                  "Bayi",
                  "Kankima",
                  "Karuyumbo",
                  "Misasa",
                  "Mpande",
                  "Nyabigugu",
                  "Nyarutovu",
                  "Ruyenzi",
                  "Rwimpundu",
                ],
              },
              {
                Kagunga: [
                  "Bukinanyana",
                  "Kamabuye",
                  "Kimigunga",
                  "Ntebe",
                  "Nyakabungo",
                  "Nyamirama",
                  "Nyamirambo",
                  "Nyamizi",
                  "Nyarubuye",
                  "Rusasa",
                  "Samuduha",
                ],
              },
              {
                Katarara: [
                  "Gasharu",
                  "Kagarama",
                  "Kamabuye",
                  "Muhero",
                  "Munyiginya",
                  "Muyenzi",
                  "Nkombe",
                  "Rebero",
                  "Rukoma",
                  "Rusebeya",
                ],
              },
            ],
          },
          {
            Nyagisozi: [
              {
                Gahunga: [
                  "Gatare",
                  "Gihara",
                  "Gituntu",
                  "Kagarama",
                  "Kigohe",
                  "Mweya",
                  "Nyamugari",
                  "Uwarukara",
                ],
              },
              {
                Kabirizi: [
                  "Cyahafi",
                  "Gihimbi",
                  "Kabuye",
                  "Muhaga",
                  "Nyagatovu",
                  "Nyamabuye",
                  "Nyaruvumu",
                ],
              },
              {
                Kabuga: [
                  "Gatoki",
                  "Mirehe",
                  "Murandaryi",
                  "Mwokora",
                  "Nyamitobo",
                  "Uwabushingwe",
                  "Uwagisozi",
                  "Uwimpura",
                ],
              },
              {
                Kirambi: [
                  "Busenyeye",
                  "Bweru",
                  "Gasharu",
                  "Gasiza",
                  "Jarama",
                  "Mpaza",
                  "Murende",
                  "Mwezi",
                  "Rwankuba",
                  "Rwimbazi",
                ],
              },
              {
                Rurangazi: [
                  "Gashyenzi",
                  "Kami",
                  "Kigarama",
                  "Musongati",
                  "Nyamagana",
                  "Nyarutovu",
                  "Nyaruvumu",
                  "Rugarama",
                ],
              },
            ],
          },
          {
            Rwabicuma: [
              {
                Gacu: ["Bisambu", "Gisake", "Karehe", "Nyamiyaga"],
              },
              {
                Gishike: [
                  "Gakoni",
                  "Gasiza A",
                  "Gasiza B",
                  "Karambo A",
                  "Karambo B",
                  "Karusimbi",
                  "Rwamushumba",
                ],
              },
              {
                Mubuga: ["Kabisine", "Kadusenyi", "Karwiru", "Nyamiseke"],
              },
              {
                Mushirarungu: [
                  "Kirwa",
                  "Nyabubare",
                  "Nyamivumu A",
                  "Nyamuvumu B",
                ],
              },
              {
                Nyarusange: [
                  "Cyarwa",
                  "Kamushi",
                  "Kamuvunyi A",
                  "Kamuvunyi B",
                  "Karambi",
                  "Kavumu A",
                  "Kavumu B",
                ],
              },
              {
                Runga: [
                  "Kigarama",
                  "Murambi",
                  "Ndago",
                  "Rugarama A",
                  "Rugarama B",
                ],
              },
            ],
          },
        ],
      },
      {
        Nyaruguru: [
          {
            Busanze: [
              {
                Kirarangombe: [
                  "Bukinanyana",
                  "Gisenyi",
                  "Gitwe",
                  "Kinyinya",
                  "Masiga",
                  "Uwindava",
                ],
              },
              {
                Nkanda: [
                  "Bitare",
                  "Mutarama",
                  "Mutobo",
                  "Nkanda",
                  "Uwamakumba",
                ],
              },
              {
                Nteko: [
                  "Gisoro",
                  "Kabavomo",
                  "Ndatemwa",
                  "Nteko",
                  "Nyarukeri",
                  "Nyarusange",
                ],
              },
              {
                Runyombyi: [
                  "Bugina",
                  "Gabiro",
                  "Musebeya",
                  "Rango",
                  "Ryabusagara",
                  "Shwima",
                ],
              },
              {
                Shororo: [
                  "Bukinga",
                  "Mirindi",
                  "Murambi",
                  "Runyami",
                  "Rutabo",
                  "Uwinteko",
                ],
              },
            ],
          },
          {
            Cyahinda: [
              {
                Coko: ["Agasharu", "Coko", "Gitara", "Ruko"],
              },
              {
                Cyahinda: [
                  "Cyahinda",
                  "Cyanwa",
                  "Kinyaga",
                  "Saburunduru",
                  "Rutega",
                ],
              },
              {
                Gasasa: ["Gasasa", "Kavumu", "Mugari", "Ryamarembo"],
              },
              {
                Muhambara: [
                  "Busanza",
                  "Byanone",
                  "Gasharu",
                  "Kubitiro",
                  "Nyagatovu",
                  "Rebero",
                ],
              },
              {
                Rutobwe: [
                  "Kanyinya",
                  "Kibumba",
                  "Ngobyi",
                  "Rubona",
                  "Rugarama",
                  "Rutobwe",
                ],
              },
            ],
          },
          {
            Kibeho: [
              {
                Gakoma: ["Nyagishayo", "Rurembo", "Viro"],
              },
              {
                Kibeho: ["Agateko", "Akajonge", "Sinayi"],
              },
              {
                Mbasa: ["Kinazi", "Migina", "Rwimbogo"],
              },
              {
                Mpanda: ["Banga", "Kibayi", "Mpanda", "Munege"],
              },
              {
                Mubuga: [
                  "Mubuga",
                  "Nyarusovu",
                  "Nyarwumba",
                  "Umurambi",
                  "Uwintobo",
                ],
              },
              {
                Nyange: ["Agateko", "Kigona", "Mpatswe", "Nkomero"],
              },
            ],
          },
          {
            Kivu: [
              {
                Cyanyirankora: [
                  "Businde",
                  "Cyanyirankora",
                  "Gakuta",
                  "Ruganza",
                ],
              },
              {
                Gahurizo: ["Gasezo", "Kintama", "Kintare", "Uwamizirikano"],
              },
              {
                Kimina: ["Kabeza", "Kabingo", "Kimina", "Uwisaga"],
              },
              {
                Kivu: ["Kavumu", "Kivu", "Murambi", "Rubumburi", "Rusuzumiro"],
              },
              {
                Rugerero: ["Kivumu", "Misundwe", "Nyarwotsi", "Rugerero"],
              },
            ],
          },
          {
            Mata: [
              {
                Gorwe: ["Mataba", "Rimbanya", "Ruhunga"],
              },
              {
                Murambi: ["Mata", "Murambi", "Nyamyumba", "Runono"],
              },
              {
                Nyamabuye: ["Nyacyondo", "Rwinanka", "Tububuru"],
              },
              {
                Ramba: ["Cyafurwe", "Gasasa", "Ramba"],
              },
              {
                Rwamiko: ["Matyazo", "Rwamiko", "Taba"],
              },
            ],
          },
          {
            Muganza: [
              {
                Muganza: [
                  "Gashinge",
                  "Mubazi",
                  "Muganza",
                  "Ngara",
                  "Nyabirondo",
                  "Rambyanyana",
                ],
              },
              {
                Rukore: [
                  "Kanazi",
                  "Karanka",
                  "Nyagisenyi",
                  "Remera",
                  "Rwishywa",
                  "Uwinzira",
                ],
              },
              {
                Samiyonga: [
                  "Bigugu",
                  "Cyurukore",
                  "Gituntu",
                  "Kigwene",
                  "Mazimeru",
                  "Murambi",
                  "Tangabo",
                ],
              },
              {
                Uwacyiza: [
                  "Bitaba",
                  "Migendo",
                  "Mukongoro",
                  "Murambya",
                  "Mutovu",
                  "Sekera",
                ],
              },
            ],
          },
          {
            Munini: [
              {
                Giheta: ["Gacumu", "Gahango", "Gasare", "Giheta", "Mashya"],
              },
              {
                Ngarurira: [
                  "Agatare",
                  "Akarehe",
                  "Gisizi",
                  "Gitega",
                  "Uwumuko",
                ],
              },
              {
                Ngeri: [
                  "Akagera",
                  "Mushwati",
                  "Ndago",
                  "Rubona",
                  "Ruseke",
                  "Rushubi",
                ],
              },
              {
                Ntwali: [
                  "Kabirizi",
                  "Ntwari",
                  "Nyambaragasa",
                  "Rwinanka",
                  "Umurambi",
                ],
              },
              {
                Nyarure: [
                  "Kamana",
                  "Kimena",
                  "Muhororo",
                  "Munanira",
                  "Nyarure",
                  "Sheke",
                ],
              },
            ],
          },
          {
            Ngera: [
              {
                Bitare: ["Bitare", "Gashiru", "Sheke"],
              },
              {
                Mukuge: ["Cyamutumba", "Cyaratsi", "Mukuge"],
              },
              {
                Murama: ["Kaganda", "Mbogo", "Nyarugano", "Runyami"],
              },
              {
                Nyamirama: ["Kinteko", "Mubuga", "Nyamirama"],
              },
              {
                Nyanza: ["Gisozi", "Kibingo", "Mpinga", "Nyanza"],
              },
              {
                Yaramba: ["Buhunga", "Kirwa", "Musumba", "Yaramba"],
              },
            ],
          },
          {
            Ngoma: [
              {
                Fugi: [
                  "Akanyaru",
                  "Gasha",
                  "Mutakwa",
                  "Nteko",
                  "Ruli",
                  "Urugeyo",
                ],
              },
              {
                Kibangu: ["Gituramigina", "Kirehe", "Kiriro", "Nyarukeri"],
              },
              {
                Kiyonza: [
                  "Akagano",
                  "Gacumbi",
                  "Maraba",
                  "Munini",
                  "Mwumba",
                  "Nyagahinga",
                ],
              },
              {
                Mbuye: [
                  "Gihishabwenge",
                  "Kigarama",
                  "Mugobe",
                  "Mujahu",
                  "Ururambo",
                ],
              },
              {
                Nyamirama: [
                  "Akabuye",
                  "Bihembe",
                  "Nyagasozi",
                  "Rushubi",
                  "Ryakanyamiganda",
                ],
              },
              {
                Rubona: [
                  "Agasaka",
                  "Agatovu",
                  "Akarambo",
                  "Nyamirama",
                  "Ryarugarama",
                  "Shyoko",
                ],
              },
            ],
          },
          {
            Nyabimata: [
              {
                Gihemvu: ["Bihembe", "Bugina", "Gihemvu", "Rugarama"],
              },
              {
                Kabere: ["Kabere", "Nyarunazi", "Uwurusugi"],
              },
              {
                Mishungero: [
                  "Mishungero",
                  "Muyira",
                  "Ngarama",
                  "Rubindi",
                  "Uwaruhigi",
                ],
              },
              {
                Nyabimata: ["Murambi", "Mutobwe", "Nyabimata", "Rwerere"],
              },
              {
                Ruhinga: ["Agasugi", "Cyumuzi", "Ndaro", "Ruhinga"],
              },
            ],
          },
          {
            Nyagisozi: [
              {
                Maraba: ["Bugarama", "Maraba", "Nkima", "Rushunguriro"],
              },
              {
                Mwoya: [
                  "Agatovu",
                  "Bwerankori",
                  "Muhombo",
                  "Mwoya",
                  "Nkomero",
                  "Nyagashubi",
                ],
              },
              {
                Nkakwa: [
                  "Bihembe",
                  "Kaduha",
                  "Nkakwa",
                  "Nyarubuye",
                  "Rarire",
                  "Rubuga",
                ],
              },
              {
                Nyagisozi: [
                  "Muriza",
                  "Nyagishayo",
                  "Nyamiyaga",
                  "Ryabidandi",
                  "Uwimfizi",
                ],
              },
            ],
          },
          {
            Ruheru: [
              {
                Gitita: [
                  "Gahotora",
                  "Kibyibushye",
                  "Nyacyonga",
                  "Ruganza",
                  "Rusagara",
                  "Ryanyaruja",
                ],
              },
              {
                Kabere: [
                  "Busenyi",
                  "Gambiriro",
                  "Mukaka",
                  "Murambi",
                  "Nshenyi",
                  "Uwigisura",
                ],
              },
              {
                Remera: ["Cyivugiza", "Gitwa", "Kirwa", "Mutumba", "Uwinyana"],
              },
              {
                Ruyenzi: [
                  "Rukarakara",
                  "Ruvuru",
                  "Ruyenzi",
                  "Tambananga",
                  "Zirambi",
                ],
              },
              {
                Uwumusebeya: [
                  "Gakaranka",
                  "Mubuga",
                  "Rugote",
                  "Uwimbogo",
                  "Yanza",
                ],
              },
            ],
          },
          {
            Ruramba: [
              {
                Gabiro: [
                  "Bukoro",
                  "Kageyo",
                  "Kansi",
                  "Nyamirambo",
                  "Ryamuhumbi",
                ],
              },
              {
                Giseke: ["Giseke", "Kabari", "Kidogo", "Matyazo", "Tugogo"],
              },
              {
                Nyarugano: ["Gisorora", "Kinyonyo", "Nyarugano", "Uruyange"],
              },
              {
                Rugogwe: ["Rugogwe", "Rugusa", "Titi"],
              },
              {
                Ruramba: ["Bugizi", "Busasamana", "Karambi", "Ruramba"],
              },
            ],
          },
          {
            Rusenge: [
              {
                Bunge: ["Bunge", "Jali", "Nyanzoga", "Toraniro"],
              },
              {
                Cyuna: ["Cyuna", "Kiramutse", "Remera", "Uwamuhizi"],
              },
              {
                Gikunzi: ["Jali", "Kibu", "Munanira", "Rwabujagi"],
              },
              {
                Mariba: ["Gihango", "Kabuye", "Miko", "Rasaniro"],
              },
              {
                Raranzige: [
                  "Akabacura",
                  "Gasave",
                  "Karimba",
                  "Ntanda",
                  "Nyamugari",
                ],
              },
              {
                Rusenge: ["Kabacuzi", "Kamusindi", "Kavumu", "Runyinya"],
              },
            ],
          },
        ],
      },
      {
        Ruhango: [
          {
            Bweramana: [
              {
                Buhanda: [
                  "Bugufi",
                  "Gakongoro",
                  "Gikarabiro",
                  "Kabere",
                  "Kamatungo",
                  "Kavumu",
                  "Mpunu",
                  "Munini",
                  "Nyakidahe",
                  "Nyarubuye",
                  "Rutarabana",
                ],
              },
              {
                Gitisi: [
                  "Kabugusu",
                  "Nyamaraba",
                  "Nyarugenge",
                  "Nyarunyinya",
                  "Ruvugizo",
                ],
              },
              {
                Murama: [
                  "Duwane",
                  "Gasharu",
                  "Gisagara",
                  "Kamirishyo",
                  "Karambo",
                  "Karima",
                  "Karutsindo",
                  "Kigarama",
                  "Kivomo",
                  "Rusororo",
                  "Rwavuningoma",
                  "Rwingwe",
                ],
              },
              {
                Rubona: [
                  "Birambo",
                  "Bugari",
                  "Gasharu",
                  "Kabega",
                  "Kirambo",
                  "Masambu",
                  "Mataba",
                  "Munyinya",
                  "Ntosho",
                  "Nyagasozi",
                  "Nyakabanda",
                  "Nyamuko",
                  "Rugogwe",
                ],
              },
              {
                Rwinyana: [
                  "Karambi",
                  "Kumunyinya",
                  "Mubuga",
                  "Mukingi",
                  "Nyagakombe",
                  "Nyagitongwe",
                  "Nyarubuye",
                  "Nyarutovu",
                  "Rugarama",
                  "Rugogwe",
                  "Rwinyana",
                  "Samba",
                ],
              },
            ],
          },
          {
            Byimana: [
              {
                Kamusenyi: [
                  "Gahama",
                  "Gakomeye",
                  "Gakurazo",
                  "Gasharu",
                  "Gasiza",
                  "Gitanga",
                  "Kabusheshe",
                  "Kinama",
                  "Mayebe",
                  "Nyakabungo",
                  "Nyarusange",
                  "Rugerero",
                ],
              },
              {
                Kirengeri: [
                  "Gahengeri",
                  "Gatoki",
                  "Kamonyi",
                  "Kirengeri",
                  "Masaka",
                  "Nyabizenga",
                  "Nyamirambo",
                  "Rusororo",
                ],
              },
              {
                Mahembe: [
                  "Akabere",
                  "Kavumu",
                  "Muhororo",
                  "Mujyejuru",
                  "Mutobo",
                  "Nyabisindu",
                  "Nyagisozi",
                ],
              },
              {
                Mpanda: [
                  "Bisika",
                  "Gatwa",
                  "Gitega",
                  "Kanyarira",
                  "Karenge",
                  "Kibande",
                  "Mpanda",
                  "Nyaburondwe",
                  "Nyagahinga",
                ],
              },
              {
                Muhororo: [
                  "Bukomero",
                  "Karama",
                  "Karenge",
                  "Kigarama",
                  "Mbuye",
                  "Nyamiseke",
                  "Nyarunyinya",
                  "Remera",
                  "Rukuro",
                  "Rutembo",
                ],
              },
              {
                Ntenyo: [
                  "Bugarura",
                  "Gihinga",
                  "Kageyo",
                  "Kamurenzi",
                  "Kavumu",
                  "Mucubi",
                  "Ngando",
                  "Ntenyo",
                  "Nyabisindu",
                  "Rukiriza",
                ],
              },
              {
                Nyakabuye: [
                  "Gasasa",
                  "Gatobotobo",
                  "Kizibaziba",
                  "Muhororo",
                  "Ndago",
                  "Nyarubumbiro",
                  "Nyarutovu",
                ],
              },
            ],
          },
          {
            Kabagali: [
              {
                Bihembe: [
                  "Bihembe",
                  "Bwama",
                  "Kanyinya",
                  "Kirwa",
                  "Misambagiro",
                  "Nyagatovu",
                  "Rusisiro",
                ],
              },
              {
                Karambi: [
                  "Bugaramantare",
                  "Karambi",
                  "Karurara",
                  "Kashyamba",
                  "Mbuye",
                  "Muhoza",
                  "Rambyanyana",
                ],
              },
              {
                Munanira: [
                  "Byimana",
                  "Kagitare",
                  "Kavumu",
                  "Munanira",
                  "Muremera",
                  "Musekera",
                  "Nyabyunyu",
                  "Remera",
                  "Ruyogoro",
                ],
              },
              {
                Remera: [
                  "Birambo",
                  "Kabacuzi",
                  "Kamuhirwa",
                  "Muhororo",
                  "Nyarusange",
                  "Ruhare",
                  "Rwankuba",
                ],
              },
              {
                Rwesero: [
                  "Bugaramantare",
                  "Mayebe",
                  "Nyabivumu",
                  "Remera",
                  "Rwesero",
                  "Serugeme",
                ],
              },
              {
                Rwoga: [
                  "Cyunyu",
                  "Gasharu",
                  "Gitwa",
                  "Kabakamba",
                  "Kanyinya",
                  "Kavumu",
                  "Kiyanja",
                  "Nyabitare",
                  "Nyagisenyi",
                  "Nyarushishi",
                  "Rusebeya",
                ],
              },
            ],
          },
          {
            Kinazi: [
              {
                Burima: [
                  "Burima",
                  "Mirambi",
                  "Nyagahama",
                  "Nyamiyaga",
                  "Nyarugenge",
                  "Nyaruteja",
                ],
              },
              {
                Gisali: [
                  "Gisari",
                  "Kabeza",
                  "Kaduha",
                  "Kakirenzi",
                  "Kamuraza",
                  "Kanaba",
                  "Kibanda",
                  "Matara",
                  "Nyabusunzu",
                  "Nyiranduga",
                  "Remera",
                ],
              },
              {
                Kinazi: [
                  "Gasiza",
                  "Impara",
                  "Kabuga",
                  "Kacyiru",
                  "Kamabuye",
                  "Karama",
                  "Kareshya",
                  "Karuhuga",
                  "Marche -commun",
                  "Mpemba",
                  "Nyabinyenga",
                  "Nyabisindu",
                  "Nyiraruhinga",
                  "Rebero",
                  "Ruhuha",
                ],
              },
              {
                Rubona: [
                  "Buhanika",
                  "Gafumba",
                  "Gako",
                  "Gashike",
                  "Kagazi",
                  "Kigarama",
                  "Rubona",
                  "Susa",
                ],
              },
              {
                Rutabo: [
                  "Bugiranteko",
                  "Gatonde",
                  "Gitwa",
                  "Kanka",
                  "Mukoma",
                  "Nyarugunga",
                  "Nyarunazi",
                  "Nyirarubayi",
                  "Runzenze",
                  "Rutabo",
                ],
              },
            ],
          },
          {
            Kinihira: [
              {
                Bweramvura: [
                  "Bugarura",
                  "Gahororo",
                  "Gihororo",
                  "Kabadende",
                  "Nyabivumu",
                  "Nyagisenyi",
                ],
              },
              {
                Gitinda: [
                  "Kabasanzu",
                  "Muremure",
                  "Nyagatovu",
                  "Nyamagana",
                  "Nyarugunga",
                  "Nyarusange",
                  "Remera",
                  "Rubona",
                  "Rugarama",
                ],
              },
              {
                Kirwa: [
                  "Gasharu",
                  "Kabareshya",
                  "Muyange",
                  "Nyarubuye",
                  "Rukeri",
                  "Sunzu",
                  "Wimana",
                ],
              },
              {
                Muyunzwe: [
                  "Gasiza",
                  "Muyunzwe",
                  "Nyamirambo",
                  "Nyarubumbiro",
                  "Nyarutovu",
                  "Ruhuha",
                ],
              },
              {
                Nyakogo: [
                  "Buhanda",
                  "Bweramana",
                  "Gashirabwoba",
                  "Kibirizi",
                  "Rusizi",
                  "Shamba",
                ],
              },
              {
                Rukina: [
                  "Dusenyi",
                  "Kabacuzi",
                  "Kabirizi",
                  "Kabuga",
                  "Munini",
                  "Murinzi",
                ],
              },
            ],
          },
          {
            Mbuye: [
              {
                Cyanza: [
                  "Kabungo",
                  "Murambi",
                  "Nyamikoni",
                  "Rwamiko",
                  "Wimana",
                ],
              },
              {
                Gisanga: [
                  "Bienvenue",
                  "Gisanga",
                  "Gishari",
                  "Karama",
                  "Kavumu",
                  "Nyarugenge",
                  "Sabudari",
                  "Sahara",
                ],
              },
              {
                Kabuga: [
                  "Kabuga",
                  "Kinyinya",
                  "Kirwa",
                  "Mpungwe",
                  "Musenyi",
                  "Nyabisindu",
                  "Nyakabanda",
                  "Nyamutarama",
                  "Rugarama",
                  "Rwinkuba",
                ],
              },
              {
                Kizibere: [
                  "Bereshi",
                  "Biraro",
                  "Bunyeshywa",
                  "Kangoma",
                  "Kivumu",
                  "Kizibere",
                  "Mayunzwe",
                  "Nyamiyaga",
                  "Rebero",
                  "Ruhuha",
                ],
              },
              {
                Mbuye: [
                  "Buremera",
                  "Cyeru",
                  "Cyobe",
                  "Kamurema",
                  "Kanyinya",
                  "Kinyambo",
                  "Ruyenzi",
                  "Rwimposha",
                ],
              },
              {
                Mwendo: [
                  "Cyanika",
                  "Gafunzo",
                  "Gasanganya",
                  "Gatare",
                  "Giticyuma",
                  "Ipate",
                  "Kabuga",
                  "Karama",
                  "Karusizi",
                  "Kavumu",
                  "Kidoma",
                  "Mataba",
                  "Vunga",
                ],
              },
              {
                Nyakarekare: [
                  "Bereshi",
                  "Jari",
                  "Kigabiro",
                  "Nyakarekare",
                  "Nyaruyonga",
                  "Rubona",
                  "Ruyenzi",
                  "Vugiza",
                ],
              },
            ],
          },
          {
            Mwendo: [
              {
                Gafunzo: [
                  "Kagarama",
                  "Kajevuba",
                  "Kimburu",
                  "Nyamigina",
                  "Nyamugari",
                  "Ruhamagariro",
                  "Rutagara",
                ],
              },
              {
                Gishweru: [
                  "Kanzu",
                  "Mabanza",
                  "Nyakabuye",
                  "Nyakizu",
                  "Rubona",
                ],
              },
              {
                Kamujisho: ["Bugaramantare", "Gakomeye", "Gitwa", "Nyarusange"],
              },
              {
                Kigarama: [
                  "Gisiza",
                  "Gitaraga",
                  "Kabacuzi",
                  "Kaburinga",
                  "Kamuganga",
                  "Kamuzimanganya",
                  "Kivumu",
                ],
              },
              {
                Kubutare: ["Buhoro", "Dusego", "Gasyogogo", "Karambo"],
              },
              {
                Mutara: [
                  "Bunyankungu",
                  "Gashiru",
                  "Kabiha",
                  "Kakarima",
                  "Mbunduye",
                  "Murambi",
                  "Nyabisindu",
                ],
              },
              {
                Nyabibugu: [
                  "Kiganira",
                  "Ntongwe",
                  "Nyarutovu",
                  "Nyaruvumu",
                  "Rukeri",
                  "Ryakabunga",
                ],
              },
              {
                Saruheshyi: [
                  "Buhigiro",
                  "Gaseke",
                  "Gasharu",
                  "Rugasari",
                  "Ruhondo",
                ],
              },
            ],
          },
          {
            Ntongwe: [
              {
                Gako: [
                  "Cyimana",
                  "Gikoma",
                  "Kamakara",
                  "Kantwari",
                  "Nyabuhuzu",
                  "Nyabyugi",
                  "Nyamahwa",
                ],
              },
              {
                Kareba: ["Kavumu", "Kibatsi", "Marimba", "Ruko"],
              },
              {
                Kayenzi: [
                  "Kanyete",
                  "Kirwa",
                  "Ntungamo",
                  "Nyagatovu",
                  "Nyamigende",
                ],
              },
              {
                Kebero: [
                  "Cyeru",
                  "Gasuna",
                  "Kaburanjwiri",
                  "Nyabigunzu",
                  "Nyabitare",
                  "Nyacyonga",
                  "Ruko",
                ],
              },
              {
                Nyagisozi: ["Karama", "Nyamirama", "Nyarusange"],
              },
              {
                Nyakabungo: [
                  "Byimana",
                  "Gacuriro",
                  "Kamaraba",
                  "Karama",
                  "Kigabiro",
                  "Kintore",
                  "Mutima",
                  "Nyamirama",
                ],
              },
              {
                Nyarurama: [
                  "Gahunga",
                  "Gikoni",
                  "Kamaraba",
                  "Karama",
                  "Mukoni",
                  "Munini",
                  "Nyamirambo",
                  "Nyarugenge",
                  "Nyarwahi",
                  "Ruhuha",
                  "Rwakajuju",
                  "Rwintama",
                ],
              },
            ],
          },
          {
            Ruhango: [
              {
                Buhoro: [
                  "Buhoro",
                  "Gako",
                  "Kabeza",
                  "Kantama",
                  "Karambo",
                  "Muhororo I",
                  "Muhororo II",
                  "Ntinyinshi",
                  "Nyagasozi",
                  "Nyangandika",
                  "Nyarutovu",
                  "Rwinkuba",
                ],
              },
              {
                Bunyogombe: [
                  "Bugarura",
                  "Busego",
                  "Gacoko",
                  "Gishegesha",
                  "Kabega",
                  "Kamugaru",
                  "Kamugaza",
                  "Karehe",
                  "Kasemahundo",
                  "Kavumu",
                  "Kigabiro",
                  "Kigarama",
                  "Murehe",
                  "Nyabibugu",
                  "Nyabisindu",
                  "Remera",
                  "Rubazi",
                  "Rusebeya",
                  "Rwankuba",
                ],
              },
              {
                Gikoma: [
                  "Gatengeri",
                  "Gikumba",
                  "Karama",
                  "Murambi",
                  "Nangurugomo",
                  "Nyarusange",
                  "Rebero",
                  "Rubiha",
                  "Rurembo",
                  "Ryabonyinka",
                  "Wimana",
                ],
              },
              {
                Munini: [
                  "Bisambu",
                  "Bugari",
                  "Bwiza",
                  "Cyeshero",
                  "Gahama",
                  "Gaseke",
                  "Gataka",
                  "Gitwa",
                  "Kabaja",
                  "Kaburanjwiri",
                  "Kanazi",
                  "Kibingo",
                  "Kigaga",
                  "Kirima",
                  "Kiruhura",
                  "Munini",
                  "Muremera",
                  "Nyabinyenga",
                  "Nyinya",
                  "Ruhuha",
                  "Rwezamenyo",
                ],
              },
              {
                Musamo: [
                  "Cana",
                  "Gaseke",
                  "Jokoma",
                  "Kabere",
                  "Kamabare",
                  "Kinama",
                  "Kinkene",
                  "Musamo",
                  "Mwali",
                  "Rwinkuba",
                  "Rwinyege",
                  "Ryanyiranda",
                  "Wimana",
                ],
              },
              {
                Nyamagana: [
                  "Bumbogo",
                  "Butare I",
                  "Butare II",
                  "Bwangacumu",
                  "Gataka",
                  "Gatengezi",
                  "Gutamba",
                  "Kamabano",
                  "Kigabiro",
                  "Kigimbu",
                  "Kinama",
                  "Mabera",
                  "Mujyejuru I",
                  "Mujyejuru II",
                  "Murinzi",
                  "Ngurukizi",
                  "Ntungamo",
                  "Nyabihanga",
                  "Nyagasozi",
                  "Nyamagana",
                  "Nyamugari",
                  "Nyarusange I",
                  "Nyarusange II",
                  "Ruhango",
                  "Ruhuha",
                ],
              },
              {
                Rwoga: [
                  "Bihome",
                  "Bugarama",
                  "Bunyogombe",
                  "Bushenyi",
                  "Gasharu",
                  "Gatebe",
                  "Kabambati",
                  "Kangoga",
                  "Kavumu",
                  "Kibiraro",
                  "Muyange",
                  "Mwezi",
                  "Nyabisindu",
                  "Ruhango",
                  "Rwinkuba",
                  "Rwoga",
                ],
              },
              {
                Tambwe: [
                  "Buterana",
                  "Mubuga",
                  "Nyamugari I",
                  "Nyamugari II",
                  "Nyundo",
                  "Ruduha I",
                  "Ruduha II",
                  "Rugarama",
                  "Rugondo",
                  "Tambwe",
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    West: [
      {
        Karongi: [
          {
            Bwishyura: [
              {
                Burunga: [
                  "Kabuga",
                  "Majuri",
                  "Matyazo",
                  "Nyabikenke",
                  "Nyamarebe",
                  "Ruyenzi",
                  "Twimbogo",
                ],
              },
              {
                Gasura: [
                  "Gafuruguto",
                  "Gatare",
                  "Gatoki",
                  "Gisayo",
                  "Nyabihanga",
                  "Nyagahinga",
                  "Nyarusange",
                  "Ruganda",
                ],
              },
              {
                Gitarama: [
                  "Gitarama",
                  "Gomba",
                  "Josi",
                  "Karambo",
                  "Kigezi",
                  "Kirambo",
                  "Kivomo",
                  "Nyamigina",
                ],
              },
              {
                Kayenzi: [
                  "Buhoro",
                  "Gitega",
                  "Mugomba",
                  "Nyabikenke",
                  "Ruhande",
                  "Sakinnyaga",
                ],
              },
              {
                Kibuye: ["Gacumba", "Gatwaro", "Rurembo"],
              },
              {
                Kiniha: [
                  "Karutete",
                  "Kiyovu",
                  "Maryohe",
                  "Nyabaguma",
                  "Nyakigezi",
                  "Nyarurembo",
                  "Nyegabo",
                  "Ruganda",
                ],
              },
              {
                Nyarusazi: [
                  "Birembo",
                  "Bupfune",
                  "Bwishyura",
                  "Kanyabusage",
                  "Karongi",
                  "Nyarusozi",
                ],
              },
            ],
          },
          {
            Gashari: [
              {
                Birambo: [
                  "Birambo",
                  "Gashari",
                  "Kabirizi",
                  "Kakibereka",
                  "Kananira",
                  "Ntarabana",
                  "Nyabikenke",
                  "Nyakibuguma",
                  "Nyarusange",
                  "Rugarama",
                ],
              },
              {
                Musasa: [
                  "Kabasare",
                  "Kaduha",
                  "Kagangare",
                  "Kigarama",
                  "Musasa",
                  "Rasaniro",
                ],
              },
              {
                Mwendo: [
                  "Gakurwe",
                  "Gataba",
                  "Gihororo",
                  "Kabageni",
                  "Kayogoro",
                  "Nyamigina",
                ],
              },
              {
                Rugobagoba: [
                  "Karambo",
                  "Karutare",
                  "Kibingo",
                  "Musongati",
                  "Nkingo",
                  "Shungwe",
                ],
              },
              {
                Tongati: ["Kayonga", "Nyabivumu", "Nyagisozi", "Rubona"],
              },
            ],
          },
          {
            Gishyita: [
              {
                Buhoro: ["Buhire", "Mboneko", "Mweya", "Ruhunde", "Tura"],
              },
              {
                Cyanya: [
                  "Gataba",
                  "Gatare",
                  "Gisiza",
                  "Gitovu",
                  "Kabuga",
                  "Kagano",
                  "Mpatsi",
                ],
              },
              {
                Kigarama: ["Gitwa", "Kabwenge", "Karenge", "Kubutare"],
              },
              {
                Munanira: [
                  "Butare",
                  "Bweramvura",
                  "Gisoro",
                  "Ngugu",
                  "Nyakabuye",
                ],
              },
              {
                Musasa: [
                  "Cyimbo",
                  "Gasharu",
                  "Kabuga",
                  "Kamunungu",
                  "Kibaya",
                  "Kirunga",
                  "Musebeya",
                  "Rwagisasa",
                ],
              },
              {
                Ngoma: [
                  "Kanyinya",
                  "Magarama",
                  "Mataba",
                  "Murambi",
                  "Rufumberi",
                  "Uwingabo",
                ],
              },
            ],
          },
          {
            Gitesi: [
              {
                Gasharu: [
                  "Gasharu",
                  "Kinyami",
                  "Nyarukeri",
                  "Nyaruvumu",
                  "Rwintare",
                ],
              },
              {
                Gitega: ["Bugoberi", "Kagari", "Kamihaho", "Muvungu", "Senga"],
              },
              {
                Kanunga: [
                  "Giticyuma",
                  "Karongi",
                  "Nemba",
                  "Nyabitare",
                  "Nyagisozi",
                  "Nyarugenge",
                ],
              },
              {
                Kirambo: [
                  "Buye",
                  "Karongi",
                  "Kirambo",
                  "Nyarusange",
                  "Nzabuhara",
                ],
              },
              {
                Munanira: [
                  "Gahigiro",
                  "Gatare",
                  "Kinama",
                  "Munanira",
                  "Nyabigugu",
                  "Nyarucyamo",
                  "Ruhundo",
                ],
              },
              {
                Nyamiringa: [
                  "Burega",
                  "Cyimba",
                  "Gisasa",
                  "Kagari",
                  "Kivuruga",
                ],
              },
              {
                Ruhinga: [
                  "Gasayo",
                  "Muramba",
                  "Nyabikati",
                  "Nyagahinga",
                  "Nyamiyaga",
                  "Nyarubuye",
                  "Ruhondo",
                ],
              },
              {
                Rwariro: [
                  "Karwiru",
                  "Kigarama",
                  "Kirwa",
                  "Rurumbu",
                  "Rusekera",
                  "Rwariro",
                ],
              },
            ],
          },
          {
            Mubuga: [
              {
                Kagabiro: [
                  "Bitaba",
                  "Buhari",
                  "Kagabiro",
                  "Kagarama",
                  "Mweya",
                  "Nyabinyenga",
                  "Nyakabande",
                  "Nyakagezi",
                  "Rubondo",
                  "Runyinya",
                ],
              },
              {
                Murangara: [
                  "Gisunzu",
                  "Kabuga",
                  "Kaduha",
                  "Karora",
                  "Murangara",
                  "Nyabitare",
                  "Rubyiro",
                  "Rwakamuri",
                ],
              },
              {
                Nyagatovu: [
                  "Bikomero",
                  "Gisizi",
                  "Karora",
                  "Mara",
                  "Nyagatovu",
                  "Nyankira",
                  "Ryarugenzi",
                ],
              },
              {
                Ryaruhanga: [
                  "Bikenke",
                  "Gihira",
                  "Jurwe",
                  "Kizibaziba",
                  "Mubuga",
                  "Rwamiko",
                  "Ryaruhanga",
                ],
              },
            ],
          },
          {
            Murambi: [
              {
                Mubuga: [
                  "Cyamatare",
                  "Gasebeya",
                  "Kazibaziba",
                  "Migina",
                  "Nyabivumu",
                  "Nyabwoma",
                  "Nyaruvumu",
                ],
              },
              {
                Muhororo: [
                  "Birambo",
                  "Bwakira",
                  "Kananira",
                  "Ndago",
                  "Nyabiranga",
                  "Nyakabuye",
                  "Tariro",
                ],
              },
              {
                Nkoto: [
                  "Gakoma",
                  "Gisovu",
                  "Kakirinda",
                  "Kibamba",
                  "Mataba",
                  "Muramba",
                ],
              },
              {
                Nyarunyinya: [
                  "Gituntu",
                  "Kamasambu",
                  "Karambo",
                  "Kigandaro",
                  "Murambi",
                  "Nyarusave",
                ],
              },
              {
                Shyembe: [
                  "Bugaramantare",
                  "Gitwa",
                  "Kaburega",
                  "Kavumu",
                  "Musibya",
                  "Nyabaguma",
                  "Nyabisindu",
                  "Nyamagana",
                  "Nyamugari",
                  "Nyaruhanga",
                ],
              },
            ],
          },
          {
            Murundi: [
              {
                Bukiro: [
                  "Bugeni",
                  "Bukiro",
                  "Gitwa",
                  "Munzanga",
                  "Nyamabuye",
                  "Nyamyumba",
                ],
              },
              {
                Kabaya: [
                  "Burwi",
                  "Gakomeye",
                  "Karambo",
                  "Mujyojyo",
                  "Murambi",
                  "Mwumba",
                ],
              },
              {
                Kamina: [
                  "Kiraro",
                  "Kirehe",
                  "Murehe",
                  "Mwunguzi",
                  "Nyakarambi",
                  "Nzobe",
                ],
              },
              {
                Kareba: [
                  "Bwenda",
                  "Gasave",
                  "Gasharu",
                  "Gisebeya",
                  "Kibingo",
                  "Kuruganda",
                  "Ruhungamiyaga",
                ],
              },
              {
                Nyamushishi: [
                  "Gasharu",
                  "Gitwa",
                  "Kisenge",
                  "Ngoma",
                  "Nyarurembo",
                  "Remera",
                  "Rubona",
                ],
              },
              {
                Nzaratsi: [
                  "Gatwaro",
                  "Gishyikiro",
                  "Nyabinombe",
                  "Nyamabuye",
                  "Remera",
                  "Ruhondo",
                  "Rusovu",
                ],
              },
            ],
          },
          {
            Mutuntu: [
              {
                Byogo: [
                  "Gasenyi",
                  "Gititi",
                  "Kivumu",
                  "Muhondo",
                  "Murambi",
                  "Musango",
                  "Rugogo",
                ],
              },
              {
                Gasharu: [
                  "Gashanga",
                  "Gasharu",
                  "Gituntu",
                  "Mukungu",
                  "Mutuntu",
                  "Nyabiguri",
                ],
              },
              {
                Gisayura: [
                  "Gashubi",
                  "Gatwa",
                  "Kabariro",
                  "Mayombo",
                  "Ryarugango",
                  "Taba",
                ],
              },
              {
                Kanyege: [
                  "Gitumba",
                  "Kanyege",
                  "Kavumu",
                  "Manji",
                  "Mukongoro",
                  "Nyarubuye",
                  "Rugogwe",
                ],
              },
              {
                Kinyonzwe: [
                  "Kadehero",
                  "Kinyonzwe",
                  "Matyazo",
                  "Ruhindiro",
                  "Uwabashi",
                  "Uwibumba",
                ],
              },
              {
                Murengezo: [
                  "Cyamakamba",
                  "Karambo",
                  "Ngundusi",
                  "Nyarutovu",
                  "Uwiraro",
                ],
              },
              {
                Rwufi: [
                  "Cyiha",
                  "Gatiti",
                  "Mwumba",
                  "Rasaniro",
                  "Rugusa",
                  "Ruhuha",
                ],
              },
            ],
          },
          {
            Rubengera: [
              {
                Bubazi: [
                  "Gakomeye",
                  "Gitwa",
                  "Kabuga",
                  "Kavumu",
                  "Kigarama",
                  "Makurungwe",
                  "Nyagahinga",
                ],
              },
              {
                Gacaca: [
                  "Gakomeye",
                  "Gasharu",
                  "Kamuvunyi",
                  "Kamwijagi",
                  "Karehe",
                  "Nyarubuye",
                  "Remera",
                ],
              },
              {
                Gisanze: [
                  "Kabatara",
                  "Kibande",
                  "Kigabiro",
                  "Nyabitare",
                  "Nyamagana",
                ],
              },
              {
                Gitwa: [
                  "Bizu",
                  "Gaseke",
                  "Gitega",
                  "Kibande",
                  "Muremera",
                  "Rubona",
                  "Rusebeya",
                  "Rwakigarati",
                ],
              },
              {
                Kibirizi: [
                  "Buhoro",
                  "Cyimana",
                  "Kabeza",
                  "Kagarama",
                  "Kamusanganya",
                  "Kimigenge",
                  "Ndengwa",
                  "Rubona",
                ],
              },
              {
                Mataba: [
                  "Gitwa",
                  "Kabahizi",
                  "Mufumbezi",
                  "Nyagisozi",
                  "Ruvumbu",
                ],
              },
              {
                Nyarugenge: [
                  "Bigugu",
                  "Gatare",
                  "Kabazi",
                  "Kambogo",
                  "Karusha",
                  "Nkomagurwa",
                  "Rukaragata",
                ],
              },
              {
                Ruragwe: [
                  "Bunyankungu",
                  "Kabeza",
                  "Nyagahinga",
                  "Nyagasozi",
                  "Nyagatovu",
                  "Nyakabungo",
                  "Rutabo",
                  "Rwimpongo",
                ],
              },
            ],
          },
          {
            Rugabano: [
              {
                Gisiza: [
                  "Gitwa",
                  "Kamina",
                  "Muciro",
                  "Rubona",
                  "Rugabano",
                  "Winyambo",
                ],
              },
              {
                Gitega: [
                  "Cyarubariro",
                  "Kabyaza",
                  "Kigarama",
                  "Mihora",
                  "Misagara",
                  "Mutotozi",
                  "Ngoma",
                  "Rwesero",
                ],
              },
              {
                Gitovu: [
                  "Bisusa",
                  "Gatobo",
                  "Matyazo",
                  "Nganzo",
                  "Nyabagoyi",
                  "Rugabe",
                  "Rutoyi",
                ],
              },
              {
                Kabuga: [
                  "Bihembe",
                  "Kamata",
                  "Karambo",
                  "Kigarama",
                  "Migina",
                  "Nyabitare",
                  "Nyagasozi",
                  "Simbi",
                ],
              },
              {
                Mubuga: [
                  "Gatwaro",
                  "Kabyigo",
                  "Karumbi",
                  "Kavumu",
                  "Mataba",
                  "Uwigiti",
                ],
              },
              {
                Mucyimba: [
                  "Gihara",
                  "Kagombyi",
                  "Kamonyi",
                  "Kigarama",
                  "Kivumu",
                  "Rwagisozi",
                  "Ryangondo",
                ],
              },
              {
                Rufungo: [
                  "Bucensha",
                  "Bwihe",
                  "Gitabi",
                  "Karambo",
                  "Kavumu",
                  "Rukoko",
                ],
              },
              {
                Rwungo: ["Gahengeri", "Gasharu", "Kabuye", "Rwungo", "Wisazi"],
              },
              {
                Tyazo: [
                  "Karambi",
                  "Kirabo",
                  "Nyakabingo",
                  "Rubatura",
                  "Winzira",
                  "Wurugogwe",
                ],
              },
            ],
          },
          {
            Ruganda: [
              {
                Biguhu: ["Gitwa", "Murambi", "Muremure", "Ngange", "Nyagasozi"],
              },
              {
                Kabingo: ["Bugarura", "Kabingo", "Nyagisozi"],
              },
              {
                Kinyovu: ["Bizitiro", "Kabaranda", "Kanyegenyege"],
              },
              {
                Kivumu: ["Birambo", "Kagorora", "Murambi", "Nyarusange"],
              },
              {
                Nyabikeri: ["Dusasa", "Gahororo", "Kiguhu", "Nyabikeri"],
              },
              {
                Nyamugwagwa: ["Burango", "Kaduha", "Kibari", "Nyamugwagwa"],
              },
              {
                Rubona: ["Gahunduguru", "Maryohe", "Muciro", "Rubona"],
              },
              {
                Rugobagoba: [
                  "Gatare",
                  "Karambo",
                  "Nyabisiga",
                  "Nyagasambu",
                  "Nyakivumba",
                  "Nyarutembe",
                ],
              },
            ],
          },
          {
            Rwankuba: [
              {
                Bigugu: [
                  "Kagusa",
                  "Kavumu",
                  "Mifuba",
                  "Nyantwa",
                  "Ruhondo",
                  "Ruhuha",
                ],
              },
              {
                Bisesero: ["Bisesero", "Jurwe", "Kigarama", "Uwingabo"],
              },
              {
                Gasata: [
                  "Cyabahanga",
                  "Muhingo",
                  "Nyagafumba",
                  "Rugeti",
                  "Rurebero",
                  "Rutiti",
                  "Rwasheke",
                ],
              },
              {
                Munini: [
                  "Bweramana",
                  "Byimana",
                  "Gakangaga",
                  "Kinaba",
                  "Muvumba",
                  "Muyira",
                  "Winzira",
                ],
              },
              {
                Nyakamira: ["Mahembe", "Musango", "Nyarushekera"],
              },
              {
                Nyarusanga: [
                  "Gasharu",
                  "Karambo",
                  "Kigogwe",
                  "Kanyege",
                  "Wingwa",
                ],
              },
              {
                Rubazo: [
                  "Bucyurabuhoro",
                  "Kanyarusanga",
                  "Nyaruyaga",
                  "Ruhinga",
                  "Wamahoro",
                ],
              },
              {
                Rubumba: ["Gishwati", "Himbo", "Rukore", "Ryampande"],
              },
            ],
          },
          {
            Twumba: [
              {
                Bihumbe: [
                  "Bihumbe",
                  "Bivumu",
                  "Gikaranka",
                  "Nyabubare",
                  "Rushishi",
                  "Uwintobo",
                ],
              },
              {
                Gakuta: [
                  "Gakoko",
                  "Karumbi",
                  "Nyamiryango",
                  "Rugogwe",
                  "Twumba",
                ],
              },
              {
                Gisovu: [
                  "Bikunda",
                  "Gashihe",
                  "Kanyovu",
                  "Karambo",
                  "Kibuburo",
                  "Mwumba",
                  "Nyakabingo",
                ],
              },
              {
                Gitabura: [
                  "Gatare",
                  "Kibingo",
                  "Mataba",
                  "Nyakiyabo",
                  "Nyarubuye",
                  "Nyaruyaga",
                  "Rugeyo",
                  "Tuvunasogi",
                ],
              },
              {
                Kavumu: [
                  "Gasharu",
                  "Kaganda",
                  "Kavumu",
                  "Muhira",
                  "Murambi",
                  "Muronzi",
                  "Nyarutagara",
                ],
              },
              {
                Murehe: ["Duhati", "Gatema", "Kaganda", "Murehe"],
              },
              {
                Rutabi: ["Gahondo", "Nyirabununu", "Rutabi", "Wintobo"],
              },
            ],
          },
        ],
      },
      {
        Ngororero: [
          {
            Bwira: [
              {
                Bungwe: ["Gasura", "Kirwa", "Nkuri", "Rutembo", "Rutoyi"],
              },
              {
                Cyahafi: ["Bushyogero", "Cyahafi", "Kamina", "Rushubi"],
              },
              {
                Gashubi: [
                  "Gasasa",
                  "Gitonde",
                  "Rugeshi",
                  "Rukeri",
                  "Rwamakara",
                ],
              },
              {
                Kabarondo: [
                  "Bereshi",
                  "Gitarama",
                  "Kurushishi",
                  "Mukingi",
                  "Nyakarambi",
                ],
              },
              {
                Ruhindage: ["Kabirizi", "Kiregamazi", "Mwiha", "Nyabitare"],
              },
            ],
          },
          {
            Gatumba: [
              {
                Cyome: [
                  "Birambo",
                  "Mpara",
                  "Musagara",
                  "Nyakagezi",
                  "Ruvumu",
                  "Rwasare",
                ],
              },
              {
                Gatsibo: [
                  "Gasave",
                  "Gatongo",
                  "Gatsibo",
                  "Gatwa",
                  "Kimirama",
                  "Rutabataba",
                  "Shyogi",
                ],
              },
              {
                Kamasiga: [
                  "Byimana",
                  "Gasave",
                  "Karehe",
                  "Kavumu",
                  "Nsyabire",
                  "Nyenyeri",
                ],
              },
              {
                Karambo: [
                  "Gahinga",
                  "Gitega",
                  "Kabarore",
                  "Karehe",
                  "Kimisagara",
                  "Nteko",
                  "Rugara",
                ],
              },
              {
                Ruhanga: [
                  "Butare",
                  "Gasagara",
                  "Jimbu",
                  "Kabeza",
                  "Kadehero",
                  "Kamina",
                ],
              },
              {
                Rusumo: ["Kagarama", "Mataba", "Mukaragata", "Rusumo"],
              },
            ],
          },
          {
            Hindiro: [
              {
                Gatare: ["Buyungu", "Kigarama", "Muhororo", "Nyagasozi"],
              },
              {
                Gatega: [
                  "Cyahafi",
                  "Gapfura",
                  "Gasharu",
                  "Gasovu",
                  "Huriro",
                  "Kabenge",
                  "Kagarama",
                  "Rutsiro",
                  "Sereri",
                ],
              },
              {
                Kajinge: ["Bwoga", "Kamana", "Rugari", "Rugeshi"],
              },
              {
                Marantima: [
                  "Kagugu",
                  "Karambo",
                  "Kiribata",
                  "Munyegera",
                  "Muvugangoma",
                  "Rugarika",
                ],
              },
              {
                Rugendabari: ["Kabuga", "Kamonyi", "Mituga", "Mukoni"],
              },
              {
                Runyinya: ["Marembo", "Murambi", "Rugarambiro", "Rwamiko"],
              },
            ],
          },
          {
            Kabaya: [
              {
                Busunzu: [
                  "Gitaba",
                  "Kabarenzi",
                  "Kabere",
                  "Kabuganza",
                  "Kabusizi",
                  "Kinyamiyaga",
                ],
              },
              {
                Gaseke: [
                  "Mbandari",
                  "Mitabo",
                  "Mizingo",
                  "Muturagara",
                  "Nyamugari",
                  "Nyamweru",
                  "Rugari",
                ],
              },
              {
                Kabaya: [
                  "Bitare",
                  "Kimisagara",
                  "Kiyovu",
                  "Migongo",
                  "Nyanza",
                  "Rebero",
                  "Rurembo",
                  "Rwantozi",
                ],
              },
              {
                Mwendo: [
                  "Bukonde",
                  "Butare",
                  "Kabeza",
                  "Karambi",
                  "Merabuye",
                  "Nyabarinda",
                  "Rubambiro",
                ],
              },
              {
                Ngoma: [
                  "Gisebeya",
                  "Gitumba",
                  "Hanika",
                  "Ngoma",
                  "Nyamugeyo",
                  "Rukorati",
                  "Rutoyi",
                ],
              },
              {
                Nyenyeri: [
                  "Bukonde",
                  "Gashyitsi",
                  "Kabasare",
                  "Kimiramba",
                  "Kirwa",
                  "Nyamugari",
                  "Nyasenge",
                ],
              },
            ],
          },
          {
            Kageyo: [
              {
                Kageshi: ["Cyungo", "Kantara", "Kariha", "Mukaka", "Ruganda"],
              },
              {
                Kirwa: ["Gatovu", "Gihonga", "Kabagari", "Nyaruzenga"],
              },
              {
                Mukore: [
                  "Gaseke",
                  "Gitongo",
                  "Kabuhake",
                  "Nyamatanga",
                  "Rusenyi",
                ],
              },
              {
                Muramba: ["Gashinge", "Kabyaza", "Murangara", "Rurambo"],
              },
              {
                Nyamata: [
                  "Bereshi",
                  "Kabuga",
                  "Kagarama",
                  "Kibanda",
                  "Nyamutuku",
                ],
              },
              {
                Rwamamara: ["Gaseke", "Gasiza", "Giseke", "Mubuga"],
              },
            ],
          },
          {
            Kavumu: [
              {
                Birembo: [
                  "Buhuma",
                  "Gashaki",
                  "Kantobo",
                  "Nyabitsina",
                  "Rwanamiza",
                ],
              },
              {
                Gitwa: [
                  "Biraro",
                  "Karambi",
                  "Kaziba",
                  "Nyamugari",
                  "Nyarukara",
                ],
              },
              {
                Murinzi: [
                  "Cyasenge",
                  "Gasibya",
                  "Ntebeyinuma",
                  "Nyaramba",
                  "Ruhurura",
                ],
              },
              {
                Nyamugeyo: [
                  "Gatovu",
                  "Kabere",
                  "Karambo",
                  "Murimba",
                  "Nyabubanda",
                ],
              },
              {
                Rugeshi: ["Cyuzi", "Gasumo", "Kabeza", "Karambi", "Mwiyanike"],
              },
              {
                Tetero: [
                  "Bereshi",
                  "Gatsibo",
                  "Kasumo",
                  "Mizingo",
                  "Ruherahere",
                ],
              },
            ],
          },
          {
            Matyazo: [
              {
                Binana: ["Busoro", "Kabuye", "Kaseke", "Kavumu", "Nyagisozi"],
              },
              {
                Gitega: [
                  "Barama",
                  "Gahanda",
                  "Gasayo",
                  "Gataka",
                  "Kabara",
                  "Rwankenke",
                ],
              },
              {
                Matare: [
                  "Gako",
                  "Gitega",
                  "Kamasorori",
                  "Munyinya",
                  "Mwumba",
                  "Nyenyeri",
                ],
              },
              {
                Rutare: [
                  "Kabingo",
                  "Nyakiliba",
                  "Ruhurura",
                  "Rwamabuye",
                  "Shori",
                ],
              },
              {
                Rwamiko: ["Butare", "Nyakibande", "Rusororo", "Rwamiko"],
              },
            ],
          },
          {
            Muhanda: [
              {
                Bugarura: [
                  "Bugarura",
                  "Burorero",
                  "Gatomvu",
                  "Ngando",
                  "Nkongora",
                  "Runayu",
                ],
              },
              {
                Gasiza: [
                  "Gasiza",
                  "Kabeza",
                  "Kigina",
                  "Nyenyeri",
                  "Rukobora",
                  "Rurandama",
                  "Rwantobotobo",
                ],
              },
              {
                Mashya: [
                  "Byerezo",
                  "Kagano",
                  "Karuhindura",
                  "Kazuba",
                  "Maryoha",
                  "Rubaya",
                ],
              },
              {
                Nganzo: [
                  "Gisebeya",
                  "Gisiza",
                  "Gisunzu",
                  "Misemburo",
                  "Murehe",
                  "Ntaruko",
                ],
              },
              {
                Ngoma: [
                  "Bugobora",
                  "Gacaca",
                  "Karambi",
                  "Ntendure",
                  "Rucano",
                  "Ruganda",
                ],
              },
              {
                Rutagara: [
                  "Bambiro",
                  "Gaseke",
                  "Kabari",
                  "Kamashya",
                  "Mushishiro",
                  "Nyamutoni",
                  "Nyanshundura",
                  "Rukondo",
                  "Rurambo",
                ],
              },
            ],
          },
          {
            Muhororo: [
              {
                Bweramana: [
                  "Buyenzi",
                  "Gasave",
                  "Musanzubize",
                  "Nyagaseke",
                  "Ruhanga",
                ],
              },
              {
                Mubuga: [
                  "Burengo",
                  "Gashonyi",
                  "Gasovu",
                  "Mitsimbi",
                  "Murambi",
                  "Nyabigogoro",
                  "Nyamirama",
                ],
              },
              {
                Myiha: ["Kabyiniro", "Myiha", "Shori"],
              },
              {
                Rugogwe: ["Butinza", "Kibingo", "Murambi", "Nganzo"],
              },
              {
                Rusororo: [
                  "Buhiro",
                  "Gapfura",
                  "Gisovu",
                  "Kagunga",
                  "Rongi",
                  "Ryabadanga",
                ],
              },
              {
                Sanza: ["Gashyushya", "Kansi", "Mubuga", "Nyaruhondo", "Sanza"],
              },
            ],
          },
          {
            Ndaro: [
              {
                Bijyojyo: [
                  "Bijyojyo",
                  "Birima",
                  "Cyajongo",
                  "Gasave",
                  "Kavumu",
                  "Kibuga",
                  "Runyoni",
                  "Rutonde",
                ],
              },
              {
                Bitabage: [
                  "Gasharu",
                  "Gituza",
                  "Kamuyobora",
                  "Kinga",
                  "Nganzo",
                  "Ngugu",
                  "Nyamugari",
                  "Rwamikeri",
                ],
              },
              {
                Kabageshi: [
                  "Gasharu",
                  "Kabuga",
                  "Kandamira",
                  "Masoro",
                  "Ruhanga",
                ],
              },
              {
                Kibanda: [
                  "Kamina",
                  "Kideberi",
                  "Kimirehe",
                  "Kirombozi",
                  "Ruhuha",
                  "Rutambiro",
                  "Rwamateke",
                  "Rwambogo",
                ],
              },
              {
                Kinyovi: ["Gahunga", "Giseke", "Rugeyo", "Rusebeya"],
              },
            ],
          },
          {
            Ngororero: [
              {
                Kaseke: [
                  "Cyandago",
                  "Gatare",
                  "Kabeza",
                  "Kabusunzu",
                  "Kanyinya",
                  "Nyabisindu",
                  "Nyamabuye",
                  "Nyarubari",
                ],
              },
              {
                Kazabe: ["Butezi", "Cyansi", "Kazabe", "Murambi", "Ngororero"],
              },
              {
                Mugano: [
                  "Gashinya",
                  "Kabuga",
                  "Mana",
                  "Manogo",
                  "Mpara",
                  "Nyabisindu",
                  "Nyenyeri",
                  "Ruhuha",
                ],
              },
              {
                Nyange: [
                  "Gatare",
                  "Gihe",
                  "Kabeza",
                  "Karama",
                  "Mazimeru",
                  "Nyakaganzo",
                  "Nyange",
                  "Turamigina",
                ],
              },
              {
                Rususa: [
                  "Cyumba",
                  "Gasarara",
                  "Kabagari",
                  "Nyarubingo",
                  "Rukaragata",
                  "Rususa",
                ],
              },
              {
                Torero: [
                  "Gatare",
                  "Kanama",
                  "Karera",
                  "Nyakariba",
                  "Nyamabuye",
                  "Nyamiyaga",
                  "Rwambariro",
                ],
              },
            ],
          },
          {
            Nyange: [
              {
                Bambiro: [
                  "Bugabe",
                  "Butare",
                  "Gakoma",
                  "Muzi",
                  "Nyarushubi",
                  "Rwasankuba",
                ],
              },
              {
                Gaseke: ["Birambo", "Dutwe", "Gaseke", "Giko", "Ngobagoba"],
              },
              {
                Nsibo: [
                  "Cyambogo",
                  "Kanyinya",
                  "Muganza",
                  "Murambi",
                  "Nyange",
                  "Nyarusange",
                  "Vungu",
                  "Zegenya",
                ],
              },
              {
                Vuganyana: [
                  "Kakinyoni",
                  "Kamuriza",
                  "Karambo",
                  "Kazenga",
                  "Mbobo",
                  "Ngorore",
                  "Nyagatama",
                  "Nyamyungo",
                ],
              },
            ],
          },
          {
            Sovu: [
              {
                Birembo: [
                  "Kabayengo",
                  "Mahembe",
                  "Muyange",
                  "Nshano",
                  "Ruseke",
                ],
              },
              {
                Kagano: [
                  "Gitabage",
                  "Karambo",
                  "Ndagarago",
                  "Nyamuza",
                  "Rusenge",
                ],
              },
              {
                Kanyana: [
                  "Bitaba",
                  "Gahombo",
                  "Gashihe",
                  "Mugobati",
                  "Ruganda",
                  "Rusebeya",
                ],
              },
              {
                Musenyi: ["Gihonga", "Gisakavu", "Gisiza", "Kabuga", "Rubindi"],
              },
              {
                Nyabipfura: [
                  "Butenga",
                  "Gatare",
                  "Migendezo",
                  "Nyirabwina",
                  "Sanzare",
                ],
              },
              {
                Rutovu: [
                  "Gasiza",
                  "Kanyirajana",
                  "Kigusa",
                  "Ngaza",
                  "Ngugu",
                  "Rukeri",
                ],
              },
            ],
          },
        ],
      },
      {
        Nyabihu: [
          {
            Bigogwe: [
              {
                Arusha: [
                  "Arusha",
                  "Bukinanyana",
                  "Busasamana",
                  "Ngamba",
                  "Ngandu",
                  "Nyabishunguru",
                  "Nyagihinga",
                ],
              },
              {
                Basumba: [
                  "Buheke",
                  "Gasizi",
                  "Giticyinyoni",
                  "Ngando",
                  "Rusenge",
                  "Vuga",
                ],
              },
              {
                Kijote: [
                  "Bikingi",
                  "Bukinanyana",
                  "Busasamana",
                  "Gasiza",
                  "Gatagara",
                  "Kabaya",
                  "Kazuba",
                  "Kijote",
                  "Shaba",
                  "Zihari",
                ],
              },
              {
                Kora: [
                  "Bweramana",
                  "Kabatezi",
                  "Kabuga",
                  "Kageli",
                  "Ruhinga",
                  "Rukore",
                  "Rwankuba",
                ],
              },
              {
                Muhe: [
                  "Bihangara",
                  "Kananira",
                  "Kirandaryi",
                  "Murambi",
                  "Rusogo",
                ],
              },
              {
                Rega: [
                  "Gaturo",
                  "Kabaya",
                  "Kagano",
                  "Kariyeri",
                  "Kinamba",
                  "Mizingo",
                  "Ngangare",
                  "Nyagafumberi",
                ],
              },
            ],
          },
          {
            Jenda: [
              {
                Bukinanyana: [
                  "Bibanza",
                  "Bugarama",
                  "Bukinanyana",
                  "Kageri",
                  "Karuhirwa",
                  "Kibaya",
                  "Nsakira",
                ],
              },
              {
                Gasizi: [
                  "Kagano",
                  "Kanyaru",
                  "Kanzenze",
                  "Kinyengagi",
                  "Mikingo",
                  "Munanira",
                  "Rwanamiza",
                ],
              },
              {
                Kabatezi: [
                  "Gitambuko",
                  "Kagaga",
                  "Kibuye",
                  "Musumba",
                  "Ndorwa",
                  "Runyanja",
                ],
              },
              {
                Kareba: [
                  "Bizu",
                  "Gikombe",
                  "Kamatenge",
                  "Kareba",
                  "Nyacyonga",
                  "Rebero",
                  "Rubare",
                ],
              },
              {
                Nyirakigugu: [
                  "Cyamabuye",
                  "Gisozi",
                  "Jenda",
                  "Nteranya",
                  "Nyamutukura",
                  "Rushunguru",
                ],
              },
              {
                Rega: [
                  "Bihinga",
                  "Gakarara",
                  "Gasesero",
                  "Kajebeshi",
                  "Rega",
                  "Rubare",
                  "Terimbere",
                ],
              },
            ],
          },
          {
            Jomba: [
              {
                Gasiza: [
                  "Cyumba",
                  "Gahama",
                  "Gasiza",
                  "Isangano",
                  "Kabingo",
                  "Kanama",
                  "Nyundo",
                ],
              },
              {
                Gasura: [
                  "Gasura",
                  "Gisoro",
                  "Kagano",
                  "Rwandarugari",
                  "Ryabasenge",
                  "Ryabirumba",
                ],
              },
              {
                Gisizi: ["Futi", "Gahanga", "Gikaranka", "Gisizi", "Kagege"],
              },
              {
                Guriro: [
                  "Guriro",
                  "Kabari",
                  "Misegwibiri",
                  "Ngabo",
                  "Nyarusongati",
                  "Ruhunga",
                ],
              },
              {
                Kavumu: [
                  "Gasanze",
                  "Kavumu",
                  "Muhare",
                  "Munyege",
                  "Rugerero",
                  "Rushubi",
                ],
              },
              {
                Nyamitanzi: [
                  "Bihinga",
                  "Kivumu",
                  "Ntwaro",
                  "Nyamitanzi",
                  "Rubavu",
                  "Rugera",
                  "Ruhongore",
                  "Rutabu",
                ],
              },
            ],
          },
          {
            Kabatwa: [
              {
                Batikoti: ["Batikoti", "Kamuhe", "Rubare", "Sake"],
              },
              {
                Cyamvumba: ["Kabagabo", "Murambi", "Nyabitembo"],
              },
              {
                Gihorwe: ["Bisukiro", "Kaminuza", "Kinyababa", "Rushubi"],
              },
              {
                Myuga: [
                  "Akabeza",
                  "Akimitoni",
                  "Butaka",
                  "Myuga",
                  "Rugendabari",
                ],
              },
              {
                Ngando: [
                  "Gaharawe",
                  "Kiramira",
                  "Mahurura",
                  "Ngando",
                  "Ruhango",
                ],
              },
              {
                Rugarama: ["Karambi", "Kinkware", "Masasa", "Rebero", "Remera"],
              },
            ],
          },
          {
            Karago: [
              {
                Busoro: [
                  "Gasasa",
                  "Gatagara",
                  "Gisesa",
                  "Kageshi",
                  "Kagohe",
                  "Rebero",
                  "Ruhigiro",
                ],
              },
              {
                Cyamabuye: [
                  "Buremera",
                  "Kinyanja",
                  "Matyazo",
                  "Muderi",
                  "Muremure",
                  "Nanga",
                  "Nkomane",
                  "Rubare",
                ],
              },
              {
                Gatagara: [
                  "Bikereri",
                  "Budacya",
                  "Gatwe",
                  "Gisunzu",
                  "Karambi",
                  "Kinanira",
                  "Muvure",
                ],
              },
              {
                Gihirwa: [
                  "Biseke",
                  "Gifumba",
                  "Kanombe",
                  "Nyagasozi",
                  "Rugarambiro",
                  "Rurambo",
                ],
              },
              {
                Kadahenda: [
                  "Bukongora",
                  "Gakoma",
                  "Gihira",
                  "Karandaryi",
                  "Kivunja",
                  "Muremure",
                  "Mwiyanike",
                  "Nkomane",
                  "Nyaburaro",
                ],
              },
              {
                Karengera: [
                  "Hanika",
                  "Kirwa",
                  "Mashyuza",
                  "Remera",
                  "Ruyebe",
                  "Rwumuyaga",
                ],
              },
            ],
          },
          {
            Kintobo: [
              {
                Gatovu: [
                  "Gatovu Centre",
                  "Giharo",
                  "Nyagitaba",
                  "Nyarusekera",
                  "Rubande",
                ],
              },
              {
                Kintobo: ["Bikingi", "Gakoro", "Gasura", "Gasyo", "Kansesa"],
              },
              {
                Nyagisozi: [
                  "Dehero",
                  "Hungiro",
                  "Nyanshundura",
                  "Rutoyi",
                  "Sinayi",
                ],
              },
              {
                Nyamugari: [
                  "Kabagundu",
                  "Kariyeri",
                  "Karucuranya",
                  "Kiyumba",
                  "Kizunga",
                ],
              },
              {
                Rukondo: ["Kamanga", "Kankima", "Kimpundu", "Mugogo"],
              },
              {
                Ryinyo: [
                  "Gahwege",
                  "Gasenyi",
                  "Humiro",
                  "Kabashumba Centre",
                  "Kadaterurwa",
                  "Kirwa",
                  "Rwamikeri",
                ],
              },
            ],
          },
          {
            Mukamira: [
              {
                Gasizi: ["Kamiro", "Sasangabo"],
              },
              {
                Jaba: [
                  "Biriba",
                  "Butondwe",
                  "Gisenyi",
                  "Hesha",
                  "Nyirabashenyi",
                  "Rwanyirangeni",
                ],
              },
              {
                Kanyove: ["Kabere", "Kanyove", "Musumba", "Rwaseka"],
              },
              {
                Rubaya: [
                  "Cyivugiza",
                  "Gashonero",
                  "Kaburende",
                  "Karandaryi",
                  "Kinyababa",
                  "Rwamikeri",
                ],
              },
              {
                Rugeshi: [
                  "Cyinkenke",
                  "Cyumukenke",
                  "Kamenyo",
                  "Karama",
                  "Kazibake",
                  "Kazuba",
                ],
              },
              {
                Rukoma: ["Bihinga", "Gatare", "Gitete", "Pfunda", "Rugaragara"],
              },
              {
                Rurengeri: [
                  "Kabyaza",
                  "Kibugazi",
                  "Maziba",
                  "Rugarambiro",
                  "Rutovu",
                  "Rwankeri",
                ],
              },
            ],
          },
          {
            Muringa: [
              {
                Gisizi: [
                  "Kabyuma",
                  "Kinihira",
                  "Kinyasenge",
                  "Munini",
                  "Muremure",
                ],
              },
              {
                Mulinga: [
                  "Bunywero",
                  "Gakamba",
                  "Gora",
                  "Kamazage",
                  "Kiruma",
                  "Kivugiza",
                  "Migongo",
                  "Ruganda",
                  "Rurambo",
                ],
              },
              {
                Mwiyanike: [
                  "Gitebe",
                  "Kayanza",
                  "Kivuruga",
                  "Mucundebo",
                  "Musaraba",
                  "Nyankukuma",
                  "Ryamwana",
                  "Ryanyirandaba",
                ],
              },
              {
                Nkomane: [
                  "Kamajanga",
                  "Kigusa",
                  "Kinaba",
                  "Mabare",
                  "Muremure",
                ],
              },
              {
                Nyamasheke: [
                  "Bambiro",
                  "Kanwiri",
                  "Muyange",
                  "Nyamasheke",
                  "Rubare",
                ],
              },
              {
                Rwantobo: [
                  "Gasura",
                  "Karambi",
                  "Musenyi",
                  "Ntango",
                  "Rurembo",
                  "Rwandarugari",
                ],
              },
            ],
          },
          {
            Rambura: [
              {
                Birembo: [
                  "Birembo",
                  "Cyugi",
                  "Kimisebeya",
                  "Mariba",
                  "Munyangari",
                  "Nyavuvu",
                  "Rugarambiro",
                ],
              },
              {
                Guriro: [
                  "Cyanika",
                  "Kimisebeya",
                  "Nteko",
                  "Nyanguragura",
                  "Raro",
                  "Rusogo",
                ],
              },
              {
                Kibisabo: [
                  "Bugonde",
                  "Gatare",
                  "Kabeza",
                  "Karambi",
                  "Kinihira",
                  "Nyampuhu",
                  "Rwenzo",
                ],
              },
              {
                Mutaho: [
                  "Bihangara",
                  "Bukinanyana",
                  "Kiraza",
                  "Murambi",
                  "Nyiragikokora",
                  "Rusekera",
                  "Rutazigurwa",
                  "Sukiro",
                ],
              },
              {
                Nyundo: [
                  "Gasiza",
                  "Kamifuho",
                  "Myumba",
                  "Nama",
                  "Ntagihendo",
                  "Nyempanika",
                  "Rusereka",
                  "Rwinkingi",
                ],
              },
              {
                Rugamba: [
                  "Giharo",
                  "Kamiro",
                  "Kibumbiro",
                  "Muturagara",
                  "Muturirwa",
                  "Nkomane",
                ],
              },
            ],
          },
          {
            Rugera: [
              {
                Gakoro: [
                  "Bweru",
                  "Kintore",
                  "Mubuga",
                  "Nyakigezi",
                  "Nyarubingo",
                  "Nyarusange",
                ],
              },
              {
                Marangara: [
                  "Bwumba",
                  "Gasayo",
                  "Gasiza",
                  "Giko",
                  "Kabahendanyi",
                  "Kagano",
                  "Nyagasozi",
                  "Rwangege",
                  "Tetero",
                ],
              },
              {
                Nyagahondo: [
                  "Buhete",
                  "Gitotsi",
                  "Kabyaza",
                  "Muhare",
                  "Munyinya",
                  "Musenyi",
                  "Nganzo",
                ],
              },
              {
                Nyarutembe: [
                  "Gatyazo",
                  "Gisenyi",
                  "Jari",
                  "Kamenyo",
                  "Kibumba",
                  "Kirebe",
                  "Mwambi",
                  "Nyamugari",
                ],
              },
              {
                Rurembo: [
                  "Bihe",
                  "Bukango",
                  "Cyasenge",
                  "Gahama",
                  "Gaseke",
                  "Gihuri",
                  "Karambi",
                  "Murama",
                ],
              },
              {
                Tyazo: [
                  "Harabana",
                  "Kabuye",
                  "Kingona",
                  "Kiyanza",
                  "Mucaca",
                  "Murengeri",
                  "Nyakiriba",
                ],
              },
            ],
          },
          {
            Rurembo: [
              {
                Gahondo: [
                  "Bihira",
                  "Gahoko",
                  "Gitega",
                  "Kamahwera",
                  "Kanama",
                  "Kazuba",
                  "Murungu",
                  "Musenyi",
                  "Rugendabari",
                  "Rwamigega",
                ],
              },
              {
                Gitega: [
                  "Bukangano",
                  "Cyanika",
                  "Cyivugiza",
                  "Cyuve",
                  "Gitega",
                  "Kagusa",
                  "Rurambo",
                ],
              },
              {
                Kirimbogo: [
                  "Cyayu",
                  "Cyinkware",
                  "Cyogo",
                  "Gabiro",
                  "Gasenyi",
                  "Karuhara",
                  "Kinaba",
                  "Nturo",
                  "Nturoy Inkoko",
                ],
              },
              {
                Murambi: [
                  "Bugeshi",
                  "Gahondo",
                  "Gisoro",
                  "Kabyaza",
                  "Karambi",
                  "Karuhindu",
                  "Kidomo",
                  "Mpinga",
                  "Muremure",
                  "Nyarukangaga",
                  "Rubavu",
                  "Rubona I",
                ],
              },
              {
                Mwana: [
                  "Busenge",
                  "Kamugarura",
                  "Karukungu",
                  "Murama",
                  "Mwana",
                  "Nemba",
                  "Nyagahangara",
                ],
              },
              {
                Rwaza: [
                  "Gatobo",
                  "Gifunzo",
                  "Kabutozi",
                  "Kamenyo I",
                  "Kamenyo II",
                  "Muhungwe",
                  "Murama",
                  "Musekera",
                  "Musenyi",
                  "Musezero",
                  "Muturagara",
                  "Rubona II",
                  "Rugarambiro",
                  "Rugote",
                  "Rwanika",
                  "Tubuye",
                ],
              },
            ],
          },
          {
            Shyira: [
              {
                Cyimanzovu: [
                  "Bihembe",
                  "Cyinyana",
                  "Kabuga",
                  "Mugwato",
                  "Murikwa",
                ],
              },
              {
                Kanyamitana: [
                  "Kamahoro",
                  "Kazirankara",
                  "Kibuye",
                  "Kigabiro",
                  "Mataba",
                  "Rubaba",
                ],
              },
              {
                Kintarure: [
                  "Kabagabo",
                  "Kabuguzo",
                  "Mabare",
                  "Munanira",
                  "Remera",
                ],
              },
              {
                Mpinga: [
                  "Gacurabwenge",
                  "Kagongo",
                  "Mukaka",
                  "Rwabahungu",
                  "Vunga",
                ],
              },
              {
                Mutanda: ["Kaziba", "Kidandari", "Murambi", "Ntende"],
              },
              {
                Shaki: [
                  "Gitega",
                  "Kabuga",
                  "Karambi",
                  "Kirwa",
                  "Kiyovu",
                  "Rutoyi",
                ],
              },
            ],
          },
        ],
      },
      {
        Nyamasheke: [
          {
            Bushekeri: [
              {
                Buvungira: [
                  "Buhinga",
                  "Bushekeri",
                  "Buvungira",
                  "Gasebeya",
                  "Gisakura",
                  "Kinzovu",
                  "Mujabagiro",
                  "Nkenga",
                  "Ruvumbu",
                  "Rwumba",
                  "Winkamba",
                  "Yove",
                ],
              },
              {
                Mpumbu: ["Bona", "Gahondo", "Kamina", "Karambi", "Kirombozi"],
              },
              {
                Ngoma: [
                  "Bitare",
                  "Buhembe",
                  "Bukiro",
                  "Cyeshero",
                  "Kagarama",
                  "Kanyovu",
                  "Mashuhira",
                  "Rugeregere",
                ],
              },
              {
                Nyarusange: [
                  "Butangata",
                  "Gatoki",
                  "Kinini",
                  "Mubuga",
                  "Nyanza",
                  "Rundwe",
                  "Rweza",
                ],
              },
            ],
          },
          {
            Bushenge: [
              {
                Gasheke: [
                  "Bagiramenyo",
                  "Biguzi",
                  "Bugungu",
                  "Gasheke",
                  "Gikombe",
                  "Gitwa",
                  "Kamayenga",
                  "Kamucyamo",
                  "Karambo",
                  "Kigenge",
                  "Kivoga",
                  "Nyamikingo",
                  "Rwashyamba",
                ],
              },
              {
                Impala: [
                  "Birava",
                  "Buninda",
                  "Bushenge",
                  "Gasharu",
                  "Gasumo",
                  "Kabeza",
                  "Mucuzi",
                  "Rumanga",
                  "Runyinya",
                ],
              },
              {
                Kagatamu: [
                  "Gashirabwoba",
                  "Gasura",
                  "Gatare",
                  "Kagatamu",
                  "Karunga",
                  "Kidashira",
                  "Maherero",
                  "Ruhinamavi",
                  "Ruhinga I",
                  "Ruhinga II",
                ],
              },
              {
                Karusimbi: [
                  "Gahongo",
                  "Gakombe",
                  "Gasharu",
                  "Karusimbi",
                  "Kasenjara",
                  "Kigaga",
                  "Nyakagezi",
                  "Remera",
                  "Rwumuyaga",
                ],
              },
            ],
          },
          {
            Cyato: [
              {
                Bisumo: [
                  "Gasasa",
                  "Hangari",
                  "Kabuga",
                  "Kayo",
                  "Munini",
                  "Mutuntu",
                  "Rugabe",
                  "Rugarama",
                  "Ruhengeri",
                  "Rwaramba",
                ],
              },
              {
                Murambi: [
                  "Bigeyo",
                  "Cyato",
                  "Kamonyi",
                  "Karehe",
                  "Matyazo",
                  "Muhingo",
                  "Muremure",
                  "Murenge",
                  "Mutiti",
                  "Nkomero",
                  "Nyakabingo",
                ],
              },
              {
                Mutongo: [
                  "Bwanama",
                  "Kavumu",
                  "Kizinga",
                  "Muyugiri",
                  "Rushahaga",
                  "Rusi",
                  "Rutiritiri",
                  "Yove",
                ],
              },
              {
                Rugari: [
                  "Gakenke",
                  "Gashihe",
                  "Gituntu",
                  "Karambo",
                  "Ntsinduka",
                  "Rubeho",
                  "Rwumba",
                ],
              },
            ],
          },
          {
            Gihombo: [
              {
                Butare: [
                  "Butare",
                  "Gahanda",
                  "Gasharu",
                  "Mbogo",
                  "Nyakabungo",
                  "Rugaragara",
                  "Rwamatamu",
                  "Rwatsi",
                ],
              },
              {
                Gitwa: [
                  "Birehe",
                  "Bwerankori",
                  "Doga",
                  "Gasagara",
                  "Gaseke",
                  "Gasharu",
                  "Kinanira",
                  "Nyagahinga",
                  "Ruboreza",
                ],
              },
              {
                Jarama: [
                  "Bigabiro",
                  "Buseso",
                  "Kadobogo",
                  "Karehe",
                  "Kibirizi",
                  "Ruvumbu",
                ],
              },
              {
                Kibingo: [
                  "Gituruka",
                  "Kigarama",
                  "Mataba",
                  "Nyabitare",
                  "Nyarunyinya",
                  "Rushoka",
                  "Rusuzumiro",
                  "Rwabisindu",
                  "Rwanyundo",
                ],
              },
              {
                Mubuga: [
                  "Bungo",
                  "Butembo",
                  "Mubuga",
                  "Muhavu",
                  "Muhororo",
                  "Ruhingo",
                ],
              },
            ],
          },
          {
            Kagano: [
              {
                Gako: [
                  "Bagarama",
                  "Gasharu",
                  "Gitwa",
                  "Kazibira",
                  "Mpombo",
                  "Musagara",
                  "Remera",
                  "Rushondi",
                  "Rwangoma",
                  "Rwisovu",
                  "Ryarutungura",
                ],
              },
              {
                Mubumbano: [
                  "Bisoro",
                  "Gikomero",
                  "Gitanga",
                  "Kabagabo",
                  "Kabuyekeru",
                  "Mabungo",
                  "Makoko",
                  "Mikingo",
                  "Murambi",
                  "Nyagashinge",
                  "Nyamirambo",
                ],
              },
              {
                Ninzi: [
                  "Gasayo",
                  "Gikuyu",
                  "Kavune",
                  "Mujabagiro",
                  "Murwa",
                  "Ninzi",
                  "Nyabageni",
                  "Rugabano",
                ],
              },
              {
                Rwesero: [
                  "Gasharu",
                  "Gitaba",
                  "Kamasera",
                  "Kijibamba",
                  "Kirehe",
                  "Mutusa",
                  "Rwesero",
                ],
              },
              {
                Shara: [
                  "Byahi",
                  "Gahumba",
                  "Gihinga",
                  "Gisunzu",
                  "Kaduha",
                  "Kamabuye",
                  "Kamina",
                  "Kibare",
                  "Matara",
                  "Mugohe",
                  "Murambi",
                  "Ntumba",
                  "Rambira",
                ],
              },
            ],
          },
          {
            Kanjongo: [
              {
                Kibogora: [
                  "Bizenga",
                  "Gataba",
                  "Kabuyaga",
                  "Kagarama",
                  "Kivugiza",
                  "Maseka",
                  "Munini",
                  "Nyagacaca",
                  "Nyarusange",
                  "Nyenyeri",
                  "Rwakagaju",
                ],
              },
              {
                Kigarama: [
                  "Gakomeye",
                  "Gatare",
                  "Gisagara",
                  "Gitwa",
                  "Kajumiro",
                  "Karambi",
                  "Karehe",
                  "Murambi",
                ],
              },
              {
                Kigoya: [
                  "Bujanga",
                  "Kabaga",
                  "Kigugu",
                  "Kirambo",
                  "Museke",
                  "Nkero",
                  "Ruganzu",
                ],
              },
              {
                Raro: [
                  "Baraguma",
                  "Gasihe",
                  "Gasumo",
                  "Kamabuye",
                  "Kamina",
                  "Musasa",
                  "Rambura",
                  "Rugeyo",
                ],
              },
              {
                Susa: [
                  "Gakenke",
                  "Gatebe",
                  "Kamuramira",
                  "Kibazi",
                  "Marongi",
                  "Nyarubura",
                  "Ruganda",
                  "Wamugeyo",
                ],
              },
            ],
          },
          {
            Karambi: [
              {
                Gasovu: [
                  "Bitare",
                  "Gasamba",
                  "Gikangaga",
                  "Gitwa",
                  "Kabeza",
                  "Murambi",
                  "Nyarugenge",
                  "Rurembo",
                  "Ryanyagahangara",
                ],
              },
              {
                Gitwe: [
                  "Giti",
                  "Gitwe",
                  "Kamina",
                  "Karongi",
                  "Kibiko",
                  "Mburabuturo",
                  "Rubingo",
                  "Taba",
                ],
              },
              {
                Kabuga: [
                  "Bugarama",
                  "Gaseke",
                  "Kamukiza",
                  "Kanombe",
                  "Mugohe",
                  "Munini",
                  "Nyabitare",
                  "Nyarusovu",
                  "Rugano",
                  "Rutiti",
                ],
              },
              {
                Kagarama: [
                  "Bizimba",
                  "Cyankuba",
                  "Gituntu",
                  "Kabingo",
                  "Kamagese",
                  "Karambo",
                  "Misirimbo",
                  "Rubona",
                  "Tetero",
                  "Wibungo",
                ],
              },
              {
                Rushyarara: [
                  "Amizero",
                  "Cyivugiza",
                  "Kageyo",
                  "Nkomero",
                  "Rubyiruko",
                  "Rudaga",
                  "Ruzibira",
                  "Rwunamuka",
                  "Tyazo",
                ],
              },
            ],
          },
          {
            Karengera: [
              {
                Gasayo: [
                  "Gitwa",
                  "Muganza",
                  "Nyamugari",
                  "Nyamurira",
                  "Rubona",
                ],
              },
              {
                Gashashi: [
                  "Kabuye",
                  "Kanenge",
                  "Karangiro",
                  "Mwiyando",
                  "Rwinkuba",
                ],
              },
              {
                Higiro: [
                  "Gihaya",
                  "Gitunda",
                  "Mpinga",
                  "Muhora",
                  "Rujeberi",
                  "Rukunguri",
                ],
              },
              {
                Miko: [
                  "Boli",
                  "Kabisheshe",
                  "Karehe",
                  "Mbanda",
                  "Nyabwinshi",
                  "Nyagisozi",
                  "Nyamiyaga",
                  "Rutare",
                ],
              },
              {
                Mwezi: [
                  "Gakeri",
                  "Gatagara",
                  "Kamanu",
                  "Nyagafunzo",
                  "Nyagashikura",
                  "Nyarusange",
                  "Ruhabwa",
                  "Ruhinga",
                ],
              },
            ],
          },
          {
            Kirimbi: [
              {
                Cyimpindu: [
                  "Buha",
                  "Gitwa",
                  "Kamatare",
                  "Katabaro",
                  "Rugeregere",
                  "Uwakibaba",
                  "Uwamuduru",
                  "Uwamugisha",
                ],
              },
              {
                Karengera: [
                  "Gisenyi",
                  "Kabuga",
                  "Kaburiro",
                  "Karambi",
                  "Mitanga",
                  "Mukoto",
                  "Nduba",
                  "Rubumba",
                  "Rugote",
                ],
              },
              {
                Muhororo: [
                  "Gabiro",
                  "Gacumbi",
                  "Giseke",
                  "Gisesero",
                  "Kigarama",
                  "Nyagacaca",
                  "Nyakabingo",
                  "Rusebeya",
                ],
              },
              {
                Nyarusange: [
                  "Bunyamanza",
                  "Gisheke",
                  "Gitsimbwe",
                  "Mushungo",
                  "Nyabinaga",
                  "Rubona",
                  "Rwamiko",
                ],
              },
            ],
          },
          {
            Macuba: [
              {
                Gatare: [
                  "Buhoro",
                  "Gaseke",
                  "Gasharu",
                  "Gashwi",
                  "Kabeza",
                  "Kayenzi",
                  "Murama",
                  "Nyakabingo",
                  "Rugarama",
                  "Ryasagahara",
                  "Wimana",
                  "Wingabe",
                ],
              },
              {
                Mutongo: [
                  "Kamina",
                  "Kanyenkondo",
                  "Karamba",
                  "Nyabihanga",
                  "Rupango",
                  "Ryagatari",
                  "Ryarugamba",
                ],
              },
              {
                Nyakabingo: [
                  "Kajumiro",
                  "Kanyege",
                  "Mataba",
                  "Musumba",
                  "Mwasa",
                  "Nyarunombe",
                  "Rugote",
                  "Rumamfu",
                  "Rwankuba",
                ],
              },
              {
                Rugari: [
                  "Bitaba",
                  "Bunyamanza",
                  "Butare",
                  "Gatyazo",
                  "Gitwa",
                  "Kabuga",
                  "Kazimba",
                  "Kirehe",
                  "Matare",
                  "Munimba",
                  "Nyakariba",
                  "Rusozi",
                  "Rutaragwe",
                  "Rwambogo",
                  "Rwamiko",
                ],
              },
              {
                Vugangoma: [
                  "Bitega",
                  "Bizi",
                  "Cyijima",
                  "Kagarama",
                  "Kigandi",
                  "Kirambira",
                  "Nkuro",
                  "Nyagahinga",
                  "Nyarusange",
                  "Wisovu",
                ],
              },
            ],
          },
          {
            Mahembe: [
              {
                Gisoke: [
                  "Fumba",
                  "Giko",
                  "Gisebeya",
                  "Kamashinge",
                  "Kanyoni",
                  "Kivumu",
                  "Muramba",
                  "Nyabumera",
                ],
              },
              {
                Kagarama: [
                  "Gabiro",
                  "Gasharu",
                  "Giti",
                  "Kanombe",
                  "Kigara",
                  "Mikingo",
                  "Nyamiheha",
                  "Ruhanga",
                  "Rukaragata",
                ],
              },
              {
                Nyagatare: [
                  "Gatare",
                  "Karambo",
                  "Kizenga",
                  "Murundo",
                  "Nyagahima",
                  "Nyakabande",
                  "Uwamaheke",
                ],
              },
              {
                Nyakavumu: [
                  "Bigali",
                  "Bisharara",
                  "Bungo",
                  "Cyinjira",
                  "Cyiya",
                  "Gitwa",
                  "Nyarusiza",
                ],
              },
            ],
          },
          {
            Nyabitekeri: [
              {
                Kigabiro: [
                  "Bunyenga",
                  "Butsure",
                  "Cyamuti",
                  "Kabarore",
                  "Kamahongo",
                  "Kigarama",
                  "Mariba",
                  "Murambi",
                  "Ruginga",
                  "Rweru",
                ],
              },
              {
                Kinunga: [
                  "Gahwazi",
                  "Gasebeya",
                  "Gashashi",
                  "Kabanda",
                  "Kagarama",
                  "Karambi",
                  "Kibanda",
                  "Mukarange",
                  "Muremure",
                  "Rugarama",
                  "Shenyeri",
                ],
              },
              {
                Mariba: [
                  "Buhinga",
                  "Gahuhezi",
                  "Gakoma",
                  "Kabacuzi",
                  "Kabukunzi",
                  "Kamabera",
                  "Kamuhoza",
                  "Karango",
                  "Mataba",
                  "Murenge",
                  "Nyarusange",
                ],
              },
              {
                Muyange: [
                  "Buhokoro",
                  "Bukiro",
                  "Bukuri",
                  "Gafunzo",
                  "Gahabwa",
                  "Gikombe",
                  "Kazibo",
                  "Nyange",
                  "Taba",
                  "Tundwe",
                ],
              },
              {
                Ntango: [
                  "Bugiga",
                  "Buhinga",
                  "Kankoni",
                  "Kanombe",
                  "Kayenzi",
                  "Murambi",
                  "Nyamirundi",
                  "Rebero",
                  "Ruhonga",
                  "Taba",
                ],
              },
            ],
          },
          {
            Rangiro: [
              {
                Banda: ["Bururi", "Gahira", "Gasumo", "Nkamba", "Uwakagano"],
              },
              {
                Gakenke: ["Gahisi", "Gasovu", "Kamatsira", "Ruhana", "Rwasa"],
              },
              {
                Jurwe: [
                  "Gasebeya",
                  "Gatagara",
                  "Kaneke",
                  "Kibavu",
                  "Rudehero",
                  "Rugomero",
                ],
              },
              {
                Murambi: [
                  "Bigeyo",
                  "Bunyenyezi",
                  "Munini",
                  "Murambi",
                  "Nyakabingo",
                  "Nyarwungo",
                  "Ryarubasha",
                ],
              },
            ],
          },
          {
            Ruharambuga: [
              {
                Kanazi: [
                  "Gashwati",
                  "Gitaba",
                  "Kadashya",
                  "Kamuhumuza",
                  "Karambo",
                  "Rubiha",
                  "Rukerereza",
                  "Rusambu",
                  "Rwamahwa",
                  "Ryamashuri",
                ],
              },
              {
                Ntendezi: [
                  "Gasharu",
                  "Kacyiru",
                  "Kagarama",
                  "Kamabuye",
                  "Kamonyi",
                  "Karambi",
                  "Kigabiro",
                  "Kigenge",
                  "Muko",
                  "Nganzo",
                  "Risansi",
                  "Rukoma",
                  "Wimpundu",
                ],
              },
              {
                Save: [
                  "Bigutu",
                  "Gihinga",
                  "Giko",
                  "Kanyovu",
                  "Manzi",
                  "Munini",
                  "Nkomero",
                  "Nyamuhunga",
                  "Save",
                ],
              },
              {
                Wimana: [
                  "Gacyamo",
                  "Gakomeye",
                  "Gasumo",
                  "Gatanga",
                  "Gikundamvura",
                  "Kabusunzu",
                  "Kamudende",
                  "Mpinga",
                  "Murambi",
                  "Ngoboka",
                  "Nkomero",
                  "Nyarushwati",
                  "Rugabano",
                  "Rumuna",
                  "Ryangange",
                ],
              },
            ],
          },
          {
            Shangi: [
              {
                Burimba: [
                  "Busangati",
                  "Gikombe",
                  "Kabahande",
                  "Nyakagano",
                  "Nyakibingo",
                  "Rubayi",
                  "Rukohwa",
                ],
              },
              {
                Mataba: [
                  "Gabiro",
                  "Gasumo",
                  "Mataba",
                  "Mpishyi",
                  "Ruzinga",
                  "Rwabagoyi",
                ],
              },
              {
                Mugera: [
                  "Bweranyange",
                  "Karugero",
                  "Karuhatana",
                  "Karuhigi",
                  "Kavo",
                  "Rwonga",
                ],
              },
              {
                Nyamugari: [
                  "Amahoro",
                  "Bitaba",
                  "Kabare",
                  "Mpande",
                  "Nyamateke",
                  "Nyamihondo",
                  "Rubavu",
                ],
              },
              {
                Shangi: [
                  "Bugomba",
                  "Busasamana",
                  "Gasharu",
                  "Kabere",
                  "Karambo",
                  "Ngoboka",
                  "Taba",
                ],
              },
            ],
          },
        ],
      },
      {
        Rubavu: [
          {
            Bugeshi: [
              {
                Buringo: [
                  "Bugeshi",
                  "Buringo",
                  "Butaka",
                  "Gaharawe",
                  "Gahira",
                  "Jenda",
                  "Mutegengeri",
                ],
              },
              {
                Butaka: [
                  "Akabajara",
                  "Akimitoni",
                  "Gaheriheri",
                  "Kabingo",
                  "Kinyamuhanga",
                  "Muremure",
                ],
              },
              {
                Hehu: [
                  "Bereshi",
                  "Bweramana",
                  "Gasizi",
                  "Gitotoma",
                  "Hangari",
                  "Humure",
                  "Kabeza",
                  "Ngando",
                ],
              },
              {
                Kabumba: [
                  "Bonde",
                  "Bugeshi",
                  "Gashaka",
                  "Gatovu",
                  "Gihira",
                  "Kabumba",
                  "Mweya",
                  "Ryarukara",
                ],
              },
              {
                Mutovu: [
                  "Bigaragara",
                  "Bugeshi",
                  "Kabuhanga",
                  "Kimpongo",
                  "Mburamazi",
                  "Rindiro",
                  "Vuna",
                ],
              },
              {
                Nsherima: [
                  "Batikoti",
                  "Bipfura",
                  "Bweza",
                  "Cyumba",
                  "Gaheriheri",
                  "Murangara",
                ],
              },
              {
                Rusiza: [
                  "Bihe",
                  "Bunjuri",
                  "Kabarore",
                  "Kitagabwa",
                  "Nyacyonga",
                  "Ryarugamba",
                ],
              },
            ],
          },
          {
            Busasamana: [
              {
                Gacurabwenge: [
                  "Biziguro",
                  "Bukumu",
                  "Busanganya",
                  "Gakomero",
                  "Kamuyenzi",
                  "Kanondo",
                  "Kanyabijumba",
                  "Nyamyenge",
                  "Nyarubuye",
                  "Nyarusozi",
                ],
              },
              {
                Gasiza: [
                  "Bunyogwe",
                  "Gisura",
                  "Kibavu",
                  "Kinyababa",
                  "Kinyandaro",
                  "Kiraro",
                  "Mashinga",
                  "Munanira",
                  "Nyarunembwe",
                  "Rwagare",
                ],
              },
              {
                Gihonga: ["Marumba", "Mubona", "Nyamyumba", "Sabushengo"],
              },
              {
                Kageshi: [
                  "Gasenyi",
                  "Kigezi",
                  "Mufumba",
                  "Ruhara",
                  "Rwamigega",
                  "Rwankuba",
                ],
              },
              {
                Makoro: ["Gakuta", "Hanika", "Kamuzamuzi", "Karambi", "Kidadi"],
              },
              {
                Nyacyonga: [
                  "Cyanika",
                  "Kacyiru",
                  "Kamiro",
                  "Kingogo",
                  "Kitagabwa",
                  "Nyarurembo",
                ],
              },
              {
                Rusura: [
                  "Cyamabuye",
                  "Kabagoyi",
                  "Kageyo",
                  "Kambonyi",
                  "Kamivumba",
                  "Kinogo",
                  "Munege",
                  "Rebero",
                ],
              },
            ],
          },
          {
            Cyanzarwe: [
              {
                Busigari: ["Bisizi", "Bugu", "Kanembwe", "Rwashungwe"],
              },
              {
                Cyanzarwe: [
                  "Butango",
                  "Cyanzarwe",
                  "Gasenyi",
                  "Karangara",
                  "Kiruhura",
                  "Rushura",
                ],
              },
              {
                Gora: ["Burima", "Gora", "Kabere"],
              },
              {
                Kinyanzovu: ["Bushanga", "Kanyentambi", "Kibaya", "Muhororo"],
              },
              {
                Makurizo: [
                  "Gashuha",
                  "Makurizo",
                  "Mukingo",
                  "Nyamugari",
                  "Ruhuranda",
                ],
              },
              {
                Rwangara: [
                  "Buramazi",
                  "Hanika",
                  "Muti",
                  "Nyakabanda",
                  "Nyakabungo",
                ],
              },
              {
                Rwanzekuma: [
                  "Kabirizi",
                  "Karambi",
                  "Kinyamiyaga",
                  "Munaba",
                  "Rukorakore",
                ],
              },
              {
                Ryabizige: [
                  "Burere",
                  "Kanyamagare",
                  "Kavumu",
                  "Muhuhuri",
                  "Musene",
                  "Nganzo",
                ],
              },
            ],
          },
          {
            Gisenyi: [
              {
                Amahoro: [
                  "Amahoro",
                  "Isangano",
                  "Kitagabwa",
                  "Muhabura",
                  "Murakazaneza",
                  "Murisanga",
                  "Terimbere",
                  "Umunezero",
                  "Urugwiro",
                ],
              },
              {
                Bugoyi: [
                  "Amataba",
                  "Bugoyi",
                  "Giraneza",
                  "Irakiza",
                  "Isangano",
                  "Ituze",
                  "Kaminuza",
                  "Nyakabungo",
                  "Ubutabera",
                  "Ubwiza",
                ],
              },
              {
                Kivumu: [
                  "Giponda",
                  "Igisubizo",
                  "Itangazamakuru",
                  "Karisimbi",
                  "Kivumu",
                  "Muduha",
                  "Murisanga",
                  "Ubukerarugendo",
                  "Ubumwe",
                  "Ubutabazi",
                  "Umurava",
                  "Urumuri",
                ],
              },
              {
                Mbugangari: [
                  "Abahuje",
                  "Amajyambere",
                  "Gasutamo",
                  "Haguruka",
                  "Icyinyambo",
                  "Ihumure",
                  "Ikaze",
                  "Ikibuga",
                  "Inkurunziza",
                  "Iyobokamana",
                  "Karundo",
                  "Nyarubande",
                  "Rebero",
                  "Uburanga",
                  "Uburezi",
                  "Ubwiyunge",
                  "Umubano",
                  "Umutekano",
                ],
              },
              {
                Nengo: [
                  "Gacuba",
                  "Gikarani",
                  "Kivu",
                  "Nyabagobe",
                  "Nyaburanga",
                  "Ubucuruzi",
                  "Urubyiruko",
                ],
              },
              {
                Rubavu: [
                  "Gahojo",
                  "Kamayugi",
                  "Kanyarutambi",
                  "Munini",
                  "Rubavu",
                  "Ruliba",
                ],
              },
              {
                Umuganda: [
                  "Bonde",
                  "Dukore",
                  "Ihuriro",
                  "Kabuga",
                  "Majengo",
                  "Muhato",
                  "Umucyo",
                  "Umuganda",
                  "Umunyinya",
                ],
              },
            ],
          },
          {
            Kanama: [
              {
                Kamuhoza: [
                  "Bambiro",
                  "Kagarama",
                  "Nyamigogo",
                  "Nyanshundura",
                  "Rukoro",
                  "Rwankomo",
                ],
              },
              {
                Karambo: ["Gahunga", "Mariba", "Mutanda", "Ndongoshori"],
              },
              {
                Mahoko: [
                  "Bikuka",
                  "Kabeza",
                  "Kabindi",
                  "Kanama",
                  "Kara",
                  "Mahoko",
                  "Nyagasozi",
                  "Nyamirambo",
                  "Nyamugari",
                  "Nyamuremure",
                  "Rubare",
                  "Shusho",
                ],
              },
              {
                Musabike: [
                  "Kabingo",
                  "Kagano",
                  "Kaje",
                  "Nteranya",
                  "Nyakibande",
                  "Ryamibungo",
                ],
              },
              {
                Nkomane: [
                  "Gashasho",
                  "Gatsina",
                  "Nkomane",
                  "Nyabishongo",
                  "Rwanzuki",
                ],
              },
              {
                Rusongati: [
                  "Busesa",
                  "Gihurizo",
                  "Kabere",
                  "Kibuga",
                  "Mashyoza",
                  "Muvebwa",
                  "Nyabitunda",
                ],
              },
              {
                Yungwe: [
                  "Bwikurure",
                  "Gikomero",
                  "Rugege",
                  "Rugogwe",
                  "Rutagara",
                  "Yungwe",
                ],
              },
            ],
          },
          {
            Kanzenze: [
              {
                Kanyirabigogo: ["Giramata", "Kabana", "Mizingo", "Murambi"],
              },
              {
                Kirerema: ["Bisesero", "Kirerema", "Rushasho"],
              },
              {
                Muramba: ["Kanya", "Muramba", "Rubara", "Tubindi"],
              },
              {
                Nyamikongi: ["Cyivugiza", "Kabari", "Nyamikongi", "Rwamikungu"],
              },
              {
                Nyamirango: ["Gasizi", "Mareru", "Mizingo", "Nyamirango"],
              },
              {
                Nyaruteme: ["Kabere", "Karagarago", "Rugali"],
              },
            ],
          },
          {
            Mudende: [
              {
                Bihungwe: [
                  "Bihungwe",
                  "Bivumu",
                  "Bunyove",
                  "Mwirima",
                  "Rukeri",
                ],
              },
              {
                Kanyundo: [
                  "Gahanika",
                  "Mugongo",
                  "Murambi",
                  "Mutura",
                  "Nyamirama",
                  "Rebero",
                ],
              },
              {
                Micinyiro: [
                  "Gasiza",
                  "Kanombe",
                  "Kanyamitura",
                  "Micinyiro",
                  "Nyagisozi",
                  "Tetero",
                ],
              },
              {
                Mirindi: ["Gasumba", "Kiryoha", "Mirindi", "Tamira"],
              },
              {
                Ndoranyi: [
                  "Gaharawe",
                  "Gikuyu",
                  "Gitega",
                  "Karandaryi",
                  "Kinyangwe",
                  "Nyabishongo",
                ],
              },
              {
                Rungu: ["Bihe", "Gahenerezo", "Ndiza", "Rungu", "Rwangara"],
              },
              {
                Rwanyakayaga: [
                  "Kabunoni",
                  "Muyange",
                  "Nangurubibi",
                  "Nyamugari",
                ],
              },
            ],
          },
          {
            Nyakiriba: [
              {
                Bisizi: [
                  "Bweza",
                  "Gisangani",
                  "Kamakinga",
                  "Kibuye",
                  "Kingoma",
                  "Mwumba",
                  "Nyamwishyura",
                  "Runaba",
                ],
              },
              {
                Gikombe: [
                  "Kitarimwa",
                  "Nyabibuye",
                  "Nyabirezi",
                  "Nyakibande",
                  "Rugerero",
                  "Rushubi",
                ],
              },
              {
                Kanyefurwe: [
                  "Kayove",
                  "Kiyovu",
                  "Muhira",
                  "Nyakabungo",
                  "Rebero",
                  "Rukoro",
                ],
              },
              {
                Nyarushyamba: [
                  "Bazirete",
                  "Kivumu",
                  "Makoro",
                  "Nyonirima",
                  "Ruhangiro",
                  "Runyeheri",
                  "Ruvuzananga",
                ],
              },
            ],
          },
          {
            Nyamyumba: [
              {
                Burushya: [
                  "Kaberamo",
                  "Kabuyekera",
                  "Karuvugiro",
                  "Muhingo",
                  "Mutembe",
                  "Nganzo",
                  "Wintwari",
                ],
              },
              {
                Busoro: [
                  "Bugoma",
                  "Buhanga",
                  "Bujenje",
                  "Bushagi",
                  "Buvano",
                  "Gateko",
                  "Kabushongo",
                  "Kanajana",
                  "Kiguri",
                ],
              },
              {
                Kinigi: [
                  "Burevu",
                  "Byima",
                  "Gatyazo",
                  "Karambi",
                  "Nyabisusa",
                  "Nyamiko",
                  "Pfunda",
                ],
              },
              {
                Kiraga: [
                  "Buhogo",
                  "Bukiro",
                  "Kigufi",
                  "Mukondo",
                  "Nyaruhonga",
                  "Rambo",
                ],
              },
              {
                Munanira: [
                  "Bugarura",
                  "Busumba",
                  "Cyeya",
                  "Kabakora",
                  "Nyamirambo",
                  "Rebero",
                  "Ruhondo",
                  "Shusho",
                ],
              },
              {
                Rubona: [
                  "Bugasha",
                  "Buharara",
                  "Bunyago",
                  "Burima",
                  "Butotori",
                  "Kabiza",
                  "Kabuyekera",
                  "Remera",
                  "Rurembo",
                  "Rushagara",
                  "Tagaza",
                ],
              },
            ],
          },
          {
            Nyundo: [
              {
                Bahimba: [
                  "Bahimba",
                  "Buhozi",
                  "Gatuntu",
                  "Kagera",
                  "Kanyiraruhindu",
                  "Ngege",
                  "Rurembo",
                ],
              },
              {
                Gatovu: [
                  "Budaha",
                  "Busheru",
                  "Cyima",
                  "Kanyahene",
                  "Murambi",
                  "Ruhanga",
                ],
              },
              {
                Kavomo: [
                  "Bahimba",
                  "Burambo",
                  "Gitwa",
                  "Kavumu",
                  "Kinihira",
                  "Kinyendaro",
                  "Shonyi",
                ],
              },
              {
                Kigarama: [
                  "Busesa",
                  "Kazabe",
                  "Mwali",
                  "Ndamiye",
                  "Rukore",
                  "Rwantobo",
                ],
              },
              {
                Mukondo: [
                  "Buroha",
                  "Busogo",
                  "Byiniro",
                  "Cyungeri",
                  "Kabitongo",
                  "Kanyamisuku",
                  "Kashumba",
                  "Nkora",
                  "Remera",
                  "Tanda",
                ],
              },
              {
                Nyundo: [
                  "Birembo",
                  "Gasenyi",
                  "Huye",
                  "Kayanza",
                  "Kiribata",
                  "Kiyove",
                  "Kiziguro",
                  "Nyakagezi",
                  "Rumbati",
                  "Runandi",
                ],
              },
              {
                Terimbere: [
                  "Gahama",
                  "Hanika",
                  "Kanyamatembe",
                  "Keya",
                  "Nombe",
                  "Rambura",
                  "Ruhango",
                  "Terimbere",
                ],
              },
            ],
          },
          {
            Rubavu: [
              {
                Buhaza: ["Dufatanye", "Gabiro", "Murambi"],
              },
              {
                Burinda: [
                  "Akasengore",
                  "Bubaji",
                  "Gasenyi",
                  "Nyabantu",
                  "Nyamwinshi",
                  "Rwezamenyo",
                ],
              },
              {
                Byahi: ["Buhuru", "Isangano", "Mikingo", "Ngugo", "Rurembo"],
              },
              {
                Gikombe: [
                  "Bambiro",
                  "Bushengo I",
                  "Gafuku",
                  "Mubuga",
                  "Rebero",
                ],
              },
              {
                Murambi: [
                  "Bushengo",
                  "Buzuta",
                  "Bwiru",
                  "Kabere II",
                  "Ruvumbu",
                  "Rwangara",
                ],
              },
              {
                Murara: ["Bugesera", "Gahinga", "Gasayo", "Kabere", "Kiroji"],
              },
              {
                Rukoko: [
                  "Bisizi",
                  "Isangano",
                  "Karukogo",
                  "Kitarimwa",
                  "Rutagara",
                ],
              },
            ],
          },
          {
            Rugerero: [
              {
                Basa: [
                  "Buranga",
                  "Gahinga",
                  "Kabeza",
                  "Kanyukiro",
                  "Mukumya",
                  "Nyaruhengeri",
                  "Tagaza",
                ],
              },
              {
                Gisa: [
                  "Gatangare",
                  "Gihira",
                  "Gisa",
                  "Kabashanja",
                  "Kaniga",
                  "Ndobogo",
                  "Rusongati",
                  "Shwemu",
                ],
              },
              {
                Kabilizi: [
                  "Amahoro",
                  "Gakoro",
                  "Nkama",
                  "Nyamyiri",
                  "Ruhangiro",
                  "Rukukumbo",
                ],
              },
              {
                Muhira: [
                  "Gatebe I",
                  "Gatebe II",
                  "Gitebe I",
                  "Gitebe II",
                  "Kasonga",
                  "Kizi",
                  "Rusamaza",
                ],
              },
              {
                Rugerero: [
                  "Kabarora",
                  "Kibaya",
                  "Nyantomvu",
                  "Nyarurembo",
                  "Rukingo",
                  "Ruranga",
                ],
              },
              {
                Rushubi: [
                  "Busheke",
                  "Butangi",
                  "Butumba",
                  "Kabashara",
                  "Kazika",
                  "Kimina",
                  "Muhingo",
                ],
              },
              {
                Rwaza: [
                  "Byima",
                  "Cyanika",
                  "Gashovu",
                  "Gateko",
                  "Kiroji",
                  "Mushoko",
                  "Rebero",
                  "Rohero",
                  "Rucyamo",
                  "Rwaza",
                ],
              },
            ],
          },
        ],
      },
      {
        Rutsiro: [
          {
            Boneza: [
              {
                Bushaka: [
                  "Bikono",
                  "Bugarura",
                  "Gaseke",
                  "Kabirizi",
                  "Kinunu",
                  "Muramba",
                  "Rutagara",
                  "Rwimbogo",
                ],
              },
              {
                Kabihogo: [
                  "Buhonongo",
                  "Bweramana",
                  "Gashoko",
                  "Kamuyaga",
                  "Rugamba",
                  "Rwabisururu",
                ],
              },
              {
                Nkira: [
                  "Gisiza",
                  "Gisoro",
                  "Kabuga",
                  "Karukamba",
                  "Kigarama",
                  "Munanira",
                  "Murambi",
                ],
              },
              {
                Remera: [
                  "Bigabiro",
                  "Buhoro",
                  "Kaganza",
                  "Kamuzigura",
                  "Kinunga",
                  "Muyange",
                  "Rusororo",
                ],
              },
            ],
          },
          {
            Gihango: [
              {
                Bugina: ["Gishushu", "Gitarama", "Kagarama", "Karambi"],
              },
              {
                "Congo-nil": [
                  "Kandahura",
                  "Kindoyi",
                  "Mukebera",
                  "Nduba",
                  "Nkwiro",
                ],
              },
              {
                Mataba: [
                  "Butare",
                  "Kabeza",
                  "Kamutambiro",
                  "Muyange",
                  "Nganzo",
                  "Terimbere",
                ],
              },
              {
                Murambi: [
                  "Gashihe",
                  "Gatomvu",
                  "Karugaju",
                  "Muhora",
                  "Nyagahinga",
                ],
              },
              {
                Ruhingo: ["Gasharu", "Kabuga", "Nyagahinga"],
              },
              {
                Shyembe: [
                  "Gisunzu",
                  "Karambo",
                  "Karongi",
                  "Rugote",
                  "Rwamiyaga",
                  "Shyembe",
                ],
              },
              {
                Teba: ["Bweramana", "Gasave", "Gateja", "Kanembwe", "Rasaniro"],
              },
            ],
          },
          {
            Kigeyo: [
              {
                Buhindure: [
                  "Burambo",
                  "Bushaka",
                  "Gacaca",
                  "Gaharawe",
                  "Gisiza",
                  "Nkamba",
                  "Nkomero",
                  "Nturo",
                ],
              },
              {
                Nkora: [
                  "Buhimba",
                  "Gahotora",
                  "Gasagara",
                  "Gasereganya",
                  "Humiro",
                  "Kabashyembe",
                  "Kanyirahweza",
                  "Karambi",
                  "Kigugu",
                  "Muhora",
                  "Rukundo",
                ],
              },
              {
                Nyagahinika: [
                  "Bukungu",
                  "Kampi",
                  "Nteko",
                  "Nyarusuku",
                  "Rugabi",
                  "Rukombe",
                  "Rupango",
                  "Rusisiro",
                  "Ruvumu",
                ],
              },
              {
                Rukaragata: [
                  "Gahunga",
                  "Gasenyi",
                  "Kagondero",
                  "Kamina",
                  "Kinihira",
                  "Murambi",
                  "Nganzo",
                  "Rwambeho",
                  "Rwamiyaga",
                  "Tagaza",
                ],
              },
            ],
          },
          {
            Kivumu: [
              {
                Bunyoni: [
                  "Bureke",
                  "Gashinga",
                  "Gihari",
                  "Gitwa",
                  "Kabigabiro",
                  "Kanyempanga",
                  "Nyarubuye",
                ],
              },
              {
                Bunyunju: [
                  "Cyivugiza",
                  "Kamabuye",
                  "Karungu",
                  "Mpinga",
                  "Rwamvura",
                  "Tarafiporo",
                ],
              },
              {
                Kabere: [
                  "Burambo",
                  "Burango",
                  "Cyato",
                  "Kabitara",
                  "Kabusagara",
                  "Kagera",
                  "Mushubati",
                ],
              },
              {
                Kabujenje: [
                  "Bitare",
                  "Buhogo",
                  "Kabagwe",
                  "Kabuye",
                  "Kanyamatembe",
                  "Rurembo",
                  "Rusisiro",
                  "Rutambi",
                  "Tarasi",
                ],
              },
              {
                Karambi: [
                  "Bukiro",
                  "Bukumba",
                  "Buroha",
                  "Bushamba",
                  "Gateko",
                  "Kabuga",
                  "Nyundo",
                  "Rusumo",
                ],
              },
              {
                Nganzo: [
                  "Bubira",
                  "Bugarishya",
                  "Kamwimba",
                  "Muramba",
                  "Nyabiti",
                  "Remera",
                  "Rwinyoni",
                  "Tawuni",
                ],
              },
            ],
          },
          {
            Manihira: [
              {
                Haniro: [
                  "Bitabaro",
                  "Gisunzu",
                  "Gitwe",
                  "Kaziramihunda",
                  "Kivumu",
                  "Mifu",
                  "Rukondo",
                  "Runaba",
                ],
              },
              {
                Muyira: [
                  "Birambo",
                  "Kagarama",
                  "Kamishunguro",
                  "Kanama",
                  "Kimpongo",
                  "Mujebeshi",
                  "Muyira",
                  "Nyakarambi",
                  "Rufungo",
                  "Rutangaza",
                  "Rutare",
                ],
              },
              {
                Tangabo: [
                  "Kabeza",
                  "Kadehero",
                  "Kanama",
                  "Karambo",
                  "Munini",
                  "Nyarushogwe",
                  "Rugano",
                ],
              },
            ],
          },
          {
            Mukura: [
              {
                Kabuga: ["Kabahigi", "Karambo Ya 1", "Miraramo", "Sanzare"],
              },
              {
                Kagano: [
                  "Cyabatsinga",
                  "Gakeri",
                  "Kabacuzi",
                  "Kagano",
                  "Kamonyi",
                  "Kazizi",
                  "Kibavu",
                  "Kiriba",
                  "Ntobo",
                  "Nyaburama",
                  "Rugomero",
                  "Tumba",
                ],
              },
              {
                Kageyo: [
                  "Bitura",
                  "Karumbi",
                  "Kigeyo",
                  "Kimishishi",
                  "Mucaca",
                  "Ntonde",
                  "Nyanzu",
                  "Rukeri",
                  "Rukondo",
                  "Site Mukura Ya 1",
                  "Site Mukura Ya 2",
                ],
              },
              {
                Kagusa: ["Bucyeye", "Gako", "Gasharu", "Muhindo", "Rusasa"],
              },
              {
                Karambo: [
                  "Bandamiko",
                  "Dehero",
                  "Gasambi",
                  "Gihumo",
                  "Gituntu",
                  "Karambo Ya 2",
                  "Terimbere",
                ],
              },
              {
                Mwendo: [
                  "Bitenga",
                  "Gafu",
                  "Gako",
                  "Gitega",
                  "Kabeza",
                  "Kabisasa",
                  "Kagogo",
                  "Kagombwa",
                  "Kamariba",
                  "Mataba",
                  "Nyarubande",
                  "Nyarusongati",
                  "Nyove",
                  "Rugari",
                ],
              },
            ],
          },
          {
            Murunda: [
              {
                Kirwa: [
                  "Bukongora",
                  "Gasasa",
                  "Kabatemba",
                  "Kajugujugu",
                  "Karumbi",
                  "Karuruma",
                  "Muremure",
                  "Nyenyeri",
                  "Ruhanga",
                  "Rusisiro",
                  "Satinsyi",
                ],
              },
              {
                Mburamazi: [
                  "Gatoki",
                  "Kamuhoza",
                  "Kariba",
                  "Murunda",
                  "Rukingu",
                  "Rurimba",
                  "Rwamiko",
                ],
              },
              {
                Rugeyo: [
                  "Kabeza",
                  "Kamabuye",
                  "Kamusambi",
                  "Karambo",
                  "Musongati",
                ],
              },
              {
                Twabugezi: [
                  "Bweramana",
                  "Gatare",
                  "Nyarucundura",
                  "Rwanika",
                  "Rwoza",
                ],
              },
            ],
          },
          {
            Musasa: [
              {
                Gabiro: [
                  "Gabiro",
                  "Gitwa",
                  "Murama",
                  "Nyagahinga",
                  "Nyarugenge",
                  "Rugarambiro",
                  "Rwagatoki",
                  "Rwangoma",
                ],
              },
              {
                Gisiza: [
                  "Bweramana",
                  "Gasharu",
                  "Gihinga",
                  "Gisiza",
                  "Gitovu",
                  "Karambi",
                  "Karambo",
                  "Ngoma",
                  "Nyagafurwe",
                  "Rubaya",
                ],
              },
              {
                Murambi: [
                  "Bunnyari",
                  "Buruseri",
                  "Kabatoni",
                  "Munyinya",
                  "Murambi",
                  "Nyamasheke",
                  "Rwintanga",
                  "Rwumba",
                  "Syiki",
                ],
              },
              {
                Nyarubuye: [
                  "Bwinyana",
                  "Gataka",
                  "Gitete",
                  "Kabuga",
                  "Mirambi",
                  "Muhororo",
                  "Rebero",
                ],
              },
            ],
          },
          {
            Mushonyi: [
              {
                Biruyi: [
                  "Buhunde",
                  "Bushunga",
                  "Buzukira",
                  "Kabakiza",
                  "Kamaranzara",
                  "Karengera",
                  "Mugara",
                  "Rurimba",
                ],
              },
              {
                Kaguriro: [
                  "Cyondo",
                  "Gakenke",
                  "Kabere",
                  "Kivumu",
                  "Maziba",
                  "Mubuga",
                  "Rugerero",
                  "Rwesero",
                  "Ryarwasa",
                ],
              },
              {
                Magaba: [
                  "Gakomeye",
                  "Gasave",
                  "Gihumba",
                  "Kakibaba",
                  "Kariba",
                  "Nkomero",
                  "Ruyogoro",
                ],
              },
              {
                Rurara: [
                  "Gasoro",
                  "Gisunzu",
                  "Kaboneye",
                  "Kagano",
                  "Kashishi",
                  "Kavumu",
                  "Mukati",
                  "Ngunguru",
                  "Rugaragara",
                  "Ruhengeri",
                ],
              },
            ],
          },
          {
            Mushubati: [
              {
                Bumba: [
                  "Bisyo",
                  "Kabiraho",
                  "Kamushozi",
                  "Karambi",
                  "Mataba",
                  "Rugote",
                  "Ruhinga",
                ],
              },
              {
                Cyarusera: [
                  "Bivumu",
                  "Cyahafi",
                  "Gasharu",
                  "Kigarama",
                  "Kunini",
                  "Mugeri",
                ],
              },
              {
                Gitwa: [
                  "Gakoma",
                  "Gashinge",
                  "Karambira",
                  "Kibari",
                  "Mbuga",
                  "Mubuga",
                  "Mugote",
                  "Rububa",
                  "Ruhinga",
                  "Rwintore",
                  "Taba",
                ],
              },
              {
                Mageragere: [
                  "Gitega",
                  "Murambi",
                  "Nyakabuye",
                  "Nyarusange",
                  "Rarankuba",
                  "Rushikiri",
                ],
              },
              {
                Sure: [
                  "Kabuga",
                  "Kaduha",
                  "Kagugu",
                  "Kanyinya",
                  "Kivumu",
                  "Nyagahinga",
                  "Nyamahuru",
                ],
              },
            ],
          },
          {
            Nyabirasi: [
              {
                Busuku: [
                  "Bishami",
                  "Busuku",
                  "Busuti",
                  "Bwiza",
                  "Gacaca",
                  "Gatare",
                  "Ngugo",
                  "Nyakibande",
                  "Rwamigega",
                  "Torwe",
                  "Tsindiro",
                ],
              },
              {
                Cyivugiza: [
                  "Cyubi",
                  "Gakumba",
                  "Gishahaga",
                  "Kageyo",
                  "Kamananga",
                  "Mukungu",
                  "Nyabishongo",
                  "Rukomero",
                ],
              },
              {
                Mubuga: [
                  "Bugorozi",
                  "Buryoshya",
                  "Gakararanka",
                  "Gashasho",
                  "Gatsiro",
                  "Gitongo",
                  "Kabaratama",
                  "Mubuga",
                  "Pfunda",
                  "Rushubi",
                  "Rutovu",
                  "Rwankuba",
                ],
              },
              {
                Ngoma: [
                  "Bukanda",
                  "Bushoga",
                  "Cyeshero",
                  "Gashihe",
                  "Gisayo",
                  "Gishowa",
                  "Kaje",
                  "Kamunyurwe",
                  "Kazo",
                  "Mpati",
                  "Ngoma",
                  "Nkuna",
                ],
              },
              {
                Terimbere: [
                  "Gihinga",
                  "Kageshi",
                  "Kanombe",
                  "Karongi",
                  "Kasonga",
                  "Kinyamavuta",
                  "Mukondo",
                  "Negenero",
                  "Nyampengeri",
                  "Ruraji",
                  "Rwandozi",
                  "Rwangambuto",
                  "Ryanyiramunonko",
                ],
              },
            ],
          },
          {
            Ruhango: [
              {
                Gatare: [
                  "Gasovu",
                  "Gasoyo",
                  "Kamuramira",
                  "Kirinja",
                  "Mwurire",
                  "Ruhimbi",
                  "Rukenesha",
                ],
              },
              {
                Gihira: [
                  "Bitenga",
                  "Busenda",
                  "Karambagiro",
                  "Kararo",
                  "Kinyenkanda",
                  "Murambi",
                  "Rukoko",
                  "Tara",
                ],
              },
              {
                Kavumu: [
                  "Gakeri",
                  "Gasasa",
                  "Gasunzu",
                  "Mubirizi",
                  "Muhingo",
                  "Nyundo",
                ],
              },
              {
                Nyakarera: [
                  "Buzeyi",
                  "Kabeza",
                  "Kagogo",
                  "Kayove",
                  "Marabuye",
                  "Mugali",
                ],
              },
              {
                Rugasa: [
                  "Cyashenge",
                  "Gicaca",
                  "Kabitovu",
                  "Kiraza",
                  "Murambi",
                  "Nyakagezi",
                ],
              },
              {
                Rundoyi: [
                  "Gakararanka",
                  "Karebero",
                  "Kaziga",
                  "Matyazo",
                  "Rugaragara",
                  "Rushasho",
                ],
              },
            ],
          },
          {
            Rusebeya: [
              {
                Kabona: [
                  "Byiniro",
                  "Kibara",
                  "Munini",
                  "Murengeri",
                  "Ntereye",
                  "Nyagasambu",
                  "Rusheshi",
                  "Rwamvura",
                ],
              },
              {
                Mberi: [
                  "Bungwe",
                  "Gakeri",
                  "Gashihe",
                  "Gatenga",
                  "Gihinga",
                  "Kabeza",
                  "Kacyiru",
                  "Kagano",
                  "Marimba",
                  "Ruganda",
                  "Rurimba",
                ],
              },
              {
                Remera: [
                  "Bihira",
                  "Bweramana",
                  "Gahunga",
                  "Kabarirwa",
                  "Kiyanja",
                  "Nturo",
                  "Ruhuha",
                  "Rurambo",
                  "Shyembe",
                ],
              },
              {
                Ruronde: [
                  "Gisozi",
                  "Kigali",
                  "Kirumbi",
                  "Mubuga",
                  "Nyamibombwe",
                ],
              },
            ],
          },
        ],
      },
      {
        Rusizi: [
          {
            Bugarama: [
              {
                Nyange: [
                  "Cité",
                  "Cyagara",
                  "Gatebe",
                  "Kabeza",
                  "Kamabuye",
                  "Mihabura",
                  "Misufi",
                  "Mubogora",
                  "Muko",
                  "Munini",
                  "Nyange",
                  "Rubumba",
                  "Rusayo",
                ],
              },
              {
                Pera: [
                  "Buhanga",
                  "Isangano",
                  "Ituze",
                  "Kabusunzu",
                  "Kabuye",
                  "Kinamba",
                  "Kiyovu",
                  "Majyambere",
                  "Murambi",
                  "Murwa",
                  "Mwaro",
                  "Pera",
                ],
              },
              {
                Ryankana: [
                  "Gihigano",
                  "Gombaniro",
                  "Kabuga",
                  "Kagarama",
                  "Kayenzi",
                  "Mahoro",
                  "Mubombo",
                  "Muyange",
                  "Nyehonga",
                  "Rubyiro",
                  "Ruhwa",
                  "Rusizi",
                ],
              },
            ],
          },
          {
            Butare: [
              {
                Butanda: [
                  "Buganzo",
                  "Gasihe",
                  "Gitega",
                  "Murambi",
                  "Mwoya",
                  "Rugera",
                  "Rujagi",
                ],
              },
              {
                Gatereri: [
                  "Giciramata",
                  "Gisovu",
                  "Kabuga",
                  "Karama",
                  "Kareba",
                  "Nyabitimbo",
                  "Nyaburenge",
                  "Nyakibanda",
                  "Nyambeho",
                  "Ruhinga",
                  "Rwibutso",
                ],
              },
              {
                Nyamihanda: [
                  "Kenya",
                  "Kirwano",
                  "Munkamba",
                  "Mwimerere",
                  "Ndengerezi",
                  "Rushwati",
                ],
              },
              {
                Rwambogo: [
                  "Bisengo",
                  "Buye",
                  "Byimana",
                  "Cyaruhiza",
                  "Cyijuru",
                  "Gasumo",
                  "Karambo",
                  "Kigarama",
                  "Nyaruteja",
                  "Rutovu",
                ],
              },
            ],
          },
          {
            Bweyeye: [
              {
                Gikungu: ["Kibonajoro", "Rwamagare"],
              },
              {
                Kiyabo: [
                  "Bunyagiro",
                  "Matyazo",
                  "Mbisabasaba",
                  "Mudasomwa",
                  "Mutara",
                  "Ruhondo",
                  "Runege",
                  "Rutobo",
                ],
              },
              {
                Murwa: ["Muyebe", "Nyabigoma"],
              },
              {
                Nyamuzi: ["Gakopfo", "Kigobe", "Muhiza", "Rwamisave"],
              },
              {
                Rasano: [
                  "Banamba",
                  "Kabuga",
                  "Nyamirambo",
                  "Nyamutake",
                  "Runyami",
                  "Runyovu",
                  "Uwinzovu",
                ],
              },
            ],
          },
          {
            Gashonga: [
              {
                Birembo: ["Mariba", "Burama"],
              },
              {
                Buhokoro: [
                  "Busekera",
                  "Cyimbazi",
                  "Gahinga",
                  "Kabahizi",
                  "Ryagacece",
                ],
              },
              {
                Kabakobwa: ["Gatare", "Munini", "Rango", "Rwesero"],
              },
              {
                Kacyuma: ["Mubuga", "Mukaba", "Rango", "Torero"],
              },
              {
                Kamurehe: [
                  "Gacyamo",
                  "Gasharu",
                  "Kamonyi",
                  "Mashya",
                  "Murehe",
                  "Nyabihanga",
                  "Rebero",
                  "Shara",
                ],
              },
              {
                Karemereye: [
                  "Kabaha",
                  "Kabahinda",
                  "Kagikongoro",
                  "Mibirizi",
                  "Rugarama",
                ],
              },
              {
                Muti: ["Gakombe", "Kabeza", "Karenge", "Marebe", "Rugende"],
              },
              {
                Rusayo: [
                  "Bitaba",
                  "Kamuhana",
                  "Kibombwe",
                  "Kiremereye",
                  "Misave",
                  "Nyamutarama",
                  "Ryagatebe",
                ],
              },
            ],
          },
          {
            Giheke: [
              {
                Cyendajuru: ["Burembo", "Kabeza", "Kibakure", "Murinzi"],
              },
              {
                Gakomeye: ["Buzi", "Gacyamo", "Kabuga", "Kagarama", "Ruvumbu"],
              },
              {
                Giheke: [
                  "Karambo",
                  "Murambi",
                  "Rugombo",
                  "Rwumvangoma",
                  "Wimana",
                ],
              },
              {
                Kamashangi: ["Gitwa", "Isha", "Kamuhozi", "Rukombe"],
              },
              {
                Kigenge: ["Gahinga", "Gahurubuka", "Rwamiko"],
              },
              {
                Ntura: [
                  "Bubanga",
                  "Kabujyogoro",
                  "Kabyuma",
                  "Karambi",
                  "Kavuye",
                  "Kigenge",
                  "Ntura",
                  "Rebero",
                ],
              },
              {
                Rwega: ["Impala", "Kanoga", "Rwega"],
              },
              {
                Turambi: ["Kamuhoza", "Munyove", "Rwinkwavu", "Turambi"],
              },
            ],
          },
          {
            Gihundwe: [
              {
                Burunga: [
                  "Burunga",
                  "Cyapa",
                  "Cyunyu",
                  "Gacamahembe",
                  "Kamabuye",
                  "Kanombe",
                  "Karangiro",
                  "Karitasi",
                  "Karorabose",
                  "Karushaririza",
                ],
              },
              {
                Gatsiro: [
                  "Gahinga",
                  "Gikombe",
                  "Kavumu",
                  "Kinyereri",
                  "Mpongora",
                  "Rwahi",
                  "Tuwonane",
                ],
              },
              {
                Gihaya: ["Budorozo", "Kinyaga"],
              },
              {
                Kagara: [
                  "Bahemba",
                  "Kivoga",
                  "Nyandarama",
                  "Rubenga I",
                  "Rubenga II",
                  "Rukohwa",
                ],
              },
              {
                Kamatita: [
                  "Cyinzovu",
                  "Gahwazi",
                  "Kamanyenga",
                  "Muhari",
                  "Munyana",
                  "Ngoma",
                ],
              },
              {
                Shagasha: [
                  "Bisanganira",
                  "Gasharu",
                  "Gitwa",
                  "Kanoga",
                  "Karambo",
                  "Nyagatare",
                  "Shagasha",
                ],
              },
            ],
          },
          {
            Gikundamvura: [
              {
                Kizura: [
                  "Gasharu",
                  "Gitambi",
                  "Hinduka",
                  "Ituze",
                  "Kamabuye",
                  "Mubera",
                  "Mutonga",
                  "Ruhango",
                  "Rukuraza",
                  "Shanike",
                ],
              },
              {
                Mpinga: [
                  "Birindiro",
                  "Busarabuye",
                  "Bushenge",
                  "Gihomba",
                  "Kaberenge",
                  "Kagari",
                  "Kirume",
                  "Matyazo",
                  "Mpuzamahanga",
                  "Mubuga",
                  "Mugerero",
                  "Nyabihanga",
                  "Rebero",
                ],
              },
              {
                Nyamigina: [
                  "Binyaburanga",
                  "Buhinga",
                  "Bumaranyota",
                  "Bwiza",
                  "Jyambere",
                  "Kanoga",
                  "Kariba",
                ],
              },
            ],
          },
          {
            Gitambi: [
              {
                Cyingwa: [
                  "Kabucuku",
                  "Kabugarama",
                  "Mpinga",
                  "Mugenge",
                  "Rwihene",
                ],
              },
              {
                Gahungeri: [
                  "Kamagaju",
                  "Kamonyi",
                  "Kaninda",
                  "Kazinda",
                  "Kigarama",
                  "Mugerero",
                  "Njambwe",
                  "Nyakibingo",
                  "Nyamaganda",
                  "Nyantaba",
                ],
              },
              {
                Hangabashi: [
                  "Kabonabose",
                  "Kabuga",
                  "Karambo",
                  "Kirehe",
                  "Nzabuhaha",
                  "Runanira",
                ],
              },
              {
                Mashesha: [
                  "Busasamana",
                  "Idaga",
                  "Kankuba",
                  "Karama",
                  "Nyakivomero",
                  "Ruvuruga",
                ],
              },
            ],
          },
          {
            Kamembe: [
              {
                Cyangugu: [
                  "Gatovu",
                  "Karambo",
                  "Karangiro",
                  "Mont Cyangugu",
                  "Mundima",
                  "Ngoma",
                  "Ntwari",
                ],
              },
              {
                Gihundwe: [
                  "Batero",
                  "Burunga",
                  "Kabeza",
                  "Munyinya",
                  "Murambi",
                  "Nkurunziza",
                ],
              },
              {
                Kamashangi: [
                  "Amahoro",
                  "Badura",
                  "Gitinda",
                  "Kadasomwa",
                  "Kannyogo",
                  "Mbagira",
                  "Mucyamo",
                  "Ntemabiti",
                  "Nyakayonga",
                  "Rushakamba",
                  "Umuganda",
                ],
              },
              {
                Kamurera: ["Cyapa", "Gikombe", "Kamuhirwa", "Murangi"],
              },
              {
                Ruganda: ["Kadashya", "Kamubaji", "Murindi", "Ruhimbi"],
              },
            ],
          },
          {
            Muganza: [
              {
                Cyarukara: [
                  "Gashinjano",
                  "Gashisha",
                  "Gisozi",
                  "Kabamba",
                  "Murira",
                  "Nyakagoma",
                  "Rubumba",
                  "Rubyiro",
                  "Rungunga",
                ],
              },
              {
                Gakoni: [
                  "Gatabuvuga",
                  "Gatanga",
                  "Kabeza",
                  "Kindobwe",
                  "Kiyovu",
                  "Muhuta",
                  "Nyakagenge",
                  "Rebero",
                  "Rugaragara",
                  "Sanganiro",
                  "Sano",
                  "Umutuzo",
                ],
              },
              {
                Shara: [
                  "Busasamana",
                  "Gakenke",
                  "Kabarore",
                  "Kamabuye",
                  "Murabyo",
                  "Nyabishunju",
                  "Nyenyeri",
                  "Ramiro",
                  "Rubeho",
                ],
              },
            ],
          },
          {
            Mururu: [
              {
                Gahinga: [
                  "Birogo",
                  "Buremera",
                  "Cyirabyo A",
                  "Cyirabyo B",
                  "Gipfura",
                  "Kabirizi",
                  "Kamarebe",
                  "Kanunga",
                  "Mutara",
                  "Ryabadugu",
                ],
              },
              {
                Kabahinda: ["Kabahire", "Karambo", "Winteko"],
              },
              {
                Kabasigirira: ["Bitongo", "Butazigurwa", "Mutimasi"],
              },
              {
                Kagarama: ["Cyete", "Gikungwe", "Gitwa", "Kamatene"],
              },
              {
                Karambi: ["Bugayi", "Gihango", "Kagarama"],
              },
              {
                Miko: ["Kabageni", "Nyakanyinya", "Ruhimbi"],
              },
              {
                Tara: [
                  "Byangoma",
                  "Cyandarama",
                  "Gatimbwa",
                  "Kamutongo",
                  "Karanjwa",
                  "Mukorazuba",
                  "Mutongo",
                  "Rugerero",
                ],
              },
            ],
          },
          {
            Nkanka: [
              {
                Gitwa: [
                  "Buganda",
                  "Burege",
                  "Kanyombya",
                  "Karama",
                  "Muhonga",
                  "Rugarika",
                ],
              },
              {
                Kamanyenga: [
                  "Gatebe",
                  "Hepfo",
                  "Kavogo",
                  "Muramba",
                  "Nyabiranga",
                  "Rweya",
                ],
              },
              {
                Kangazi: [
                  "Bahemba",
                  "Busekanka",
                  "Gafoka",
                  "Muyange",
                  "Rusunyu",
                ],
              },
              {
                Kinyaga: [
                  "Kabutimbiri",
                  "Kinyaga",
                  "Miramba",
                  "Rugaragara",
                  "Sumoyamana",
                ],
              },
              {
                Rugabano: [
                  "Bitaba",
                  "Kagarama",
                  "Kamahoro",
                  "Karambo",
                  "Rebero",
                  "Rurembo",
                ],
              },
            ],
          },
          {
            Nkombo: [
              {
                Bigoga: [
                  "Gisunyu",
                  "Giteme",
                  "Kabashinga",
                  "Ngoma",
                  "Nyawenya",
                  "Rebero",
                ],
              },
              {
                Bugarura: ["Gaturo", "Nyakabanda", "Nyankumbira", "Rurembo"],
              },
              {
                Ishywa: ["Biraro", "Kaboneke", "Kabuga", "Mapfura"],
              },
              {
                Kamagimbo: [
                  "Gashara",
                  "Gitwa",
                  "Kabuye",
                  "Kanyinya",
                  "Karenge",
                  "Mbuga",
                  "Muhora",
                ],
              },
              {
                Rwenje: ["Gituro", "Mirara", "Nyabintare", "Rutarakiro"],
              },
            ],
          },
          {
            Nkungu: [
              {
                Gatare: [
                  "Bahuro",
                  "Cyandarama",
                  "Kimpundu",
                  "Kivugiza",
                  "Madaho",
                  "Njambwe",
                  "Rubona",
                  "Rutegamatwi",
                ],
              },
              {
                Kiziguro: [
                  "Byugaro",
                  "Gasarabuye",
                  "Kabigohe",
                  "Kabuga",
                  "Kabuganza",
                  "Kadashya",
                  "Kamabuye",
                  "Karongoro",
                  "Mpinga",
                  "Mukenke",
                  "Rebero",
                  "Ryamibuga",
                ],
              },
              {
                Mataba: [
                  "Gashashi",
                  "Gatagara",
                  "Gatondo",
                  "Gikombe",
                  "Honga",
                  "Kabinyugwe",
                  "Kamajumba",
                  "Migazo",
                  "Muhora",
                  "Rubona",
                  "Rwamaraba",
                ],
              },
              {
                Ryamuhirwa: [
                  "Gako",
                  "Gatarange",
                  "Kigurwe",
                  "Kinanira",
                  "Kiyanza",
                  "Nyarushishi",
                  "Rugabe",
                  "Rususa",
                  "Ryamaraza",
                ],
              },
            ],
          },
          {
            Nyakabuye: [
              {
                Gasebeya: [
                  "Biteri",
                  "Gacyamo",
                  "Gahuna",
                  "Gaseke",
                  "Gashyuha",
                  "Kabuye",
                  "Kanoga",
                  "Karambi",
                  "Kaveya",
                ],
              },
              {
                Gaseke: [
                  "Bitendezi",
                  "Gatambamo",
                  "Kagabiro",
                  "Kagenge",
                  "Kinunga",
                  "Muyange",
                  "Rubona",
                ],
              },
              {
                Kamanu: [
                  "Bikinga",
                  "Bugumya",
                  "Gatare",
                  "Gishagara",
                  "Kamusana",
                  "Kiyovu",
                  "Mpoga",
                  "Mukondo",
                  "Murambi",
                  "Nyakagoma",
                  "Nyeshati",
                  "Ruguti",
                  "Ryamberu",
                  "Segege",
                  "Shaba",
                  "Site",
                ],
              },
              {
                Kiziho: [
                  "Bunyereri",
                  "Kamagerero",
                  "Makoko",
                  "Nkanga",
                  "Ruhinga",
                  "Rwimbogo",
                ],
              },
              {
                Mashyuza: [
                  "Cyamura",
                  "Kibirizi",
                  "Nyamaronko",
                  "Ruganzu",
                  "Rukamba",
                ],
              },
              {
                Nyabintare: [
                  "Barenga",
                  "Gakungu",
                  "Gatanga",
                  "Gatare",
                  "Mabuye",
                  "Mizibira",
                  "Peru",
                  "Ryarubaka",
                ],
              },
            ],
          },
          {
            Nyakarenzo: [
              {
                Gatare: ["Bigando", "Kabumbwe", "Rwindare"],
              },
              {
                Kabagina: [
                  "Bitaba",
                  "Gacyamo",
                  "Gitovu",
                  "Karambi",
                  "Nyamugari",
                ],
              },
              {
                Kabuye: [
                  "Bisenyi",
                  "Kazuba",
                  "Kigarama",
                  "Mashya",
                  "Mugerero",
                  "Nyamagana",
                  "Nyungu",
                ],
              },
              {
                Kanoga: ["Kamanura", "Kanoga", "Kanyovu", "Kumana"],
              },
              {
                Karangiro: ["Cyimbogo", "Gihusi", "Gituza", "Kabayego"],
              },
              {
                Murambi: ["Gisovu", "Njambwe", "Runyanzovu"],
              },
              {
                Rusambu: ["Gataramo", "Karambi", "Mugongo", "Rusambu"],
              },
            ],
          },
          {
            Nzahaha: [
              {
                Butambamo: [
                  "Gashagwa",
                  "Karunyerera",
                  "Muguri",
                  "Ngoma",
                  "Ryarusaro",
                ],
              },
              {
                Kigenge: ["Gihungwe", "Kacyiru", "Karagizwa", "Ndabereye"],
              },
              {
                Murya: [
                  "Buganza",
                  "Gacuriro",
                  "Gisheke",
                  "Kamina",
                  "Nyagahanga",
                  "Nyagasozi",
                  "Ryagashyitsi",
                  "Tare",
                ],
              },
              {
                Nyenji: [
                  "Gasharu",
                  "Gatare",
                  "Kinengwe",
                  "Murindi",
                  "Ruganzu",
                  "Rugunga",
                ],
              },
              {
                Rebero: ["Gatovu", "Giti", "Kabuyange", "Rukoro", "Shariyo"],
              },
              {
                Rwinzuki: [
                  "Gasave",
                  "Kabugabo",
                  "Kibirezi",
                  "Kiranga",
                  "Murambi",
                  "Nyagahinga",
                  "Peru",
                ],
              },
            ],
          },
          {
            Rwimbogo: [
              {
                Karenge: [
                  "Batura",
                  "Gatanga",
                  "Gishoma",
                  "Makambi",
                  "Nyabihanga",
                  "Ruzeneko",
                ],
              },
              {
                Muhehwe: [
                  "Kibare",
                  "Murama",
                  "Musigiti",
                  "Nyarusebeya",
                  "Renga",
                  "Rungunga",
                ],
              },
              {
                Mushaka: [
                  "Gakombe",
                  "Gatambamo",
                  "Kabajoba",
                  "Kamabuye",
                  "Nyagashora",
                ],
              },
              {
                Rubugu: ["Gatare", "Ntenyi", "Nyange", "Rukombe"],
              },
              {
                Ruganda: [
                  "Cyunguriro",
                  "Musumba",
                  "Rubamba",
                  "Rubuye",
                  "Ruhinga",
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
